import * as React from "react";
import wrapIcon from "../utils/wrapIcon";

const Molecule24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 12a5 5 0 10-4.34-2.51l-2.71 1.8A3.99 3.99 0 002 14a4 4 0 007.18 2.43l3.89 1.94a3 3 0 10.67-1.34l-3.89-1.94a4 4 0 00-.11-2.52l2.86-1.9c.9.82 2.09 1.33 3.4 1.33zm0-1.5a3.5 3.5 0 110-7 3.5 3.5 0 010 7zm-10 6a2.5 2.5 0 110-5 2.5 2.5 0 010 5zM17.5 19a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
    fill: primaryFill
  }));
};

export const Molecule24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Molecule24RegularIcon, 'Molecule24Regular');

const Molecule28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 14a6 6 0 10-5.36-3.3l-3.36 2.35a4.5 4.5 0 10-.3 5.3l5.2 3.04a3.5 3.5 0 10.77-1.29l-5.23-3.05a4.5 4.5 0 00.16-2.59l3.6-2.52A5.99 5.99 0 0019 14z",
    fill: primaryFill
  }));
};

export const Molecule28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Molecule28FilledIcon, 'Molecule28Filled');

const Molecule28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19 14a6 6 0 10-5.36-3.3l-3.36 2.35a4.5 4.5 0 10-.3 5.3l5.2 3.04a3.5 3.5 0 10.77-1.29l-5.23-3.05a4.5 4.5 0 00.16-2.59l3.6-2.52A5.99 5.99 0 0019 14zm0-1.5a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm-12.5 6a3 3 0 110-6 3 3 0 010 6zm14 4a2 2 0 11-4 0 2 2 0 014 0z",
    fill: primaryFill
  }));
};

export const Molecule28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Molecule28RegularIcon, 'Molecule28Regular');

const Molecule32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M22 16a7 7 0 10-6.4-4.17l-2.84 2.2a5.49 5.49 0 10-.26 7.25l4.77 2.68a4.5 4.5 0 101.1-1.68l-4.78-2.68a5.48 5.48 0 00.14-3.8l2.93-2.27A6.98 6.98 0 0022 16z",
    fill: primaryFill
  }));
};

export const Molecule32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Molecule32FilledIcon, 'Molecule32Filled');

const Molecule32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M22 16a7 7 0 10-6.4-4.17l-2.84 2.2a5.49 5.49 0 10-.26 7.25l4.77 2.68a4.5 4.5 0 101.1-1.68l-4.78-2.68a5.48 5.48 0 00.14-3.8l2.93-2.27A6.98 6.98 0 0022 16zm0-2a5 5 0 110-10 5 5 0 010 10zM8.5 21a3.5 3.5 0 110-7 3.5 3.5 0 010 7zM24 25.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z",
    fill: primaryFill
  }));
};

export const Molecule32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Molecule32RegularIcon, 'Molecule32Regular');

const Molecule48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M32 24a10 10 0 10-8.55-4.8l-5.38 3.58a8 8 0 10.44 9.87l7.68 3.84a6.01 6.01 0 101.12-2.23l-7.68-3.84a8 8 0 00-.25-5.5l5.64-3.76A9.97 9.97 0 0032 24z",
    fill: primaryFill
  }));
};

export const Molecule48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Molecule48FilledIcon, 'Molecule48Filled');

const Molecule48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M32 24a10 10 0 10-8.55-4.8l-5.38 3.58a8 8 0 10.44 9.87l7.68 3.84a6.01 6.01 0 101.12-2.23l-7.68-3.84a8 8 0 00-.25-5.5l5.64-3.76A9.97 9.97 0 0032 24zm0-2.5a7.5 7.5 0 110-15 7.5 7.5 0 010 15zm-20 12a5.5 5.5 0 110-11 5.5 5.5 0 010 11zM35.5 38a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0z",
    fill: primaryFill
  }));
};

export const Molecule48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Molecule48RegularIcon, 'Molecule48Regular');

const Money16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1 4.25C1 3.56 1.56 3 2.25 3h9.5c.69 0 1.25.56 1.25 1.25v5.5c0 .69-.56 1.25-1.25 1.25h-9.5C1.56 11 1 10.44 1 9.75v-5.5zm3 .25V4H3v.5a.5.5 0 01-.5.5H2v1h.5C3.33 6 4 5.33 4 4.5zM9 7a2 2 0 10-4 0 2 2 0 004 0zm2-3h-1v.5c0 .83.67 1.5 1.5 1.5h.5V5h-.5a.5.5 0 01-.5-.5V4zM4 9.5C4 8.67 3.33 8 2.5 8H2v1h.5c.28 0 .5.22.5.5v.5h1v-.5zm7 .5v-.5c0-.28.22-.5.5-.5h.5V8h-.5c-.83 0-1.5.67-1.5 1.5v.5h1zm-6.5 3a1.5 1.5 0 01-1.43-1.04c.14.03.28.04.43.04h8.25C12.99 12 14 11 14 9.75V5.09c.58.2 1 .76 1 1.41v3.25c0 1.8-1.46 3.25-3.25 3.25H4.5z",
    fill: primaryFill
  }));
};

export const Money16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Money16FilledIcon, 'Money16Filled');

const Money16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 7a2 2 0 11-4 0 2 2 0 014 0zM8 7a1 1 0 10-2 0 1 1 0 002 0zM1 4.25C1 3.56 1.56 3 2.25 3h9.5c.69 0 1.25.56 1.25 1.25v5.5c0 .69-.56 1.25-1.25 1.25h-9.5C1.56 11 1 10.44 1 9.75v-5.5zM2.25 4a.25.25 0 00-.25.25V5h.5a.5.5 0 00.5-.5V4h-.75zM2 9.75c0 .14.11.25.25.25H3v-.5a.5.5 0 00-.5-.5H2v.75zm2-.25v.5h6v-.5c0-.83.67-1.5 1.5-1.5h.5V6h-.5A1.5 1.5 0 0110 4.5V4H4v.5C4 5.33 3.33 6 2.5 6H2v2h.5C3.33 8 4 8.67 4 9.5zm7 .5h.75c.14 0 .25-.11.25-.25V9h-.5a.5.5 0 00-.5.5v.5zm1-5v-.75a.25.25 0 00-.25-.25H11v.5c0 .28.22.5.5.5h.5zm-7.5 8a1.5 1.5 0 01-1.43-1.04c.14.03.28.04.43.04h8.25C12.99 12 14 11 14 9.75V5.09c.58.2 1 .76 1 1.41v3.25c0 1.8-1.46 3.25-3.25 3.25H4.5z",
    fill: primaryFill
  }));
};

export const Money16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Money16RegularIcon, 'Money16Regular');

const Money20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 4C2.67 4 2 4.67 2 5.5v7c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5h-11zM6 5v1a2 2 0 01-2 2H3V7h1a1 1 0 001-1V5h1zm3 5.75a1.75 1.75 0 110-3.5 1.75 1.75 0 010 3.5zM3 11v-1h1a2 2 0 012 2v1H5v-1a1 1 0 00-1-1H3zm11 0a1 1 0 00-1 1v1h-1v-1c0-1.1.9-2 2-2h1v1h-1zm0-4h1v1h-1a2 2 0 01-2-2V5h1v1a1 1 0 001 1zm3 5.5a2.5 2.5 0 01-2.5 2.5H4.09c.2.58.76 1 1.41 1h9a3.5 3.5 0 003.5-3.5v-5c0-.65-.42-1.2-1-1.41v6.41z",
    fill: primaryFill
  }));
};

export const Money20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Money20FilledIcon, 'Money20Filled');

const Money20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 9a2 2 0 114 0 2 2 0 01-4 0zm2-1a1 1 0 100 2 1 1 0 000-2zM3.5 4C2.67 4 2 4.67 2 5.5v7c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5h-11zM3 5.5c0-.28.22-.5.5-.5H5v1a1 1 0 01-1 1H3V5.5zM3 8h1a2 2 0 002-2V5h6v1c0 1.1.9 2 2 2h1v2h-1a2 2 0 00-2 2v1H6v-1a2 2 0 00-2-2H3V8zm10-3h1.5c.28 0 .5.22.5.5V7h-1a1 1 0 01-1-1V5zm2 6v1.5a.5.5 0 01-.5.5H13v-1a1 1 0 011-1h1zM5 13H3.5a.5.5 0 01-.5-.5V11h1a1 1 0 011 1v1zm12-.5a2.5 2.5 0 01-2.5 2.5H4.09c.2.58.76 1 1.41 1h9a3.5 3.5 0 003.5-3.5v-5c0-.65-.42-1.2-1-1.41v6.41z",
    fill: primaryFill
  }));
};

export const Money20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Money20RegularIcon, 'Money20Regular');

const Money24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.75C2 5.78 2.78 5 3.75 5h13.5c.97 0 1.75.78 1.75 1.75v8.5c0 .97-.78 1.75-1.75 1.75H3.75C2.78 17 2 16.22 2 15.25v-8.5zm3-.5v1c0 .41-.34.75-.75.75h-1v1.5h1c1.24 0 2.25-1 2.25-2.25v-1H5zm5.5 7.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zm-7.25.5h1c.41 0 .75.34.75.75v1h1.5v-1c0-1.24-1-2.25-2.25-2.25h-1V14zm12.75.75c0-.41.34-.75.75-.75h1v-1.5h-1c-1.24 0-2.25 1-2.25 2.25v1H16v-1zm0-7.5v-1h-1.5v1c0 1.24 1 2.25 2.25 2.25h1V8h-1a.75.75 0 01-.75-.75zM4.4 18.5A3 3 0 007 20h10.25A4.75 4.75 0 0022 15.25V10a3 3 0 00-1.5-2.6v7.85c0 1.8-1.46 3.25-3.25 3.25H4.4z",
    fill: primaryFill
  }));
};

export const Money24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Money24FilledIcon, 'Money24Filled');

const Money24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.5 8a3 3 0 100 6 3 3 0 000-6zM9 11a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM2 7.25C2 6.01 3 5 4.25 5h12.5C17.99 5 19 6 19 7.25v7.5c0 1.24-1 2.25-2.25 2.25H4.25C3.01 17 2 16 2 14.75v-7.5zm2.25-.75a.75.75 0 00-.75.75V8h.75c.41 0 .75-.34.75-.75V6.5h-.75zm-.75 6h.75c1.24 0 2.25 1 2.25 2.25v.75h8v-.75c0-1.24 1-2.25 2.25-2.25h.75v-3h-.75c-1.24 0-2.25-1-2.25-2.25V6.5h-8v.75c0 1.24-1 2.25-2.25 2.25H3.5v3zm14-4.5v-.75a.75.75 0 00-.75-.75H16v.75c0 .41.34.75.75.75h.75zm0 6h-.75a.75.75 0 00-.75.75v.75h.75c.41 0 .75-.34.75-.75V14zm-14 .75c0 .41.34.75.75.75H5v-.75a.75.75 0 00-.75-.75H3.5v.75zm.9 3.75A3 3 0 007 20h10.25A4.75 4.75 0 0022 15.25V10a3 3 0 00-1.5-2.6v7.85c0 1.8-1.46 3.25-3.25 3.25H4.4z",
    fill: primaryFill
  }));
};

export const Money24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Money24RegularIcon, 'Money24Regular');

const MoneyCalculator20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4.5C2 3.67 2.67 3 3.5 3h11c.83 0 1.5.67 1.5 1.5V8h-3a2 2 0 00-2 2v3H3.5A1.5 1.5 0 012 11.5v-7zM4 7a2 2 0 002-2V4H5v1a1 1 0 01-1 1H3v1h1zm3.25 1a1.75 1.75 0 103.5 0 1.75 1.75 0 00-3.5 0zM3 9v1h1a1 1 0 011 1v1h1v-1a2 2 0 00-2-2H3zm12-2V6h-1a1 1 0 01-1-1V4h-1v1c0 1.1.9 2 2 2h1zm2 1V5.09c.58.2 1 .76 1 1.41V8h-1zm-6 6v1H5.5a1.5 1.5 0 01-1.41-1H11zm2.5-5c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5h-4zm0 4h1a.5.5 0 010 1h-1a.5.5 0 010-1zm3 0h1a.5.5 0 010 1h-1a.5.5 0 010-1zm-3 2h1a.5.5 0 010 1h-1a.5.5 0 010-1zm3 0h1a.5.5 0 010 1h-1a.5.5 0 010-1zm-3 2h1a.5.5 0 010 1h-1a.5.5 0 010-1zm3 0h1a.5.5 0 010 1h-1a.5.5 0 010-1zM13 10.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v1a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-1z",
    fill: primaryFill
  }));
};

export const MoneyCalculator20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneyCalculator20FilledIcon, 'MoneyCalculator20Filled');

const MoneyCalculator20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 6a2 2 0 100 4 2 2 0 000-4zM8 8a1 1 0 112 0 1 1 0 01-2 0zM2 4.5C2 3.67 2.67 3 3.5 3h11c.83 0 1.5.67 1.5 1.5V8h-1V7h-1a2 2 0 01-2-2V4H6v1a2 2 0 01-2 2H3v2h1a2 2 0 012 2v1h5v1H3.5A1.5 1.5 0 012 11.5v-7zM3.5 4a.5.5 0 00-.5.5V6h1a1 1 0 001-1V4H3.5zm11 0H13v1a1 1 0 001 1h1V4.5a.5.5 0 00-.5-.5zm-11 8H5v-1a1 1 0 00-1-1H3v1.5c0 .28.22.5.5.5zM17 8V5.09c.58.2 1 .76 1 1.41V8h-1zm-6 6v1H5.5a1.5 1.5 0 01-1.41-1H11zm2.5-5c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5h-4zm0 4h1a.5.5 0 010 1h-1a.5.5 0 010-1zm3 0h1a.5.5 0 010 1h-1a.5.5 0 010-1zm-3 2h1a.5.5 0 010 1h-1a.5.5 0 010-1zm3 0h1a.5.5 0 010 1h-1a.5.5 0 010-1zm-3 2h1a.5.5 0 010 1h-1a.5.5 0 010-1zm3 0h1a.5.5 0 010 1h-1a.5.5 0 010-1zM13 10.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v1a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-1z",
    fill: primaryFill
  }));
};

export const MoneyCalculator20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneyCalculator20RegularIcon, 'MoneyCalculator20Regular');

const MoneyCalculator24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 5.75C2 4.78 2.78 4 3.75 4h13.5c.97 0 1.75.78 1.75 1.75V11h-3a2 2 0 00-2 2v3H3.75C2.78 16 2 15.22 2 14.25v-8.5zm3 .5c0 .41-.34.75-.75.75h-1v1.5h1c1.24 0 2.25-1 2.25-2.25v-1H5v1zm5.5 6.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zm-6.25.5c.41 0 .75.34.75.75v1h1.5v-1c0-1.24-1-2.25-2.25-2.25h-1V13h1zm12.5-6a.75.75 0 01-.75-.75v-1h-1.5v1c0 1.24 1 2.25 2.25 2.25h1V7h-1zM4.4 17.5H14V19H7a3 3 0 01-2.6-1.5zM22 9v2h-1.5V6.4A3 3 0 0122 9zm-5.5 3c-.83 0-1.5.67-1.5 1.5v8c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-8c0-.83-.67-1.5-1.5-1.5h-5zm.5 4.5h1a.5.5 0 010 1h-1a.5.5 0 010-1zm3 0h1a.5.5 0 010 1h-1a.5.5 0 010-1zm-3 2h1a.5.5 0 010 1h-1a.5.5 0 010-1zm3 0h1a.5.5 0 010 1h-1a.5.5 0 010-1zm-3 2h1a.5.5 0 010 1h-1a.5.5 0 010-1zm3 0h1a.5.5 0 010 1h-1a.5.5 0 010-1zM16.5 14c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v1a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-1z",
    fill: primaryFill
  }));
};

export const MoneyCalculator24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneyCalculator24FilledIcon, 'MoneyCalculator24Filled');

const MoneyCalculator24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.5 7a3 3 0 100 6 3 3 0 000-6zM9 10a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM2 6.25C2 5.01 3 4 4.25 4h12.5C17.99 4 19 5 19 6.25V11h-1.5V8.5h-.75c-1.24 0-2.25-1-2.25-2.25V5.5h-8v.75c0 1.24-1 2.25-2.25 2.25H3.5v3h.75c1.24 0 2.25 1 2.25 2.25v.75H14V16H4.25C3.01 16 2 15 2 13.75v-7.5zm2.25-.75a.75.75 0 00-.75.75V7h.75c.41 0 .75-.34.75-.75V5.5h-.75zM17.5 7v-.75a.75.75 0 00-.75-.75H16v.75c0 .41.34.75.75.75h.75zm-14 6.75c0 .41.34.75.75.75H5v-.75a.75.75 0 00-.75-.75H3.5v.75zm.9 3.75H14V19H7a3 3 0 01-2.6-1.5zM22 11V9a3 3 0 00-1.5-2.6V11H22zm-5.5 1c-.83 0-1.5.67-1.5 1.5v8c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-8c0-.83-.67-1.5-1.5-1.5h-5zm.5 4.5h1a.5.5 0 010 1h-1a.5.5 0 010-1zm3 0h1a.5.5 0 010 1h-1a.5.5 0 010-1zm-3 2h1a.5.5 0 010 1h-1a.5.5 0 010-1zm3 0h1a.5.5 0 010 1h-1a.5.5 0 010-1zm-3 2h1a.5.5 0 010 1h-1a.5.5 0 010-1zm3 0h1a.5.5 0 010 1h-1a.5.5 0 010-1zM16.5 14c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5v1a.5.5 0 01-.5.5h-4a.5.5 0 01-.5-.5v-1z",
    fill: primaryFill
  }));
};

export const MoneyCalculator24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneyCalculator24RegularIcon, 'MoneyCalculator24Regular');

const MoneyDismiss20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 4C2.67 4 2 4.67 2 5.5v7c0 .83.67 1.5 1.5 1.5h5.52A5.5 5.5 0 0116 9.2V5.5c0-.83-.67-1.5-1.5-1.5h-11zM6 6a2 2 0 01-2 2H3V7h1a1 1 0 001-1V5h1v1zm3 4.75a1.75 1.75 0 110-3.5 1.75 1.75 0 010 3.5zM3 11v-1h1a2 2 0 012 2v1H5v-1a1 1 0 00-1-1H3zm10-5a1 1 0 001 1h1v1h-1a2 2 0 01-2-2V5h1v1zm-8.91 9h4.93c.03.34.1.68.19 1H5.5a1.5 1.5 0 01-1.41-1zM18 7.5v2.76a5.5 5.5 0 00-1-.66V6.09c.58.2 1 .76 1 1.41zm1 7a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-3.8 0l1.15-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15z",
    fill: primaryFill
  }));
};

export const MoneyDismiss20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneyDismiss20FilledIcon, 'MoneyDismiss20Filled');

const MoneyDismiss20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 9a2 2 0 114 0 2 2 0 01-4 0zm2-1a1 1 0 100 2 1 1 0 000-2zM3.5 4C2.67 4 2 4.67 2 5.5v7c0 .83.67 1.5 1.5 1.5h5.52c.03-.34.1-.68.19-1H6v-1a2 2 0 00-2-2H3V8h1a2 2 0 002-2V5h6v1c0 1.1.9 2 2 2h1v1.02c.34.03.68.1 1 .19V5.5c0-.83-.67-1.5-1.5-1.5h-11zM3 5.5c0-.28.22-.5.5-.5H5v1a1 1 0 01-1 1H3V5.5zM13 5h1.5c.28 0 .5.22.5.5V7h-1a1 1 0 01-1-1V5zm-8 8H3.5a.5.5 0 01-.5-.5V11h1a1 1 0 011 1v1zm-.91 2h4.93c.03.34.1.68.19 1H5.5a1.5 1.5 0 01-1.41-1zM18 7.5v2.76a5.5 5.5 0 00-1-.66V6.09c.58.2 1 .76 1 1.41zm1 7a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-3.8 0l1.15-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15z",
    fill: primaryFill
  }));
};

export const MoneyDismiss20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneyDismiss20RegularIcon, 'MoneyDismiss20Regular');

const MoneyDismiss24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 6.75C2 5.78 2.78 5 3.75 5h13.5c.97 0 1.75.78 1.75 1.75v4.42A6.52 6.52 0 0011.02 17H3.75C2.78 17 2 16.22 2 15.25v-8.5zm3 .5c0 .41-.34.75-.75.75h-1v1.5h1c1.24 0 2.25-1 2.25-2.25v-1H5v1zm5.5 6.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zm-6.25.5c.41 0 .75.34.75.75v1h1.5v-1c0-1.24-1-2.25-2.25-2.25h-1V14h1zm12.5-6a.75.75 0 01-.75-.75v-1h-1.5v1c0 1.24 1 2.25 2.25 2.25h1V8h-1zM4.4 18.5h6.68c.08.52.22 1.03.42 1.5H7a3 3 0 01-2.6-1.5zm16.1-6.77c.55.29 1.06.65 1.5 1.08V10a3 3 0 00-1.5-2.6v4.33zM23 17.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-7.15-2.35a.5.5 0 00-.7.7l1.64 1.65-1.64 1.65a.5.5 0 00.7.7l1.65-1.64 1.65 1.64a.5.5 0 00.7-.7l-1.64-1.65 1.64-1.65a.5.5 0 00-.7-.7l-1.65 1.64-1.65-1.64z",
    fill: primaryFill
  }));
};

export const MoneyDismiss24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneyDismiss24FilledIcon, 'MoneyDismiss24Filled');

const MoneyDismiss24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.5 8a3 3 0 100 6 3 3 0 000-6zM9 11a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM2 7.25C2 6.01 3 5 4.25 5h12.5C17.99 5 19 6 19 7.25v3.92a6.52 6.52 0 00-1.5-.17V9.5h-.75c-1.24 0-2.25-1-2.25-2.25V6.5h-8v.75c0 1.24-1 2.25-2.25 2.25H3.5v3h.75c1.24 0 2.25 1 2.25 2.25v.75h4.81c-.15.48-.25.98-.3 1.5H4.26C3.01 17 2 16 2 14.75v-7.5zm2.25-.75a.75.75 0 00-.75.75V8h.75c.41 0 .75-.34.75-.75V6.5h-.75zM17.5 8v-.75a.75.75 0 00-.75-.75H16v.75c0 .41.34.75.75.75h.75zm-14 6.75c0 .41.34.75.75.75H5v-.75a.75.75 0 00-.75-.75H3.5v.75zm.9 3.75h6.68c.08.52.22 1.03.42 1.5H7a3 3 0 01-2.6-1.5zm16.1-6.77c.55.29 1.06.65 1.5 1.08V10a3 3 0 00-1.5-2.6v4.33zM23 17.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-7.15-2.35a.5.5 0 00-.7.7l1.64 1.65-1.64 1.65a.5.5 0 00.7.7l1.65-1.64 1.65 1.64a.5.5 0 00.7-.7l-1.64-1.65 1.64-1.65a.5.5 0 00-.7-.7l-1.65 1.64-1.65-1.64z",
    fill: primaryFill
  }));
};

export const MoneyDismiss24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneyDismiss24RegularIcon, 'MoneyDismiss24Regular');

const MoneyHand20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 3.5C3 2.67 3.67 2 4.5 2h7c.83 0 1.5.67 1.5 1.5v1.8l3.27 3.26c.47.47.73 1.1.73 1.77v7.17a.5.5 0 01-1 0v-7.17c0-.4-.16-.78-.44-1.06L13 6.7v3.08l.85.86a.5.5 0 01-.7.7l-3-3c-.43-.42-.66-.4-.76-.38-.18.05-.33.19-.54.4-.1.09-.15.18-.13.32.03.18.17.49.63.96.98.97 1.1 1.1 1.22 1.2l.28.3c.1.09.15.22.15.35 0 .77 0 1.55.22 2.14.1.28.24.49.42.62.18.14.45.24.86.24.28 0 .5.22.5.5v1.5c0 .83-.67 1.5-1.5 1.5h-7A1.5 1.5 0 013 16.5v-13zm5 4a2.5 2.5 0 101.9 4.12l-.04-.05-1.21-1.22a2.85 2.85 0 01-.91-1.51c-.08-.52.13-.93.41-1.2l.04-.04.1-.08L8 7.5zm2 9v.5h1v-.5c0-.28.22-.5.5-.5h.5v-.54c-.37-.06-.68-.2-.95-.4-.6.2-1.05.77-1.05 1.44zM4 5h.5C5.33 5 6 4.33 6 3.5V3H5v.5a.5.5 0 01-.5.5H4v1zm6-1.5c0 .83.67 1.5 1.5 1.5h.5V4h-.5a.5.5 0 01-.5-.5V3h-1v.5zm-4 13c0-.83-.67-1.5-1.5-1.5H4v1h.5c.28 0 .5.22.5.5v.5h1v-.5z",
    fill: primaryFill
  }));
};

export const MoneyHand20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneyHand20FilledIcon, 'MoneyHand20Filled');

const MoneyHand20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 2C3.67 2 3 2.67 3 3.5v13c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5V15a.5.5 0 00-.5-.5c-.41 0-.68-.1-.86-.24a1.3 1.3 0 01-.42-.62A6.69 6.69 0 0111 11.5a.5.5 0 00-.15-.35l-.28-.3-1.22-1.2c-.46-.47-.6-.78-.63-.96-.02-.14.03-.23.13-.33.21-.2.36-.34.54-.39.1-.02.33-.04.76.38l3 3a.5.5 0 00.7-.7L13 9.79V6.71l2.56 2.56c.28.28.44.66.44 1.06v7.17a.5.5 0 001 0v-7.17c0-.66-.26-1.3-.73-1.77L13 5.3V3.5c0-.83-.67-1.5-1.5-1.5h-7zM12 5.5v3.3l-1.15-1.15c-.57-.58-1.15-.78-1.7-.65-.11.03-.22.07-.31.12A3 3 0 1010 12.23c.01.58.07 1.21.27 1.75.15.41.38.8.76 1.08h.01c-.6.2-1.05.77-1.05 1.44v.5H6v-.5c0-.83-.67-1.5-1.5-1.5H4V5h.5C5.33 5 6 4.33 6 3.5V3h4v.5c0 .83.67 1.5 1.5 1.5h.5v.5zm0 11a.5.5 0 01-.5.5H11v-.5c0-.28.22-.5.5-.5h.5v.5zM6 10a2 2 0 011.87-2c-.12.23-.18.51-.13.84.07.48.37.98.9 1.51l.91.91A2 2 0 016 10zM5 3v.5a.5.5 0 01-.5.5H4v-.5c0-.28.22-.5.5-.5H5zM4 16h.5c.28 0 .5.22.5.5v.5h-.5a.5.5 0 01-.5-.5V16zm8-12h-.5a.5.5 0 01-.5-.5V3h.5c.28 0 .5.22.5.5V4z",
    fill: primaryFill
  }));
};

export const MoneyHand20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneyHand20RegularIcon, 'MoneyHand20Regular');

const MoneyHand24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.25 2C5.01 2 4 3 4 4.25v15.5C4 20.99 5 22 6.25 22h7.5c1.24 0 2.24-1 2.25-2.23v-1.52a.75.75 0 00-.75-.75c-.45 0-.74-.12-.94-.28-.2-.17-.38-.43-.5-.79a8.39 8.39 0 01-.31-2.68.75.75 0 00-.2-.51l-.17-.18-.17-.17-1.18-1.17a3 3 0 01-.81-1.17.61.61 0 01-.02-.32c.02-.09.07-.2.2-.33a.7.7 0 01.33-.2.61.61 0 01.32.02c.3.08.7.34 1.17.81l1.51 1.5c.76.75 1.37 1.36 1.72 1.73a.75.75 0 001.1-1.02L16 11.42V8.06l2.84 2.84c.42.42.66 1 .66 1.6v8.75a.75.75 0 001.5 0v-8.76c0-1-.4-1.95-1.1-2.65L16 5.94V4.25C16 3.01 15 2 13.75 2h-7.5zm7.12 16.39c.32.26.7.44 1.13.53V19h-.75a.75.75 0 00-.75.75v.75h-1.5v-.75c0-.9.52-1.67 1.28-2.03.16.25.35.47.6.67zM12 14.05c0 .25 0 .52.02.8a3.5 3.5 0 11-1.55-6.32 2.49 2.49 0 00-.97 1.32c-.1.38-.08.76.02 1.1.2.68.67 1.3 1.2 1.83A66.72 66.72 0 0011.96 14l.04.04zM7 3.5h1.5v.75c0 1.24-1 2.25-2.25 2.25H5.5V5h.75c.41 0 .75-.34.75-.75V3.5zm4.5 0H13v.75c0 .41.34.75.75.75h.75v1.5h-.75c-1.24 0-2.25-1-2.25-2.25V3.5zm-3 17H7v-.75a.75.75 0 00-.75-.75H5.5v-1.5h.75c1.24 0 2.25 1 2.25 2.25v.75z",
    fill: primaryFill
  }));
};

export const MoneyHand24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneyHand24FilledIcon, 'MoneyHand24Filled');

const MoneyHand24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.25 2C5.01 2 4 3 4 4.25v15.5C4 20.99 5 22 6.25 22h7.5c1.24 0 2.24-1 2.25-2.23v-1.52a.75.75 0 00-.75-.75c-.45 0-.74-.12-.94-.28-.2-.17-.38-.43-.5-.79a8.39 8.39 0 01-.31-2.68.75.75 0 00-.2-.51l-.17-.18-.17-.17-1.18-1.17a3 3 0 01-.81-1.17.61.61 0 01-.02-.32c.02-.09.07-.2.2-.33a.7.7 0 01.33-.2.61.61 0 01.32.02c.3.08.7.34 1.17.81l1.51 1.5c.76.75 1.37 1.36 1.72 1.73a.75.75 0 001.1-1.02L16 11.42V8.06l2.84 2.84c.42.42.66 1 .66 1.6v8.75a.75.75 0 001.5 0v-8.76c0-1-.4-1.95-1.1-2.65L16 5.94V4.25C16 3.01 15 2 13.75 2h-7.5zm6.14 14.94c.1.27.22.53.39.78a2.25 2.25 0 00-1.28 2.03v.75h-3v-.75c0-1.24-1-2.25-2.25-2.25H5.5v-11h.75c1.24 0 2.25-1 2.25-2.25V3.5h3v.75c0 1.24 1 2.25 2.25 2.25h.75v3.44l-.47-.47c-.53-.53-1.15-1-1.82-1.2a2.1 2.1 0 00-1.74.26 3.5 3.5 0 101.55 6.32c.04.69.13 1.43.37 2.09zM8 12a2 2 0 011.46-1.93c-.05.3-.02.6.06.89.2.67.67 1.29 1.2 1.82l.67.66A2 2 0 018 12zM5.5 4.25c0-.41.34-.75.75-.75H7v.75c0 .41-.34.75-.75.75H5.5v-.75zM13 3.5h.75c.41 0 .75.34.75.75V5h-.75a.75.75 0 01-.75-.75V3.5zM14.5 19v.75c0 .41-.34.75-.75.75H13v-.75c0-.41.34-.75.75-.75h.75zM7 20.5h-.75a.75.75 0 01-.75-.75V19h.75c.41 0 .75.34.75.75v.75z",
    fill: primaryFill
  }));
};

export const MoneyHand24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneyHand24RegularIcon, 'MoneyHand24Regular');

const MoneyOff20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L3.3 4.01C2.57 4.11 2 4.74 2 5.5v7c0 .83.67 1.5 1.5 1.5h9.8l1 1H4.08c.2.58.76 1 1.41 1h9c.25 0 .49-.03.72-.07l1.93 1.92a.5.5 0 00.7-.7l-15-15zm6.98 8.39a1.75 1.75 0 01-2.37-2.37l2.37 2.37zM5.9 6.61A2 2 0 014 8H3V7h1a1 1 0 001-1v-.3l.9.91zM3 11v-1h1a2 2 0 012 2v1H5v-1a1 1 0 00-1-1H3zm6.42-3.7l1.28 1.28 1.95 1.95A2 2 0 0114 10h1v1h-1a1 1 0 00-.65.24l2.27 2.26c.24-.27.38-.62.38-1v-7c0-.83-.67-1.5-1.5-1.5H6.12l3.3 3.3zM15 7v1h-1a2 2 0 01-2-2V5h1v1a1 1 0 001 1h1zm1.33 7.2l.7.72c.6-.63.97-1.48.97-2.42v-5c0-.65-.42-1.2-1-1.41v6.41a2.5 2.5 0 01-.67 1.7z",
    fill: primaryFill
  }));
};

export const MoneyOff20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneyOff20FilledIcon, 'MoneyOff20Filled');

const MoneyOff20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L3.3 4.01C2.57 4.11 2 4.74 2 5.5v7c0 .83.67 1.5 1.5 1.5h9.8l1 1H4.08c.2.58.76 1 1.41 1h9c.25 0 .49-.03.72-.07l1.93 1.92a.5.5 0 00.7-.7l-15-15zM12 12.7V13H6v-1a2 2 0 00-2-2H3V8h1a2 2 0 001.9-1.39l1.38 1.37a2 2 0 002.74 2.74L12 12.71zM4.3 5l.7.7V6a1 1 0 01-1 1H3V5.5c0-.28.22-.5.5-.5h.8zm3.73 3.74l1.23 1.23a1 1 0 01-1.23-1.23zM3.5 13a.5.5 0 01-.5-.5V11h1a1 1 0 011 1v1H3.5zM14 10a2 2 0 00-1.35.53l.7.7A1 1 0 0114 11h1v1.5c0 .1-.03.2-.1.29l.72.71c.24-.27.38-.62.38-1v-7c0-.83-.67-1.5-1.5-1.5H6.12l1 1H12v1c0 1.1.9 2 2 2h1v2h-1zm.5-5c.28 0 .5.22.5.5V7h-1a1 1 0 01-1-1V5h1.5zm1.83 9.2l.7.72c.6-.63.97-1.48.97-2.42v-5c0-.65-.42-1.2-1-1.41v6.41a2.5 2.5 0 01-.67 1.7z",
    fill: primaryFill
  }));
};

export const MoneyOff20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneyOff20RegularIcon, 'MoneyOff20Regular');

const MoneyOff24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.28 2.22a.75.75 0 00-1.06 1.06L3.94 5h-.19C2.78 5 2 5.78 2 6.75v8.5c0 .97.78 1.75 1.75 1.75h12.19l1.5 1.5H4.4A3 3 0 007 20h10.25c.51 0 1-.08 1.46-.23l2.01 2.01a.75.75 0 101.06-1.06L3.28 2.22zm8.65 10.77a2.25 2.25 0 01-3.17-3.17L11.93 13zM5.19 6.25l1.3 1.3A2.25 2.25 0 014.24 9.5h-1V8h1c.41 0 .75-.34.75-.75v-1h.19zM4.25 14h-1v-1.5h1c1.24 0 2.25 1 2.25 2.25v1H5v-1a.75.75 0 00-.75-.75zm13.5 0h-.57l1.75 1.75c.04-.16.07-.33.07-.5v-8.5C19 5.78 18.22 5 17.25 5H8.18l7.68 7.68c.27-.12.57-.18.89-.18h1V14zM16 6.25v1c0 .41.34.75.75.75h1v1.5h-1c-1.24 0-2.25-1-2.25-2.25v-1H16zm4.06 10.63l1.09 1.09c.53-.77.85-1.71.85-2.72V10a3 3 0 00-1.5-2.6v7.85c0 .6-.16 1.15-.44 1.63z",
    fill: primaryFill
  }));
};

export const MoneyOff24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneyOff24FilledIcon, 'MoneyOff24Filled');

const MoneyOff24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.28 2.22a.75.75 0 00-1.06 1.06l1.74 1.74A2.25 2.25 0 002 7.25v7.5C2 15.99 3 17 4.25 17h11.69l1.5 1.5H4.4A3 3 0 007 20h10.25c.51 0 1-.08 1.46-.23l2.01 2.01a.75.75 0 101.06-1.06L3.28 2.22zM14.44 15.5H6.5v-.75c0-1.24-1-2.25-2.25-2.25H3.5v-3h.75c1.14 0 2.09-.85 2.23-1.96l1.64 1.64a3 3 0 004.2 4.2l2.12 2.12zM9.2 10.26l2.04 2.04a1.5 1.5 0 01-2.05-2.05zM3.5 7.25c0-.41.34-.75.75-.75H5v.75c0 .41-.34.75-.75.75H3.5v-.75zm.75 8.25a.75.75 0 01-.75-.75V14h.75c.41 0 .75.34.75.75v.75h-.75zm12.5-3c-.32 0-.62.06-.89.18L17.18 14h.32v.32l1.32 1.32c.12-.27.18-.57.18-.89v-7.5C19 6.01 18 5 16.75 5H8.18l1.5 1.5h4.82v.75c0 1.24 1 2.25 2.25 2.25h.75v3h-.75zm.75-5.25V8h-.75a.75.75 0 01-.75-.75V6.5h.75c.41 0 .75.34.75.75zm2.56 9.63l1.09 1.09c.53-.77.85-1.71.85-2.72V10a3 3 0 00-1.5-2.6v7.85c0 .6-.16 1.15-.44 1.63z",
    fill: primaryFill
  }));
};

export const MoneyOff24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneyOff24RegularIcon, 'MoneyOff24Regular');

const MoneySettings20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 4C2.67 4 2 4.67 2 5.5v7c0 .83.67 1.5 1.5 1.5h5.52A5.5 5.5 0 0116 9.2V5.5c0-.83-.67-1.5-1.5-1.5h-11zM6 6a2 2 0 01-2 2H3V7h1a1 1 0 001-1V5h1v1zm3 4.75a1.75 1.75 0 110-3.5 1.75 1.75 0 010 3.5zM3 11v-1h1a2 2 0 012 2v1H5v-1a1 1 0 00-1-1H3zm10-5a1 1 0 001 1h1v1h-1a2 2 0 01-2-2V5h1v1zm-8.91 9h4.93c.03.34.1.68.19 1H5.5a1.5 1.5 0 01-1.41-1zM18 7.5v2.76a5.5 5.5 0 00-1-.66V6.09c.58.2 1 .76 1 1.41zm-5.94 3.94a2 2 0 01-1.43 2.48l-.46.12a4.73 4.73 0 00.01 1.02l.35.08A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.16-.55a2 2 0 011.44-2.48l.46-.12a4.7 4.7 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.15.55zm2.44 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const MoneySettings20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneySettings20FilledIcon, 'MoneySettings20Filled');

const MoneySettings20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 9a2 2 0 114 0 2 2 0 01-4 0zm2-1a1 1 0 100 2 1 1 0 000-2zM3.5 4C2.67 4 2 4.67 2 5.5v7c0 .83.67 1.5 1.5 1.5h5.52c.03-.34.1-.68.19-1H6v-1a2 2 0 00-2-2H3V8h1a2 2 0 002-2V5h6v1c0 1.1.9 2 2 2h1v1.02c.34.03.68.1 1 .19V5.5c0-.83-.67-1.5-1.5-1.5h-11zM3 5.5c0-.28.22-.5.5-.5H5v1a1 1 0 01-1 1H3V5.5zM13 5h1.5c.28 0 .5.22.5.5V7h-1a1 1 0 01-1-1V5zm-8 8H3.5a.5.5 0 01-.5-.5V11h1a1 1 0 011 1v1zm-.91 2h4.93c.03.34.1.68.19 1H5.5a1.5 1.5 0 01-1.41-1zM18 7.5v2.76a5.5 5.5 0 00-1-.66V6.09c.58.2 1 .76 1 1.41zm-5.94 3.94a2 2 0 01-1.43 2.48l-.46.12a4.73 4.73 0 00.01 1.02l.35.08A2 2 0 0112 17.66l-.13.42c.26.2.54.38.84.52l.32-.35a2 2 0 012.91 0l.34.36c.3-.13.57-.3.82-.5l-.16-.55a2 2 0 011.44-2.48l.46-.12a4.7 4.7 0 00-.01-1.01l-.35-.09A2 2 0 0117 11.34l.13-.42c-.26-.2-.54-.38-.84-.52l-.32.35a2 2 0 01-2.91 0l-.34-.36c-.3.13-.57.3-.82.5l.15.55zm2.44 4.06a1 1 0 110-2 1 1 0 010 2z",
    fill: primaryFill
  }));
};

export const MoneySettings20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoneySettings20RegularIcon, 'MoneySettings20Regular');

const MoreCircle20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a8 8 0 100 16 8 8 0 000-16zm-3 8a1 1 0 11-2 0 1 1 0 012 0zm4 0a1 1 0 11-2 0 1 1 0 012 0zm4 0a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }));
};

export const MoreCircle20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreCircle20FilledIcon, 'MoreCircle20Filled');

const MoreCircle20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 10a1 1 0 11-2 0 1 1 0 012 0zm4 0a1 1 0 11-2 0 1 1 0 012 0zm4 0a1 1 0 11-2 0 1 1 0 012 0zm-5-8a8 8 0 100 16 8 8 0 000-16zm-7 8a7 7 0 1114 0 7 7 0 01-14 0z",
    fill: primaryFill
  }));
};

export const MoreCircle20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreCircle20RegularIcon, 'MoreCircle20Regular');

const MoreCircle32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 30a14 14 0 100-28 14 14 0 000 28zm-6-12a2 2 0 110-4 2 2 0 010 4zm8-2a2 2 0 11-4 0 2 2 0 014 0zm4 2a2 2 0 110-4 2 2 0 010 4z",
    fill: primaryFill
  }));
};

export const MoreCircle32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreCircle32FilledIcon, 'MoreCircle32Filled');

const MoreCircle32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 18a2 2 0 100-4 2 2 0 000 4zm6 0a2 2 0 100-4 2 2 0 000 4zm8-2a2 2 0 11-4 0 2 2 0 014 0zm6 0a14 14 0 11-28 0 14 14 0 0128 0zm-2 0a12 12 0 10-24 0 12 12 0 0024 0z",
    fill: primaryFill
  }));
};

export const MoreCircle32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreCircle32RegularIcon, 'MoreCircle32Regular');

const MoreHorizontal16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.25 8a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm4 0a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM12 9.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
    fill: primaryFill
  }));
};

export const MoreHorizontal16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreHorizontal16FilledIcon, 'MoreHorizontal16Filled');

const MoreHorizontal16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 8a1 1 0 11-2 0 1 1 0 012 0zm4 0a1 1 0 11-2 0 1 1 0 012 0zm3 1a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const MoreHorizontal16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreHorizontal16RegularIcon, 'MoreHorizontal16Regular');

const MoreHorizontal20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.75 10a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0zm5 0a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0zM15 11.75a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5z",
    fill: primaryFill
  }));
};

export const MoreHorizontal20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreHorizontal20FilledIcon, 'MoreHorizontal20Filled');

const MoreHorizontal20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.25 10a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm5 0a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zM15 11.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
    fill: primaryFill
  }));
};

export const MoreHorizontal20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreHorizontal20RegularIcon, 'MoreHorizontal20Regular');

const MoreHorizontal24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 12a2 2 0 11-4 0 2 2 0 014 0zm6 0a2 2 0 11-4 0 2 2 0 014 0zm4 2a2 2 0 100-4 2 2 0 000 4z",
    fill: primaryFill
  }));
};

export const MoreHorizontal24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreHorizontal24FilledIcon, 'MoreHorizontal24Filled');

const MoreHorizontal24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.75 12a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0zm6 0a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0zM18 13.75a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5z",
    fill: primaryFill
  }));
};

export const MoreHorizontal24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreHorizontal24RegularIcon, 'MoreHorizontal24Regular');

const MoreHorizontal28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.75 14a2.75 2.75 0 11-5.5 0 2.75 2.75 0 015.5 0zm8 0a2.75 2.75 0 11-5.5 0 2.75 2.75 0 015.5 0zM22 16.75a2.75 2.75 0 100-5.5 2.75 2.75 0 000 5.5z",
    fill: primaryFill
  }));
};

export const MoreHorizontal28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreHorizontal28FilledIcon, 'MoreHorizontal28Filled');

const MoreHorizontal28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.25 14a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm8 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zM22 16.25a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5z",
    fill: primaryFill
  }));
};

export const MoreHorizontal28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreHorizontal28RegularIcon, 'MoreHorizontal28Regular');

const MoreHorizontal32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 19a3 3 0 100-6 3 3 0 000 6zm9 0a3 3 0 100-6 3 3 0 000 6zm9 0a3 3 0 100-6 3 3 0 000 6z",
    fill: primaryFill
  }));
};

export const MoreHorizontal32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreHorizontal32FilledIcon, 'MoreHorizontal32Filled');

const MoreHorizontal32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.5 16a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm9 0a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm6.5 2.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
    fill: primaryFill
  }));
};

export const MoreHorizontal32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreHorizontal32RegularIcon, 'MoreHorizontal32Regular');

const MoreHorizontal48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 24a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zm11.5 0a3.5 3.5 0 11-7 0 3.5 3.5 0 017 0zm8 3.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7z",
    fill: primaryFill
  }));
};

export const MoreHorizontal48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreHorizontal48FilledIcon, 'MoreHorizontal48Filled');

const MoreHorizontal48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.75 24a3.25 3.25 0 11-6.5 0 3.25 3.25 0 016.5 0zm11.5 0a3.25 3.25 0 11-6.5 0 3.25 3.25 0 016.5 0zm8.25 3.25a3.25 3.25 0 100-6.5 3.25 3.25 0 000 6.5z",
    fill: primaryFill
  }));
};

export const MoreHorizontal48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreHorizontal48RegularIcon, 'MoreHorizontal48Regular');

const MoreVertical16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 5.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm0 4a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zM6.75 12a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0z",
    fill: primaryFill
  }));
};

export const MoreVertical16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreVertical16FilledIcon, 'MoreVertical16Filled');

const MoreVertical16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 5a1 1 0 110-2 1 1 0 010 2zm0 4a1 1 0 110-2 1 1 0 010 2zm-1 3a1 1 0 102 0 1 1 0 00-2 0z",
    fill: primaryFill
  }));
};

export const MoreVertical16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreVertical16RegularIcon, 'MoreVertical16Regular');

const MoreVertical20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 6.5A1.75 1.75 0 1110 3a1.75 1.75 0 010 3.5zM10 17a1.75 1.75 0 110-3.5 1.75 1.75 0 010 3.5zm-1.75-7a1.75 1.75 0 103.5 0 1.75 1.75 0 00-3.5 0z",
    fill: primaryFill
  }));
};

export const MoreVertical20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreVertical20FilledIcon, 'MoreVertical20Filled');

const MoreVertical20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 6a1.25 1.25 0 110-2.5A1.25 1.25 0 0110 6zm0 5.25a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5zm-1.25 4a1.25 1.25 0 102.5 0 1.25 1.25 0 00-2.5 0z",
    fill: primaryFill
  }));
};

export const MoreVertical20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreVertical20RegularIcon, 'MoreVertical20Regular');

const MoreVertical24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 8a2 2 0 110-4 2 2 0 010 4zm0 6a2 2 0 110-4 2 2 0 010 4zm-2 4a2 2 0 104 0 2 2 0 00-4 0z",
    fill: primaryFill
  }));
};

export const MoreVertical24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreVertical24FilledIcon, 'MoreVertical24Filled');

const MoreVertical24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 7.75a1.75 1.75 0 110-3.5 1.75 1.75 0 010 3.5zm0 6a1.75 1.75 0 110-3.5 1.75 1.75 0 010 3.5zM10.25 18a1.75 1.75 0 103.5 0 1.75 1.75 0 00-3.5 0z",
    fill: primaryFill
  }));
};

export const MoreVertical24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreVertical24RegularIcon, 'MoreVertical24Regular');

const MoreVertical28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 8.75a2.75 2.75 0 110-5.5 2.75 2.75 0 010 5.5zm0 8a2.75 2.75 0 110-5.5 2.75 2.75 0 010 5.5zM11.25 22a2.75 2.75 0 105.5 0 2.75 2.75 0 00-5.5 0z",
    fill: primaryFill
  }));
};

export const MoreVertical28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreVertical28FilledIcon, 'MoreVertical28Filled');

const MoreVertical28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 8.25a2.25 2.25 0 110-4.5 2.25 2.25 0 010 4.5zm0 8a2.25 2.25 0 110-4.5 2.25 2.25 0 010 4.5zM11.75 22a2.25 2.25 0 104.5 0 2.25 2.25 0 00-4.5 0z",
    fill: primaryFill
  }));
};

export const MoreVertical28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreVertical28RegularIcon, 'MoreVertical28Regular');

const MoreVertical32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13 7a3 3 0 106 0 3 3 0 00-6 0zm0 9a3 3 0 106 0 3 3 0 00-6 0zm0 9a3 3 0 106 0 3 3 0 00-6 0z",
    fill: primaryFill
  }));
};

export const MoreVertical32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreVertical32FilledIcon, 'MoreVertical32Filled');

const MoreVertical32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5zm0 9a2.5 2.5 0 110-5 2.5 2.5 0 010 5zM13.5 25a2.5 2.5 0 105 0 2.5 2.5 0 00-5 0z",
    fill: primaryFill
  }));
};

export const MoreVertical32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreVertical32RegularIcon, 'MoreVertical32Regular');

const MoreVertical48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M24 16a3.5 3.5 0 110-7 3.5 3.5 0 010 7zm0 11.5a3.5 3.5 0 110-7 3.5 3.5 0 010 7zm-3.5 8a3.5 3.5 0 107 0 3.5 3.5 0 00-7 0z",
    fill: primaryFill
  }));
};

export const MoreVertical48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreVertical48FilledIcon, 'MoreVertical48Filled');

const MoreVertical48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M24 15.75a3.25 3.25 0 110-6.5 3.25 3.25 0 010 6.5zm0 11.5a3.25 3.25 0 110-6.5 3.25 3.25 0 010 6.5zm-3.25 8.25a3.25 3.25 0 106.5 0 3.25 3.25 0 00-6.5 0z",
    fill: primaryFill
  }));
};

export const MoreVertical48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoreVertical48RegularIcon, 'MoreVertical48Regular');

const MoviesAndTv16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.22 4.25L7.09 6.24a.5.5 0 01-.24.08L4.75 7h8.75c.28 0 .5.22.5.5v5a2.5 2.5 0 01-2.5 2.5h-7A2.5 2.5 0 012 12.5v-5c0-.1.03-.2.09-.29l-.2-.6A2.5 2.5 0 013.5 3.46l6.66-2.16a2.5 2.5 0 013.15 1.6l.23.72a.5.5 0 01-.32.63zm-3.75.16l1.29-2.23-.3.07-1.24.4-1.3 2.27 1.55-.5zm2.3-1.98l-.02.04-.85 1.48 1.53-.5-.07-.24a1.5 1.5 0 00-.6-.78zm-3.97.69l-1.56.5-1.3 2.27 1.55-.51 1.3-2.26zM2.92 6.54l.59-.2 1.3-2.26-1 .33a1.5 1.5 0 00-.96 1.9l.07.23z",
    fill: primaryFill
  }));
};

export const MoviesAndTv16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoviesAndTv16FilledIcon, 'MoviesAndTv16Filled');

const MoviesAndTv16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.22 4.25L7.09 6.24a.5.5 0 01-.24.08L4.75 7h8.75c.28 0 .5.22.5.5v5a2.5 2.5 0 01-2.5 2.5h-7A2.5 2.5 0 012 12.5v-5c0-.1.03-.2.09-.29l-.2-.6A2.5 2.5 0 013.5 3.46l6.66-2.16a2.5 2.5 0 013.15 1.6l.23.72a.5.5 0 01-.32.63zm-3.75.16l1.29-2.23-.3.07-1.24.4-1.3 2.27 1.55-.5zm2.3-1.98l-.02.04-.85 1.48 1.53-.5-.07-.24a1.5 1.5 0 00-.6-.78zm-3.97.69l-1.56.5-1.3 2.27 1.55-.51 1.3-2.26zM2.92 6.54l.59-.2 1.3-2.26-1 .33a1.5 1.5 0 00-.96 1.9l.07.23zM3 8v4.5c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5V8H3z",
    fill: primaryFill
  }));
};

export const MoviesAndTv16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoviesAndTv16RegularIcon, 'MoviesAndTv16Regular');

const MoviesAndTv20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.13 5.38L7.03 8h9.47c.28 0 .5.22.5.5v7a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 15.5V8.57l-.26-.9a2.5 2.5 0 011.71-3.09L13.1 2.1a2.5 2.5 0 013.1 1.7l.27.97a.5.5 0 01-.34.62zM3.84 7.88l.6-.17L5.9 5.2l-1.16.33A1.5 1.5 0 003.7 7.4l.14.48zm2-.57l2.11-.61L9.4 4.2l-2.13.61-.02.04-1.42 2.46zm5.62-1.63l1.44-2.5-2.12.62-.03.05L9.34 6.3l2.12-.62zm2.68-2.65c0 .02 0 .03-.02.04l-1.27 2.22 2.52-.73-.14-.48a1.5 1.5 0 00-1.09-1.05z",
    fill: primaryFill
  }));
};

export const MoviesAndTv20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoviesAndTv20FilledIcon, 'MoviesAndTv20Filled');

const MoviesAndTv20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.13 5.38L7.03 8h9.47c.28 0 .5.22.5.5v7a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 15.5V8.57l-.26-.9a2.5 2.5 0 011.71-3.09L13.1 2.1a2.5 2.5 0 013.1 1.7l.27.97a.5.5 0 01-.34.62zM3.84 7.88l.6-.17L5.9 5.2l-1.16.33A1.5 1.5 0 003.7 7.4l.14.48zm2-.57l2.11-.61L9.4 4.2l-2.13.61-.02.04-1.42 2.46zm5.62-1.63l1.44-2.5-2.12.62-.03.05L9.34 6.3l2.12-.62zm2.68-2.65c0 .02 0 .03-.02.04l-1.27 2.22 2.52-.73-.14-.48a1.5 1.5 0 00-1.09-1.05zM4 9v6.5c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V9H4z",
    fill: primaryFill
  }));
};

export const MoviesAndTv20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoviesAndTv20RegularIcon, 'MoviesAndTv20Regular');

const MoviesAndTv24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19.73 3.88l.05.15.55 1.93c.1.36-.08.74-.42.89l-.1.03L9.1 9.96h11.16c.38 0 .7.28.74.65v8.6a2.75 2.75 0 01-2.57 2.74H5.75a2.75 2.75 0 01-2.74-2.57L3 19.2v-8.4L2.48 9c-.4-1.41.36-2.87 1.72-3.35l.16-.06 12.02-3.44c1.4-.4 2.87.36 3.35 1.73zM6.27 6.6l-1.5.43c-.61.17-1 .8-.88 1.42l.03.12.34 1.2.3-.08 1.71-3.1zm4.76-1.37l-2.72.78-1.71 3.1 2.72-.79 1.7-3.09zm4.76-1.36l-2.72.78-1.71 3.09 2.71-.78 1.72-3.1zm1.84-.23l-1.52 2.74 2.57-.74-.34-1.2c-.1-.38-.38-.66-.7-.8z",
    fill: primaryFill
  }));
};

export const MoviesAndTv24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoviesAndTv24FilledIcon, 'MoviesAndTv24Filled');

const MoviesAndTv24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19.73 3.92l.05.16.55 1.92c.1.36-.08.74-.42.9l-.1.03L9.1 10h11.16c.38 0 .7.29.74.65v8.6A2.75 2.75 0 0118.43 22H5.75a2.75 2.75 0 01-2.74-2.58L3 19.25v-8.4l-.52-1.81c-.4-1.4.36-2.87 1.72-3.35l.16-.05 12.02-3.45c1.4-.4 2.87.37 3.35 1.73zm-.23 7.58h-15v7.75c0 .6.43 1.1 1 1.23l.12.01.13.01h12.5c.65 0 1.18-.5 1.24-1.12V11.5zM6.27 6.65l-1.5.43c-.61.18-1 .8-.88 1.42l.03.12.34 1.2.3-.08 1.71-3.1zm4.76-1.36l-2.72.77-1.71 3.1 2.72-.78 1.7-3.1zm4.76-1.37l-2.72.78-1.71 3.1L14.07 7l1.72-3.09zm1.84-.23l-1.52 2.74 2.57-.74-.34-1.2c-.1-.37-.38-.66-.7-.8z",
    fill: primaryFill
  }));
};

export const MoviesAndTv24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MoviesAndTv24RegularIcon, 'MoviesAndTv24Regular');

const Multiplier12X20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.7 8.75a.75.75 0 00.8-.7l.02-.1c.02-.08.06-.19.13-.3.1-.16.34-.4.95-.4.58 0 .86.19 1 .38.16.22.27.61.16 1.24a.78.78 0 01-.4.6c-.2.13-.42.2-.72.31l-.43.17c-.47.18-1.06.45-1.5 1-.47.55-.71 1.3-.71 2.3a.75.75 0 00.75.75h3.75a.75.75 0 000-1.5H9.58c.07-.28.17-.47.28-.6.2-.24.48-.4.9-.56l.27-.1c.34-.12.77-.28 1.12-.5.52-.32.95-.82 1.09-1.61.15-.87.06-1.73-.43-2.38-.5-.69-1.29-1-2.21-1-1.14 0-1.83.5-2.21 1.1A2.53 2.53 0 008 7.92v.01c0 .01-.02.36 0 .01-.03.41.29.77.7.8zm6.58 1.47a.75.75 0 10-1.06 1.06l.72.72-.72.72a.75.75 0 101.06 1.06l.72-.72.72.72a.75.75 0 101.06-1.06l-.72-.72.72-.72a.75.75 0 10-1.06-1.06l-.72.72-.72-.72zM7 13.5a.5.5 0 11-1 0 .5.5 0 011 0zM4.46 6.03c.32.1.54.39.54.72v6.5a.75.75 0 01-1.5 0V8.8c-.24.2-.52.39-.86.6a.75.75 0 01-.78-1.3c.58-.34.9-.61 1.13-.86.22-.24.36-.47.58-.81l.04-.08a.75.75 0 01.85-.32z",
    fill: primaryFill
  }));
};

export const Multiplier12X20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier12X20FilledIcon, 'Multiplier12X20Filled');

const Multiplier12X20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.66 6.03c.2.06.34.26.34.47v7a.5.5 0 01-1 0V7.96a6 6 0 01-1.24.97.5.5 0 01-.52-.86c.94-.56 1.31-1.1 1.64-1.57l.22-.3a.5.5 0 01.56-.17zm4.33 2.06v-.03l.05-.12c.04-.11.1-.25.2-.39.2-.26.55-.55 1.26-.55.64 0 1.04.2 1.27.5.23.3.35.76.24 1.42-.07.38-.26.61-.57.8-.24.16-.52.28-.85.41a22 22 0 00-.43.18c-.5.21-1.05.5-1.47 1A3.27 3.27 0 008 13.5a.5.5 0 00.5.5h4a.5.5 0 100-1H9.03c.07-.49.23-.81.43-1.05.26-.32.64-.52 1.1-.72.1-.05.2-.1.32-.14.36-.14.77-.3 1.1-.52.49-.31.89-.76 1.01-1.49.15-.84.02-1.62-.44-2.2C12.1 6.29 11.36 6 10.5 6a2.44 2.44 0 00-2.47 1.81L8 7.88v.03L8 7.99v-.06a.5.5 0 001 .17zm5.86 2.06a.5.5 0 00-.7.7L15.29 12l-1.14 1.15a.5.5 0 00.7.7L16 12.71l1.15 1.14a.5.5 0 00.7-.7L16.71 12l1.14-1.15a.5.5 0 00-.7-.7L16 11.29l-1.15-1.14zM7 13.5a.5.5 0 11-1 0 .5.5 0 011 0z",
    fill: primaryFill
  }));
};

export const Multiplier12X20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier12X20RegularIcon, 'Multiplier12X20Regular');

const Multiplier12X24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.34 10.49a1 1 0 001.14-.82v-.01l.04-.1c.03-.1.09-.21.18-.33.15-.2.45-.48 1.15-.48.72 0 1.06.22 1.23.42.17.23.31.65.18 1.41a.88.88 0 01-.47.68c-.25.16-.53.25-.9.39l-.55.2c-.6.23-1.35.56-1.93 1.25-.6.7-.91 1.65-.91 2.9a1 1 0 001 1h4.75a1 1 0 100-2h-3.63c.09-.28.2-.47.32-.6.24-.29.59-.48 1.12-.68l.33-.13c.44-.15 1-.35 1.44-.62a2.87 2.87 0 001.4-2.05 3.7 3.7 0 00-.58-2.98c-.66-.83-1.67-1.19-2.8-1.19a3.29 3.29 0 00-3.22 2.14 3.02 3.02 0 00-.11.43v.02s-.04.2 0 0a1 1 0 00.82 1.15zM5.27 6.94A1 1 0 016 7.9V16a1 1 0 01-2 0v-5.33c-.28.23-.6.46-.99.69A1 1 0 012 9.64C3.23 8.9 3.67 8.17 4.07 7.5l.08-.12a1 1 0 011.12-.44zm13.44 5.35a1 1 0 00-1.42 1.42l.8.79-.8.8a1 1 0 001.42 1.4l.79-.79.8.8a1 1 0 001.4-1.42l-.79-.79.8-.8a1 1 0 00-1.42-1.4l-.79.79-.8-.8zM7.75 17a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: primaryFill
  }));
};

export const Multiplier12X24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier12X24FilledIcon, 'Multiplier12X24Filled');

const Multiplier12X24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.45 7.03c.33.09.55.38.55.72v8.5a.75.75 0 01-1.5 0V9.83c-.38.37-.84.75-1.36 1.06a.75.75 0 01-.78-1.28A6.88 6.88 0 004.6 7.37v-.01h.01a.75.75 0 01.84-.33zm4.97 3.22a.75.75 0 00.83-.68l.03-.12c.03-.1.1-.25.2-.38.17-.25.53-.57 1.37-.57.77 0 1.2.24 1.42.52.24.3.38.8.24 1.6-.07.44-.28.7-.61.9a5.7 5.7 0 01-.98.48l-.52.22c-.6.26-1.28.61-1.8 1.26a4.23 4.23 0 00-.85 2.77.75.75 0 00.75.75h4.75a.75.75 0 000-1.5h-3.94c.08-.5.25-.83.45-1.07.29-.36.7-.6 1.24-.84l.37-.15c.43-.18.94-.39 1.35-.66.6-.4 1.1-.98 1.27-1.9.18-1.05.05-2.04-.54-2.79-.6-.75-1.52-1.09-2.6-1.09-1.32 0-2.13.55-2.6 1.18a2.86 2.86 0 00-.5 1.22v.01s-.04.4 0 0c-.04.42.26.8.67.84zm7.86 1.97a.75.75 0 00-1.06 1.06l1.22 1.22-1.22 1.22a.75.75 0 001.06 1.06l1.22-1.22 1.22 1.22a.75.75 0 001.06-1.06l-1.22-1.22 1.22-1.22a.75.75 0 10-1.06-1.06l-1.22 1.22-1.22-1.22zM8.5 16.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
    fill: primaryFill
  }));
};

export const Multiplier12X24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier12X24RegularIcon, 'Multiplier12X24Regular');

const Multiplier12X28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13 10.82v.01a1 1 0 01-2-.14c0 .18 0 0 0 0v-.03a2.42 2.42 0 01.1-.5c.07-.26.22-.63.48-1 .56-.77 1.56-1.41 3.17-1.41 1.34 0 2.55.45 3.36 1.37.82.92 1.11 2.18.88 3.55a3.3 3.3 0 01-1.65 2.37c-.53.32-1.19.55-1.73.75l-.46.17c-.69.27-1.19.53-1.54.93-.21.25-.4.59-.52 1.11H18a1 1 0 110 2h-6a1 1 0 01-1-1 5 5 0 011.1-3.42 5.65 5.65 0 012.32-1.48l.67-.25c.48-.18.87-.32 1.22-.53.4-.23.62-.5.7-.99.16-.88-.05-1.5-.4-1.89-.35-.4-.95-.69-1.86-.69-1.02 0-1.39.36-1.55.58a1.2 1.2 0 00-.2.49zM8.75 20a.75.75 0 100-1.5.75.75 0 000 1.5zm11.54-5.7a1 1 0 011.42 0L23 15.58l1.3-1.3a1 1 0 011.4 1.42L24.42 17l1.3 1.3a1 1 0 01-1.42 1.4L23 18.42l-1.3 1.3a1 1 0 01-1.4-1.42L21.58 17l-1.3-1.3a1 1 0 010-1.4zM7 9a1 1 0 00-1.86-.52v.01a3.37 3.37 0 01-.17.25l-.53.7a8.13 8.13 0 01-1.95 1.7 1 1 0 101.02 1.72A9.18 9.18 0 005 11.73V19a1 1 0 102 0V9zm-1.86-.52z",
    fill: primaryFill
  }));
};

export const Multiplier12X28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier12X28FilledIcon, 'Multiplier12X28Filled');

const Multiplier12X28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.97 8.03c.32.1.53.4.53.72v10.5a.75.75 0 11-1.5 0v-8.3c-.45.47-1.05.95-1.86 1.44a.75.75 0 01-.78-1.28c1.53-.92 2.08-1.75 2.58-2.5.07-.1.13-.2.2-.28a.75.75 0 01.83-.3zm6.52 2.87v-.03l.05-.15c.06-.13.15-.3.3-.49.28-.33.82-.73 1.91-.73.96 0 1.56.31 1.9.75.35.44.53 1.14.36 2.12-.1.58-.39.93-.84 1.22-.38.24-.8.4-1.3.61l-.63.26c-.74.32-1.57.75-2.2 1.5A4.9 4.9 0 0011 19.26a.75.75 0 00.75.75h6a.75.75 0 100-1.5h-5.2c.1-.73.34-1.22.63-1.57.4-.48.96-.8 1.65-1.09l.5-.2c.54-.22 1.15-.47 1.65-.79a3.18 3.18 0 001.5-2.22 4.11 4.11 0 00-.65-3.31C17.13 8.44 16.04 8 14.75 8c-1.53 0-2.5.6-3.06 1.27a3.33 3.33 0 00-.67 1.32v.02a.75.75 0 001.47.29zm8.79 3.32a.75.75 0 10-1.06 1.06L21.94 17l-1.72 1.72a.75.75 0 001.06 1.06L23 18.06l1.72 1.72a.75.75 0 101.06-1.06L24.06 17l1.72-1.72a.75.75 0 00-1.06-1.06L23 15.94l-1.72-1.72zM9.5 19.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
    fill: primaryFill
  }));
};

export const Multiplier12X28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier12X28RegularIcon, 'Multiplier12X28Regular');

const Multiplier12X32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.98 13.75a1.25 1.25 0 001.5-.96c0-.04.03-.1.06-.18.07-.16.18-.38.35-.6.32-.38.88-.83 1.98-.83 1.03 0 1.75.34 2.17.79.4.43.64 1.1.48 2.07-.09.49-.33.78-.83 1.06a9 9 0 01-1.54.61l-.82.28c-.92.33-2.04.8-2.9 1.71A5.62 5.62 0 0012 21.75 1.25 1.25 0 0013.25 23h7.5a1.25 1.25 0 000-2.5h-6.1c.13-.5.35-.83.59-1.08a4.79 4.79 0 011.93-1.08l.57-.19c.7-.23 1.5-.5 2.17-.87a3.88 3.88 0 002.07-2.82 4.8 4.8 0 00-1.11-4.2 5.36 5.36 0 00-4-1.58 4.84 4.84 0 00-4.83 3.55v.02h-.01c0 .01-.08.36 0 .01-.15.67.27 1.34.95 1.5zM10 23a1 1 0 100-2 1 1 0 000 2zm13.37-6.63a1.25 1.25 0 011.76 0l1.37 1.36 1.37-1.36a1.25 1.25 0 111.76 1.76l-1.36 1.37 1.36 1.37a1.25 1.25 0 01-1.76 1.76l-1.37-1.36-1.37 1.36a1.25 1.25 0 01-1.76-1.76l1.36-1.37-1.36-1.37a1.25 1.25 0 010-1.76zM7.2 9.09c.48.19.79.65.79 1.16v11.5a1.25 1.25 0 01-2.5 0v-8.5c-.43.33-.95.68-1.6 1.07a1.25 1.25 0 11-1.3-2.14 11.1 11.1 0 002.02-1.47c.29-.27.48-.49.71-.75l.5-.56c.36-.38.9-.5 1.38-.31z",
    fill: primaryFill
  }));
};

export const Multiplier12X32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier12X32FilledIcon, 'Multiplier12X32Filled');

const Multiplier12X32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.39 12.7v-.04l.07-.2c.06-.17.17-.4.34-.63.31-.42.89-.9 2.07-.9 1.07 0 1.72.35 2.09.81.37.48.58 1.25.39 2.36-.1.62-.42.99-.92 1.31-.42.27-.88.46-1.45.7l-.76.3a6.7 6.7 0 00-2.6 1.78 5.8 5.8 0 00-1.22 3.88 1 1 0 001 1h6.93a1 1 0 100-2h-5.85a3.2 3.2 0 01.68-1.6A4.77 4.77 0 0117 18.25l.56-.23c.63-.25 1.35-.55 1.94-.92a3.8 3.8 0 001.8-2.66 4.89 4.89 0 00-.78-3.93 4.48 4.48 0 00-3.66-1.58 4.37 4.37 0 00-4.44 3.37l-.01.04v.02s-.1.52 0 0a1 1 0 001.96.35zm10.32 3.6a1 1 0 10-1.42 1.4l1.8 1.8-1.8 1.8a1 1 0 001.42 1.4l1.79-1.79 1.8 1.8a1 1 0 101.4-1.42l-1.79-1.79 1.8-1.8a1 1 0 00-1.42-1.4l-1.79 1.79-1.8-1.8zM11 22a1 1 0 11-2 0 1 1 0 012 0zM7.33 9.06A1 1 0 018 10v12a1 1 0 11-2 0v-9.58c-.55.47-1.22.98-1.99 1.44A1 1 0 013 12.14 13.27 13.27 0 006.2 9.4a1 1 0 011.12-.33z",
    fill: primaryFill
  }));
};

export const Multiplier12X32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier12X32RegularIcon, 'Multiplier12X32Regular');

const Multiplier12X48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M20.34 20.24A1.5 1.5 0 0022 18.9a2.68 2.68 0 01.45-1c.35-.49 1.09-1.14 2.8-1.14 1.54 0 2.55.5 3.13 1.19.57.68.9 1.76.64 3.3a2.45 2.45 0 01-1.27 1.81c-.6.37-1.26.62-2.08.93l-1.09.43a9.44 9.44 0 00-3.8 2.48C19.66 28.23 19 30.04 19 32.5a1.5 1.5 0 001.5 1.5h10a1.5 1.5 0 100-3h-8.38c.18-1.01.54-1.68.95-2.16.62-.72 1.5-1.19 2.64-1.65l.78-.3c.91-.35 1.97-.75 2.83-1.29a5.43 5.43 0 002.66-3.85c.38-2.2-.04-4.24-1.31-5.75-1.27-1.5-3.21-2.25-5.42-2.25-2.66 0-4.3 1.1-5.23 2.36a5.67 5.67 0 00-1 2.44v.02l-.01.01c0 .01-.03.3 0 .01a1.5 1.5 0 001.33 1.65zm16.22 4.2a1.5 1.5 0 00-2.12 2.12L36.88 29l-2.44 2.44a1.5 1.5 0 002.12 2.12L39 31.12l2.44 2.44a1.5 1.5 0 002.12-2.12L41.12 29l2.44-2.44a1.5 1.5 0 00-2.12-2.12L39 26.88l-2.44-2.44zM16.5 32.75a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm-5.6-18.7c.65.18 1.1.78 1.1 1.45v17a1.5 1.5 0 11-3 0V19.67a15.4 15.4 0 01-2.73 2.12 1.5 1.5 0 11-1.54-2.58c1.37-.82 2.5-1.94 3.3-2.88a15.94 15.94 0 001.17-1.59l.01-.01a1.5 1.5 0 011.7-.68z",
    fill: primaryFill
  }));
};

export const Multiplier12X48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier12X48FilledIcon, 'Multiplier12X48Filled');

const Multiplier12X48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 15.25a1.25 1.25 0 00-2.32-.64l-.02.03a9.89 9.89 0 01-.34.51c-.23.35-.58.82-1 1.33a9.67 9.67 0 01-3.09 2.63 1.25 1.25 0 001.04 2.28A10.77 10.77 0 009 18.92v13.83a1.25 1.25 0 002.5 0v-17.5zm8.53 4.73c.68.12 1.32-.33 1.45-1l.01-.06.1-.27c.08-.23.24-.55.5-.87.47-.59 1.36-1.28 3.16-1.28 1.6 0 2.6.52 3.17 1.24.58.74.88 1.9.6 3.55a2.81 2.81 0 01-1.41 2.02c-.62.4-1.32.69-2.15 1.02l-1.06.44a9.48 9.48 0 00-3.68 2.5c-1.09 1.3-1.72 3.06-1.72 5.48A1.25 1.25 0 0020.25 34h10a1.25 1.25 0 000-2.5h-8.67a4.94 4.94 0 011.06-2.62c.67-.8 1.6-1.31 2.75-1.8.25-.12.53-.23.82-.35.9-.37 1.92-.78 2.75-1.31a5.3 5.3 0 002.52-3.7c.36-2.12.04-4.07-1.1-5.52-1.16-1.47-2.98-2.2-5.13-2.2-2.58 0-4.18 1.06-5.12 2.22a5.81 5.81 0 00-1.1 2.28v.02h-.01s.14-.78 0 .01c-.12.68.33 1.33 1.01 1.45zm16.1 4.39a1.25 1.25 0 10-1.76 1.76L37.23 29l-2.86 2.87a1.25 1.25 0 001.76 1.76L39 30.77l2.87 2.86a1.25 1.25 0 001.76-1.76L40.77 29l2.86-2.87a1.25 1.25 0 00-1.76-1.76L39 27.23l-2.87-2.86zM16.5 32.75a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0z",
    fill: primaryFill
  }));
};

export const Multiplier12X48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier12X48RegularIcon, 'Multiplier12X48Regular');

const Multiplier15X20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.46 6.03c.32.1.54.39.54.72v6.5a.75.75 0 01-1.5 0V8.81c-.24.19-.52.38-.86.58a.75.75 0 01-.78-1.28c.58-.35.9-.62 1.13-.87.22-.24.36-.47.58-.81l.04-.08a.75.75 0 01.85-.32zM9 6c-.39 0-.71.3-.75.68L8 9.43a.75.75 0 00.85.81l1.37-.18a1.35 1.35 0 11.16 2.69c-.36 0-.72-.15-.97-.4l-.38-.38a.75.75 0 00-1.06 1.06l.38.38a2.86 2.86 0 004.9-2.01 2.85 2.85 0 00-3.23-2.83l-.44.06.1-1.13h2.57a.75.75 0 000-1.5H9zm-2.5 8a.5.5 0 100-1 .5.5 0 000 1zm7.72-3.78c.3-.3.77-.3 1.06 0l.72.72.72-.72a.75.75 0 111.06 1.06l-.72.72.72.72a.75.75 0 11-1.06 1.06l-.72-.72-.72.72a.75.75 0 11-1.06-1.06l.72-.72-.72-.72a.75.75 0 010-1.06z",
    fill: primaryFill
  }));
};

export const Multiplier15X20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier15X20FilledIcon, 'Multiplier15X20Filled');

const Multiplier15X20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.66 6.03c.2.06.34.26.34.47v7a.5.5 0 01-1 0V7.96a6 6 0 01-1.24.97.5.5 0 01-.52-.86c.94-.56 1.31-1.1 1.64-1.57l.22-.3a.5.5 0 01.56-.17zm3.84.43A.5.5 0 019 6h3.5a.5.5 0 010 1H9.46L9.3 8.93l1.28-.15a2.62 2.62 0 11.3 5.22h-.35c-.8 0-1.55-.31-2.1-.87l-.28-.28a.5.5 0 11.7-.7l.28.27c.37.37.87.58 1.4.58h.35a1.62 1.62 0 10-.19-3.23L8.81 10a.5.5 0 01-.56-.54l.25-3zm6.35 3.69a.5.5 0 00-.7.7L15.29 12l-1.14 1.15a.5.5 0 00.7.7L16 12.71l1.15 1.14a.5.5 0 00.7-.7L16.71 12l1.14-1.15a.5.5 0 00-.7-.7L16 11.29l-1.15-1.14zM6.5 14a.5.5 0 100-1 .5.5 0 000 1z",
    fill: primaryFill
  }));
};

export const Multiplier15X20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier15X20RegularIcon, 'Multiplier15X20Regular');

const Multiplier15X24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 7.9a1 1 0 00-1.85-.52l-.08.12c-.4.67-.84 1.4-2.08 2.14A1 1 0 003 11.36c.38-.23.7-.46.99-.69V16a1 1 0 102 0V7.9zm5-.9a1 1 0 00-.99.86l-.5 3.5a1 1 0 001.15 1.13l1.82-.29a1.53 1.53 0 11.24 3.05h-.28a1.8 1.8 0 01-1.2-.45l-.33-.3A1 1 0 109.6 16l.34.3c.7.61 1.59.95 2.51.95h.28a3.53 3.53 0 10-.56-7.03l-.48.08.19-1.3H15a1 1 0 000-2h-4zm7.7 5.3a1 1 0 10-1.4 1.4l.79.8-.8.8a1 1 0 001.42 1.4l.79-.79.8.8a1 1 0 101.4-1.42l-.79-.79.8-.8a1 1 0 00-1.42-1.4l-.79.79-.8-.8zM8.5 16.24a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
    fill: primaryFill
  }));
};

export const Multiplier15X24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier15X24FilledIcon, 'Multiplier15X24Filled');

const Multiplier15X24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.45 7.03c.33.09.55.38.55.72v8.5a.75.75 0 01-1.5 0V9.83c-.38.37-.84.75-1.36 1.06a.75.75 0 01-.78-1.28A6.88 6.88 0 004.6 7.37v-.01h.01a.75.75 0 01.84-.33zm5.3-.03c-.4 0-.72.3-.75.7l-.25 3.75a.75.75 0 00.86.8l2.2-.32a1.92 1.92 0 11.27 3.82h-.36c-.64 0-1.25-.27-1.68-.75l-.23-.25a.75.75 0 10-1.12 1l.24.26a3.78 3.78 0 002.8 1.24h.35a3.42 3.42 0 10-.48-6.8l-1.29.18.14-2.13h3.8a.75.75 0 100-1.5h-4.5zm7.53 5.22a.75.75 0 00-1.06 1.06l1.22 1.22-1.22 1.22a.75.75 0 101.06 1.06l1.22-1.22 1.22 1.22a.75.75 0 001.06-1.06l-1.22-1.22 1.22-1.22a.75.75 0 10-1.06-1.06l-1.22 1.22-1.22-1.22zM8.5 16.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
    fill: primaryFill
  }));
};

export const Multiplier15X24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier15X24RegularIcon, 'Multiplier15X24Regular');

const Multiplier15X28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 9a1 1 0 00-1.86-.52v.01a3.45 3.45 0 01-.17.25 8.13 8.13 0 01-2.49 2.4 1 1 0 001.03 1.72A9.18 9.18 0 005 11.73V19a1 1 0 102 0V9zm4.5-.12a1 1 0 011-.88h5a1 1 0 110 2h-4.11l-.25 2.1 1.44-.17a4.17 4.17 0 11.5 8.32h-.37c-1.2 0-2.35-.48-3.2-1.33l-.72-.71a1 1 0 111.42-1.42l.71.72c.48.47 1.12.74 1.8.74h.36a2.17 2.17 0 10-.26-4.33l-2.7.32a1 1 0 01-1.11-1.1l.5-4.26zm10.2 5.41a1 1 0 00-1.4 1.42L21.58 17l-1.3 1.3a1 1 0 001.42 1.4L23 18.42l1.3 1.3a1 1 0 001.4-1.42L24.42 17l1.3-1.3a1 1 0 00-1.42-1.4L23 15.58l-1.3-1.3zM8.76 20a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: primaryFill
  }));
};

export const Multiplier15X28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier15X28FilledIcon, 'Multiplier15X28Filled');

const Multiplier15X28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.97 8.03c.32.1.53.4.53.72v10.5a.75.75 0 01-1.5 0v-8.3c-.45.47-1.05.95-1.86 1.44a.75.75 0 01-.78-1.28c1.53-.92 2.08-1.75 2.58-2.5.07-.1.13-.2.2-.28a.75.75 0 01.83-.3zm5.78.68c.02-.4.35-.71.75-.71h5.25a.75.75 0 010 1.5h-4.54l-.16 2.9 1.68-.2a4.04 4.04 0 11.48 8.05h-.3a4.35 4.35 0 01-3.3-1.52l-.43-.5a.75.75 0 111.14-.97l.42.5c.54.63 1.33.99 2.16.99h.3a2.54 2.54 0 10-.3-5.06l-2.56.3a.75.75 0 01-.84-.78l.25-4.5zm9.53 5.51a.75.75 0 10-1.06 1.06L21.94 17l-1.72 1.72a.75.75 0 101.06 1.06L23 18.06l1.72 1.72a.75.75 0 101.06-1.06L24.06 17l1.72-1.72a.75.75 0 00-1.06-1.06L23 15.94l-1.72-1.72zM8.75 20a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: primaryFill
  }));
};

export const Multiplier15X28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier15X28RegularIcon, 'Multiplier15X28Regular');

const Multiplier15X32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.2 9.09c.49.19.8.65.8 1.16v11.5a1.25 1.25 0 11-2.5 0v-8.5c-.43.32-.95.68-1.6 1.07a1.25 1.25 0 01-1.3-2.14c1.03-.61 1.6-1.07 2.02-1.47.29-.27.48-.49.71-.75l.5-.56c.36-.38.9-.5 1.38-.31zM14.26 9c-.64 0-1.18.49-1.24 1.13l-.5 5a1.25 1.25 0 001.41 1.36l2.9-.41a2.35 2.35 0 11.33 4.67h-.43c-.7 0-1.38-.27-1.9-.74l-.72-.68a1.25 1.25 0 10-1.7 1.84l.72.67c.98.9 2.26 1.41 3.6 1.41h.43a4.85 4.85 0 10-.67-9.65l-1.33.2.23-2.3h4.87a1.25 1.25 0 100-2.5h-6zm10.88 7.37a1.25 1.25 0 00-1.76 1.76l1.36 1.37-1.36 1.37a1.25 1.25 0 001.76 1.76l1.37-1.36 1.37 1.36a1.25 1.25 0 001.76-1.76l-1.36-1.37 1.36-1.37a1.25 1.25 0 00-1.76-1.76l-1.37 1.36-1.37-1.36zM11 22a1 1 0 11-2 0 1 1 0 012 0z",
    fill: primaryFill
  }));
};

export const Multiplier15X32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier15X32FilledIcon, 'Multiplier15X32Filled');

const Multiplier15X32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.25 9a1 1 0 00-1 .9l-.5 5.26a1 1 0 001.13 1.08l3.28-.43a2.73 2.73 0 11.36 5.44h-.53c-.9 0-1.77-.38-2.39-1.04l-.37-.4a1 1 0 00-1.46 1.37l.37.4a5.26 5.26 0 003.85 1.67h.53a4.73 4.73 0 10-.62-9.42l-2.04.27.3-3.1h5.34a1 1 0 100-2h-6.25zm10.46 7.3a1 1 0 00-1.42 1.4l1.8 1.8-1.8 1.8a1 1 0 001.42 1.4l1.79-1.79 1.8 1.8a1 1 0 101.4-1.42l-1.79-1.79 1.8-1.8a1 1 0 00-1.42-1.4l-1.79 1.79-1.8-1.8zM11 22a1 1 0 11-2 0 1 1 0 012 0zM7.33 9.05A1 1 0 018 10v12a1 1 0 11-2 0v-9.58c-.55.47-1.22.98-1.99 1.44A1 1 0 113 12.14 13.27 13.27 0 006.2 9.4a1 1 0 011.12-.34z",
    fill: primaryFill
  }));
};

export const Multiplier15X32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier15X32RegularIcon, 'Multiplier15X32Regular');

const Multiplier15X48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.9 14.05c.65.18 1.1.78 1.1 1.45v17a1.5 1.5 0 11-3 0V19.67a15.4 15.4 0 01-2.73 2.12 1.5 1.5 0 01-1.54-2.58c1.37-.82 2.5-1.94 3.3-2.88a15.94 15.94 0 001.17-1.59l.01-.01a1.5 1.5 0 011.7-.68zM21 14a1.5 1.5 0 00-1.48 1.29l-1 7a1.5 1.5 0 001.62 1.7l5.01-.45a3.99 3.99 0 11.36 7.96h-.92c-1.26 0-2.47-.5-3.36-1.4l-.67-.66a1.5 1.5 0 00-2.12 2.12l.67.67a7.75 7.75 0 005.48 2.27h.92a6.99 6.99 0 10-.63-13.95l-3.13.28.55-3.83H30a1.5 1.5 0 000-3h-9zm15.56 10.44a1.5 1.5 0 00-2.12 2.12L36.88 29l-2.44 2.44a1.5 1.5 0 002.12 2.12L39 31.12l2.44 2.44a1.5 1.5 0 002.12-2.12L41.12 29l2.44-2.44a1.5 1.5 0 00-2.12-2.12L39 26.88l-2.44-2.44zM16.5 32.75a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0z",
    fill: primaryFill
  }));
};

export const Multiplier15X48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier15X48FilledIcon, 'Multiplier15X48Filled');

const Multiplier15X48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 15.25a1.25 1.25 0 00-2.32-.64l-.02.03a9.89 9.89 0 01-.34.51c-.23.35-.58.82-1 1.33a9.67 9.67 0 01-3.09 2.63 1.25 1.25 0 001.04 2.28A10.77 10.77 0 009 18.92v13.83a1.25 1.25 0 002.5 0v-17.5zm10-1.25c-.64 0-1.18.49-1.24 1.13l-.75 7.5a1.25 1.25 0 001.39 1.36l4.45-.53a4.16 4.16 0 11.5 8.29h-.5c-1.3 0-2.55-.55-3.43-1.52l-.74-.82a1.25 1.25 0 10-1.85 1.68l.74.82a7.14 7.14 0 005.29 2.34h.48a6.66 6.66 0 10-.79-13.27l-2.9.34.48-4.82h7.62a1.25 1.25 0 000-2.5H21.5zm14.63 10.37a1.25 1.25 0 10-1.76 1.76L37.23 29l-2.86 2.87a1.25 1.25 0 001.76 1.76L39 30.77l2.87 2.86a1.25 1.25 0 001.76-1.76L40.77 29l2.86-2.87a1.25 1.25 0 00-1.76-1.76L39 27.23l-2.87-2.86zM16.5 32.75a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0z",
    fill: primaryFill
  }));
};

export const Multiplier15X48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier15X48RegularIcon, 'Multiplier15X48Regular');

const Multiplier18X20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.46 6.03c.32.1.54.39.54.72v6.5a.75.75 0 01-1.5 0V8.81c-.24.19-.52.38-.86.58a.75.75 0 01-.78-1.28c.58-.35.9-.62 1.13-.87.22-.24.36-.47.58-.81l.04-.08a.75.75 0 01.85-.32zm8.79 2.22c0 .58-.23 1.07-.59 1.45.51.44.84 1.07.84 1.8 0 1.47-1.33 2.5-2.75 2.5S8 12.97 8 11.5c0-.73.33-1.36.84-1.8a2.08 2.08 0 01-.59-1.45C8.25 6.9 9.48 6 10.75 6s2.5.9 2.5 2.25zm-2.5-.75c-.66 0-1 .44-1 .75s.34.75 1 .75c.66 0 1-.44 1-.75s-.34-.75-1-.75zm-1.25 4c0 .46.46 1 1.25 1s1.25-.54 1.25-1c0-.46-.46-1-1.25-1s-1.25.54-1.25 1zm4.72-1.28c.3-.3.77-.3 1.06 0l.72.72.72-.72a.75.75 0 111.06 1.06l-.72.72.72.72a.75.75 0 11-1.06 1.06l-.72-.72-.72.72a.75.75 0 11-1.06-1.06l.72-.72-.72-.72a.75.75 0 010-1.06zM7 13.5a.5.5 0 11-1 0 .5.5 0 011 0z",
    fill: primaryFill
  }));
};

export const Multiplier18X20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier18X20FilledIcon, 'Multiplier18X20Filled');

const Multiplier18X20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.66 6.03c.2.06.34.26.34.47v7a.5.5 0 01-1 0V7.96a6 6 0 01-1.24.97.5.5 0 01-.52-.86c.94-.56 1.31-1.1 1.64-1.57l.22-.3a.5.5 0 01.56-.17zM13 8c0 .59-.27 1.09-.69 1.44.7.44 1.19 1.18 1.19 2.06 0 1.43-1.29 2.5-2.75 2.5S8 12.93 8 11.5c0-.88.48-1.62 1.19-2.06A1.87 1.87 0 018.5 8c0-1.17 1.08-2 2.25-2S13 6.83 13 8zm-2.25-1c-.77 0-1.25.52-1.25 1s.48 1 1.25 1S12 8.48 12 8s-.48-1-1.25-1zM9 11.5c0 .77.73 1.5 1.75 1.5s1.75-.73 1.75-1.5-.73-1.5-1.75-1.5S9 10.73 9 11.5zm5.15-1.35c.2-.2.5-.2.7 0L16 11.29l1.15-1.14a.5.5 0 01.7.7L16.71 12l1.14 1.15a.5.5 0 01-.7.7L16 12.71l-1.15 1.14a.5.5 0 01-.7-.7L15.29 12l-1.14-1.15a.5.5 0 010-.7zM7 13.5a.5.5 0 11-1 0 .5.5 0 011 0z",
    fill: primaryFill
  }));
};

export const Multiplier18X20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier18X20RegularIcon, 'Multiplier18X20Regular');

const Multiplier18X24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 9.5c0 .66-.24 1.23-.62 1.68A3.5 3.5 0 0113 17.25a3.5 3.5 0 01-2.38-6.07A2.56 2.56 0 0110 9.5c0-1.64 1.47-2.75 3-2.75s3 1.11 3 2.75zm-3-.75c-.68 0-1 .46-1 .75 0 .3.32.75 1 .75.68 0 1-.46 1-.75 0-.3-.32-.75-1-.75zm-1.5 5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zM7.75 17a.75.75 0 100-1.5.75.75 0 000 1.5zm9.54-4.7a1 1 0 011.42 0l.79.79.8-.8a1 1 0 011.4 1.42l-.79.79.8.8a1 1 0 01-1.42 1.4l-.79-.79-.8.8a1 1 0 01-1.4-1.42l.79-.79-.8-.8a1 1 0 010-1.4zM6 7.9a1 1 0 00-1.85-.52l-.08.12c-.4.67-.84 1.4-2.08 2.14A1 1 0 103 11.36c.38-.23.7-.46.99-.69V16a1 1 0 002 0V7.9z",
    fill: primaryFill
  }));
};

export const Multiplier18X24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier18X24FilledIcon, 'Multiplier18X24Filled');

const Multiplier18X24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 9.5a2.6 2.6 0 01-.86 1.93c.82.58 1.36 1.5 1.36 2.57 0 1.86-1.64 3.25-3.5 3.25S9.5 15.86 9.5 14c0-1.07.54-1.99 1.36-2.57A2.6 2.6 0 0110 9.5c0-1.6 1.43-2.75 3-2.75s3 1.15 3 2.75zm-3-1.25c-.91 0-1.5.64-1.5 1.25s.59 1.25 1.5 1.25 1.5-.64 1.5-1.25-.59-1.25-1.5-1.25zM11 14c0 .9.83 1.75 2 1.75s2-.85 2-1.75-.83-1.75-2-1.75-2 .85-2 1.75zm7.28-1.78a.75.75 0 00-1.06 1.06l1.22 1.22-1.22 1.22a.75.75 0 101.06 1.06l1.22-1.22 1.22 1.22a.75.75 0 001.06-1.06l-1.22-1.22 1.22-1.22a.75.75 0 10-1.06-1.06l-1.22 1.22-1.22-1.22zM8.5 16.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM5.45 7.03c.33.09.55.38.55.72v8.5a.75.75 0 01-1.5 0V9.83c-.38.37-.84.75-1.36 1.06a.75.75 0 01-.78-1.28A6.88 6.88 0 004.6 7.37v-.01h.01a.75.75 0 01.84-.33z",
    fill: primaryFill
  }));
};

export const Multiplier18X24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier18X24RegularIcon, 'Multiplier18X24Regular');

const Multiplier18X28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.25 7.75c-1.82 0-3.75 1.17-3.75 3.13 0 .81.34 1.5.87 2.01A3.83 3.83 0 0010.75 16c0 2.32 2.07 4 4.38 4 2.3 0 4.37-1.68 4.37-4 0-1.23-.59-2.29-1.48-3 .59-.53.98-1.25.98-2.13 0-1.95-1.93-3.12-3.75-3.12zm-1.75 3.13c0-.4.53-1.13 1.75-1.13s1.75.73 1.75 1.13c0 .4-.53 1.12-1.75 1.12s-1.75-.73-1.75-1.13zM15.13 14c1.42 0 2.37 1 2.37 2s-.95 2-2.38 2c-1.42 0-2.37-1-2.37-2s.95-2 2.38-2zm6.58.3a1 1 0 00-1.42 1.4l1.3 1.3-1.3 1.3a1 1 0 001.42 1.4L23 18.42l1.3 1.3a1 1 0 001.4-1.42L24.42 17l1.3-1.3a1 1 0 00-1.42-1.4L23 15.58l-1.3-1.3zM8.75 20a.75.75 0 100-1.5.75.75 0 000 1.5zm-6.6-7.49a1 1 0 01.34-1.37A8.13 8.13 0 005.14 8.5 1 1 0 017 9v10a1 1 0 01-2 0v-7.27c-.43.4-.92.79-1.49 1.13a1 1 0 01-1.37-.35zm3-4.03z",
    fill: primaryFill
  }));
};

export const Multiplier18X28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier18X28FilledIcon, 'Multiplier18X28Filled');

const Multiplier18X28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.97 8.03c.32.1.53.4.53.72v10.5a.75.75 0 01-1.5 0v-8.3c-.45.47-1.05.95-1.86 1.44a.75.75 0 01-.78-1.28c1.53-.92 2.08-1.75 2.58-2.5.07-.1.13-.2.2-.28a.75.75 0 01.83-.3zM18.5 11a2.8 2.8 0 01-1.05 2.18 3.8 3.8 0 011.8 3.2c0 2.19-1.9 3.87-4.13 3.87-2.22 0-4.12-1.68-4.12-3.88a3.8 3.8 0 011.8-3.2A2.8 2.8 0 0111.75 11c0-1.76 1.62-3 3.38-3 1.75 0 3.37 1.24 3.37 3zm-3.38-1.5c-1.14 0-1.87.78-1.87 1.5s.73 1.5 1.88 1.5c1.14 0 1.87-.78 1.87-1.5s-.73-1.5-1.88-1.5zm-2.62 6.88c0 1.25 1.12 2.37 2.63 2.37 1.5 0 2.62-1.12 2.62-2.38 0-1.25-1.12-2.37-2.63-2.37-1.5 0-2.62 1.12-2.62 2.38zm7.72-2.16c.3-.3.77-.3 1.06 0L23 15.94l1.72-1.72a.75.75 0 111.06 1.06L24.06 17l1.72 1.72a.75.75 0 11-1.06 1.06L23 18.06l-1.72 1.72a.75.75 0 11-1.06-1.06L21.94 17l-1.72-1.72a.75.75 0 010-1.06zM9.5 19.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
    fill: primaryFill
  }));
};

export const Multiplier18X28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier18X28RegularIcon, 'Multiplier18X28Regular');

const Multiplier18X32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.75 12.63c0-2.3 2.1-3.88 4.28-3.88 2.2 0 4.29 1.57 4.29 3.88 0 1-.4 1.86-1.03 2.52A4.43 4.43 0 0122 18.62c0 2.68-2.37 4.63-5 4.63s-5-1.95-5-4.63c0-1.44.7-2.68 1.74-3.5a3.6 3.6 0 01-.99-2.5zm4.28-1.38c-1.16 0-1.78.78-1.78 1.38 0 .6.62 1.37 1.78 1.37 1.16 0 1.79-.78 1.79-1.38 0-.6-.63-1.37-1.79-1.37zM17 16.5c-1.5 0-2.5 1.07-2.5 2.13 0 1.05 1 2.12 2.5 2.12s2.5-1.07 2.5-2.13c0-1.05-1-2.12-2.5-2.12zm8.13-.13a1.25 1.25 0 00-1.76 1.76l1.36 1.37-1.36 1.37a1.25 1.25 0 001.76 1.76l1.37-1.36 1.37 1.36a1.25 1.25 0 001.76-1.76l-1.36-1.37 1.36-1.37a1.25 1.25 0 00-1.76-1.76l-1.37 1.36-1.37-1.36zM11 22a1 1 0 11-2 0 1 1 0 012 0zM7.2 9.09c.49.19.8.65.8 1.16v11.5a1.25 1.25 0 11-2.5 0v-8.5c-.43.32-.95.68-1.6 1.07a1.25 1.25 0 01-1.3-2.14 11.1 11.1 0 002.02-1.47c.29-.27.48-.5.71-.75l.5-.56c.36-.38.9-.5 1.38-.31z",
    fill: primaryFill
  }));
};

export const Multiplier18X32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier18X32FilledIcon, 'Multiplier18X32Filled');

const Multiplier18X32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13 12.68c0-2.16 1.9-3.75 4.03-3.75 2.14 0 4.04 1.6 4.04 3.75 0 1.06-.45 1.97-1.16 2.64A4.18 4.18 0 0122 18.88c0 2.56-2.4 4.37-5 4.37s-5-1.8-5-4.37c0-1.55.87-2.82 2.13-3.59A3.57 3.57 0 0113 12.7zm4.03-1.75c-1.21 0-2.03.88-2.03 1.75 0 .88.82 1.75 2.03 1.75 1.22 0 2.04-.87 2.04-1.75 0-.87-.82-1.75-2.04-1.75zM17 16.5c-1.82 0-3 1.22-3 2.38 0 1.15 1.18 2.37 3 2.37s3-1.22 3-2.37c0-1.16-1.18-2.38-3-2.38zm7.7-.2a1 1 0 00-1.4 1.4l1.79 1.8-1.8 1.8a1 1 0 001.42 1.4l1.79-1.79 1.8 1.8a1 1 0 001.4-1.42l-1.79-1.79 1.8-1.8a1 1 0 00-1.42-1.4l-1.79 1.79-1.8-1.8zM11 22a1 1 0 11-2 0 1 1 0 012 0zM7.33 9.06A1 1 0 018 10v12a1 1 0 11-2 0v-9.58c-.55.47-1.22.98-1.99 1.44A1 1 0 013 12.14 13.27 13.27 0 006.2 9.4a1 1 0 011.12-.33z",
    fill: primaryFill
  }));
};

export const Multiplier18X32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier18X32RegularIcon, 'Multiplier18X32Regular');

const Multiplier18X48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M31 19c0 1.48-.66 2.73-1.67 3.64A6.28 6.28 0 0132 27.75c0 3.72-3.27 6.5-7 6.5s-7-2.78-7-6.5a6.28 6.28 0 012.67-5.1A4.83 4.83 0 0119 19c0-3.14 2.95-5.25 6-5.25s6 2.1 6 5.25zm-6-2.25c-1.92 0-3 1.25-3 2.25s1.08 2.25 3 2.25S28 20 28 19s-1.08-2.25-3-2.25zm-4 11c0 1.8 1.65 3.5 4 3.5s4-1.7 4-3.5-1.65-3.5-4-3.5-4 1.7-4 3.5zm15.56-3.31a1.5 1.5 0 00-2.12 2.12L36.88 29l-2.44 2.44a1.5 1.5 0 002.12 2.12L39 31.12l2.44 2.44a1.5 1.5 0 002.12-2.12L41.12 29l2.44-2.44a1.5 1.5 0 00-2.12-2.12L39 26.88l-2.44-2.44zM16.5 32.75a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm-5.6-18.7c.65.18 1.1.78 1.1 1.45v17a1.5 1.5 0 11-3 0V19.67a15.4 15.4 0 01-2.73 2.12 1.5 1.5 0 11-1.54-2.58c1.37-.82 2.5-1.94 3.3-2.88a15.94 15.94 0 001.17-1.59l.01-.01a1.5 1.5 0 011.7-.68z",
    fill: primaryFill
  }));
};

export const Multiplier18X48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier18X48FilledIcon, 'Multiplier18X48Filled');

const Multiplier18X48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M30.5 18.88c0 1.5-.7 2.81-1.76 3.72a6.22 6.22 0 013.01 5.27c0 3.63-3.19 6.38-6.87 6.38-3.69 0-6.88-2.75-6.88-6.38a6.22 6.22 0 013.01-5.27 4.86 4.86 0 01-1.76-3.73c0-2.96 2.67-5.12 5.63-5.12 2.95 0 5.62 2.16 5.62 5.13zm-5.62-2.63c-1.88 0-3.13 1.31-3.13 2.63 0 1.3 1.25 2.62 3.13 2.62 1.87 0 3.12-1.31 3.12-2.63 0-1.3-1.25-2.62-3.12-2.62zM20.5 27.88c0 2.03 1.85 3.87 4.38 3.87 2.52 0 4.37-1.84 4.37-3.88 0-2.03-1.85-3.87-4.37-3.87-2.53 0-4.38 1.84-4.38 3.88zm15.63-3.51a1.25 1.25 0 00-1.76 1.76L37.23 29l-2.86 2.87a1.25 1.25 0 001.76 1.76L39 30.77l2.87 2.86a1.25 1.25 0 001.76-1.76L40.77 29l2.86-2.87a1.25 1.25 0 00-1.76-1.76L39 27.23l-2.87-2.86zM16.5 32.75a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm-5-17.5a1.25 1.25 0 00-2.32-.64l-.02.03a9.15 9.15 0 01-.34.51c-.23.35-.58.82-1 1.33a9.67 9.67 0 01-3.09 2.63 1.25 1.25 0 001.04 2.28A10.77 10.77 0 009 18.92v13.83a1.25 1.25 0 002.5 0v-17.5z",
    fill: primaryFill
  }));
};

export const Multiplier18X48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier18X48RegularIcon, 'Multiplier18X48Regular');

const Multiplier1X20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 6.75a.75.75 0 00-1.39-.4l-.04.08a5.3 5.3 0 01-.58.8 4.8 4.8 0 01-1.13.88.75.75 0 10.78 1.28c.34-.2.62-.4.86-.58v4.44a.75.75 0 001.5 0v-6.5zm2.78 3.47a.75.75 0 10-1.06 1.06l.72.72-.72.72a.75.75 0 101.06 1.06l.72-.72.72.72a.75.75 0 101.06-1.06l-.72-.72.72-.72a.75.75 0 00-1.06-1.06l-.72.72-.72-.72z",
    fill: primaryFill
  }));
};

export const Multiplier1X20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier1X20FilledIcon, 'Multiplier1X20Filled');

const Multiplier1X20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 6.5a.5.5 0 00-.9-.3l-.22.3c-.33.48-.7 1-1.64 1.57a.5.5 0 10.52.86A6 6 0 007 7.96v5.54a.5.5 0 101 0v-7zm2.85 3.65a.5.5 0 00-.7.7L11.29 12l-1.14 1.15a.5.5 0 00.7.7L12 12.71l1.15 1.14a.5.5 0 00.7-.7L12.71 12l1.14-1.15a.5.5 0 00-.7-.7L12 11.29l-1.15-1.14z",
    fill: primaryFill
  }));
};

export const Multiplier1X20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier1X20RegularIcon, 'Multiplier1X20Regular');

const Multiplier1X24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 7.9a1 1 0 00-1.85-.52l-.08.12c-.4.67-.84 1.4-2.08 2.14A1 1 0 007 11.36c.38-.23.7-.46.99-.69V16a1 1 0 102 0V7.9zm3.7 4.4a1 1 0 10-1.4 1.4l.79.8-.8.8a1 1 0 001.42 1.4l.79-.78.8.79a1 1 0 101.4-1.42l-.79-.79.8-.8a1 1 0 00-1.42-1.4l-.79.79-.8-.8z",
    fill: primaryFill
  }));
};

export const Multiplier1X24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier1X24FilledIcon, 'Multiplier1X24Filled');

const Multiplier1X24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 7.75a.75.75 0 00-1.39-.4v.01a3.07 3.07 0 01-.15.22 6.88 6.88 0 01-2.1 2.03.75.75 0 10.78 1.28c.52-.31.98-.69 1.36-1.06v6.42a.75.75 0 001.5 0v-8.5zm3.28 4.47a.75.75 0 00-1.06 1.06l1.22 1.22-1.22 1.22a.75.75 0 101.06 1.06l1.22-1.22 1.22 1.22a.75.75 0 001.06-1.06l-1.22-1.22 1.22-1.22a.75.75 0 10-1.06-1.06l-1.22 1.22-1.22-1.22z",
    fill: primaryFill
  }));
};

export const Multiplier1X24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier1X24RegularIcon, 'Multiplier1X24Regular');

const Multiplier1X28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 9a1 1 0 00-1.86-.52v.01a2.97 2.97 0 01-.17.25 8.13 8.13 0 01-2.49 2.4 1 1 0 001.03 1.72A9.18 9.18 0 0010 11.73V19a1 1 0 102 0V9zm3.7 5.3a1 1 0 00-1.4 1.4l1.29 1.3-1.3 1.3a1 1 0 001.42 1.4L17 18.42l1.3 1.3a1 1 0 001.4-1.42L18.42 17l1.3-1.3a1 1 0 00-1.42-1.4L17 15.58l-1.3-1.3z",
    fill: primaryFill
  }));
};

export const Multiplier1X28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier1X28FilledIcon, 'Multiplier1X28Filled');

const Multiplier1X28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.5 8.75a.75.75 0 00-1.37-.42l-.19.28c-.5.75-1.05 1.58-2.58 2.5a.75.75 0 10.78 1.28c.81-.49 1.4-.97 1.86-1.43v8.29a.75.75 0 101.5 0V8.75zm3.78 5.47a.75.75 0 10-1.06 1.06L15.94 17l-1.72 1.72a.75.75 0 001.06 1.06L17 18.06l1.72 1.72a.75.75 0 101.06-1.06L18.06 17l1.72-1.72a.75.75 0 00-1.06-1.06L17 15.94l-1.72-1.72z",
    fill: primaryFill
  }));
};

export const Multiplier1X28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier1X28RegularIcon, 'Multiplier1X28Regular');

const Multiplier1X32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.5 10.25a1.25 1.25 0 00-2.16-.85l-.51.56c-.23.26-.42.48-.7.75-.42.4-1 .86-2.02 1.47a1.25 1.25 0 101.28 2.14c.66-.4 1.18-.75 1.61-1.08v8.51a1.25 1.25 0 102.5 0v-11.5zm4.63 6.12a1.25 1.25 0 00-1.76 1.76l1.36 1.37-1.36 1.37a1.25 1.25 0 001.76 1.76l1.37-1.36 1.37 1.36a1.25 1.25 0 001.76-1.76l-1.36-1.37 1.36-1.37a1.25 1.25 0 00-1.76-1.76l-1.37 1.36-1.37-1.36z",
    fill: primaryFill
  }));
};

export const Multiplier1X32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier1X32FilledIcon, 'Multiplier1X32Filled');

const Multiplier1X32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13 10a1 1 0 00-1.79-.62v.01a4.52 4.52 0 01-.2.23 13.26 13.26 0 01-3.02 2.52A1 1 0 009 13.86c.77-.46 1.44-.97 1.99-1.44V22a1 1 0 102 0V10zm4.7 6.3a1 1 0 00-1.4 1.4l1.79 1.8-1.8 1.8a1 1 0 001.42 1.4l1.79-1.79 1.8 1.8a1 1 0 001.4-1.42l-1.79-1.79 1.8-1.8a1 1 0 00-1.42-1.4l-1.79 1.79-1.8-1.8z",
    fill: primaryFill
  }));
};

export const Multiplier1X32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier1X32RegularIcon, 'Multiplier1X32Regular');

const Multiplier1X48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M20 15.5a1.5 1.5 0 00-2.78-.77l-.02.01a8.11 8.11 0 01-.27.42c-.2.29-.5.7-.9 1.17-.8.94-1.93 2.06-3.3 2.88a1.5 1.5 0 101.54 2.58A15.4 15.4 0 0017 19.67V32.5a1.5 1.5 0 003 0v-17zm6.56 8.94a1.5 1.5 0 00-2.12 2.12L26.88 29l-2.44 2.44a1.5 1.5 0 002.12 2.12L29 31.12l2.44 2.44a1.5 1.5 0 002.12-2.12L31.12 29l2.44-2.44a1.5 1.5 0 00-2.12-2.12L29 26.88l-2.44-2.44z",
    fill: primaryFill
  }));
};

export const Multiplier1X48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier1X48FilledIcon, 'Multiplier1X48Filled');

const Multiplier1X48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19.5 15.25a1.25 1.25 0 00-2.32-.64l-.02.03a10.19 10.19 0 01-.34.51c-.23.35-.58.82-1 1.33a9.67 9.67 0 01-3.09 2.63 1.25 1.25 0 001.04 2.28A10.77 10.77 0 0017 18.92v13.83a1.25 1.25 0 002.5 0v-17.5zm6.63 9.12a1.25 1.25 0 10-1.76 1.76L27.23 29l-2.86 2.87a1.25 1.25 0 001.76 1.76L29 30.77l2.87 2.86a1.25 1.25 0 001.76-1.76L30.77 29l2.86-2.87a1.25 1.25 0 00-1.76-1.76L29 27.23l-2.87-2.86z",
    fill: primaryFill
  }));
};

export const Multiplier1X48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier1X48RegularIcon, 'Multiplier1X48Regular');

const Multiplier2X20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.7 8.75a.75.75 0 00.8-.7l.02-.1c.02-.08.06-.19.13-.3.1-.16.34-.4.95-.4.58 0 .86.19 1 .38.16.22.27.61.16 1.24a.78.78 0 01-.4.6c-.2.13-.42.2-.72.31l-.43.17c-.47.18-1.06.45-1.5 1-.46.55-.7 1.3-.7 2.3a.75.75 0 00.74.75H9.5a.75.75 0 000-1.5H6.58c.07-.28.17-.47.28-.6.2-.24.48-.4.9-.56l.27-.1c.34-.12.77-.28 1.12-.5.52-.32.95-.82 1.09-1.61a3.1 3.1 0 00-.42-2.38c-.5-.69-1.3-1-2.22-1-1.13 0-1.83.5-2.2 1.1A2.53 2.53 0 005 7.92v.02c-.02.41.29.77.7.8zm6.58 1.47a.75.75 0 10-1.06 1.06l.72.72-.72.72a.75.75 0 001.06 1.06l.72-.72.72.72a.75.75 0 101.06-1.06l-.72-.72.72-.72a.75.75 0 00-1.06-1.06l-.72.72-.72-.72z",
    fill: primaryFill
  }));
};

export const Multiplier2X20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier2X20FilledIcon, 'Multiplier2X20Filled');

const Multiplier2X20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 8.09l.01-.03.04-.12c.04-.11.1-.25.2-.39.2-.26.56-.55 1.26-.55.64 0 1.04.2 1.26.5.24.3.36.76.25 1.42-.07.38-.26.61-.57.8-.24.16-.52.28-.85.41l-.43.18c-.5.21-1.05.5-1.47 1a3.27 3.27 0 00-.69 2.19.5.5 0 00.5.5h4a.5.5 0 000-1H6.04c.07-.49.23-.81.43-1.05.26-.32.64-.52 1.1-.72.1-.05.2-.1.32-.14.36-.14.77-.3 1.1-.52.48-.31.89-.76 1.01-1.49.14-.84.02-1.62-.44-2.2C9.1 6.29 8.37 6 7.5 6a2.44 2.44 0 00-2.48 1.88v.03h-.01c0 .03-.04.27 0 0A.5.5 0 006 8.1zm5.86 2.06a.5.5 0 10-.7.7L12.3 12l-1.15 1.15a.5.5 0 00.7.7L13 12.71l1.15 1.14a.5.5 0 10.7-.7L13.71 12l1.14-1.15a.5.5 0 00-.7-.7L13 11.29l-1.14-1.14z",
    fill: primaryFill
  }));
};

export const Multiplier2X20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier2X20RegularIcon, 'Multiplier2X20Regular');

const Multiplier2X24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.49 9.67a1 1 0 01-1.98-.33c-.03.2 0 0 0 0v-.02a1.83 1.83 0 01.04-.13 3.02 3.02 0 01.55-1.17 3.29 3.29 0 012.75-1.27c1.13 0 2.14.36 2.8 1.19.64.81.77 1.89.59 2.98a2.87 2.87 0 01-1.41 2.05c-.44.27-1 .47-1.43.62l-.34.13c-.53.2-.88.39-1.12.67-.12.14-.23.33-.32.61h3.63a1 1 0 010 2H6.5a1 1 0 01-1-1c0-1.25.32-2.2.91-2.9a4.55 4.55 0 011.93-1.25l.55-.2c.37-.14.65-.23.9-.39a.88.88 0 00.48-.68c.13-.76-.02-1.18-.2-1.4-.15-.21-.5-.43-1.22-.43-.7 0-1 .27-1.15.48a1.29 1.29 0 00-.21.43v.01zm0 0v-.01zm0 0zm7.22 2.62a1 1 0 10-1.42 1.42l.8.79-.8.8a1 1 0 001.42 1.4l.79-.79.8.8a1 1 0 101.4-1.42l-.79-.79.8-.8a1 1 0 00-1.42-1.4l-.79.79-.8-.8z",
    fill: primaryFill
  }));
};

export const Multiplier2X24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier2X24FilledIcon, 'Multiplier2X24Filled');

const Multiplier2X24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.16 10.24A.75.75 0 007 9.58l.03-.12c.03-.1.1-.25.2-.4.18-.24.55-.56 1.39-.56.77 0 1.28.24 1.57.56.28.3.45.8.32 1.56-.07.43-.28.68-.64.9-.3.19-.63.32-1.04.48l-.54.21c-.62.26-1.34.61-1.9 1.26a4.1 4.1 0 00-.89 2.78.75.75 0 00.75.75h5a.75.75 0 000-1.5H7.06c.1-.5.27-.82.47-1.06.32-.36.76-.6 1.33-.84l.4-.16c.45-.17.98-.38 1.4-.65.63-.39 1.17-.97 1.33-1.91.19-1.1-.03-2.1-.69-2.83A3.52 3.52 0 008.62 7c-1.32 0-2.14.55-2.6 1.18a2.88 2.88 0 00-.51 1.21v.02s-.05.39 0 0c-.05.41.24.79.65.83zm8.12 1.98a.75.75 0 00-1.06 1.06l1.22 1.22-1.22 1.22a.75.75 0 101.06 1.06l1.22-1.22 1.22 1.22a.75.75 0 101.06-1.06l-1.22-1.22 1.22-1.22a.75.75 0 10-1.06-1.06l-1.22 1.22-1.22-1.22z",
    fill: primaryFill
  }));
};

export const Multiplier2X24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier2X24RegularIcon, 'Multiplier2X24Regular');

const Multiplier2X28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 10.82v.01a1 1 0 01-2-.14c0 .31 0 0 0 0v-.03a1.9 1.9 0 01.02-.15l.08-.34c.07-.27.22-.64.48-1 .56-.78 1.56-1.42 3.17-1.42 1.34 0 2.55.45 3.36 1.37.82.92 1.11 2.18.88 3.55a3.3 3.3 0 01-1.65 2.37c-.53.32-1.19.55-1.73.75l-.46.17c-.69.27-1.19.53-1.54.93-.21.25-.4.59-.52 1.11H14a1 1 0 110 2H8a1 1 0 01-1-1 5 5 0 011.1-3.42 5.65 5.65 0 012.32-1.48l.67-.25c.48-.18.87-.32 1.22-.53.4-.23.62-.5.7-.99.16-.88-.05-1.5-.4-1.89-.35-.4-.95-.69-1.86-.69-1.02 0-1.39.36-1.55.58a1.2 1.2 0 00-.2.49zm8.7 3.47a1 1 0 00-1.4 1.42L17.58 17l-1.3 1.3a1 1 0 001.42 1.4L19 18.42l1.3 1.3a1 1 0 001.4-1.42L20.42 17l1.3-1.3a1 1 0 00-1.42-1.4L19 15.58l-1.3-1.3z",
    fill: primaryFill
  }));
};

export const Multiplier2X28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier2X28FilledIcon, 'Multiplier2X28Filled');

const Multiplier2X28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.49 10.9v-.03l.05-.15c.06-.13.15-.3.3-.49.28-.33.82-.73 1.9-.73.97 0 1.57.31 1.91.75.35.44.53 1.14.36 2.12-.1.58-.39.93-.84 1.22-.38.24-.8.4-1.3.61l-.63.26c-.74.32-1.57.75-2.2 1.5A4.9 4.9 0 007 19.26a.75.75 0 00.75.75h6a.75.75 0 000-1.5h-5.2c.1-.73.34-1.22.63-1.57.4-.48.96-.79 1.65-1.09l.5-.2c.54-.22 1.15-.47 1.65-.79a3.18 3.18 0 001.5-2.22 4.11 4.11 0 00-.65-3.31C13.13 8.44 12.04 8 10.75 8c-1.53 0-2.5.6-3.06 1.27a3.33 3.33 0 00-.67 1.32v.02a.75.75 0 001.47.29zm0 0zm8.79 3.32a.75.75 0 00-1.06 1.06L17.94 17l-1.72 1.72a.75.75 0 101.06 1.06L19 18.06l1.72 1.72a.75.75 0 101.06-1.06L20.06 17l1.72-1.72a.75.75 0 10-1.06-1.06L19 15.94l-1.72-1.72z",
    fill: primaryFill
  }));
};

export const Multiplier2X28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier2X28RegularIcon, 'Multiplier2X28Regular');

const Multiplier2X32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.98 13.75a1.25 1.25 0 001.5-.96c0-.04.03-.1.06-.18.07-.16.18-.38.35-.6.32-.38.88-.83 1.98-.83 1.03 0 1.75.34 2.17.79.4.43.64 1.1.48 2.07-.09.49-.33.78-.83 1.06a9 9 0 01-1.54.61l-.82.28c-.92.33-2.04.8-2.9 1.71A5.62 5.62 0 007 21.75 1.25 1.25 0 008.25 23h7.5a1.25 1.25 0 000-2.5h-6.1c.13-.5.35-.83.59-1.08a4.79 4.79 0 011.93-1.08l.57-.19c.7-.23 1.5-.5 2.17-.87a3.88 3.88 0 002.07-2.82 4.8 4.8 0 00-1.11-4.2 5.36 5.36 0 00-4-1.58 4.83 4.83 0 00-4.83 3.55v.02h-.01c0 .01-.13.6 0 .01-.15.67.27 1.34.95 1.5zm12.15 2.62a1.25 1.25 0 10-1.76 1.76l1.36 1.37-1.36 1.37a1.25 1.25 0 101.76 1.76l1.37-1.36 1.37 1.36a1.25 1.25 0 001.76-1.76l-1.36-1.37 1.36-1.37a1.25 1.25 0 00-1.76-1.76l-1.37 1.36-1.37-1.36z",
    fill: primaryFill
  }));
};

export const Multiplier2X32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier2X32FilledIcon, 'Multiplier2X32Filled');

const Multiplier2X32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.39 12.7v-.04l.07-.2c.06-.17.17-.4.34-.63.31-.42.89-.9 2.07-.9 1.07 0 1.72.35 2.09.81.37.48.58 1.25.39 2.36-.1.62-.42.99-.92 1.31-.42.27-.88.46-1.45.7l-.76.3a6.7 6.7 0 00-2.6 1.78 5.8 5.8 0 00-1.22 3.88 1 1 0 001 1h6.93a1 1 0 000-2H9.48a3.2 3.2 0 01.68-1.6A4.77 4.77 0 0112 18.25l.56-.23c.63-.25 1.35-.55 1.94-.92a3.8 3.8 0 001.8-2.66 4.89 4.89 0 00-.78-3.93 4.48 4.48 0 00-3.66-1.58 4.37 4.37 0 00-4.44 3.37l-.01.04v.02s-.09.5 0 0a1 1 0 001.96.35v-.01zm10.32 3.6a1 1 0 10-1.42 1.4l1.8 1.8-1.8 1.8a1 1 0 101.42 1.4l1.79-1.79 1.8 1.8a1 1 0 101.4-1.42l-1.79-1.79 1.8-1.8a1 1 0 00-1.42-1.4l-1.79 1.79-1.8-1.8z",
    fill: primaryFill
  }));
};

export const Multiplier2X32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier2X32RegularIcon, 'Multiplier2X32Regular');

const Multiplier2X48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.34 20.24A1.5 1.5 0 0015 18.9a2.68 2.68 0 01.45-1c.35-.49 1.09-1.14 2.8-1.14 1.54 0 2.55.5 3.13 1.19.57.68.9 1.76.64 3.3a2.45 2.45 0 01-1.27 1.81c-.6.37-1.26.62-2.08.93l-1.09.43a9.44 9.44 0 00-3.8 2.48C12.66 28.23 12 30.04 12 32.5a1.5 1.5 0 001.5 1.5h10a1.5 1.5 0 000-3h-8.38c.18-1.01.54-1.68.95-2.16.62-.72 1.5-1.19 2.64-1.65l.78-.3c.91-.35 1.97-.75 2.84-1.29a5.43 5.43 0 002.65-3.85c.38-2.2-.04-4.24-1.31-5.75-1.27-1.5-3.21-2.25-5.42-2.25-2.66 0-4.3 1.1-5.23 2.36a5.67 5.67 0 00-1 2.44v.02l-.01.01c0 .01-.05.44 0 .01a1.5 1.5 0 001.33 1.65zm16.22 4.2a1.5 1.5 0 00-2.12 2.12L29.88 29l-2.44 2.44a1.5 1.5 0 002.12 2.12L32 31.12l2.44 2.44a1.5 1.5 0 002.12-2.12L34.12 29l2.44-2.44a1.5 1.5 0 00-2.12-2.12L32 26.88l-2.44-2.44z",
    fill: primaryFill
  }));
};

export const Multiplier2X48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier2X48FilledIcon, 'Multiplier2X48Filled');

const Multiplier2X48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.03 19.98c.68.12 1.32-.33 1.45-1l.01-.06.1-.27c.08-.23.24-.55.5-.87.47-.59 1.36-1.28 3.16-1.28 1.6 0 2.6.52 3.17 1.24.58.74.88 1.9.6 3.55a2.81 2.81 0 01-1.41 2.02c-.62.4-1.32.69-2.15 1.02l-1.06.44a9.48 9.48 0 00-3.68 2.5c-1.09 1.3-1.72 3.06-1.72 5.48A1.25 1.25 0 0013.25 34h10a1.25 1.25 0 100-2.5h-8.67a4.94 4.94 0 011.06-2.62c.66-.8 1.6-1.31 2.75-1.8.25-.12.53-.23.82-.35.9-.37 1.92-.78 2.75-1.31a5.3 5.3 0 002.52-3.7c.36-2.12.04-4.07-1.1-5.52-1.16-1.47-2.98-2.2-5.13-2.2-2.58 0-4.18 1.06-5.12 2.22a5.81 5.81 0 00-1.1 2.28v.02h-.01c0 .01-.04.13 0 .01-.12.68.33 1.33 1.01 1.45zm1.45-1zm0 0zm14.65 5.39a1.25 1.25 0 00-1.76 1.76L30.23 29l-2.86 2.87a1.25 1.25 0 001.76 1.76L32 30.77l2.87 2.86a1.25 1.25 0 001.76-1.76L33.77 29l2.86-2.87a1.25 1.25 0 00-1.76-1.76L32 27.23l-2.87-2.86z",
    fill: primaryFill
  }));
};

export const Multiplier2X48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier2X48RegularIcon, 'Multiplier2X48Regular');

const Multiplier5X20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.25 6.68A.75.75 0 017 6h3.25a.75.75 0 010 1.5H7.68l-.1 1.13.44-.06a2.85 2.85 0 11.36 5.68c-.75 0-1.5-.3-2.03-.84l-.38-.38a.75.75 0 111.06-1.06l.38.38a1.36 1.36 0 002.34-.95c0-.82-.72-1.45-1.53-1.34l-1.37.18a.75.75 0 01-.85-.8l.25-2.76zM5 13.5a.5.5 0 11-1 0 .5.5 0 011 0zm8.28-3.28a.75.75 0 10-1.06 1.06l.72.72-.72.72a.75.75 0 101.06 1.06l.72-.72.72.72a.75.75 0 101.06-1.06l-.72-.72.72-.72a.75.75 0 10-1.06-1.06l-.72.72-.72-.72z",
    fill: primaryFill
  }));
};

export const Multiplier5X20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier5X20FilledIcon, 'Multiplier5X20Filled');

const Multiplier5X20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 6a.5.5 0 00-.5.46l-.25 3a.5.5 0 00.56.54l1.88-.23A1.62 1.62 0 118.9 13h-.36c-.53 0-1.03-.2-1.4-.58l-.28-.27a.5.5 0 00-.7.7l.27.28c.56.56 1.32.87 2.1.87h.36a2.62 2.62 0 10-.3-5.22l-1.28.15L7.46 7h3.04a.5.5 0 000-1H7zm5.15 4.15c.2-.2.5-.2.7 0L14 11.29l1.15-1.14a.5.5 0 01.7.7L14.71 12l1.14 1.15a.5.5 0 01-.7.7L14 12.71l-1.15 1.14a.5.5 0 01-.7-.7L13.29 12l-1.14-1.15a.5.5 0 010-.7zM5 13.5a.5.5 0 11-1 0 .5.5 0 011 0z",
    fill: primaryFill
  }));
};

export const Multiplier5X20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier5X20RegularIcon, 'Multiplier5X20Regular');

const Multiplier5X24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.01 7.86A1 1 0 018 7h4a1 1 0 110 2H8.87l-.19 1.3.35-.05a3.65 3.65 0 11.55 7.25 3.7 3.7 0 01-2.73-1.2l-.34-.38a1 1 0 111.48-1.34l.34.37c.31.35.77.55 1.25.55a1.65 1.65 0 10-.24-3.28l-1.68.27a1 1 0 01-1.15-1.13l.5-3.5zm7.28 4.43a1 1 0 011.42 0l.79.8.8-.8a1 1 0 011.4 1.42l-.79.79.8.8a1 1 0 01-1.42 1.4l-.79-.79-.8.8a1 1 0 01-1.4-1.42l.79-.79-.8-.8a1 1 0 010-1.4zM4.75 17a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: primaryFill
  }));
};

export const Multiplier5X24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier5X24FilledIcon, 'Multiplier5X24Filled');

const Multiplier5X24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 7.7c.03-.4.36-.7.75-.7h4.5a.75.75 0 010 1.5h-3.8l-.14 2.13 1.29-.19a3.42 3.42 0 11.48 6.81h-.36a3.78 3.78 0 01-2.8-1.24l-.23-.26a.75.75 0 011.12-1l.23.25c.43.48 1.04.75 1.68.75h.36a1.92 1.92 0 10-.27-3.82l-2.2.31a.75.75 0 01-.86-.79L7 7.7zm7.22 4.52c.3-.3.77-.3 1.06 0l1.22 1.22 1.22-1.22a.75.75 0 011.06 1.06l-1.22 1.22 1.22 1.22a.75.75 0 11-1.06 1.06l-1.22-1.22-1.22 1.22a.75.75 0 01-1.06-1.06l1.22-1.22-1.22-1.22a.75.75 0 010-1.06zM4.75 17a.75.75 0 100-1.5.75.75 0 000 1.5z",
    fill: primaryFill
  }));
};

export const Multiplier5X24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier5X24RegularIcon, 'Multiplier5X24Regular');

const Multiplier5X28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.5 8a1 1 0 00-1 .88L8 13.13a1 1 0 001.12 1.11l2.57-.3a2.3 2.3 0 11.27 4.56h-.15c-.7 0-1.37-.3-1.84-.83l-.72-.83a1 1 0 10-1.5 1.32l.72.82a4.44 4.44 0 003.34 1.52h.15a4.3 4.3 0 10-.51-8.55l-1.3.16.24-2.11h4.11a1 1 0 100-2h-5zm7.8 6.3a1 1 0 011.4 0l1.3 1.29 1.3-1.3a1 1 0 011.4 1.42L21.42 17l1.3 1.3a1 1 0 01-1.42 1.4L20 18.42l-1.3 1.3a1 1 0 01-1.4-1.42L18.58 17l-1.3-1.3a1 1 0 010-1.4zM6.5 19.24a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
    fill: primaryFill
  }));
};

export const Multiplier5X28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier5X28FilledIcon, 'Multiplier5X28Filled');

const Multiplier5X28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.5 8c-.4 0-.73.31-.75.7l-.25 4.5a.75.75 0 00.84.8l2.57-.31a2.54 2.54 0 11.3 5.06h-.3c-.84 0-1.63-.36-2.17-1l-.42-.49a.75.75 0 10-1.14.98l.42.5a4.35 4.35 0 003.3 1.51h.3a4.04 4.04 0 10-.47-8.05l-1.68.2.16-2.9h4.54a.75.75 0 000-1.5H9.5zm7.72 6.22c.3-.3.77-.3 1.06 0L20 15.94l1.72-1.72a.75.75 0 111.06 1.06L21.06 17l1.72 1.72a.75.75 0 11-1.06 1.06L20 18.06l-1.72 1.72a.75.75 0 11-1.06-1.06L18.94 17l-1.72-1.72a.75.75 0 010-1.06zM6.5 19.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
    fill: primaryFill
  }));
};

export const Multiplier5X28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier5X28RegularIcon, 'Multiplier5X28Regular');

const Multiplier5X32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 10.13c.07-.64.6-1.13 1.25-1.13h6a1.25 1.25 0 110 2.5h-4.87l-.23 2.3 1.2-.18a4.96 4.96 0 11.69 9.88h-.21a5.17 5.17 0 01-3.77-1.63l-.72-.76a1.25 1.25 0 111.82-1.72l.72.77c.5.54 1.21.84 1.95.84h.2a2.46 2.46 0 10-.34-4.9l-2.77.39a1.25 1.25 0 01-1.41-1.36l.5-5zm10.37 6.24a1.25 1.25 0 011.76 0l1.37 1.36 1.37-1.36a1.25 1.25 0 011.76 1.76l-1.36 1.37 1.36 1.37a1.25 1.25 0 01-1.76 1.76l-1.37-1.36-1.37 1.36a1.25 1.25 0 01-1.76-1.76l1.36-1.37-1.36-1.37a1.25 1.25 0 010-1.76zM7 23a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const Multiplier5X32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier5X32FilledIcon, 'Multiplier5X32Filled');

const Multiplier5X32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.25 9.9a1 1 0 011-.9h6.25a1 1 0 110 2h-5.34l-.3 3.1 2.04-.27a4.73 4.73 0 11.62 9.42h-.53c-1.46 0-2.86-.6-3.85-1.67l-.37-.4a1 1 0 011.46-1.36l.37.4A3.26 3.26 0 0014 21.24h.53a2.73 2.73 0 10-.36-5.44l-3.28.43a1 1 0 01-1.13-1.08l.5-5.25zm10.04 6.4a1 1 0 011.42 0l1.79 1.79 1.8-1.8a1 1 0 011.4 1.42l-1.79 1.79 1.8 1.8a1 1 0 01-1.42 1.4l-1.79-1.79-1.8 1.8a1 1 0 01-1.4-1.42l1.79-1.79-1.8-1.8a1 1 0 010-1.4zM7 23a1 1 0 100-2 1 1 0 000 2z",
    fill: primaryFill
  }));
};

export const Multiplier5X32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier5X32RegularIcon, 'Multiplier5X32Regular');

const Multiplier5X48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.52 15.29A1.5 1.5 0 0116 14h9a1.5 1.5 0 010 3h-7.7l-.55 3.83 3.13-.28a6.99 6.99 0 11.63 13.95h-.56c-2.15 0-4.19-.9-5.62-2.5l-.44-.5a1.5 1.5 0 112.22-2l.45.5c.86.95 2.1 1.5 3.39 1.5h.56a3.99 3.99 0 10-.36-7.96l-5.01.45a1.5 1.5 0 01-1.62-1.7l1-7zm14.92 9.15a1.5 1.5 0 012.12 0L34 26.88l2.44-2.44a1.5 1.5 0 012.12 2.12L36.12 29l2.44 2.44a1.5 1.5 0 01-2.12 2.12L34 31.12l-2.44 2.44a1.5 1.5 0 01-2.12-2.12L31.88 29l-2.44-2.44a1.5 1.5 0 010-2.12zM10.25 34a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
    fill: primaryFill
  }));
};

export const Multiplier5X48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier5X48FilledIcon, 'Multiplier5X48Filled');

const Multiplier5X48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.26 15.13c.06-.64.6-1.13 1.24-1.13h8.75a1.25 1.25 0 110 2.5h-7.62l-.48 4.82 2.9-.34a6.66 6.66 0 11.8 13.27h-.5a7.14 7.14 0 01-5.28-2.34l-.74-.82a1.25 1.25 0 111.84-1.68l.75.82a4.64 4.64 0 003.44 1.52h.48a4.16 4.16 0 10-.5-8.29L15.9 24a1.25 1.25 0 01-1.4-1.36l.76-7.5zm14.1 9.24a1.25 1.25 0 011.77 0L34 27.23l2.87-2.86a1.25 1.25 0 011.76 1.76L35.77 29l2.86 2.87a1.25 1.25 0 01-1.76 1.76L34 30.77l-2.87 2.86a1.25 1.25 0 01-1.76-1.76L32.23 29l-2.86-2.87a1.25 1.25 0 010-1.76zM10.26 34a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z",
    fill: primaryFill
  }));
};

export const Multiplier5X48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Multiplier5X48RegularIcon, 'Multiplier5X48Regular');

const MultiselectLtr16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.03 1.97c.3.3.3.77 0 1.06l-2 2c-.3.3-.77.3-1.06 0l-1-1a.75.75 0 011.06-1.06l.47.47 1.47-1.47c.3-.3.77-.3 1.06 0zM6 3.75c0-.41.34-.75.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 016 3.75zM6 8c0-.41.34-.75.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 016 8zm-.97 2.97c.3.3.3.77 0 1.06l-2 2c-.3.3-.77.3-1.06 0l-1-1a.75.75 0 111.06-1.06l.47.47 1.47-1.47c.3-.3.77-.3 1.06 0zM6 12.25c0-.41.34-.75.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75z",
    fill: primaryFill
  }));
};

export const MultiselectLtr16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MultiselectLtr16FilledIcon, 'MultiselectLtr16Filled');

const MultiselectLtr16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.85 2.15c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7 0l-1-1a.5.5 0 11.7-.7l.65.64 1.65-1.64c.2-.2.5-.2.7 0zM14.5 4h-8a.5.5 0 010-1h8a.5.5 0 010 1zM6 8c0-.28.22-.5.5-.5h8a.5.5 0 010 1h-8A.5.5 0 016 8zm-1.15 3.15c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7 0l-1-1a.5.5 0 01.7-.7l.65.64 1.65-1.64c.2-.2.5-.2.7 0zM14.5 13h-8a.5.5 0 010-1h8a.5.5 0 010 1z",
    fill: primaryFill
  }));
};

export const MultiselectLtr16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MultiselectLtr16RegularIcon, 'MultiselectLtr16Regular');

const MultiselectLtr20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.25 3.2c.31.27.33.74.06 1.05l-2.25 2.5a.75.75 0 01-1.09.03L1.72 5.53a.75.75 0 011.06-1.06l.7.7 1.71-1.92a.75.75 0 011.06-.06zM8 5.24c0-.41.34-.75.75-.75h8.5a.75.75 0 010 1.5h-8.5A.75.75 0 018 5.25zm0 5c0-.41.34-.75.75-.75h8.5a.75.75 0 010 1.5h-8.5a.75.75 0 01-.75-.75zm.75 4.25a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5zm-2.44-.25a.75.75 0 10-1.12-1l-1.72 1.91-.69-.69a.75.75 0 00-1.06 1.06l1.25 1.25a.75.75 0 001.09-.03l2.25-2.5z",
    fill: primaryFill
  }));
};

export const MultiselectLtr20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MultiselectLtr20FilledIcon, 'MultiselectLtr20Filled');

const MultiselectLtr20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.85 4.35a.5.5 0 10-.7-.7L3.5 5.29l-.65-.64a.5.5 0 10-.7.7l1 1c.2.2.5.2.7 0l2-2zM8 5.5c0-.28.22-.5.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5zm0 5c0-.28.22-.5.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5zm.5 4.5a.5.5 0 000 1h9a.5.5 0 000-1h-9zm-2.65-.85c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7 0l-1-1a.5.5 0 01.7-.7l.65.64 1.65-1.64c.2-.2.5-.2.7 0z",
    fill: primaryFill
  }));
};

export const MultiselectLtr20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MultiselectLtr20RegularIcon, 'MultiselectLtr20Regular');

const MultiselectLtr24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.7 3.3a1 1 0 00-1.4 0L4 4.58l-.3-.3a1 1 0 00-1.4 1.42l1 1a1 1 0 001.4 0l2-2a1 1 0 000-1.42zM10 17h11a1 1 0 01.12 1.99H10A1 1 0 019.88 17H10zm0-6h11a1 1 0 01.12 2H10a1 1 0 01-.12-2H10zm0-6h11a1 1 0 01.12 2H10a1 1 0 01-.12-2H10zM5.3 16.3a1 1 0 011.4 1.4l-2 2a1 1 0 01-1.4 0l-1-1a1 1 0 111.4-1.4l.3.29 1.3-1.3z",
    fill: primaryFill
  }));
};

export const MultiselectLtr24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MultiselectLtr24FilledIcon, 'MultiselectLtr24Filled');

const MultiselectLtr24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.78 4.78a.75.75 0 00-1.06-1.06L3.75 5.69l-.47-.47a.75.75 0 00-1.06 1.06l1 1c.3.3.77.3 1.06 0l2.5-2.5zm2.97 13.23h11.5a.75.75 0 01.1 1.49H9.75a.75.75 0 01-.1-1.49h.1zm0-6.51h11.5a.75.75 0 01.1 1.5H9.75a.75.75 0 01-.1-1.5h.1zm0-6.5h11.5a.75.75 0 01.1 1.5H9.75a.75.75 0 01-.1-1.5h.1zM6.78 16.72c.3.3.3.77 0 1.06l-2.5 2.5c-.3.3-.77.3-1.06 0l-1-1a.75.75 0 111.06-1.06l.47.47 1.97-1.97c.3-.3.77-.3 1.06 0z",
    fill: primaryFill
  }));
};

export const MultiselectLtr24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MultiselectLtr24RegularIcon, 'MultiselectLtr24Regular');

const MultiselectRtl16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.03 3.03a.75.75 0 00-1.06-1.06L12.5 3.44l-.47-.47a.75.75 0 10-1.06 1.06l1 1c.3.3.77.3 1.06 0l2-2zm-2 11l2-2a.75.75 0 10-1.06-1.06l-1.47 1.47-.47-.47a.75.75 0 10-1.06 1.06l1 1c.3.3.77.3 1.06 0zM1.75 3a.75.75 0 000 1.5h7.5a.75.75 0 000-1.5h-7.5zm0 4.25a.75.75 0 000 1.5h7.5a.75.75 0 000-1.5h-7.5zm0 4.25a.75.75 0 000 1.5h7.5a.75.75 0 000-1.5h-7.5z",
    fill: primaryFill
  }));
};

export const MultiselectRtl16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MultiselectRtl16FilledIcon, 'MultiselectRtl16Filled');

const MultiselectRtl16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.85 2.85a.5.5 0 00-.7-.7L12.5 3.79l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l2-2zm0 9a.5.5 0 00-.7-.7l-1.65 1.64-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l2-2zM1.5 3a.5.5 0 000 1h8a.5.5 0 000-1h-8zm0 4.5a.5.5 0 000 1h8a.5.5 0 000-1h-8zm0 4.5a.5.5 0 000 1h8a.5.5 0 000-1h-8z",
    fill: primaryFill
  }));
};

export const MultiselectRtl16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MultiselectRtl16RegularIcon, 'MultiselectRtl16Regular');

const MultiselectRtl20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 5.25c0-.41.34-.75.75-.75h8.5a.75.75 0 010 1.5h-8.5A.75.75 0 012 5.25zm0 5c0-.41.34-.75.75-.75h8.5a.75.75 0 010 1.5h-8.5a.75.75 0 01-.75-.75zm.75 4.25a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5zM18.31 4.25a.75.75 0 10-1.12-1l-1.72 1.91-.69-.69a.75.75 0 10-1.06 1.06l1.25 1.25a.75.75 0 001.09-.03l2.25-2.5zm-.06 8.94c.31.28.33.75.06 1.06l-2.25 2.5a.75.75 0 01-1.09.03l-1.25-1.25a.75.75 0 111.06-1.06l.7.7 1.71-1.92a.75.75 0 011.06-.06z",
    fill: primaryFill
  }));
};

export const MultiselectRtl20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MultiselectRtl20FilledIcon, 'MultiselectRtl20Filled');

const MultiselectRtl20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.85 4.35a.5.5 0 00-.7-.7L15.5 5.29l-.65-.64a.5.5 0 00-.7.7l1 1c.2.2.5.2.7 0l2-2zm0 9.8c.2.2.2.5 0 .7l-2 2a.5.5 0 01-.7 0l-1-1a.5.5 0 01.7-.7l.65.64 1.65-1.64c.2-.2.5-.2.7 0zM2.5 5a.5.5 0 000 1h9a.5.5 0 000-1h-9zm0 5a.5.5 0 000 1h9a.5.5 0 000-1h-9zM2 15.5c0-.28.22-.5.5-.5h9a.5.5 0 010 1h-9a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const MultiselectRtl20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MultiselectRtl20RegularIcon, 'MultiselectRtl20Regular');

const MultiselectRtl24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.7 3.3a1 1 0 00-1.4 0L19 4.58l-.3-.3a1 1 0 10-1.4 1.42l1 1a1 1 0 001.4 0l2-2a1 1 0 000-1.42zM3 17h11a1 1 0 01.12 1.99H3A1 1 0 012.88 17H3zm0-6h11a1 1 0 01.12 2H3a1 1 0 01-.12-2H3zm0-6h11a1 1 0 01.12 2H3a1 1 0 01-.12-2H3zm17.3 11.3a1 1 0 011.4 1.4l-2 2a1 1 0 01-1.4 0l-1-1a1 1 0 011.4-1.4l.3.29 1.3-1.3z",
    fill: primaryFill
  }));
};

export const MultiselectRtl24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MultiselectRtl24FilledIcon, 'MultiselectRtl24Filled');

const MultiselectRtl24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.78 4.78a.75.75 0 00-1.06-1.06l-1.97 1.97-.47-.47a.75.75 0 10-1.06 1.06l1 1c.3.3.77.3 1.06 0l2.5-2.5zM2.75 18.01h11.5a.75.75 0 01.1 1.49H2.75a.75.75 0 01-.1-1.49h.1zm0-6.51h11.5a.75.75 0 01.1 1.5H2.75a.75.75 0 01-.1-1.5h.1zm0-6.5h11.5a.75.75 0 01.1 1.5H2.75a.75.75 0 01-.1-1.5h.1zm19.03 11.72c.3.3.3.77 0 1.06l-2.5 2.5c-.3.3-.77.3-1.06 0l-1-1a.75.75 0 111.06-1.06l.47.47 1.97-1.97c.3-.3.77-.3 1.06 0z",
    fill: primaryFill
  }));
};

export const MultiselectRtl24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MultiselectRtl24RegularIcon, 'MultiselectRtl24Regular');

const MusicNote120FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.15 2.02a.5.5 0 00-.65.48v9.9A3.24 3.24 0 004 14.75a3.25 3.25 0 106.5-.25V7.18l5.85 1.8A.5.5 0 0017 8.5V5.98a2.5 2.5 0 00-1.76-2.4l-5.1-1.56z",
    fill: primaryFill
  }));
};

export const MusicNote120Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNote120FilledIcon, 'MusicNote120Filled');

const MusicNote120RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.15 2.02a.5.5 0 00-.65.48v9.9A3.24 3.24 0 004 14.75a3.25 3.25 0 106.5-.25V7.18l5.85 1.8A.5.5 0 0017 8.5V5.98a2.5 2.5 0 00-1.76-2.4l-5.1-1.56zM16 7.82l-5.5-1.69V3.18l4.44 1.36c.63.2 1.06.78 1.06 1.44v1.84zM5 14.75a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0z",
    fill: primaryFill
  }));
};

export const MusicNote120Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNote120RegularIcon, 'MusicNote120Regular');

const MusicNote124FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.51 2.05a.75.75 0 00-1.01.7v12.13a4 4 0 101.5 3.37V8.83l6.99 2.62a.75.75 0 001.01-.7V7.48c0-1.35-.84-2.56-2.1-3.04l-6.39-2.4z",
    fill: primaryFill
  }));
};

export const MusicNote124Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNote124FilledIcon, 'MusicNote124Filled');

const MusicNote124RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.51 2.05a.75.75 0 00-1.01.7v12.13a4 4 0 101.5 3.37V8.83l6.99 2.62a.75.75 0 001.01-.7V7.48c0-1.35-.84-2.56-2.1-3.04l-6.39-2.4zM10.5 18a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm8-8.33L12 7.23v-3.4l5.36 2.01c.69.26 1.14.91 1.14 1.64v2.19z",
    fill: primaryFill
  }));
};

export const MusicNote124Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNote124RegularIcon, 'MusicNote124Regular');

const MusicNote216FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 5.21v5.06A2 2 0 1013 12V1.93a.8.8 0 00-1.07-.76l-6.4 2.29A.8.8 0 005 4.2v7.06A2 2 0 106 13V7.35l6-2.14z",
    fill: primaryFill
  }));
};

export const MusicNote216Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNote216FilledIcon, 'MusicNote216Filled');

const MusicNote216RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 5.21v5.06A2 2 0 1013 12V1.93a.8.8 0 00-1.07-.76l-6.4 2.29A.8.8 0 005 4.2v7.06A2 2 0 106 13V7.35l6-2.14zm0-1.06L6 6.29V4.35l6-2.14v1.94zM11 11a1 1 0 110 2 1 1 0 010-2zm-7 1a1 1 0 110 2 1 1 0 010-2z",
    fill: primaryFill
  }));
};

export const MusicNote216Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNote216RegularIcon, 'MusicNote216Regular');

const MusicNote220FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.99 3.02a1 1 0 00-1.29-.8l-7 2.2a1 1 0 00-.7.95v8.13a2.5 2.5 0 101 2V8.37l7-2.19v5.32a2.5 2.5 0 101 2V3.18l-.01-.16z",
    fill: primaryFill
  }));
};

export const MusicNote220Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNote220FilledIcon, 'MusicNote220Filled');

const MusicNote220RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.7 2.23a1 1 0 011.3.95V13.5a2.5 2.5 0 11-1-2V6.18L8 8.37v7.13a2.5 2.5 0 11-1-2V5.37a1 1 0 01.7-.96l7-2.18zM8 7.32l7-2.19V3.18L8 5.37v1.95zM5.5 14a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm6.5-.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0z",
    fill: primaryFill
  }));
};

export const MusicNote220Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNote220RegularIcon, 'MusicNote220Regular');

const MusicNote224FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M20 2.75a.75.75 0 00-.97-.72l-10 3a.75.75 0 00-.53.72v9.88a3.5 3.5 0 101.5 2.62v-7.94l8.5-2.55v5.87a3.5 3.5 0 101.5 2.62V2.75z",
    fill: primaryFill
  }));
};

export const MusicNote224Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNote224FilledIcon, 'MusicNote224Filled');

const MusicNote224RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19.7 2.15c.19.14.3.36.3.6V16.5a3.5 3.5 0 11-1.5-2.87V7.76L10 10.3v8.19a3.5 3.5 0 11-1.5-2.87V5.75c0-.33.22-.62.53-.72l10-3a.75.75 0 01.67.12zM10 8.75l8.5-2.56V3.76L10 6.3v2.43zM6.5 16.5a2 2 0 100 4 2 2 0 000-4zm8 0a2 2 0 104 0 2 2 0 00-4 0z",
    fill: primaryFill
  }));
};

export const MusicNote224Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNote224RegularIcon, 'MusicNote224Regular');

const MusicNote2Play20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.99 3.02a1 1 0 00-1.29-.8l-7 2.2a1 1 0 00-.7.95v8.13a2.5 2.5 0 101 2V8.37l7-2.19v2.84c.34.03.68.1 1 .19V3.18l-.01-.16zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.26-.44l-3-1.65a.5.5 0 00-.74.44v3.3c0 .38.4.62.74.44l3-1.65a.5.5 0 000-.88z",
    fill: primaryFill
  }));
};

export const MusicNote2Play20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNote2Play20FilledIcon, 'MusicNote2Play20Filled');

const MusicNote2Play20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.7 2.23a1 1 0 011.3.95v6.03c-.32-.1-.66-.16-1-.19V6.18L8 8.37v7.13a2.5 2.5 0 11-1-2V5.37a1 1 0 01.7-.96l7-2.18zM8 7.32l7-2.19V3.18L8 5.37v1.95zM5.5 14a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm13.5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.26-.44l-3-1.65a.5.5 0 00-.74.44v3.3c0 .38.4.62.74.44l3-1.65a.5.5 0 000-.88z",
    fill: primaryFill
  }));
};

export const MusicNote2Play20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNote2Play20RegularIcon, 'MusicNote2Play20Regular');

const MusicNoteOff120FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7l7.35 7.36v2.2A3.24 3.24 0 004 14.74a3.25 3.25 0 106.5-.25v-3.3l6.65 6.65a.5.5 0 00.7-.7l-15-15zm7.65 5.03v1.2l-1-1V2.5a.5.5 0 01.65-.48l5.09 1.57A2.5 2.5 0 0117 5.98V8.5a.5.5 0 01-.65.48l-5.85-1.8z",
    fill: primaryFill
  }));
};

export const MusicNoteOff120Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNoteOff120FilledIcon, 'MusicNoteOff120Filled');

const MusicNoteOff120RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7l7.35 7.36v2.2A3.24 3.24 0 004 14.74a3.25 3.25 0 106.5-.25v-3.3l6.65 6.65a.5.5 0 00.7-.7l-15-15zM5 14.75a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zm5.5-7.57v1.2l-1-1V2.5a.5.5 0 01.65-.48l5.09 1.57A2.5 2.5 0 0117 5.98V8.5a.5.5 0 01-.65.48l-5.85-1.8zm5.5.64V5.98a1.5 1.5 0 00-1.06-1.44L10.5 3.18v2.95l5.5 1.7z",
    fill: primaryFill
  }));
};

export const MusicNoteOff120Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNoteOff120RegularIcon, 'MusicNoteOff120Regular');

const MusicNoteOff124FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 13.06l8.72 8.72a.75.75 0 001.06-1.06L3.28 2.22a.75.75 0 10-1.06 1.06l8.28 8.28v3.32a4 4 0 101.5 3.37v-5.19zm6.99-1.6l-6.97-2.62-1.52-1.52V2.75a.75.75 0 011.01-.7l6.38 2.39A3.25 3.25 0 0120 7.48v3.27a.75.75 0 01-1.01.7z",
    fill: primaryFill
  }));
};

export const MusicNoteOff124Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNoteOff124FilledIcon, 'MusicNoteOff124Filled');

const MusicNoteOff124RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 13.06l8.72 8.72a.75.75 0 001.06-1.06L3.28 2.22a.75.75 0 10-1.06 1.06l8.28 8.28v3.32a4 4 0 101.5 3.37v-5.19zM10.5 18a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm8.49-6.55l-6.97-2.6-1.52-1.53V2.75a.75.75 0 011.01-.7l6.38 2.39A3.25 3.25 0 0120 7.48v3.27a.75.75 0 01-1.01.7zm-.49-1.78V7.48c0-.73-.45-1.38-1.14-1.64l-5.36-2v3.39l6.5 2.44z",
    fill: primaryFill
  }));
};

export const MusicNoteOff124Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNoteOff124RegularIcon, 'MusicNoteOff124Regular');

const MusicNoteOff216FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.55 13.26l1.6 1.6a.5.5 0 00.7-.71l-13-13a.5.5 0 10-.7.7L5 5.71v5.56A2 2 0 106 13V7.35l.48-.17 3.26 3.27a2 2 0 102.81 2.81zM12 5.21v4.67l1 1V1.93a.8.8 0 00-1.07-.76L5.57 3.45l2.99 2.99L12 5.2z",
    fill: primaryFill
  }));
};

export const MusicNoteOff216Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNoteOff216FilledIcon, 'MusicNoteOff216Filled');

const MusicNoteOff216RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.55 13.26l1.6 1.6a.5.5 0 00.7-.71l-13-13a.5.5 0 10-.7.7L5 5.71v5.56A2 2 0 106 13V7.35l.48-.17 3.26 3.27a2 2 0 102.81 2.81zm-.71-.71a1 1 0 11-1.39-1.39l1.39 1.39zM4 12a1 1 0 110 2 1 1 0 010-2zm8-7.85l-4.22 1.5.78.79L12 5.2v4.67l1 1V1.93a.8.8 0 00-1.07-.76L5.57 3.45l.78.78L12 2.2v1.94z",
    fill: primaryFill
  }));
};

export const MusicNoteOff216Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNoteOff216RegularIcon, 'MusicNoteOff216Regular');

const MusicNoteOff220FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L7 7.71v5.79a2.5 2.5 0 101 2V8.7l3.41 3.42a2.5 2.5 0 003.46 3.46l2.28 2.27a.5.5 0 00.7-.7l-15-15zM13.5 11c-.12 0-.24 0-.35.02l2.83 2.83.02-.35V3.18l-.01-.16a1 1 0 00-1.29-.8l-7 2.2a1 1 0 00-.61.54l2.8 2.82L15 6.18v5.32c-.42-.31-.94-.5-1.5-.5z",
    fill: primaryFill
  }));
};

export const MusicNoteOff220Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNoteOff220FilledIcon, 'MusicNoteOff220Filled');

const MusicNoteOff220RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15a.5.5 0 10-.7.7L7 7.71v5.79a2.5 2.5 0 101 2V8.7l3.41 3.42a2.5 2.5 0 003.46 3.46l2.28 2.27a.5.5 0 00.7-.7l-15-15zm11.3 12.7a1.5 1.5 0 01-2-2l2 2zM5.5 14a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm8-3c-.12 0-.24 0-.35.02l2.83 2.83.02-.35V3.18a1 1 0 00-1.3-.95l-7 2.18a1 1 0 00-.61.55l.91.92v-.51l7-2.19v1.95L9.1 6.98l.8.8 5.1-1.6v5.32c-.42-.31-.94-.5-1.5-.5z",
    fill: primaryFill
  }));
};

export const MusicNoteOff220Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNoteOff220RegularIcon, 'MusicNoteOff220Regular');

const MusicNoteOff224FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 9.56v6.07a3.5 3.5 0 101.5 2.62v-7.19l3.55 3.55a3.5 3.5 0 004.84 4.84l2.33 2.33a.75.75 0 001.06-1.06L3.28 2.22a.75.75 0 10-1.06 1.06L8.5 9.56zm8 3.44l-.3.01 3.79 3.8a3.54 3.54 0 00.01-.56V2.75a.75.75 0 00-.97-.72l-10 3c-.2.06-.35.2-.44.37l4.1 4.1 5.81-1.74v5.87a3.48 3.48 0 00-2-.63z",
    fill: primaryFill
  }));
};

export const MusicNoteOff224Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNoteOff224FilledIcon, 'MusicNoteOff224Filled');

const MusicNoteOff224RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 9.56v6.07a3.5 3.5 0 101.5 2.62v-7.19l3.55 3.55a3.5 3.5 0 004.84 4.84l2.33 2.33a.75.75 0 001.06-1.06L3.28 2.22a.75.75 0 10-1.06 1.06L8.5 9.56zm8.78 8.78a2 2 0 01-2.62-2.62l2.62 2.62zM6.5 16.5a2 2 0 110 4 2 2 0 010-4zm10-3.5l-.3.01 3.79 3.8a3.54 3.54 0 00.01-.56V2.75a.75.75 0 00-.97-.72l-10 3c-.2.06-.35.2-.44.37L10 6.82V6.3l8.5-2.55v2.43l-7.02 2.1 1.2 1.21 5.82-1.74v5.87a3.48 3.48 0 00-2-.63z",
    fill: primaryFill
  }));
};

export const MusicNoteOff224Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MusicNoteOff224RegularIcon, 'MusicNoteOff224Regular');

const MyLocation12FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 7.75a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zm.75-5.68a4 4 0 013.18 3.18h1.32a.75.75 0 010 1.5H9.93a4 4 0 01-3.18 3.18v1.32a.75.75 0 01-1.5 0V10v-.07a4 4 0 01-3.18-3.18H.75a.75.75 0 010-1.5h1.32a4 4 0 013.18-3.18V.75a.75.75 0 011.5 0v1.32zM8.5 6a2.5 2.5 0 10-5 0 2.5 2.5 0 005 0z",
    fill: primaryFill
  }));
};

export const MyLocation12Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MyLocation12FilledIcon, 'MyLocation12Filled');

const MyLocation12RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 8a2 2 0 100-4 2 2 0 000 4zm-.5-5.97V.5a.5.5 0 011 0v1.53A4 4 0 019.97 5.5h1.53a.5.5 0 010 1H9.97A4 4 0 016.5 9.97a.5.5 0 010 .03v1.5a.5.5 0 01-1 0V10a.5.5 0 010-.03A4 4 0 012.03 6.5a.5.5 0 01-.03 0H.5a.5.5 0 010-1H2a.5.5 0 01.03 0A4 4 0 015.5 2.03zM3 6a3 3 0 106 0 3 3 0 00-6 0z",
    fill: primaryFill
  }));
};

export const MyLocation12Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MyLocation12RegularIcon, 'MyLocation12Regular');

const MyLocation16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 10.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm.75-8.75a.75.75 0 00-1.5 0v1.3a5 5 0 00-4.2 4.2h-1.3a.75.75 0 000 1.5h1.3a5 5 0 004.2 4.2v1.3a.75.75 0 001.5 0v-1.3a5 5 0 004.2-4.2h1.3a.75.75 0 000-1.5h-1.3a5 5 0 00-4.2-4.2v-1.3zM8 11.5a3.5 3.5 0 110-7 3.5 3.5 0 010 7z",
    fill: primaryFill
  }));
};

export const MyLocation16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MyLocation16FilledIcon, 'MyLocation16Filled');

const MyLocation16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 10.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm.5-9a.5.5 0 00-1 0v1.52A5 5 0 003.02 7.5H1.5a.5.5 0 000 1h1.52a5 5 0 004.48 4.48v1.52a.5.5 0 001 0v-1.52a5 5 0 004.48-4.48h1.52a.5.5 0 100-1h-1.52A5 5 0 008.5 3.02V1.5zM8 12a4 4 0 110-8 4 4 0 010 8z",
    fill: primaryFill
  }));
};

export const MyLocation16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MyLocation16RegularIcon, 'MyLocation16Regular');

const MyLocation20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 13a3 3 0 100-6 3 3 0 000 6zm.75-10.25a.75.75 0 00-1.5 0v1.3a6 6 0 00-5.2 5.2h-1.3a.75.75 0 000 1.5h1.3a6 6 0 005.2 5.2v1.3a.75.75 0 001.5 0v-1.3a6 6 0 005.2-5.2h1.3a.75.75 0 000-1.5h-1.3a6 6 0 00-5.2-5.2v-1.3zM10 14.5a4.5 4.5 0 110-9 4.5 4.5 0 010 9z",
    fill: primaryFill
  }));
};

export const MyLocation20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MyLocation20FilledIcon, 'MyLocation20Filled');

const MyLocation20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 13a3 3 0 100-6 3 3 0 000 6zm.5-10.5a.5.5 0 00-1 0v1.52A6 6 0 004.02 9.5H2.5a.5.5 0 000 1h1.52a6 6 0 005.48 5.48v1.52a.5.5 0 001 0v-1.52a6 6 0 005.48-5.48h1.52a.5.5 0 000-1h-1.52a6 6 0 00-5.48-5.48V2.5zM10 15a5 5 0 110-10 5 5 0 010 10z",
    fill: primaryFill
  }));
};

export const MyLocation20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MyLocation20RegularIcon, 'MyLocation20Regular');

const MyLocation24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 2a1 1 0 011 .88V4.31a7.75 7.75 0 016.69 6.7L21 11a1 1 0 01.12 2H19.69A7.75 7.75 0 0113 19.69V21a1 1 0 01-2 .12V19.69A7.75 7.75 0 014.31 13H3a1 1 0 01-.12-2H4.31a7.75 7.75 0 016.7-6.69L11 3a1 1 0 011-1zm0 4.25a5.75 5.75 0 100 11.5 5.75 5.75 0 000-11.5zM12 8a4 4 0 110 8 4 4 0 010-8z",
    fill: primaryFill
  }));
};

export const MyLocation24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/MyLocation24FilledIcon, 'MyLocation24Filled');

const MyLocation24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 2c.38 0 .7.28.74.65l.01.1v1.79a7.5 7.5 0 016.71 6.71h1.79a.75.75 0 01.1 1.5H19.46a7.5 7.5 0 01-6.71 6.71v1.79a.75.75 0 01-1.5.1V19.46a7.5 7.5 0 01-6.71-6.71H2.75a.75.75 0 01-.1-1.5H4.54a7.5 7.5 0 016.71-6.71V2.75c0-.41.34-.75.75-.75zm0 4a6 6 0 100 12 6 6 0 000-12zm0 2a4 4 0 110 8 4 4 0 010-8z",
    fill: primaryFill
  }));
};

export const MyLocation24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/MyLocation24RegularIcon, 'MyLocation24Regular');

const Navigation16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 3.75c0-.41.34-.75.75-.75h10.5a.75.75 0 010 1.5H2.75A.75.75 0 012 3.75zm0 4c0-.41.34-.75.75-.75h10.5a.75.75 0 010 1.5H2.75A.75.75 0 012 7.75zm0 4c0-.41.34-.75.75-.75h10.5a.75.75 0 010 1.5H2.75a.75.75 0 01-.75-.75z",
    fill: primaryFill
  }));
};

export const Navigation16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Navigation16FilledIcon, 'Navigation16Filled');

const Navigation16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 3.5c0-.28.22-.5.5-.5h11a.5.5 0 010 1h-11a.5.5 0 01-.5-.5zm0 4c0-.28.22-.5.5-.5h11a.5.5 0 010 1h-11a.5.5 0 01-.5-.5zm0 4c0-.28.22-.5.5-.5h11a.5.5 0 010 1h-11a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const Navigation16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Navigation16RegularIcon, 'Navigation16Regular');

const Navigation20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4.75c0-.41.34-.75.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 5c0-.41.34-.75.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 9.75zM2.75 14a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5H2.75z",
    fill: primaryFill
  }));
};

export const Navigation20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Navigation20FilledIcon, 'Navigation20Filled');

const Navigation20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4.5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zm0 5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zm.5 4.5a.5.5 0 000 1h15a.5.5 0 000-1h-15z",
    fill: primaryFill
  }));
};

export const Navigation20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Navigation20RegularIcon, 'Navigation20Regular');

const Navigation24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 17h18a1 1 0 01.12 2H3a1 1 0 01-.12-2H21 3zm0-6h18a1 1 0 01.12 2H3a1 1 0 01-.12-2H21 3zm0-6h18a1 1 0 01.12 2H3a1 1 0 01-.12-2H21 3z",
    fill: primaryFill
  }));
};

export const Navigation24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Navigation24FilledIcon, 'Navigation24Filled');

const Navigation24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.75 18h18.5a.75.75 0 01.1 1.5H2.75a.75.75 0 01-.1-1.5h18.6-18.5zm0-6.5h18.5a.75.75 0 01.1 1.5H2.75a.75.75 0 01-.1-1.5h18.6-18.5zm0-6.5h18.5a.75.75 0 01.1 1.5H2.75a.75.75 0 01-.1-1.49h18.6-18.5z",
    fill: primaryFill
  }));
};

export const Navigation24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Navigation24RegularIcon, 'Navigation24Regular');

const NavigationLocationTarget20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.75 5a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5H2.75zM2 10.75c0-.41.34-.75.75-.75h11.34a1.5 1.5 0 00-.07.27 4.47 4.47 0 00-1.85 1.23H2.75a.75.75 0 01-.75-.75zM2.75 15h7.34a1.5 1.5 0 001.18.98c.06.18.13.35.22.52H2.75a.75.75 0 010-1.5zm13.3.33a1 1 0 11-1.1-1.66 1 1 0 011.1 1.66zm2.9-1.33h.55a.5.5 0 010 1h-.55A3.49 3.49 0 0116 17.95v.55a.5.5 0 01-1 0v-.55A3.49 3.49 0 0112.05 15h-.55a.5.5 0 010-1h.55A3.49 3.49 0 0115 11.05v-.55a.5.5 0 011 0v.55A3.49 3.49 0 0118.95 14zm-3.2 2.99a2.5 2.5 0 10-.5-4.98 2.5 2.5 0 00.5 4.98z",
    fill: primaryFill
  }));
};

export const NavigationLocationTarget20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NavigationLocationTarget20FilledIcon, 'NavigationLocationTarget20Filled');

const NavigationLocationTarget20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.5 5a.5.5 0 000 1h15a.5.5 0 000-1h-15zm0 5a.5.5 0 000 1h10.2c.4-.32.84-.56 1.32-.73.01-.1.04-.18.07-.27H2.5zm7.86 5.48a1.5 1.5 0 01-.27-.48H2.5a.5.5 0 000 1h8.77v-.02a1.5 1.5 0 01-.91-.5zm5.14.02a1 1 0 100-2 1 1 0 000 2zm4-1.5h-.55A3.49 3.49 0 0016 11.05v-.55a.5.5 0 00-1 0v.55A3.49 3.49 0 0012.05 14h-.55a.5.5 0 000 1h.55A3.49 3.49 0 0015 17.95v.55a.5.5 0 001 0v-.55A3.49 3.49 0 0018.95 15h.55a.5.5 0 000-1zm-2.23 2.27a2.5 2.5 0 11-3.54-3.54 2.5 2.5 0 013.54 3.54z",
    fill: primaryFill
  }));
};

export const NavigationLocationTarget20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NavigationLocationTarget20RegularIcon, 'NavigationLocationTarget20Regular');

const NavigationPlay20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.75 5a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5H2.75zM2 10.75c0-.41.34-.75.75-.75h9.59c-.58.4-1.07.91-1.45 1.5H2.75a.75.75 0 01-.75-.75zM2.75 15h7.27c.05.52.17 1.03.35 1.5H2.75a.75.75 0 010-1.5zM20 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.29-.44l-2.97-1.65a.5.5 0 00-.74.44v3.3c0 .38.41.62.74.44l2.97-1.65a.5.5 0 000-.88z",
    fill: primaryFill
  }));
};

export const NavigationPlay20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NavigationPlay20FilledIcon, 'NavigationPlay20Filled');

const NavigationPlay20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.5 5a.5.5 0 000 1h15a.5.5 0 000-1h-15zm0 5a.5.5 0 000 1h8.76c.31-.38.67-.72 1.08-1H2.5zm7.7 6c-.08-.32-.15-.66-.18-1H2.5a.5.5 0 000 1h7.7zm9.8-1.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.29-.44l-2.97-1.65a.5.5 0 00-.74.44v3.3c0 .38.41.62.74.44l2.97-1.65a.5.5 0 000-.88z",
    fill: primaryFill
  }));
};

export const NavigationPlay20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NavigationPlay20RegularIcon, 'NavigationPlay20Regular');

const NavigationUnread20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.98 4.57l.02-.32a2.25 2.25 0 10-.28 1.08c.13-.24.22-.5.26-.76zM2.75 4h9.76a3.28 3.28 0 00.24 1.5h-10a.75.75 0 010-1.5zM2 9.75c0-.41.34-.75.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 9.75zM2.75 14a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5H2.75z",
    fill: primaryFill
  }));
};

export const NavigationUnread20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NavigationUnread20FilledIcon, 'NavigationUnread20Filled');

const NavigationUnread20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18 4.42v-.17a2.25 2.25 0 10-.05.46c.02-.1.04-.2.04-.29zM2.5 4h10a3.28 3.28 0 00.09 1H2.5a.5.5 0 010-1zM2 9.5c0-.28.22-.5.5-.5h15a.5.5 0 010 1h-15a.5.5 0 01-.5-.5zm.5 4.5a.5.5 0 000 1h15a.5.5 0 000-1h-15z",
    fill: primaryFill
  }));
};

export const NavigationUnread20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NavigationUnread20RegularIcon, 'NavigationUnread20Regular');

const NavigationUnread24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19.25 8.5a2.75 2.75 0 100-5.5 2.75 2.75 0 000 5.5zM15.71 7a3.74 3.74 0 01-.14-2H2.88A1 1 0 003 7h12.71zM21 17H2.88A1 1 0 003 19h18.12a1 1 0 00-.12-2zM3 11h18a1 1 0 01.12 2H3a1 1 0 01-.12-2H3z",
    fill: primaryFill
  }));
};

export const NavigationUnread24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NavigationUnread24FilledIcon, 'NavigationUnread24Filled');

const NavigationUnread24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M19.25 8.5a2.75 2.75 0 100-5.5 2.75 2.75 0 000 5.5zm-3.67-2a3.77 3.77 0 010-1.5H2.74l-.1.01a.75.75 0 00.1 1.5h12.83zM21.25 18H2.65a.75.75 0 00.1 1.5h18.6a.75.75 0 00-.1-1.5zm-18.5-6.5h18.5a.75.75 0 01.1 1.5H2.75a.75.75 0 01-.1-1.49h.1z",
    fill: primaryFill
  }));
};

export const NavigationUnread24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NavigationUnread24RegularIcon, 'NavigationUnread24Regular');

const NetworkCheck20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.51 10.18a8 8 0 0110.37-4.65l.57-.72.08-.1a9 9 0 00-11.95 5.1.5.5 0 10.93.37zm13.5-3.87a9.02 9.02 0 012.41 3.51.5.5 0 01-.93.36 8 8 0 00-1.87-2.88l.26-.66.14-.33zM10 6.5c.66 0 1.3.1 1.9.28l-.67.86a5.52 5.52 0 00-6.56 3.98.5.5 0 11-.96-.24A6.5 6.5 0 0110 6.5zm5 2.35l-.44 1.08c.35.51.6 1.08.77 1.7a.5.5 0 10.97-.25c-.25-.95-.7-1.8-1.3-2.53zM10 9h.16l-.83 1.08A3 3 0 007 13a.5.5 0 01-1 0 4 4 0 014-4zm3.17 4.35v.02c.08.08.2.13.33.13a.5.5 0 00.5-.5 4 4 0 00-.19-1.21l-.64 1.56zm.22-6.85l.61-.78.23-.29.04-.04a.5.5 0 01.86.37l-.04.16-.14.35a1207.08 1207.08 0 01-2.7 6.7 77.26 77.26 0 01-.73 1.66 1.75 1.75 0 01-3.04-1.75l.38-.54.7-.92a341.32 341.32 0 013.83-4.92zm1.74-.74a.5.5 0 01-.04.16z",
    fill: primaryFill
  }));
};

export const NetworkCheck20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NetworkCheck20FilledIcon, 'NetworkCheck20Filled');

const NetworkCheck20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.51 10.18a8 8 0 0110.37-4.65l.57-.72.08-.1a9 9 0 00-11.95 5.1.5.5 0 10.93.37zm13.5-3.87a9.02 9.02 0 012.41 3.51.5.5 0 01-.93.36 8 8 0 00-1.87-2.88l.26-.66.14-.33zM10 6.5c.66 0 1.3.1 1.9.28l-.67.86a5.52 5.52 0 00-6.56 3.98.5.5 0 11-.96-.24A6.5 6.5 0 0110 6.5zm5 2.35l-.44 1.08c.35.51.6 1.08.77 1.7a.5.5 0 10.97-.25c-.25-.95-.7-1.8-1.3-2.53zM10 9h.16l-.83 1.08A3 3 0 007 13a.5.5 0 01-1 0 4 4 0 014-4zm3.17 4.35v.02c.08.08.2.13.33.13a.5.5 0 00.5-.5 4 4 0 00-.19-1.21l-.64 1.56zm.22-6.85l.61-.78.23-.29.04-.04a.5.5 0 01.86.37l-.04.16-.14.35a1207.08 1207.08 0 01-2.7 6.7 77.26 77.26 0 01-.73 1.66 1.75 1.75 0 01-3.04-1.75l.38-.54.7-.92a341.32 341.32 0 013.83-4.92zm-1.1 3.02a338.93 338.93 0 00-2.94 3.86.75.75 0 101.3.75l.23-.5.44-1.05a342.47 342.47 0 001.55-3.8l-.57.74zm2.84-3.76a.5.5 0 01-.04.16z",
    fill: primaryFill
  }));
};

export const NetworkCheck20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NetworkCheck20RegularIcon, 'NetworkCheck20Regular');

const NetworkCheck24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.05 15.42l6.26-8.48a.7.7 0 011.23.57l-.03.1-3.87 9.8a2.07 2.07 0 11-3.74-1.76l.07-.12.08-.11 6.26-8.48-6.26 8.48zm2.05-4.55l-1.23 1.66a3.33 3.33 0 00-2.29 3.03.75.75 0 01-1.5-.07 4.82 4.82 0 015.02-4.62zm4.17 2.75c.28.59.43 1.22.46 1.87a.75.75 0 01-1.38.44l.92-2.3zm-2.24-5.37l-.96 1.31a6.22 6.22 0 00-7.16 4.41.75.75 0 01-1.44-.4 7.7 7.7 0 019.56-5.32zm3.51 2.14a7.65 7.65 0 011.8 3.15.75.75 0 01-1.44.42 6.23 6.23 0 00-.88-1.84l-.1-.14.62-1.59zm-1.56-4.54l-.09.06c-.12.08-.23.18-.33.3l-.1.11-.54.73a9.14 9.14 0 00-11.54 5.32.75.75 0 11-1.4-.54 10.64 10.64 0 0114-5.97zm2.63 1.56a10.65 10.65 0 013.22 4.41.75.75 0 11-1.4.55 9.17 9.17 0 00-2.32-3.4l.38-.97c.07-.2.11-.39.12-.59z",
    fill: primaryFill
  }));
};

export const NetworkCheck24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NetworkCheck24FilledIcon, 'NetworkCheck24Filled');

const NetworkCheck24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.05 15.42l6.26-8.48a.7.7 0 011.23.57l-.03.1-3.87 9.8a2.07 2.07 0 11-3.74-1.76l.07-.12.08-.11 6.26-8.48-6.26 8.48zm3.8-2.62l-2.6 3.51-.03.06a.57.57 0 00.22.78l.07.03c.26.1.55 0 .7-.24l.04-.08 1.6-4.06zm-1.75-1.93l-1.23 1.66a3.33 3.33 0 00-2.29 3.03.75.75 0 01-1.5-.07 4.82 4.82 0 015.02-4.62zm4.17 2.75c.28.59.43 1.22.46 1.87a.75.75 0 01-1.38.44l.92-2.3zm-2.24-5.37l-.96 1.31a6.22 6.22 0 00-7.16 4.41.75.75 0 01-1.44-.4 7.7 7.7 0 019.56-5.32zm3.51 2.14a7.65 7.65 0 011.8 3.15.75.75 0 01-1.44.42 6.23 6.23 0 00-.88-1.84l-.1-.14.62-1.59zm-1.56-4.54l-.09.06c-.12.08-.23.18-.33.3l-.1.11-.54.73a9.14 9.14 0 00-11.54 5.32.75.75 0 11-1.4-.54 10.64 10.64 0 0114-5.97zm2.63 1.56a10.65 10.65 0 013.22 4.41.75.75 0 11-1.4.55 9.17 9.17 0 00-2.32-3.4l.38-.97c.07-.2.11-.39.12-.59z",
    fill: primaryFill
  }));
};

export const NetworkCheck24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NetworkCheck24RegularIcon, 'NetworkCheck24Regular');

const New16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.75 11h4.5a.75.75 0 01.1 1.5h-4.6a.75.75 0 01-.1-1.5h4.6-4.5zm1.47-5.78a.75.75 0 01.98-.07l.08.07 3.5 3.5a.75.75 0 01-.98 1.13l-.08-.07-3.5-3.5a.75.75 0 010-1.06zM11.75 3c.38 0 .7.28.74.65l.01.1v4.5a.75.75 0 01-1.5.1v-4.6c0-.41.34-.75.75-.75z",
    fill: primaryFill
  }));
};

export const New16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/New16FilledIcon, 'New16Filled');

const New16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 11h5a.5.5 0 01.1 1H3.5a.5.5 0 01-.09-1h5.1-5zm1.65-5.85a.5.5 0 01.64-.06l.07.06 4 4a.5.5 0 01-.64.76l-.07-.06-4-4a.5.5 0 010-.7zM11.5 3a.5.5 0 01.5.41V8.5a.5.5 0 01-.99.09V3.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const New16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/New16RegularIcon, 'New16Regular');

const New20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.5 2.75c.41 0 .75.34.75.75v8a.75.75 0 01-1.5 0v-8c0-.41.34-.75.75-.75zM5.97 5.97c.3-.3.77-.3 1.06 0l6 6a.75.75 0 11-1.06 1.06l-6-6a.75.75 0 010-1.06zM3.5 14.75a.75.75 0 000 1.5h8a.75.75 0 000-1.5h-8z",
    fill: primaryFill
  }));
};

export const New20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/New20FilledIcon, 'New20Filled');

const New20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.5 3c.28 0 .5.22.5.5v8a.5.5 0 01-1 0v-8c0-.28.22-.5.5-.5zM6.15 6.15c.2-.2.5-.2.7 0l6 6a.5.5 0 01-.7.7l-6-6a.5.5 0 010-.7zM3.5 15a.5.5 0 000 1h8a.5.5 0 000-1h-8z",
    fill: primaryFill
  }));
};

export const New20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/New20RegularIcon, 'New20Regular');

const New24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18 4a1 1 0 011 1v8a1 1 0 11-2 0V5a1 1 0 011-1zM4 18a1 1 0 011-1h8a1 1 0 110 2H5a1 1 0 01-1-1zM7.7 6.3a1 1 0 00-1.4 1.4l7 7a1 1 0 001.4-1.4l-7-7z",
    fill: primaryFill
  }));
};

export const New24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/New24FilledIcon, 'New24Filled');

const New24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.25 4c.41 0 .75.34.75.75v8.5a.75.75 0 01-1.5 0v-8.5c0-.41.34-.75.75-.75zM4 18.25c0-.41.34-.75.75-.75h8.5a.75.75 0 010 1.5h-8.5a.75.75 0 01-.75-.75zM8.28 7.22a.75.75 0 00-1.06 1.06l6.5 6.5a.75.75 0 101.06-1.06l-6.5-6.5z",
    fill: primaryFill
  }));
};

export const New24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/New24RegularIcon, 'New24Regular');

const News16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 9V8h1v1H4zM1 4c0-1.1.9-2 2-2h7a2 2 0 012 2v6.5a.5.5 0 001 0V4a2 2 0 012 2v4.5a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 011 10.5V4zm2.5 1a.5.5 0 000 1h6a.5.5 0 000-1h-6zm0 2a.5.5 0 00-.5.5v2c0 .28.22.5.5.5h2a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-2zm4 0a.5.5 0 000 1h2a.5.5 0 000-1h-2zm0 2a.5.5 0 000 1h2a.5.5 0 000-1h-2z",
    fill: primaryFill
  }));
};

export const News16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/News16FilledIcon, 'News16Filled');

const News16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 5a.5.5 0 000 1h7a.5.5 0 000-1h-7zm0 2a.5.5 0 00-.5.5v2c0 .28.22.5.5.5h2a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-2zM4 9V8h1v1H4zm3.5-2a.5.5 0 000 1h3a.5.5 0 000-1h-3zm0 2a.5.5 0 000 1h3a.5.5 0 000-1h-3zM1 4c0-1.1.9-2 2-2h8a2 2 0 012 2 2 2 0 012 2v4.5a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 011 10.5V4zm11.5 6.5a.5.5 0 01-.5-.5V4a1 1 0 00-1-1H3a1 1 0 00-1 1v6.5c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5V6a1 1 0 00-1-1v5a.5.5 0 01-.5.5z",
    fill: primaryFill
  }));
};

export const News16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/News16RegularIcon, 'News16Regular');

const News20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 12v-2h2v2H5zm10-7.5c0-.83-.67-1.5-1.5-1.5H3.42c-.83 0-1.5.67-1.5 1.5v9a2.5 2.5 0 002.5 2.5h11.16a2.5 2.5 0 002.5-2.5v-6c0-.83-.67-1.5-1.5-1.5H16v7.23a.5.5 0 01-1 0V4.5zm-11 2c0-.28.22-.5.5-.5h8a.5.5 0 010 1h-8a.5.5 0 01-.5-.5zM9.5 9h3a.5.5 0 010 1h-3a.5.5 0 010-1zM9 12.5c0-.28.22-.5.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5zM4.5 9h3c.28 0 .5.22.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-3c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const News20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/News20FilledIcon, 'News20Filled');

const News20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 6.5c0-.28.22-.5.5-.5h7a.5.5 0 010 1h-7a.5.5 0 01-.5-.5zM10.5 9a.5.5 0 000 1h2a.5.5 0 000-1h-2zm-.5 3.5c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5zM5.5 9a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h3a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-3zm.5 3v-2h2v2H6zM2 5c0-1.1.9-2 2-2h10a2 2 0 012 2v1a2 2 0 012 2v5.5a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 012 13.5V5zm13 0a1 1 0 00-1-1H4a1 1 0 00-1 1v8.5c0 .83.67 1.5 1.5 1.5h11c.83 0 1.5-.67 1.5-1.5V8a1 1 0 00-1-1v6.5a.5.5 0 01-1 0V5z",
    fill: primaryFill
  }));
};

export const News20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/News20RegularIcon, 'News20Regular');

const News24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.75 4c1.2 0 2.17.93 2.24 2.1l.01.15V17.5a.5.5 0 001 .09V7.01c1.07.12 1.92 1 2 2.08v7.66a3.25 3.25 0 01-3.07 3.24l-.18.01H5.25a3.25 3.25 0 01-3.24-3.07L2 16.75V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h12.5zm-7.5 7h-3.5a.75.75 0 00-.75.75v3.5c0 .41.33.75.75.75h3.5c.41 0 .75-.34.75-.75v-3.5a.75.75 0 00-.75-.75zm6 3.5h-2.6a.75.75 0 00.1 1.5h2.6a.75.75 0 00-.1-1.5zm-6.75-2v2h-2v-2h2zm6.75-1.5h-2.5l-.1.01a.75.75 0 00.1 1.5l2.5-.01h.1a.75.75 0 00-.1-1.5zm0-3.5h-9.5l-.1.01a.75.75 0 00.1 1.5h9.5l.1-.01a.75.75 0 00-.1-1.5z",
    fill: primaryFill
  }));
};

export const News24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/News24FilledIcon, 'News24Filled');

const News24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.75 20H5.25a3.25 3.25 0 01-3.24-3.07L2 16.75V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h12.5c1.2 0 2.17.93 2.24 2.1l.01.15V7h.75c1.2 0 2.17.93 2.24 2.1l.01.15v7.5a3.25 3.25 0 01-3.07 3.24l-.18.01H5.25h13.5zm-13.5-1.5h13.5c.92 0 1.67-.7 1.74-1.6l.01-.15v-7.5c0-.38-.28-.7-.65-.74l-.1-.01H19v7.75c0 .38-.28.7-.65.74l-.1.01a.75.75 0 01-.74-.65l-.01-.1v-10c0-.38-.28-.7-.65-.74l-.1-.01H4.25c-.38 0-.7.28-.74.65l-.01.1v10.5c0 .92.7 1.67 1.6 1.74l.15.01h13.5-13.5zm7-4h3a.75.75 0 01.1 1.5h-3.1a.75.75 0 01-.1-1.5h3.1-3zm-3-3.5c.4 0 .74.34.74.75v3.5c0 .41-.33.75-.75.75h-3.5a.75.75 0 01-.74-.75v-3.5c0-.41.33-.75.75-.75h3.5zm-.76 1.5h-2v2h2v-2zm3.76-1.5h3a.75.75 0 01.1 1.5h-3.1a.75.75 0 01-.1-1.49h3.1-3zm-6.5-3.5h9.5a.75.75 0 01.1 1.5h-9.6a.75.75 0 01-.1-1.5h9.6-9.5z",
    fill: primaryFill
  }));
};

export const News24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/News24RegularIcon, 'News24Regular');

const News28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M22 5.75V20.5a.5.5 0 001 .09V7h1.25c.92 0 1.67.7 1.74 1.6l.01.15v12a3.25 3.25 0 01-3.07 3.24l-.18.01H5.25a3.25 3.25 0 01-3.24-3.07L2 20.75v-15c0-.92.7-1.67 1.6-1.74L3.76 4h16.5c.92 0 1.67.7 1.74 1.6l.01.15V20.5 5.75zM9.75 13h-2.5c-.92 0-1.67.71-1.74 1.61l-.01.14v2.5c0 .92.7 1.67 1.6 1.74l.15.01h2.5c.91 0 1.67-.7 1.74-1.6v-2.65c0-.91-.7-1.67-1.6-1.74h-.14zm8 4.5h-3.6a.75.75 0 000 1.5h3.7a.75.75 0 000-1.5h-.1zm-10.5-3h2.5c.11 0 .21.09.24.2v2.55c0 .12-.08.22-.19.24l-.05.01h-2.5a.25.25 0 01-.24-.2L7 17.26v-2.5c0-.11.08-.21.2-.24h2.55-2.5zm10.5-1.5h-3.5l-.1.01a.75.75 0 000 1.49h3.7a.75.75 0 000-1.49h-.1zm0-4.5H6.15a.75.75 0 000 1.49h11.7a.75.75 0 000-1.49h-.1z",
    fill: primaryFill
  }));
};

export const News28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/News28FilledIcon, 'News28Filled');

const News28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M22.75 24H5.25a3.25 3.25 0 01-3.24-3.07L2 20.75V6.25c0-1.2.93-2.17 2.1-2.24L4.25 4h15.5c1.2 0 2.17.93 2.24 2.1l.01.15V7h1.75c1.2 0 2.17.93 2.24 2.1l.01.15v11.5a3.25 3.25 0 01-3.07 3.24l-.18.01H5.25h17.5zm-17.5-1.5h17.5c.92 0 1.67-.7 1.74-1.6l.01-.15V9.25c0-.38-.28-.7-.65-.74l-.1-.01H22v10.75c0 .38-.28.7-.65.74l-.1.01a.75.75 0 01-.74-.65l-.01-.1v-13c0-.38-.28-.7-.65-.74l-.1-.01H4.25c-.38 0-.7.28-.74.65l-.01.1v14.5c0 .92.7 1.67 1.6 1.74l.15.01h17.5-17.5zm5-9.5c.69 0 1.25.56 1.25 1.25v3.5c0 .69-.56 1.25-1.25 1.25h-3.5c-.69 0-1.25-.56-1.25-1.25v-3.5c0-.69.56-1.25 1.25-1.25h3.5zm4 4.5h3.5a.75.75 0 01.1 1.5h-3.6a.75.75 0 01-.1-1.5h3.6-3.5zm-4.25-3H7v3h3v-3zm4.25-1.5h3.5a.75.75 0 01.1 1.5h-3.6a.75.75 0 01-.1-1.49h3.6-3.5zm-8-4.5h11.5a.75.75 0 01.1 1.49H6.25a.75.75 0 01-.1-1.49h11.6-11.5z",
    fill: primaryFill
  }));
};

export const News28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/News28RegularIcon, 'News28Regular');

const Next16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 3a1 1 0 011.58-.81l7 4.96a1 1 0 010 1.63l-7 5.03a1 1 0 01-1.58-.8V3zm12-.5a.5.5 0 10-1 0v11a.5.5 0 001 0v-11z",
    fill: primaryFill
  }));
};

export const Next16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Next16FilledIcon, 'Next16Filled');

const Next16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 2.5a.5.5 0 10-1 0v11a.5.5 0 001 0v-11zM2 3a1 1 0 011.58-.81l7 4.96a1 1 0 010 1.63l-7 5.03a1 1 0 01-1.58-.8V3zm8 4.96L3 3v10l7-5.04z",
    fill: primaryFill
  }));
};

export const Next16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Next16RegularIcon, 'Next16Regular');

const Next20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 4.25c0-1 1.12-1.6 1.95-1.04l8.5 5.71c.73.5.73 1.57 0 2.07l-8.5 5.8A1.25 1.25 0 013 15.75V4.25zm14-.75a.5.5 0 00-1 0v13a.5.5 0 101 0v-13z",
    fill: primaryFill
  }));
};

export const Next20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Next20FilledIcon, 'Next20Filled');

const Next20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17 3.5a.5.5 0 10-1 0v13a.5.5 0 001 0v-13zM3 4.25c0-1 1.12-1.6 1.95-1.04l8.5 5.71c.73.5.73 1.57 0 2.07l-8.5 5.8A1.25 1.25 0 013 15.75V4.25zm1.39-.2a.25.25 0 00-.39.2v11.5c0 .2.23.32.4.2l8.49-5.78a.25.25 0 000-.42l-8.5-5.7z",
    fill: primaryFill
  }));
};

export const Next20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Next20RegularIcon, 'Next20Regular');

const Next24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 4.75c0-1.4 1.58-2.24 2.74-1.44l10.5 7.2c1 .68 1.01 2.17 0 2.87l-10.5 7.3A1.75 1.75 0 013 19.25V4.75zm18-1a.75.75 0 00-1.5 0v16.5a.75.75 0 001.5 0V3.75z",
    fill: primaryFill
  }));
};

export const Next24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Next24FilledIcon, 'Next24Filled');

const Next24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 4.75c0-1.4 1.58-2.24 2.74-1.44l10.5 7.2c1 .68 1.01 2.17 0 2.87l-10.5 7.3A1.75 1.75 0 013 19.25V4.75zm1.9-.2a.25.25 0 00-.4.2v14.5c0 .2.23.32.4.2l10.5-7.3a.25.25 0 00-.01-.41l-10.5-7.2zm16.1-.8a.75.75 0 00-1.5 0v16.5a.75.75 0 001.5 0V3.75z",
    fill: primaryFill
  }));
};

export const Next24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Next24RegularIcon, 'Next24Regular');

const Next28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M23.5 3.75a.75.75 0 011.5 0v20.5a.75.75 0 01-1.5 0V3.75zM3 5.25a2.25 2.25 0 013.53-1.84l12.5 8.68c1.3.89 1.3 2.78.02 3.68l-12.5 8.81A2.25 2.25 0 013 22.75V5.25z",
    fill: primaryFill
  }));
};

export const Next28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Next28FilledIcon, 'Next28Filled');

const Next28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M23.5 3.75a.75.75 0 011.5 0v20.5a.75.75 0 01-1.5 0V3.75zM3 5.25a2.25 2.25 0 013.53-1.84l12.5 8.68c1.3.89 1.3 2.78.02 3.68l-12.5 8.81A2.25 2.25 0 013 22.75V5.25zm2.68-.61a.75.75 0 00-1.18.61v17.5c0 .6.69.96 1.18.6l12.5-8.8a.75.75 0 000-1.23L5.68 4.64z",
    fill: primaryFill
  }));
};

export const Next28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Next28RegularIcon, 'Next28Regular');

const Next32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M26 5a1 1 0 112 0v22a1 1 0 01-2 0V5zM4 6.5c0-2 2.24-3.19 3.9-2.07l14 9.43A2.5 2.5 0 0121.9 18l-14 9.56A2.5 2.5 0 014 25.5v-19z",
    fill: primaryFill
  }));
};

export const Next32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Next32FilledIcon, 'Next32Filled');

const Next32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M26 5a1 1 0 112 0v22a1 1 0 01-2 0V5zM4 6.5c0-2 2.24-3.19 3.9-2.07l14 9.43A2.5 2.5 0 0121.9 18l-14 9.56A2.5 2.5 0 014 25.5v-19zm2.78-.41A.5.5 0 006 6.5v19c0 .4.45.64.78.4l14-9.55a.5.5 0 000-.83l-14-9.43z",
    fill: primaryFill
  }));
};

export const Next32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Next32RegularIcon, 'Next32Regular');

const Next48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M40.75 6c-.69 0-1.25.56-1.25 1.25v33.5a1.25 1.25 0 002.5 0V7.25C42 6.56 41.44 6 40.75 6zM6 9.26a3.25 3.25 0 015.09-2.68l21.5 14.74a3.25 3.25 0 010 5.36L11.1 41.42A3.25 3.25 0 016 38.74V9.26z",
    fill: primaryFill
  }));
};

export const Next48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Next48FilledIcon, 'Next48Filled');

const Next48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M39.5 7.25a1.25 1.25 0 112.5 0v33.5a1.25 1.25 0 01-2.5 0V7.25zM6 9.25v29.5a3.25 3.25 0 005.09 2.67l21.5-14.74a3.25 3.25 0 000-5.36L11.1 6.58A3.25 3.25 0 006 9.26zm3.67-.61l21.5 14.74c.44.3.44.94 0 1.24L9.68 39.36a.75.75 0 01-1.17-.62V9.26c0-.6.68-.96 1.17-.62z",
    fill: primaryFill
  }));
};

export const Next48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Next48RegularIcon, 'Next48Regular');

const Note16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 4.5A2.5 2.5 0 014.5 2h7A2.5 2.5 0 0114 4.5V8h-3.5A2.5 2.5 0 008 10.5V14H4.5A2.5 2.5 0 012 11.5v-7zm7 9.36c.35-.12.67-.32.94-.6l3.33-3.32c.27-.27.47-.59.59-.94H10.5C9.67 9 9 9.67 9 10.5v3.36z",
    fill: primaryFill
  }));
};

export const Note16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Note16FilledIcon, 'Note16Filled');

const Note16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 2A2.5 2.5 0 002 4.5v7A2.5 2.5 0 004.5 14h3.67c.66 0 1.3-.26 1.77-.73l3.33-3.33c.47-.47.73-1.1.73-1.77V4.5A2.5 2.5 0 0011.5 2h-7zM3 4.5C3 3.67 3.67 3 4.5 3h7c.83 0 1.5.67 1.5 1.5V8h-2.5A2.5 2.5 0 008 10.5V13H4.5A1.5 1.5 0 013 11.5v-7zm6 8.25V10.5c0-.83.67-1.5 1.5-1.5h2.25a1.5 1.5 0 01-.19.23l-3.33 3.33a1.5 1.5 0 01-.23.2z",
    fill: primaryFill
  }));
};

export const Note16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Note16RegularIcon, 'Note16Regular');

const Note20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 3a3 3 0 013 2.82V10h-4.18a3 3 0 00-2.81 2.82L10 13v4H6a3 3 0 01-3-2.82V6a3 3 0 012.82-3H14zm2.9 8a2 2 0 01-.36.65l-.13.14-4.62 4.62a2 2 0 01-.79.5V12.84a2 2 0 011.84-1.84L13 11h3.9z",
    fill: primaryFill
  }));
};

export const Note20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Note20FilledIcon, 'Note20Filled');

const Note20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 3a3 3 0 013 2.82v4.56a2 2 0 01-.47 1.28l-.12.13-4.62 4.62a2 2 0 01-1.24.58l-.17.01H6a3 3 0 01-3-2.82V6a3 3 0 012.82-3H14zm0 1H6a2 2 0 00-2 1.85V14a2 2 0 001.85 2H10v-3a3 3 0 012.82-3H16V6a2 2 0 00-1.85-2H14zm1.78 7H13a2 2 0 00-2 1.85V15.78l.09-.07 4.62-4.62a1 1 0 00.07-.09z",
    fill: primaryFill
  }));
};

export const Note20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Note20RegularIcon, 'Note20Regular');

const Note24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.75 3C19.55 3 21 4.46 21 6.25V13h-4.75A3.25 3.25 0 0013 16.25V21H6.25A3.25 3.25 0 013 17.75V6.25C3 4.45 4.46 3 6.25 3h11.5zm2.81 11.5l-6.06 6.06v-4.31c0-.97.78-1.75 1.75-1.75h4.31z",
    fill: primaryFill
  }));
};

export const Note24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Note24FilledIcon, 'Note24Filled');

const Note24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.75 3C19.55 3 21 4.46 21 6.25v6.88c0 .6-.24 1.17-.66 1.59l-5.62 5.62c-.42.42-1 .66-1.6.66H6.26A3.25 3.25 0 013 17.75V6.25C3 4.45 4.46 3 6.25 3h11.5zm0 1.5H6.25c-.97 0-1.75.78-1.75 1.75v11.5c0 .97.78 1.75 1.75 1.75H13v-3.25a3.25 3.25 0 013.07-3.24l.18-.01h3.25V6.25c0-.97-.78-1.75-1.75-1.75zm.69 10h-2.19c-.92 0-1.67.7-1.74 1.6l-.01.15v2.19l3.94-3.94z",
    fill: primaryFill
  }));
};

export const Note24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Note24RegularIcon, 'Note24Regular');

const Note28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6.75A3.75 3.75 0 016.75 3h14.5A3.75 3.75 0 0125 6.75V15h-6.25A3.75 3.75 0 0015 18.75V25H6.75A3.75 3.75 0 013 21.25V6.75zM16.5 25h.06L25 16.56v-.06h-6.25c-1.24 0-2.25 1-2.25 2.25V25z",
    fill: primaryFill
  }));
};

export const Note28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Note28FilledIcon, 'Note28Filled');

const Note28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.75 3A3.75 3.75 0 003 6.75v14.5A3.75 3.75 0 006.75 25h8.5c1 0 1.96-.4 2.66-1.1l6-6c.7-.7 1.09-1.65 1.09-2.64V6.75A3.75 3.75 0 0021.25 3H6.75zM4.5 6.75c0-1.24 1-2.25 2.25-2.25h14.5c1.24 0 2.25 1 2.25 2.25V15h-4.75A3.75 3.75 0 0015 18.75v4.75H6.75c-1.24 0-2.25-1-2.25-2.25V6.75zm12 16.38v-4.38c0-1.24 1-2.25 2.25-2.25h4.38c-.09.12-.18.24-.29.35l-6 6c-.1.1-.22.2-.34.28z",
    fill: primaryFill
  }));
};

export const Note28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Note28RegularIcon, 'Note28Regular');

const Note48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.25 6A6.25 6.25 0 006 12.25v23.5C6 39.2 8.8 42 12.25 42H26v-9.75C26 28.8 28.8 26 32.25 26H42V12.25C42 8.8 39.2 6 35.75 6h-23.5zm29.2 22.5h-9.2a3.75 3.75 0 00-3.75 3.75v9.2c.68-.31 1.3-.74 1.85-1.28l9.82-9.82c.54-.54.97-1.17 1.28-1.85z",
    fill: primaryFill
  }));
};

export const Note48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Note48FilledIcon, 'Note48Filled');

const Note48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.25 6A6.25 6.25 0 006 12.25v23.5C6 39.2 8.8 42 12.25 42h13.68c1.66 0 3.25-.66 4.42-1.83l9.82-9.82A6.25 6.25 0 0042 25.93V12.25C42 8.8 39.2 6 35.75 6h-23.5zM8.5 12.25a3.75 3.75 0 013.75-3.75h23.5a3.75 3.75 0 013.75 3.75V26h-7.25A6.25 6.25 0 0026 32.25v7.25H12.25a3.75 3.75 0 01-3.75-3.75v-23.5zm20 26.23v-6.23a3.75 3.75 0 013.75-3.75h6.23l-.08.08-9.82 9.82-.08.08z",
    fill: primaryFill
  }));
};

export const Note48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Note48RegularIcon, 'Note48Regular');

const NoteAdd16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5H3.5a.5.5 0 000 1H5v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H6V3.5zM5.5 11a5.5 5.5 0 004.9-8h2.1A2.5 2.5 0 0115 5.5V9h-3a3 3 0 00-3 3v3H5.5A2.5 2.5 0 013 12.5v-2.1c.75.38 1.6.6 2.5.6zm4.5 3.98c.32-.04.62-.19.85-.42l3.71-3.71c.23-.23.38-.53.42-.85H12a2 2 0 00-2 2v2.98z",
    fill: primaryFill
  }));
};

export const NoteAdd16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NoteAdd16FilledIcon, 'NoteAdd16Filled');

const NoteAdd16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5H3.5a.5.5 0 000 1H5v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H6V3.5zm6.5.5h-1.7c-.1-.35-.24-.68-.4-1h2.1A2.5 2.5 0 0115 5.5v4.29c0 .4-.16.78-.44 1.06l-3.71 3.71a1.5 1.5 0 01-1.06.44H5.5A2.5 2.5 0 013 12.5v-2.1c.32.16.65.3 1 .4v1.7c0 .83.67 1.5 1.5 1.5H9v-2a3 3 0 013-3h2V5.5c0-.83-.67-1.5-1.5-1.5zM10 13.95a.5.5 0 00.14-.1l3.71-3.71a.5.5 0 00.1-.14H12a2 2 0 00-2 2v1.95z",
    fill: primaryFill
  }));
};

export const NoteAdd16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NoteAdd16RegularIcon, 'NoteAdd16Regular');

const NoteAdd20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5H3.5a.5.5 0 000 1H5v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H6V3.5zM5.5 11a5.5 5.5 0 004.9-8H14a3 3 0 013 2.82V10h-4.18a3 3 0 00-2.81 2.82L10 13v4H6a3 3 0 01-3-2.82V10.4c.75.38 1.6.6 2.5.6zm11.4 0a2 2 0 01-.36.65l-.13.14-4.62 4.62a2 2 0 01-.79.5V12.84a2 2 0 011.84-1.84L13 11h3.9z",
    fill: primaryFill
  }));
};

export const NoteAdd20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NoteAdd20FilledIcon, 'NoteAdd20Filled');

const NoteAdd20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 5.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V5H3.5a.5.5 0 000 1H5v1.5a.5.5 0 001 0V6h1.5a.5.5 0 000-1H6V3.5zm8 .5h-3.2c-.1-.35-.24-.68-.4-1H14a3 3 0 013 2.82v4.56a2 2 0 01-.47 1.28l-.12.13-4.62 4.62a2 2 0 01-1.24.58l-.17.01H6a3 3 0 01-3-2.82V10.4c.32.16.65.3 1 .4V14a2 2 0 001.85 2H10v-3a3 3 0 012.82-3H16V6a2 2 0 00-1.85-2H14zm1.78 7H13a2 2 0 00-2 1.85V15.78l.09-.07 4.62-4.62a1 1 0 00.07-.09z",
    fill: primaryFill
  }));
};

export const NoteAdd20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NoteAdd20RegularIcon, 'NoteAdd20Regular');

const NoteAdd24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 6.5a5.5 5.5 0 10-11 0 5.5 5.5 0 0011 0zM7 7v2.5a.5.5 0 01-1 0V7H3.5a.5.5 0 010-1H6V3.5a.5.5 0 011 0V6h2.5a.5.5 0 010 1H7zm-.5 6a6.5 6.5 0 005.48-10h5.77C19.55 3 21 4.46 21 6.25V13h-4.75A3.25 3.25 0 0013 16.25V21H6.25A3.25 3.25 0 013 17.75v-5.77A6.47 6.47 0 006.5 13zm14.06 1.5l-6.06 6.06v-4.31c0-.97.78-1.75 1.75-1.75h4.31z",
    fill: primaryFill
  }));
};

export const NoteAdd24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NoteAdd24FilledIcon, 'NoteAdd24Filled');

const NoteAdd24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 6.5a5.5 5.5 0 10-11 0 5.5 5.5 0 0011 0zM7 7v2.5a.5.5 0 01-1 0V7H3.5a.5.5 0 010-1H6V3.5a.5.5 0 011 0V6h2.5a.5.5 0 010 1H7zm10.75-2.5h-5.06a6.47 6.47 0 00-.71-1.5h5.77C19.55 3 21 4.46 21 6.25v6.88c0 .6-.24 1.17-.66 1.59l-5.62 5.62c-.42.42-1 .66-1.6.66H6.26A3.25 3.25 0 013 17.75v-5.77c.46.3.97.53 1.5.7v5.07c0 .97.78 1.75 1.75 1.75H13v-3.25a3.25 3.25 0 013.07-3.24l.18-.01h3.25V6.25c0-.97-.78-1.75-1.75-1.75zm.69 10h-2.19c-.92 0-1.67.7-1.74 1.6l-.01.15v2.19l3.94-3.94z",
    fill: primaryFill
  }));
};

export const NoteAdd24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NoteAdd24RegularIcon, 'NoteAdd24Regular');

const NoteAdd28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15 7.5a7.5 7.5 0 01-12 6v7.75A3.75 3.75 0 006.75 25H15v-6.25A3.75 3.75 0 0118.75 15H25V6.75A3.75 3.75 0 0021.25 3H13.5A7.47 7.47 0 0115 7.5zM16.56 25h-.06v-6.25c0-1.24 1-2.25 2.25-2.25H25v.06L16.56 25zM7.5 14a6.5 6.5 0 100-13 6.5 6.5 0 000 13zm0-11c.28 0 .5.22.5.5V7h3.5a.5.5 0 010 1H8v3.5a.5.5 0 01-1 0V8H3.5a.5.5 0 010-1H7V3.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const NoteAdd28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NoteAdd28FilledIcon, 'NoteAdd28Filled');

const NoteAdd28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 7.5a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0zm-6-4a.5.5 0 00-1 0V7H3.5a.5.5 0 000 1H7v3.5a.5.5 0 001 0V8h3.5a.5.5 0 000-1H8V3.5zm13.25 1h-6.87A7.49 7.49 0 0013.5 3h7.75A3.75 3.75 0 0125 6.75v8.5c0 1-.4 1.96-1.1 2.66l-6 6c-.7.7-1.65 1.09-2.64 1.09H6.75A3.75 3.75 0 013 21.25V13.5c.46.35.96.64 1.5.88v6.87c0 1.24 1 2.25 2.25 2.25H15v-4.75A3.75 3.75 0 0118.75 15h4.75V6.75c0-1.24-1-2.25-2.25-2.25zM16.5 23.13c.12-.09.24-.18.35-.29l6-6c.1-.1.2-.22.28-.34h-4.38c-1.24 0-2.25 1-2.25 2.25v4.38z",
    fill: primaryFill
  }));
};

export const NoteAdd28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NoteAdd28RegularIcon, 'NoteAdd28Regular');

const NoteAdd48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M24 13a11 11 0 11-22 0 11 11 0 0122 0zM14 6a1 1 0 10-2 0v6H6a1 1 0 100 2h6v6a1 1 0 102 0v-6h6a1 1 0 100-2h-6V6zm-1 20A13 13 0 0023.96 6h11.79C39.2 6 42 8.8 42 12.25V26h-9.75A6.25 6.25 0 0026 32.25V42H12.25A6.25 6.25 0 016 35.75v-11.8A12.94 12.94 0 0013 26zm28.45 2.5h-9.2a3.75 3.75 0 00-3.75 3.75v9.2c.68-.31 1.3-.74 1.85-1.28l9.82-9.82c.54-.54.97-1.17 1.28-1.85z",
    fill: primaryFill
  }));
};

export const NoteAdd48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NoteAdd48FilledIcon, 'NoteAdd48Filled');

const NoteAdd48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M24 13a11 11 0 11-22 0 11 11 0 0122 0zM14 6a1 1 0 10-2 0v6H6a1 1 0 100 2h6v6a1 1 0 102 0v-6h6a1 1 0 100-2h-6V6zm21.75 2.5H25.2c-.33-.88-.74-1.72-1.24-2.5h11.79C39.2 6 42 8.8 42 12.25v13.68c0 1.66-.66 3.25-1.83 4.42l-9.82 9.82A6.25 6.25 0 0125.93 42H12.25A6.25 6.25 0 016 35.75v-11.8c.78.5 1.62.92 2.5 1.25v10.55a3.75 3.75 0 003.75 3.75H26v-7.25C26 28.8 28.8 26 32.25 26h7.25V12.25a3.75 3.75 0 00-3.75-3.75zM28.5 38.48l.08-.08 9.82-9.82.08-.08h-6.23a3.75 3.75 0 00-3.75 3.75v6.23z",
    fill: primaryFill
  }));
};

export const NoteAdd48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NoteAdd48RegularIcon, 'NoteAdd48Regular');

const NoteEdit20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 14.18A3 3 0 006 17h2l.06-.35.37-1.5a3.2 3.2 0 01.84-1.48l4.83-4.83a2.87 2.87 0 012.9-.7V5.81A3 3 0 0014 3h-4v4.18a3 3 0 01-2.82 2.81L7 10H3v4.18zm.46-5.83A2 2 0 003.1 9h4.06a2 2 0 001.83-1.85L9 7V3.1a2 2 0 00-.8.49L3.6 8.2l-.13.14zm6.52 6.03l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const NoteEdit20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NoteEdit20FilledIcon, 'NoteEdit20Filled');

const NoteEdit20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 14.18A3 3 0 006 17h2l.06-.35.16-.65H5.85A2 2 0 014 14v-4h3.18A3 3 0 0010 7V4h4.15A2 2 0 0116 6v2c.34-.01.68.03 1 .13V5.82A3 3 0 0014 3H9.45a2 2 0 00-1.24.59L3.59 8.2l-.12.13A2 2 0 003 9.62v4.56zM7 9H4.22a1 1 0 01.07-.09L8.91 4.3 9 4.22V7.15A2 2 0 017 9zm2.98 5.38l4.83-4.83a1.87 1.87 0 112.64 2.64l-4.83 4.83a2.2 2.2 0 01-1.02.58l-1.5.37a.89.89 0 01-1.07-1.07l.37-1.5c.1-.39.3-.74.58-1.02z",
    fill: primaryFill
  }));
};

export const NoteEdit20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NoteEdit20RegularIcon, 'NoteEdit20Regular');

const NoteEdit24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 17.75C3 19.55 4.46 21 6.25 21h4.92l.35-1.42c.16-.65.5-1.24.97-1.72l5.9-5.9a3.28 3.28 0 012.61-.95V6.25C21 4.45 19.54 3 17.75 3H11v4.75C11 9.55 9.54 11 7.75 11H3v6.75zM9.5 3.44L3.44 9.5h4.31c.97 0 1.75-.78 1.75-1.75V3.44zm9.6 9.23l-5.9 5.9c-.35.35-.6.78-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46c.47-.12.9-.36 1.25-.7l5.9-5.9a2.29 2.29 0 00-3.23-3.24z",
    fill: primaryFill
  }));
};

export const NoteEdit24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NoteEdit24FilledIcon, 'NoteEdit24Filled');

const NoteEdit24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 17.75C3 19.55 4.46 21 6.25 21h4.92l.35-1.42.02-.08H6.25c-.97 0-1.75-.78-1.75-1.75V11h3.43A3.25 3.25 0 0011 7.74V4.5h6.75c.97 0 1.75.78 1.75 1.75v4.98c.48-.19 1-.26 1.5-.22V6.25C21 4.45 19.54 3 17.75 3h-6.88c-.6 0-1.17.24-1.59.66L3.66 9.28c-.42.42-.66 1-.66 1.6v6.87zM7.75 9.5H5.56L9.5 5.56V7.9c-.08.9-.83 1.61-1.75 1.61zm11.35 3.17l-5.9 5.9c-.35.35-.6.78-.7 1.25l-.47 1.83c-.2.8.53 1.52 1.32 1.32l1.83-.46c.47-.12.9-.36 1.25-.7l5.9-5.9a2.29 2.29 0 00-3.23-3.24z",
    fill: primaryFill
  }));
};

export const NoteEdit24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NoteEdit24RegularIcon, 'NoteEdit24Regular');

const NotePin16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.61 1.46l1.93 1.93a1.5 1.5 0 01-.4 2.4l-1.65.8a1 1 0 00-.51.58l-.38 1.1a1 1 0 01-1.65.38L3 7.71 1.7 9H1v-.7L2.3 7l-.96-.95a1 1 0 01.39-1.65l1.1-.38a1 1 0 00.57-.5l.8-1.66a1.5 1.5 0 012.41-.4zM2 11.5V9.93l.95-.96.44.43c.94.95 2.56.58 3-.69l.44-1.28 1.9-.92a2.27 2.27 0 00.6-3.65L8.47 2h3.03A2.5 2.5 0 0114 4.5V8h-3.5A2.5 2.5 0 008 10.5V14H4.5A2.5 2.5 0 012 11.5zm7 2.36c.35-.12.67-.32.94-.6l3.33-3.32c.27-.27.47-.59.59-.94H10.5C9.67 9 9 9.67 9 10.5v3.36z",
    fill: primaryFill
  }));
};

export const NotePin16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotePin16FilledIcon, 'NotePin16Filled');

const NotePin16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.61 1.46l1.93 1.93a1.5 1.5 0 01-.4 2.4l-1.65.8a1 1 0 00-.51.58l-.38 1.1a1 1 0 01-1.65.38L3 7.71 1.7 9H1v-.7L2.3 7l-.96-.95a1 1 0 01.39-1.65l1.1-.38a1 1 0 00.57-.5l.8-1.66a1.5 1.5 0 012.41-.4zM2 11.5V9.93l.95-.96.05.05v2.48c0 .83.67 1.5 1.5 1.5H8v-2.5A2.5 2.5 0 0110.5 8H13V4.5c0-.83-.67-1.5-1.5-1.5H9.46l-.13-.14L8.47 2h3.03A2.5 2.5 0 0114 4.5v3.67c0 .66-.26 1.3-.73 1.77l-3.33 3.33a2.5 2.5 0 01-1.77.73H4.5A2.5 2.5 0 012 11.5zm7 1.25c.08-.05.16-.12.23-.19l3.33-3.33.2-.23H10.5C9.67 9 9 9.67 9 10.5v2.25z",
    fill: primaryFill
  }));
};

export const NotePin16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotePin16RegularIcon, 'NotePin16Regular');

const NotePin20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 9.02v5.16A3 3 0 006 17h4v-4.18a3 3 0 012.82-2.81L13 10h4V5.82A3 3 0 0014 3H9.46c.95 1.12.6 2.85-.74 3.51l-1.89.92-.44 1.28a1.82 1.82 0 01-3 .7L3 9zm13.54 2.63a2 2 0 00.36-.65h-4.06a2 2 0 00-1.83 1.85L11 13v3.9a2 2 0 00.8-.49l4.61-4.62.13-.14zm-8-8.26L6.6 1.46a1.5 1.5 0 00-2.4.4L3.4 3.51a1 1 0 01-.57.5l-1.1.39a1 1 0 00-.39 1.65L2.3 7 1 8.3V9h.7L3 7.7l.95.95a1 1 0 001.65-.38l.38-1.1a1 1 0 01.5-.57l1.65-.8a1.5 1.5 0 00.4-2.41z",
    fill: primaryFill
  }));
};

export const NotePin20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotePin20FilledIcon, 'NotePin20Filled');

const NotePin20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 9.02v5.16A3 3 0 006 17h4.55a2 2 0 001.24-.59l4.62-4.62.12-.13a2 2 0 00.47-1.28V5.82A3 3 0 0014 3H9.46c.26.3.42.64.5 1h4.19A2 2 0 0116 6v4h-3.18A3 3 0 0010 13v3H5.85A2 2 0 014 14V9.81a1.82 1.82 0 01-.61-.4L3 9zM13 11h2.78a1 1 0 01-.07.09l-4.62 4.62-.09.07V12.85A2 2 0 0113 11zM8.54 3.39L6.6 1.46a1.5 1.5 0 00-2.4.4L3.4 3.51a1 1 0 01-.57.5l-1.1.39a1 1 0 00-.39 1.65L2.3 7 1 8.3V9h.7L3 7.7l.95.95a1 1 0 001.65-.38l.38-1.1a1 1 0 01.5-.57l1.65-.8a1.5 1.5 0 00.4-2.41z",
    fill: primaryFill
  }));
};

export const NotePin20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotePin20RegularIcon, 'NotePin20Regular');

const Notebook16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.75 1C2.78 1 2 1.78 2 2.75v10.5c0 .97.78 1.75 1.75 1.75h7.5c.97 0 1.75-.78 1.75-1.75V2.75C13 1.78 12.22 1 11.25 1h-7.5zM4 3.75c0-.41.34-.75.75-.75h5.5c.41 0 .75.34.75.75v.5c0 .41-.34.75-.75.75h-5.5A.75.75 0 014 4.25v-.5zM14 4h.63c.2 0 .37.17.37.38v1.25c0 .2-.17.37-.38.37H14V4zm.63 3H14v2h.63c.2 0 .37-.17.37-.38V7.38c0-.21-.17-.38-.38-.38zM14 10h.63c.2 0 .37.17.37.38v1.24c0 .21-.17.38-.38.38H14v-2z",
    fill: primaryFill
  }));
};

export const Notebook16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Notebook16FilledIcon, 'Notebook16Filled');

const Notebook16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.75 3a.75.75 0 00-.75.75v1.5c0 .41.34.75.75.75h5.5c.41 0 .75-.34.75-.75v-1.5a.75.75 0 00-.75-.75h-5.5zM5 5V4h5v1H5zM2 2.75C2 1.78 2.78 1 3.75 1h7.5c.97 0 1.75.78 1.75 1.75v10.5c0 .97-.78 1.75-1.75 1.75h-7.5C2.78 15 2 14.22 2 13.25V2.75zM3.75 2a.75.75 0 00-.75.75v10.5c0 .41.34.75.75.75h7.5c.41 0 .75-.34.75-.75V2.75a.75.75 0 00-.75-.75h-7.5zm10.88 2H14v2h.63c.2 0 .37-.17.37-.38V4.38c0-.2-.17-.37-.38-.37zM14 7h.63c.2 0 .37.17.37.38v1.25c0 .2-.17.37-.38.37H14V7zm.63 3H14v2h.63c.2 0 .37-.17.37-.38v-1.24c0-.21-.17-.38-.38-.38z",
    fill: primaryFill
  }));
};

export const Notebook16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Notebook16RegularIcon, 'Notebook16Regular');

const Notebook20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 2a2 2 0 00-2 2v12c0 1.1.9 2 2 2h8a2 2 0 002-2V4a2 2 0 00-2-2H5zm0 3.5c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v1a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-1zM16 6h.5c.28 0 .5.22.5.5V8a.5.5 0 01-.5.5H16V6zm0 3.5h.5c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H16V9.5zm0 3.5h.5c.28 0 .5.22.5.5V15a.5.5 0 01-.5.5H16V13z",
    fill: primaryFill
  }));
};

export const Notebook20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Notebook20FilledIcon, 'Notebook20Filled');

const Notebook20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 5a.5.5 0 00-.5.5v2c0 .28.22.5.5.5h7a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-7zM6 7V6h6v1H6zM3 4c0-1.1.9-2 2-2h8a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V4zm2-1a1 1 0 00-1 1v12a1 1 0 001 1h8a1 1 0 001-1V4a1 1 0 00-1-1H5zm11 3h.5c.28 0 .5.22.5.5V8a.5.5 0 01-.5.5H16V6zm.5 3.5H16V12h.5a.5.5 0 00.5-.5V10a.5.5 0 00-.5-.5zM16 13h.5c.28 0 .5.22.5.5V15a.5.5 0 01-.5.5H16V13z",
    fill: primaryFill
  }));
};

export const Notebook20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Notebook20RegularIcon, 'Notebook20Regular');

const Notebook24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.75 2C17.99 2 19 3 19 4.25v15.5c0 1.24-1 2.25-2.25 2.25H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2h10.5zM20 15h.75c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20v-3h.75H20zm0-4h.75c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20v-3h.75H20zm0-4h.75c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20V7h.75H20zm-5.25-1.5h-6.5c-.38 0-.7.28-.74.65v1.6c0 .38.27.7.64.74l.1.01h6.5c.38 0 .7-.28.75-.65v-1.6a.75.75 0 00-.75-.75z",
    fill: primaryFill
  }));
};

export const Notebook24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Notebook24FilledIcon, 'Notebook24Filled');

const Notebook24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.75 2C17.99 2 19 3 19 4.25v15.5c0 1.24-1 2.25-2.25 2.25H6.25C5.01 22 4 21 4 19.75V4.25C4 3.01 5 2 6.25 2h10.5zm0 1.5H6.25a.75.75 0 00-.75.75v15.5c0 .41.34.75.75.75h10.5c.41 0 .75-.34.75-.75V4.25a.75.75 0 00-.75-.75zM20 15h.75c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20v-3h.75H20zm0-4h.75c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20v-3h.75H20zm0-4h.75c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20V7h.75H20zm-4.75-2c.41 0 .75.34.75.75v2.5c0 .41-.34.75-.75.75h-7.5A.75.75 0 017 8.25v-2.5c0-.41.34-.75.75-.75h7.5zm-.75 1.5h-6v1h6v-1z",
    fill: primaryFill
  }));
};

export const Notebook24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Notebook24RegularIcon, 'Notebook24Regular');

const Notebook32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.25 2A3.25 3.25 0 004 5.25v21.5C4 28.55 5.46 30 7.25 30h16.5c1.8 0 3.25-1.46 3.25-3.25V5.25C27 3.45 25.54 2 23.75 2H7.25zM10 7h11a1 1 0 011 1v2a1 1 0 01-1 1H10a1 1 0 01-1-1V8a1 1 0 011-1zm18 1h1.25c.41 0 .75.34.75.75v2.5c0 .41-.34.75-.75.75H28V8zm1.25 6H28v4h1.25c.41 0 .75-.34.75-.75v-2.5a.75.75 0 00-.75-.75zM28 20h1.25c.41 0 .75.34.75.75v2.5c0 .41-.34.75-.75.75H28v-4z",
    fill: primaryFill
  }));
};

export const Notebook32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Notebook32FilledIcon, 'Notebook32Filled');

const Notebook32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 7.5C8 6.67 8.67 6 9.5 6h12c.83 0 1.5.67 1.5 1.5v3c0 .83-.67 1.5-1.5 1.5h-12A1.5 1.5 0 018 10.5v-3zm2 .5v2h11V8H10zM4 5.25C4 3.45 5.46 2 7.25 2h16.5C25.55 2 27 3.46 27 5.25v21.5c0 1.8-1.46 3.25-3.25 3.25H7.25A3.25 3.25 0 014 26.75V5.25zM7.25 4C6.56 4 6 4.56 6 5.25v21.5c0 .69.56 1.25 1.25 1.25h16.5c.69 0 1.25-.56 1.25-1.25V5.25C25 4.56 24.44 4 23.75 4H7.25zm22 4H28v4h1.25c.41 0 .75-.34.75-.75v-2.5a.75.75 0 00-.75-.75zM28 14h1.25c.41 0 .75.34.75.75v2.5c0 .41-.34.75-.75.75H28v-4zm1.25 6H28v4h1.25c.41 0 .75-.34.75-.75v-2.5a.75.75 0 00-.75-.75z",
    fill: primaryFill
  }));
};

export const Notebook32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Notebook32RegularIcon, 'Notebook32Regular');

const NotebookAdd20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 2a2 2 0 00-2 2v5.6A5.5 5.5 0 019.74 18H13a2 2 0 002-2V4a2 2 0 00-2-2H5zm0 3c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-7A.5.5 0 015 7V5zm11 1h.5c.28 0 .5.22.5.5V8a.5.5 0 01-.5.5H16V6zm.5 3.5H16V12h.5a.5.5 0 00.5-.5V10a.5.5 0 00-.5-.5zM16 13h.5c.28 0 .5.22.5.5V15a.5.5 0 01-.5.5H16V13zm-6 1.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14H3.5a.5.5 0 000 1H5v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H6v-1.5z",
    fill: primaryFill
  }));
};

export const NotebookAdd20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookAdd20FilledIcon, 'NotebookAdd20Filled');

const NotebookAdd20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 4c0-1.1.9-2 2-2h8a2 2 0 012 2v12a2 2 0 01-2 2H9.74c.26-.3.48-.64.66-1H13a1 1 0 001-1V4a1 1 0 00-1-1H5a1 1 0 00-1 1v5.2c-.35.1-.68.24-1 .4V4zm2.5.5A.5.5 0 005 5v2c0 .28.22.5.5.5h7A.5.5 0 0013 7V5a.5.5 0 00-.5-.5h-7zm.5 2v-1h6v1H6zM16.5 6H16v2.5h.5A.5.5 0 0017 8V6.5a.5.5 0 00-.5-.5zm0 3.5H16V12h.5a.5.5 0 00.5-.5V10a.5.5 0 00-.5-.5zm0 3.5H16v2.5h.5a.5.5 0 00.5-.5v-1.5a.5.5 0 00-.5-.5zm-11 6a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 010 1H6v1.5a.5.5 0 01-1 0V15H3.5a.5.5 0 010-1H5v-1.5c0-.28.22-.5.5-.5z",
    fill: primaryFill
  }));
};

export const NotebookAdd20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookAdd20RegularIcon, 'NotebookAdd20Regular');

const NotebookAdd24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.75 2C17.99 2 19 3 19 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-5.56A6.5 6.5 0 004 11.5V4.25C4 3.01 5 2 6.25 2h10.5zm-2 3.5h-6.5c-.38 0-.7.28-.74.65v1.6c0 .38.27.7.64.74l.1.01h6.5c.38 0 .7-.28.75-.65v-1.6a.75.75 0 00-.75-.75z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M20 15h.75c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20v-3z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M20 11h.75c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20v-3z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M20 7h.75c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20V7z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M12 17.5a5.5 5.5 0 10-11 0 5.5 5.5 0 0011 0zM7 18v2.5a.5.5 0 11-1 0V18H3.5a.5.5 0 010-1H6v-2.5a.5.5 0 111 0V17h2.5a.5.5 0 010 1H7z",
    fill: primaryFill
  }));
};

export const NotebookAdd24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookAdd24FilledIcon, 'NotebookAdd24Filled');

const NotebookAdd24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.75 2C17.99 2 19 3 19 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-5.56c.43-.44.8-.95 1.08-1.5h4.48c.41 0 .75-.34.75-.75V4.25a.75.75 0 00-.75-.75H6.25a.75.75 0 00-.75.75v6.83c-.52.08-1.03.22-1.5.42V4.25C4 3.01 5 2 6.25 2h10.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M20 15h.75c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20v-3z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M20 11h.75c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20v-3z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M20 7h.75c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20V7z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M15.25 5c.41 0 .75.34.75.75v2.5c0 .41-.34.75-.75.75h-7.5A.75.75 0 017 8.25v-2.5c0-.41.34-.75.75-.75h7.5zm-.75 1.5h-6v1h6v-1z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M12 17.5a5.5 5.5 0 10-11 0 5.5 5.5 0 0011 0zM7 18v2.5a.5.5 0 11-1 0V18H3.5a.5.5 0 010-1H6v-2.5a.5.5 0 111 0V17h2.5a.5.5 0 010 1H7z",
    fill: primaryFill
  }));
};

export const NotebookAdd24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookAdd24RegularIcon, 'NotebookAdd24Regular');

const NotebookArrowCurveDown20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 5.5a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zm6.4.9l-.9.9V5.74A2.75 2.75 0 004.75 3H4.5a.5.5 0 100 1h.25c.96 0 1.75.78 1.75 1.75v1.54l-.9-.9a.5.5 0 00-.7.71l1.75 1.76a.5.5 0 00.7 0L9.1 7.1a.5.5 0 10-.7-.7zm3.6-.9a5.5 5.5 0 01-8 4.9V16c0 1.1.89 2 2 2h8a2 2 0 002-2V4a2 2 0 00-2-2h-3.26A5.48 5.48 0 0112 5.5zm5 .5h.5c.27 0 .5.22.5.5V8a.5.5 0 01-.5.5H17V6zm0 3.5h.5c.27 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H17V9.5zm0 3.5h.5c.27 0 .5.22.5.5V15a.5.5 0 01-.5.5H17V13z",
    fill: primaryFill
  }));
};

export const NotebookArrowCurveDown20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookArrowCurveDown20FilledIcon, 'NotebookArrowCurveDown20Filled');

const NotebookArrowCurveDown20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1 5.5a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zm6.4.9l-.9.9V5.74A2.75 2.75 0 003.75 3H3.5a.5.5 0 100 1h.25c.97 0 1.75.78 1.75 1.75v1.54l-.9-.9a.5.5 0 00-.7.71l1.75 1.76a.5.5 0 00.7 0L8.12 7.1a.5.5 0 10-.71-.7zm-4.4 4c.31.16.65.3 1 .4V16a1 1 0 001 1h8a1 1 0 001-1V4a1 1 0 00-1-1h-2.6a5.5 5.5 0 00-.66-1H13a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2v-5.6zM16 6h.5c.28 0 .5.22.5.5V8a.5.5 0 01-.5.5H16V6zm.5 3.5H16V12h.5a.5.5 0 00.5-.5V10a.5.5 0 00-.5-.5zM16 13h.5c.28 0 .5.22.5.5V15a.5.5 0 01-.5.5H16V13z",
    fill: primaryFill
  }));
};

export const NotebookArrowCurveDown20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookArrowCurveDown20RegularIcon, 'NotebookArrowCurveDown20Regular');

const NotebookError20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 4c0-1.1.9-2 2-2h8a2 2 0 012 2v12a2 2 0 01-2 2H9.74A5.5 5.5 0 003 9.6V4zm2.5 1a.5.5 0 00-.5.5v1c0 .28.22.5.5.5h7a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-7zm11 1H16v2.5h.5A.5.5 0 0017 8V6.5a.5.5 0 00-.5-.5zM16 9.5h.5c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H16V9.5zm.5 3.5H16v2.5h.5a.5.5 0 00.5-.5v-1.5a.5.5 0 00-.5-.5zm-11 6a4.5 4.5 0 100-9 4.5 4.5 0 000 9zM5 12.5a.5.5 0 011 0v2a.5.5 0 01-1 0v-2zm1.13 4a.62.62 0 11-1.25 0 .62.62 0 011.25 0z",
    fill: primaryFill
  }));
};

export const NotebookError20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookError20FilledIcon, 'NotebookError20Filled');

const NotebookError20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 2a2 2 0 00-2 2v5.6c.32-.16.65-.3 1-.4V4a1 1 0 011-1h8a1 1 0 011 1v12a1 1 0 01-1 1h-2.6c-.18.36-.4.7-.66 1H13a2 2 0 002-2V4a2 2 0 00-2-2H5zm0 3.5v2c0 .28.22.5.5.5h7a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5zM6 6h6v1H6V6zm10 0h.5c.28 0 .5.22.5.5V8a.5.5 0 01-.5.5H16V6zm0 3.5h.5c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H16V9.5zm0 3.5h.5c.28 0 .5.22.5.5V15a.5.5 0 01-.5.5H16V13zm-6 1.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM5.5 12a.5.5 0 00-.5.5v2a.5.5 0 001 0v-2a.5.5 0 00-.5-.5zm0 5.13a.62.62 0 100-1.25.62.62 0 000 1.24z",
    fill: primaryFill
  }));
};

export const NotebookError20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookError20RegularIcon, 'NotebookError20Regular');

const NotebookError24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 12a5.5 5.5 0 110 11 5.5 5.5 0 010-11zM16.75 2C17.99 2 19 3 19 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-5.56A6.5 6.5 0 004 11.5V4.25C4 3.01 5 2 6.25 2h10.5zM6.5 19.88a.62.62 0 100 1.25.62.62 0 000-1.25zm0-5.88a.5.5 0 00-.5.41v4.18a.5.5 0 001 0v-4.18a.5.5 0 00-.5-.4zm14.25 1c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20v-3h.75zm0-4c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20v-3h.75zm0-4c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20V7h.75zm-6-1.5h-6.5c-.38 0-.7.28-.75.65v1.6c0 .38.28.7.65.74l.1.01h6.5c.38 0 .7-.28.74-.65v-1.6a.75.75 0 00-.74-.75z",
    fill: primaryFill
  }));
};

export const NotebookError24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookError24FilledIcon, 'NotebookError24Filled');

const NotebookError24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 12a5.5 5.5 0 110 11 5.5 5.5 0 010-11zM16.75 2C17.99 2 19 3 19 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-5.56c.43-.44.79-.95 1.08-1.5h4.48c.41 0 .75-.34.75-.75V4.25a.75.75 0 00-.75-.75H6.25a.75.75 0 00-.75.75v6.83c-.52.08-1.03.22-1.5.42V4.25C4 3.01 5 2 6.25 2h10.5zM6.5 19.88a.62.62 0 100 1.25.62.62 0 000-1.25zm0-5.88a.5.5 0 00-.5.41v4.18a.5.5 0 001 0v-4.18a.5.5 0 00-.5-.4zm14.25 1c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20v-3h.75zm0-4c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20v-3h.75zm0-4c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20V7h.75zm-5.5-2c.41 0 .75.34.75.75v2.5c0 .41-.34.75-.75.75h-7.5A.75.75 0 017 8.25v-2.5c0-.41.34-.75.75-.75h7.5zm-.75 1.5h-6v1h6v-1z",
    fill: primaryFill
  }));
};

export const NotebookError24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookError24RegularIcon, 'NotebookError24Regular');

const NotebookEye20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 2a2 2 0 00-2 2v7.57a5.8 5.8 0 016.47 1c.88.82 1.53 1.94 1.53 2.93a3.3 3.3 0 01-.43 1.52c-.18.33-.41.66-.7.98H13a2 2 0 002-2V4a2 2 0 00-2-2H5zm0 3.5c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v1a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-1zM16 6h.5c.28 0 .5.22.5.5V8a.5.5 0 01-.5.5H16V6zm0 3.5h.5c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H16V9.5zm0 3.5h.5c.28 0 .5.22.5.5V15a.5.5 0 01-.5.5H16V13zM1 15.5C1 14.32 2.74 12 5.5 12s4.5 2.3 4.5 3.5c0 1.18-1.74 3.5-4.5 3.5S1 16.7 1 15.5zm3.11 2.08a2.5 2.5 0 102.78-4.16 2.5 2.5 0 00-2.78 4.16zm2.64-1.25a1.5 1.5 0 10-2.5-1.66 1.5 1.5 0 002.5 1.66z",
    fill: primaryFill
  }));
};

export const NotebookEye20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookEye20FilledIcon, 'NotebookEye20Filled');

const NotebookEye20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 5a.5.5 0 00-.5.5v2c0 .28.22.5.5.5h7a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-7zM6 7V6h6v1H6zM3 4c0-1.1.9-2 2-2h8a2 2 0 012 2v12a2 2 0 01-2 2H9.88c.28-.32.5-.65.69-.98V17H13a1 1 0 001-1V4a1 1 0 00-1-1H5a1 1 0 00-1 1v7.2c-.35.1-.69.22-1 .37V4zm13 2h.5c.28 0 .5.22.5.5V8a.5.5 0 01-.5.5H16V6zm.5 3.5H16V12h.5a.5.5 0 00.5-.5V10a.5.5 0 00-.5-.5zM16 13h.5c.28 0 .5.22.5.5V15a.5.5 0 01-.5.5H16V13zM1 15.5C1 14.32 2.74 12 5.5 12s4.5 2.3 4.5 3.5c0 1.18-1.74 3.5-4.5 3.5S1 16.7 1 15.5zm3.11 2.08a2.5 2.5 0 102.78-4.16 2.5 2.5 0 00-2.78 4.16zm2.64-1.25a1.5 1.5 0 10-2.5-1.66 1.5 1.5 0 002.5 1.66z",
    fill: primaryFill
  }));
};

export const NotebookEye20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookEye20RegularIcon, 'NotebookEye20Regular');

const NotebookLightning20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 4c0-1.1.9-2 2-2h8a2 2 0 012 2v12a2 2 0 01-2 2H9.74A5.5 5.5 0 003 9.6V4zm2.5 1a.5.5 0 00-.5.5v1c0 .28.22.5.5.5h7a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-7zm11 1H16v2.5h.5A.5.5 0 0017 8V6.5a.5.5 0 00-.5-.5zM16 9.5h.5c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H16V9.5zm.5 3.5H16v2.5h.5a.5.5 0 00.5-.5v-1.5a.5.5 0 00-.5-.5zm-11 6a4.5 4.5 0 100-9 4.5 4.5 0 000 9zm-1.13-3.66h-.6c-.2 0-.32-.2-.25-.39l1.1-2.78c.04-.1.13-.17.24-.17h1.83c.18 0 .3.19.25.37l-.31.97c-.05.17.07.33.24.33h.23c.36 0 .54.46.27.72l-2.56 2.53c-.2.2-.5 0-.44-.27l.24-1a.25.25 0 00-.24-.31z",
    fill: primaryFill
  }));
};

export const NotebookLightning20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookLightning20FilledIcon, 'NotebookLightning20Filled');

const NotebookLightning20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 2a2 2 0 00-2 2v5.6c.32-.16.65-.3 1-.4V4a1 1 0 011-1h8a1 1 0 011 1v12a1 1 0 01-1 1h-2.6c-.18.36-.4.7-.66 1H13a2 2 0 002-2V4a2 2 0 00-2-2H5zm0 3.5c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-2zM6 6v1h6V6H6zm10 0h.5c.28 0 .5.22.5.5V8a.5.5 0 01-.5.5H16V6zm0 3.5h.5c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H16V9.5zm0 3.5h.5c.28 0 .5.22.5.5V15a.5.5 0 01-.5.5H16V13zm-6 1.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-5.63.84c.16 0 .28.15.24.3l-.24 1.01c-.06.27.25.46.44.27l2.56-2.53c.27-.26.1-.72-.27-.72h-.23a.25.25 0 01-.24-.33l.3-.97C7 12.19 6.88 12 6.7 12H4.86c-.1 0-.2.07-.24.17l-1.1 2.78c-.07.19.06.39.24.39h.6z",
    fill: primaryFill
  }));
};

export const NotebookLightning20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookLightning20RegularIcon, 'NotebookLightning20Regular');

const NotebookLightning24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 12a5.5 5.5 0 110 11 5.5 5.5 0 010-11zM16.75 2C17.99 2 19 3 19 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-5.56A6.5 6.5 0 004 11.5V4.25C4 3.01 5 2 6.25 2h10.5zM7.5 14H6a.5.5 0 00-.47.34l-1 3A.5.5 0 005 18h.8l-.77 2.34c-.2.56.58.92.9.42l2.5-4A.5.5 0 008 16h-.45l.43-1.35A.5.5 0 007.5 14zm13.25 1c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20v-3h.75zm0-4c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20v-3h.75zm0-4c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20V7h.75zm-6-1.5h-6.5c-.38 0-.69.28-.74.65v1.6c0 .38.28.7.64.74l.1.01h6.5c.38 0 .7-.28.74-.65l.01-.1v-1.5a.75.75 0 00-.75-.75z",
    fill: primaryFill
  }));
};

export const NotebookLightning24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookLightning24FilledIcon, 'NotebookLightning24Filled');

const NotebookLightning24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 12a5.5 5.5 0 110 11 5.5 5.5 0 010-11zM16.75 2C17.99 2 19 3 19 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-5.56c.43-.44.79-.95 1.08-1.5h4.48c.41 0 .75-.34.75-.75V4.25a.75.75 0 00-.75-.75H6.25a.75.75 0 00-.75.75v6.83c-.52.08-1.03.22-1.5.42V4.25C4 3.01 5 2 6.25 2h10.5zM7.5 14H6a.5.5 0 00-.47.34l-1 3A.5.5 0 005 18h.8l-.77 2.34c-.2.56.58.92.9.42l2.5-4A.5.5 0 008 16h-.45l.43-1.35A.5.5 0 007.5 14zm13.25 1c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20v-3h.75zm0-4c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20v-3h.75zm0-4c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20V7h.75zm-5.5-2c.41 0 .75.34.75.75v2.5c0 .41-.34.75-.75.75h-7.5A.75.75 0 017 8.25v-2.5c0-.41.34-.75.75-.75h7.5zm-.75 1.5h-6v1h6v-1z",
    fill: primaryFill
  }));
};

export const NotebookLightning24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookLightning24RegularIcon, 'NotebookLightning24Regular');

const NotebookQuestionMark20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 2a2 2 0 00-2 2v5.6A5.5 5.5 0 019.74 18H13a2 2 0 002-2V4a2 2 0 00-2-2H5zm0 3.5c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v1a.5.5 0 01-.5.5h-7a.5.5 0 01-.5-.5v-1zM16 6h.5c.28 0 .5.22.5.5V8a.5.5 0 01-.5.5H16V6zm.5 3.5H16V12h.5a.5.5 0 00.5-.5V10a.5.5 0 00-.5-.5zM16 13h.5c.28 0 .5.22.5.5V15a.5.5 0 01-.5.5H16V13zm-6 1.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.5 1.88a.62.62 0 100 1.25.62.62 0 000-1.25zm0-4.88c-1.05 0-1.86.82-1.85 1.96a.5.5 0 101-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .2-.07.32-.36.55l-.27.21c-.51.4-.72.72-.72 1.29a.5.5 0 001 .09v-.16c.02-.14.1-.25.35-.44l.28-.22c.5-.4.72-.73.72-1.32 0-1.1-.82-1.95-1.85-1.95z",
    fill: primaryFill
  }));
};

export const NotebookQuestionMark20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookQuestionMark20FilledIcon, 'NotebookQuestionMark20Filled');

const NotebookQuestionMark20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 2a2 2 0 00-2 2v5.6c.32-.16.65-.3 1-.4V4a1 1 0 011-1h8a1 1 0 011 1v12a1 1 0 01-1 1h-2.6c-.18.36-.4.7-.66 1H13a2 2 0 002-2V4a2 2 0 00-2-2H5zm0 3.5v2c0 .28.22.5.5.5h7a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5zM6 6h6v1H6V6zm10 0h.5c.28 0 .5.22.5.5V8a.5.5 0 01-.5.5H16V6zm0 3.5h.5c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H16V9.5zm0 3.5h.5c.28 0 .5.22.5.5V15a.5.5 0 01-.5.5H16V13zm-6 1.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4.5 1.88a.62.62 0 100 1.25.62.62 0 000-1.25zm0-4.88c-1.05 0-1.86.82-1.85 1.96a.5.5 0 101-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .2-.07.32-.36.55l-.27.21c-.51.4-.72.72-.72 1.29a.5.5 0 001 .09v-.16c.02-.14.1-.25.35-.44l.28-.22c.5-.4.72-.73.72-1.32 0-1.1-.82-1.95-1.85-1.95z",
    fill: primaryFill
  }));
};

export const NotebookQuestionMark20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookQuestionMark20RegularIcon, 'NotebookQuestionMark20Regular');

const NotebookQuestionMark24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 12a5.5 5.5 0 110 11 5.5 5.5 0 010-11zM16.75 2C17.99 2 19 3 19 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-5.56A6.5 6.5 0 004 11.5V4.25C4 3.01 5 2 6.25 2h10.5zM6.5 19.88a.62.62 0 100 1.25.62.62 0 000-1.25zm0-5.88c-1.05 0-1.86.82-1.85 1.96a.5.5 0 001-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .23-.07.4-.31.68l-.1.11-.27.3c-.48.53-.67.89-.67 1.46a.5.5 0 001 0c0-.23.08-.4.32-.7l.1-.1.27-.3c.48-.53.66-.88.66-1.45 0-1.1-.82-1.95-1.85-1.95zm14.25 1c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20v-3h.75zm0-4c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20v-3h.75zm0-4c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20V7h.75zm-6-1.5h-6.5c-.38 0-.7.28-.74.65v1.6c0 .38.27.7.64.74l.1.01h6.5c.38 0 .7-.28.74-.65v-1.6a.75.75 0 00-.74-.75z",
    fill: primaryFill
  }));
};

export const NotebookQuestionMark24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookQuestionMark24FilledIcon, 'NotebookQuestionMark24Filled');

const NotebookQuestionMark24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 12a5.5 5.5 0 110 11 5.5 5.5 0 010-11zM16.75 2C17.99 2 19 3 19 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-5.56c.43-.44.79-.95 1.08-1.5h4.48c.41 0 .75-.34.75-.75V4.25a.75.75 0 00-.75-.75H6.25a.75.75 0 00-.75.75v6.83c-.52.08-1.03.22-1.5.42V4.25C4 3.01 5 2 6.25 2h10.5zM6.5 19.88a.62.62 0 100 1.25.62.62 0 000-1.25zm0-5.88c-1.05 0-1.86.82-1.85 1.96a.5.5 0 001-.01c0-.58.36-.95.85-.95.47 0 .85.4.85.95 0 .23-.07.4-.31.68l-.1.11-.27.3c-.48.53-.67.89-.67 1.46a.5.5 0 001 0c0-.23.08-.4.32-.7l.1-.1.27-.3c.48-.53.66-.88.66-1.45 0-1.1-.82-1.95-1.85-1.95zm14.25 1c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20v-3h.75zm0-4c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20v-3h.75zm0-4c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20V7h.75zm-5.5-2c.41 0 .75.34.75.75v2.5c0 .41-.34.75-.75.75h-7.5A.75.75 0 017 8.25v-2.5c0-.41.34-.75.75-.75h7.5zm-.75 1.5h-6v1h6v-1z",
    fill: primaryFill
  }));
};

export const NotebookQuestionMark24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookQuestionMark24RegularIcon, 'NotebookQuestionMark24Regular');

const NotebookSection20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 2.5a.5.5 0 00-1 0V3H8a2 2 0 00-2 2v10c0 1.1.9 2 2 2h1.6A5.5 5.5 0 0114 9.02V2.5zm.5 7.5a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const NotebookSection20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookSection20FilledIcon, 'NotebookSection20Filled');

const NotebookSection20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 2.5a.5.5 0 00-1 0V3H8a2 2 0 00-2 2v10c0 1.1.9 2 2 2h1.6c-.16-.32-.3-.65-.4-1H8a1 1 0 01-1-1V5a1 1 0 011-1h5v5.2c.32-.08.66-.15 1-.18V2.5zm.5 7.5a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm2.35 4.85a.5.5 0 00.15-.35.5.5 0 00-.15-.35l-2-2a.5.5 0 00-.7.7L15.29 14H12.5a.5.5 0 000 1h2.8l-1.15 1.15a.5.5 0 00.7.7l2-2z",
    fill: primaryFill
  }));
};

export const NotebookSection20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookSection20RegularIcon, 'NotebookSection20Regular');

const NotebookSection24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.65 2h.1c.38 0 .7.28.74.65l.01.1v18.5a.75.75 0 01-1.5.1V20H9.25C8.01 20 7 18.99 7 17.75V6.25C7 5.01 8 4 9.25 4H15V2.75c0-.38.28-.7.65-.74l.1-.01h-.1z",
    fill: primaryFill
  }));
};

export const NotebookSection24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookSection24FilledIcon, 'NotebookSection24Filled');

const NotebookSection24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.65 2h.1c.38 0 .7.28.74.65l.01.1v18.5a.75.75 0 01-1.5.1V20H9.25C8.01 20 7 18.99 7 17.75V6.25C7 5.01 8 4 9.25 4H15V2.75c0-.38.28-.7.65-.74l.1-.01h-.1zM15 5.5H9.25a.75.75 0 00-.75.75v11.5c0 .41.34.75.75.75H15v-13z",
    fill: primaryFill
  }));
};

export const NotebookSection24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookSection24RegularIcon, 'NotebookSection24Regular');

const NotebookSectionArrowRight24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.65 2h.1c.38 0 .7.28.74.65l.01.1v8.33a6.5 6.5 0 00-5 8.92H9.25C8.01 20 7 18.99 7 17.75V6.25C7 5.01 8 4 9.25 4H15V2.75c0-.38.28-.7.65-.74z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M23 17.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-8.5-.5a.5.5 0 000 1h4.8l-1.65 1.65a.5.5 0 00.7.7l2.5-2.5a.5.5 0 000-.7l-2.5-2.5a.5.5 0 00-.7.7L19.29 17H14.5z",
    fill: primaryFill
  }));
};

export const NotebookSectionArrowRight24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookSectionArrowRight24FilledIcon, 'NotebookSectionArrowRight24Filled');

const NotebookSectionArrowRight24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.65 2h.1c.38 0 .7.28.74.65l.01.1v8.33c-.52.08-1.03.22-1.5.42v-6H9.25a.75.75 0 00-.75.75v11.5c0 .41.34.75.75.75h1.83c.08.52.22 1.02.42 1.5H9.25C8.01 20 7 18.99 7 17.75V6.25C7 5.01 8 4 9.25 4H15V2.75c0-.38.28-.7.65-.74z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M23 17.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-8.5-.5a.5.5 0 000 1h4.8l-1.65 1.65a.5.5 0 00.7.7l2.5-2.5a.5.5 0 000-.7l-2.5-2.5a.5.5 0 00-.7.7L19.29 17H14.5z",
    fill: primaryFill
  }));
};

export const NotebookSectionArrowRight24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookSectionArrowRight24RegularIcon, 'NotebookSectionArrowRight24Regular');

const NotebookSubsection20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 5.5A3.5 3.5 0 017.5 2H10c.82 0 1.54.4 2 1H7.5A2.5 2.5 0 005 5.5V15a2.5 2.5 0 01-1-2V5.5zM13.5 2h-.07c-.24.05-.43.3-.43.6V4H7.5C6.67 4 6 4.67 6 5.5v10c0 .83.67 1.5 1.5 1.5H13V17.48c.04.3.25.52.5.52.28 0 .5-.27.5-.6V2.52c-.04-.3-.25-.52-.5-.52z",
    fill: primaryFill
  }));
};

export const NotebookSubsection20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookSubsection20FilledIcon, 'NotebookSubsection20Filled');

const NotebookSubsection20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 5.5A3.5 3.5 0 017.5 2H10c.82 0 1.54.4 2 1H7.5A2.5 2.5 0 005 5.5V15a2.5 2.5 0 01-1-2V5.5zM13.43 2h.07c.25 0 .46.23.5.52V17.4c0 .33-.22.6-.5.6-.25 0-.46-.23-.5-.52V17H8a2 2 0 01-2-2V6c0-1.1.9-2 2-2h5V2.6c0-.3.19-.55.43-.6zM8 5a1 1 0 00-1 1v9a1 1 0 001 1h5V5H8z",
    fill: primaryFill
  }));
};

export const NotebookSubsection20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookSubsection20RegularIcon, 'NotebookSubsection20Regular');

const NotebookSubsection24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 2a4.5 4.5 0 00-4.5 4.5v9.4c0 .98.63 1.81 1.5 2.12V6.5a3 3 0 013-3h5A2.25 2.25 0 0011.88 2H9z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M7 6.75C7 5.51 8 4.5 9.25 4.5H15V2.75a.75.75 0 011.5 0v18.5a.75.75 0 01-1.5 0V20H9.25C8.01 20 7 19 7 17.75v-11z",
    fill: primaryFill
  }));
};

export const NotebookSubsection24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookSubsection24FilledIcon, 'NotebookSubsection24Filled');

const NotebookSubsection24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 2a4.5 4.5 0 00-4.5 4.5v9.4c0 .98.63 1.81 1.5 2.12V6.5a3 3 0 013-3h5A2.25 2.25 0 0011.88 2H9z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M7 6.75C7 5.51 8 4.5 9.25 4.5H15V2.75a.75.75 0 011.5 0v18.5a.75.75 0 01-1.5 0V20H9.25C8.01 20 7 19 7 17.75v-11zm8 11.75V6H9.25a.75.75 0 00-.75.75v11c0 .41.34.75.75.75H15z",
    fill: primaryFill
  }));
};

export const NotebookSubsection24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookSubsection24RegularIcon, 'NotebookSubsection24Regular');

const NotebookSync20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 2a2 2 0 00-2 2v5.6A5.5 5.5 0 019.74 18H13a2 2 0 002-2V4a2 2 0 00-2-2H5zm0 3c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-7A.5.5 0 015 7V5zm11 1h.5c.28 0 .5.22.5.5V8a.5.5 0 01-.5.5H16V6zm0 3.5h.5c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H16V9.5zm0 3.5h.5c.28 0 .5.22.5.5V15a.5.5 0 01-.5.5H16V13zM1 14.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H6a.5.5 0 010-1h.47a1.99 1.99 0 00-2.38.34.5.5 0 01-.71-.71A3 3 0 017 12.15V12c0-.28.22-.5.5-.5zm-.88 5.53A3 3 0 014 16.85V17a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H5a.5.5 0 010 1h-.47a1.99 1.99 0 002.38-.34.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const NotebookSync20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookSync20FilledIcon, 'NotebookSync20Filled');

const NotebookSync20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 4.5A.5.5 0 005 5v2c0 .28.22.5.5.5h7A.5.5 0 0013 7V5a.5.5 0 00-.5-.5h-7zm.5 2v-1h6v1H6zM3 4c0-1.1.9-2 2-2h8a2 2 0 012 2v12a2 2 0 01-2 2H9.74c.26-.3.48-.64.66-1H13a1 1 0 001-1V4a1 1 0 00-1-1H5a1 1 0 00-1 1v5.2c-.35.1-.68.24-1 .4V4zm13 2h.5c.28 0 .5.22.5.5V8a.5.5 0 01-.5.5H16V6zm.5 3.5H16V12h.5a.5.5 0 00.5-.5V10a.5.5 0 00-.5-.5zM16 13h.5c.28 0 .5.22.5.5V15a.5.5 0 01-.5.5H16V13zM1 14.5a4.5 4.5 0 109 0 4.5 4.5 0 00-9 0zm6.5-3c.28 0 .5.22.5.5v1.5a.5.5 0 01-.5.5H6a.5.5 0 010-1h.47a1.99 1.99 0 00-2.38.34.5.5 0 01-.71-.71A3 3 0 017 12.15V12c0-.28.22-.5.5-.5zm-.88 5.53A3 3 0 014 16.85V17a.5.5 0 01-1 0v-1.5c0-.28.22-.5.5-.5H5a.5.5 0 010 1h-.47a1.99 1.99 0 002.38-.34.5.5 0 01.71.71 3 3 0 01-1 .66z",
    fill: primaryFill
  }));
};

export const NotebookSync20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookSync20RegularIcon, 'NotebookSync20Regular');

const NotebookSync24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.75 2C17.99 2 19 3 19 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-5.56A6.5 6.5 0 004 11.5V4.25C4 3.01 5 2 6.25 2h10.5zm-2 3.5h-6.5c-.38 0-.7.28-.74.65v1.6c0 .38.27.7.64.74l.1.01h6.5c.38 0 .7-.28.75-.65v-1.6a.75.75 0 00-.75-.75zM20 15h.75c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20v-3zm0-4h.75c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20v-3zm0-4h.75c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20V7zM1 17.5a5.5 5.5 0 1011 0 5.5 5.5 0 00-11 0zM9.5 14c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 010-1h1a2.5 2.5 0 00-4.03.04.5.5 0 11-.8-.59 3.5 3.5 0 015.33-.4v-.55c0-.28.22-.5.5-.5zM4 19.95v.55a.5.5 0 01-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-1a2.5 2.5 0 003.91.11.5.5 0 01.77.65 3.5 3.5 0 01-5.18.19z",
    fill: primaryFill
  }));
};

export const NotebookSync24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookSync24FilledIcon, 'NotebookSync24Filled');

const NotebookSync24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.75 2C17.99 2 19 3 19 4.25v15.5c0 1.24-1 2.25-2.25 2.25h-5.56c.43-.44.8-.95 1.08-1.5h4.48c.41 0 .75-.34.75-.75V4.25a.75.75 0 00-.75-.75H6.25a.75.75 0 00-.75.75v6.83c-.52.08-1.03.22-1.5.42V4.25C4 3.01 5 2 6.25 2h10.5zM20 15h.75c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20v-3zm0-4h.75c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20v-3zm0-4h.75c.38 0 .7.28.74.65l.01.1v1.5c0 .38-.28.7-.65.74l-.1.01H20V7zm-4.75-2c.41 0 .75.34.75.75v2.5c0 .41-.34.75-.75.75h-7.5A.75.75 0 017 8.25v-2.5c0-.41.34-.75.75-.75h7.5zm-.75 1.5h-6v1h6v-1zM1 17.5a5.5 5.5 0 1011 0 5.5 5.5 0 00-11 0zM9.5 14c.28 0 .5.22.5.5v2a.5.5 0 01-.5.5h-2a.5.5 0 010-1h1a2.5 2.5 0 00-4.03.04.5.5 0 11-.8-.59 3.5 3.5 0 015.33-.4v-.55c0-.28.22-.5.5-.5zM4 19.95v.55a.5.5 0 01-1 0v-2c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-1a2.5 2.5 0 003.91.11.5.5 0 01.77.65 3.5 3.5 0 01-5.18.19z",
    fill: primaryFill
  }));
};

export const NotebookSync24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotebookSync24RegularIcon, 'NotebookSync24Regular');

const Notepad12FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 1.5a.5.5 0 011 0V2h2v-.5a.5.5 0 011 0V2a2 2 0 012 2v3H7.5C6.67 7 6 7.67 6 8.5V11H4a2 2 0 01-2-2V4c0-1.1.9-2 2-2v-.5zm0 3c0 .28.22.5.5.5h3a.5.5 0 000-1h-3a.5.5 0 00-.5.5zm0 2c0 .28.22.5.5.5h1a.5.5 0 000-1h-1a.5.5 0 00-.5.5zM4.5 9a.5.5 0 100-1 .5.5 0 000 1zM7 8.5c0-.28.22-.5.5-.5H10l-3 3V8.5z",
    fill: primaryFill
  }));
};

export const Notepad12Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Notepad12FilledIcon, 'Notepad12Filled');

const Notepad12RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 4.5c0 .28.22.5.5.5h3a.5.5 0 000-1h-3a.5.5 0 00-.5.5zM4.5 7a.5.5 0 010-1h3a.5.5 0 010 1h-3zM4 8.5c0 .28.22.5.5.5h1a.5.5 0 000-1h-1a.5.5 0 00-.5.5zm0-7a.5.5 0 011 0V2h2v-.5a.5.5 0 011 0V2a2 2 0 012 2v4l-3 3H4a2 2 0 01-2-2V4c0-1.1.9-2 2-2v-.5zM7 10V8.5c0-.28.22-.5.5-.5H9V4a1 1 0 00-1-1H4a1 1 0 00-1 1v5a1 1 0 001 1h3z",
    fill: primaryFill
  }));
};

export const Notepad12Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Notepad12RegularIcon, 'Notepad12Regular');

const Notepad16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 1c.28 0 .5.22.5.5V2h2v-.5a.5.5 0 011 0V2h2v-.5a.5.5 0 011 0V2c.83 0 1.5.67 1.5 1.5V10H9.5c-.83 0-1.5.67-1.5 1.5V15H4.5A1.5 1.5 0 013 13.5v-10C3 2.67 3.67 2 4.5 2v-.5c0-.28.22-.5.5-.5zm.5 4.5c0 .28.22.5.5.5h4a.5.5 0 000-1H6a.5.5 0 00-.5.5zm0 3c0 .28.22.5.5.5h4a.5.5 0 000-1H6a.5.5 0 00-.5.5zm0 3c0 .28.22.5.5.5h.5a.5.5 0 000-1H6a.5.5 0 00-.5.5zM9 14.69l.15-.13 3.41-3.41.13-.15H9.5a.5.5 0 00-.5.5v3.19z",
    fill: primaryFill
  }));
};

export const Notepad16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Notepad16FilledIcon, 'Notepad16Filled');

const Notepad16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 5a.5.5 0 000 1h4a.5.5 0 000-1H6zm0 3a.5.5 0 000 1h4a.5.5 0 000-1H6zm0 3a.5.5 0 000 1h.5a.5.5 0 000-1H6zM5 1c.28 0 .5.22.5.5V2h2v-.5a.5.5 0 011 0V2h2v-.5a.5.5 0 011 0V2c.83 0 1.5.67 1.5 1.5v6.59c0 .4-.16.78-.44 1.06l-3.41 3.41a1.5 1.5 0 01-1.06.44H4.5A1.5 1.5 0 013 13.5v-10C3 2.67 3.67 2 4.5 2v-.5c0-.28.22-.5.5-.5zm6.5 2h-7a.5.5 0 00-.5.5v10c0 .28.22.5.5.5H8v-2.5c0-.83.67-1.5 1.5-1.5H12V3.5a.5.5 0 00-.5-.5zM9 13.3l2.3-2.3H9.5a.5.5 0 00-.5.5v1.8z",
    fill: primaryFill
  }));
};

export const Notepad16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Notepad16RegularIcon, 'Notepad16Regular');

const Notepad20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 2.5a.5.5 0 00-1 0V3h-.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5H11v-3.5c0-.83.67-1.5 1.5-1.5H16V4.5c0-.83-.67-1.5-1.5-1.5H14v-.5a.5.5 0 00-1 0V3h-2.5v-.5a.5.5 0 00-1 0V3H7v-.5zm0 5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm.5 2.5h5a.5.5 0 010 1h-5a.5.5 0 010-1zM7 13.5c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5zm8.69.5H12.5a.5.5 0 00-.5.5v3.19l.15-.13 3.41-3.41.13-.15z",
    fill: primaryFill
  }));
};

export const Notepad20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Notepad20FilledIcon, 'Notepad20Filled');

const Notepad20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 7a.5.5 0 000 1h5a.5.5 0 000-1h-5zM7 10.5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm.5 2.5a.5.5 0 000 1h2a.5.5 0 000-1h-2zm-1-11a.5.5 0 00-.5.5V3h-.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h6a.5.5 0 00.35-.15l4-4a.5.5 0 00.15-.35v-9c0-.83-.67-1.5-1.5-1.5H14v-.5a.5.5 0 00-1 0V3h-2.5v-.5a.5.5 0 00-1 0V3H7v-.5a.5.5 0 00-.5-.5zm8 2c.28 0 .5.22.5.5V13h-2.5c-.83 0-1.5.67-1.5 1.5V17H5.5a.5.5 0 01-.5-.5v-12c0-.28.22-.5.5-.5h9zm-.2 10L12 16.3v-1.8c0-.28.22-.5.5-.5h1.8z",
    fill: primaryFill
  }));
};

export const Notepad20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Notepad20RegularIcon, 'Notepad20Regular');

const Notepad24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.25 2c.38 0 .7.28.74.65l.01.1v.75h.75c1.24 0 2.25 1 2.25 2.25V16h-3.91A2.25 2.25 0 0014 18.1V22H5.75c-1.24 0-2.25-1-2.25-2.25v-14c0-1.24 1-2.25 2.25-2.25h.75v-.75a.75.75 0 011.5-.1v.85h3v-.75a.75.75 0 011.5-.1v.85h3v-.75c0-.41.34-.75.75-.75zm3.3 15.5l-4.06 4.07v-3.32l.01-.1c.05-.33.31-.6.64-.64l.1-.01h3.32zm-8.3-1.5h-4.1a.75.75 0 000 1.5H11.35a.75.75 0 000-1.5h-.1zm5-4h-9.1a.75.75 0 000 1.5h9.2a.75.75 0 000-1.5h-.1zm0-4h-9.1a.75.75 0 000 1.5h9.2a.75.75 0 000-1.5h-.1z",
    fill: primaryFill
  }));
};

export const Notepad24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Notepad24FilledIcon, 'Notepad24Filled');

const Notepad24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.75 22c-1.24 0-2.25-1-2.25-2.25v-14c0-1.24 1-2.25 2.25-2.25h.75v-.75c0-.38.28-.7.65-.74l.1-.01c.38 0 .7.28.74.65l.01.1v.75h3v-.75c0-.38.28-.7.65-.74l.1-.01c.38 0 .7.28.75.65v.85h3v-.75c0-.38.28-.7.65-.74l.1-.01c.38 0 .7.28.74.65l.01.1v.75h.75c1.24 0 2.25 1 2.25 2.25v11c0 .06 0 .12-.02.18l-.03.09-.04.1-.03.03a.69.69 0 01-.1.13l-4.5 4.5a.74.74 0 01-.09.08l.09-.08a.74.74 0 01-.1.1l-.1.04-.11.05-.12.03h-9.1zm12-17h-12c-.42 0-.75.34-.75.75v14c0 .42.34.75.75.75H14v-2.25c0-1.2.93-2.17 2.1-2.24l.16-.01h2.25V5.75a.75.75 0 00-.75-.75zm-.31 12.5h-1.2c-.37 0-.69.28-.74.65v1.3l1.94-1.95zM7.25 16h4a.75.75 0 01.1 1.5h-4.1a.75.75 0 01-.1-1.5h4.1-4zm0-4h9a.75.75 0 01.1 1.5h-9.1a.75.75 0 01-.1-1.5h9.1-9zm0-4h9a.75.75 0 01.1 1.5h-9.1a.75.75 0 01-.1-1.5h9.1-9z",
    fill: primaryFill
  }));
};

export const Notepad24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Notepad24RegularIcon, 'Notepad24Regular');

const Notepad28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 2c.41 0 .75.34.75.75V4h3.75V2.75a.75.75 0 011.5 0V4h.75C21.99 4 23 5 23 6.25V18.5h-4.75c-1.25 0-2.25 1-2.25 2.25v4.75H6.75c-1.24 0-2.25-1-2.25-2.25v-17C4.5 5.01 5.5 4 6.75 4H8V2.75a.75.75 0 011.5 0V4h3.75V2.75c0-.41.34-.75.75-.75zm-6 8.25c0 .41.34.75.75.75h10a.75.75 0 000-1.5h-10a.75.75 0 00-.75.75zm0 4.5c0 .41.34.75.75.75h10a.75.75 0 000-1.5h-10a.75.75 0 00-.75.75zm0 4.5c0 .41.34.75.75.75h4.5a.75.75 0 000-1.5h-4.5a.75.75 0 00-.75.75zm9.5 5.81L22.56 20h-4.31a.75.75 0 00-.75.75v4.31z",
    fill: primaryFill
  }));
};

export const Notepad28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Notepad28FilledIcon, 'Notepad28Filled');

const Notepad28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 10.25c0-.41.34-.75.75-.75h10a.75.75 0 010 1.5h-10a.75.75 0 01-.75-.75zm0 4.5c0-.41.34-.75.75-.75h10a.75.75 0 010 1.5h-10a.75.75 0 01-.75-.75zm.75 3.75a.75.75 0 000 1.5h4.5a.75.75 0 000-1.5h-4.5zM14 2c.41 0 .75.34.75.75V4h3.75V2.75a.75.75 0 011.5 0V4h.75C21.99 4 23 5 23 6.25v13c0 .2-.08.39-.22.53l-5.5 5.5a.75.75 0 01-.53.22h-10c-1.24 0-2.25-1-2.25-2.25v-17C4.5 5.01 5.5 4 6.75 4H8V2.75a.75.75 0 011.5 0V4h3.75V2.75c0-.41.34-.75.75-.75zM6 6.25v17c0 .41.34.75.75.75H16v-3.25c0-1.25 1-2.25 2.25-2.25h3.25V6.25a.75.75 0 00-.75-.75h-14a.75.75 0 00-.75.75zM18.25 20a.75.75 0 00-.75.75v2.19L20.44 20h-2.2z",
    fill: primaryFill
  }));
};

export const Notepad28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Notepad28RegularIcon, 'Notepad28Regular');

const Notepad32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 4a1 1 0 10-2 0v1H9a3 3 0 00-3 3v18a3 3 0 003 3h8.5v-5.5A2.5 2.5 0 0120 21h6V8a3 3 0 00-3-3h-1V4a1 1 0 10-2 0v1h-3V4a1 1 0 10-2 0v1h-3V4zm0 7h8a1 1 0 110 2h-8a1 1 0 110-2zm-1 6a1 1 0 011-1h8a1 1 0 110 2h-8a1 1 0 01-1-1zm1 4h3a1 1 0 110 2h-3a1 1 0 110-2zm8.25 7.21a3 3 0 01-.75.5V23.5c0-.28.22-.5.5-.5h5.66a3 3 0 01-.63.83l-4.78 4.38z",
    fill: primaryFill
  }));
};

export const Notepad32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Notepad32FilledIcon, 'Notepad32Filled');

const Notepad32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 12a1 1 0 011-1h8a1 1 0 110 2h-8a1 1 0 01-1-1zm1 4a1 1 0 100 2h8a1 1 0 100-2h-8zm-1 6a1 1 0 011-1h3a1 1 0 110 2h-3a1 1 0 01-1-1zm1-18a1 1 0 10-2 0v1H9a3 3 0 00-3 3v18a3 3 0 003 3h9.22a3 3 0 002.03-.79l4.78-4.38a3 3 0 00.97-2.21V8a3 3 0 00-3-3h-1V4a1 1 0 10-2 0v1h-3V4a1 1 0 10-2 0v1h-3V4zM9 7h14a1 1 0 011 1v13h-4a2.5 2.5 0 00-2.5 2.5V27H9a1 1 0 01-1-1V8a1 1 0 011-1zm10.5 19.19V23.5c0-.28.22-.5.5-.5h2.97l-3.47 3.19z",
    fill: primaryFill
  }));
};

export const Notepad32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Notepad32RegularIcon, 'Notepad32Regular');

const NotepadEdit16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 1c.28 0 .5.22.5.5V2h2v-.5a.5.5 0 011 0V2h2v-.5a.5.5 0 011 0V2c.83 0 1.5.67 1.5 1.5v2.54c-.5.08-.98.32-1.37.7L10.3 8.1A.5.5 0 0010 8H6a.5.5 0 000 1h3.38l-2.04 2.04c-.12.12-.24.25-.34.4a.5.5 0 00-.5-.44H6a.5.5 0 000 1h.5c.05 0 .1 0 .16-.03-.14.26-.24.54-.31.82L6.05 14c-.1.36-.06.7.07 1H4.5A1.5 1.5 0 013 13.5v-10C3 2.67 3.67 2 4.5 2v-.5c0-.28.22-.5.5-.5zm.5 4.5c0 .28.22.5.5.5h4a.5.5 0 000-1H6a.5.5 0 00-.5.5zm6.84 1.96a1.56 1.56 0 012.2 2.2l-4.28 4.29c-.36.36-.8.6-1.3.73l-1.2.3a.6.6 0 01-.74-.74l.3-1.2c.12-.5.37-.94.73-1.3l4.29-4.28z",
    fill: primaryFill
  }));
};

export const NotepadEdit16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotepadEdit16FilledIcon, 'NotepadEdit16Filled');

const NotepadEdit16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 1c.28 0 .5.22.5.5V2h2v-.5a.5.5 0 011 0V2h2v-.5a.5.5 0 011 0V2c.83 0 1.5.67 1.5 1.5v2.54c-.35.06-.7.2-1 .4V3.5a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5v10c0 .28.22.5.5.5h1.55c-.1.36-.06.7.07 1H4.5A1.5 1.5 0 013 13.5v-10C3 2.67 3.67 2 4.5 2v-.5c0-.28.22-.5.5-.5zm5 7c.1 0 .2.03.29.1l-.91.9H6a.5.5 0 010-1h4zm-3 3.44a.5.5 0 00-.5-.44H6a.5.5 0 000 1h.5c.05 0 .1 0 .16-.03.1-.18.2-.36.34-.53zM6 5a.5.5 0 000 1h4a.5.5 0 000-1H6zm6.34 2.46a1.56 1.56 0 012.2 2.2l-4.28 4.29c-.36.36-.8.6-1.3.73l-1.2.3a.6.6 0 01-.74-.74l.3-1.2c.12-.5.37-.94.73-1.3l4.29-4.28z",
    fill: primaryFill
  }));
};

export const NotepadEdit16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotepadEdit16RegularIcon, 'NotepadEdit16Regular');

const NotepadEdit20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.8 10.55l-4.82 4.83a2.2 2.2 0 00-.58 1.02l-.37 1.5a.89.89 0 001.08 1.07l1.5-.37c.38-.1.73-.3 1.01-.58l4.83-4.83a1.87 1.87 0 00-2.64-2.64zM7 2.5a.5.5 0 00-1 0V3h-.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5H9l.06-.35.37-1.5a3.2 3.2 0 01.84-1.48l4.83-4.83c.27-.27.57-.47.9-.6V4.5c0-.83-.67-1.5-1.5-1.5H14v-.5a.5.5 0 00-1 0V3h-2.5v-.5a.5.5 0 00-1 0V3H7v-.5zM7.5 7h5a.5.5 0 010 1h-5a.5.5 0 010-1zm5.5 3.5a.5.5 0 01-.5.5h-5a.5.5 0 010-1h5c.28 0 .5.22.5.5zM7.5 13h2a.5.5 0 010 1h-2a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const NotepadEdit20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotepadEdit20FilledIcon, 'NotepadEdit20Filled');

const NotepadEdit20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 7.5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm.5 2.5a.5.5 0 000 1h5a.5.5 0 000-1h-5zM7 13.5c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5zm-1-11a.5.5 0 011 0V3h2.5v-.5a.5.5 0 011 0V3H13v-.5a.5.5 0 011 0V3h.5c.83 0 1.5.67 1.5 1.5v4.73c-.33.14-.63.34-.9.61l-.1.1V4.5a.5.5 0 00-.5-.5h-9a.5.5 0 00-.5.5v12c0 .28.22.5.5.5h3.72l-.16.65L9 18H5.5A1.5 1.5 0 014 16.5v-12C4 3.67 4.67 3 5.5 3H6v-.5zm9.8 8.05l-4.82 4.83a2.2 2.2 0 00-.58 1.02l-.37 1.5a.89.89 0 001.08 1.07l1.5-.37c.38-.1.73-.3 1.01-.58l4.83-4.83a1.87 1.87 0 00-2.64-2.64z",
    fill: primaryFill
  }));
};

export const NotepadEdit20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotepadEdit20RegularIcon, 'NotepadEdit20Regular');

const NotepadPerson16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 1c.28 0 .5.22.5.5V2h2v-.5a.5.5 0 011 0V2h2v-.5a.5.5 0 011 0V2c.83 0 1.5.67 1.5 1.5v1.9a2.99 2.99 0 00-2.6-.2.5.5 0 00-.4-.2H6a.5.5 0 000 1h3.26a2.99 2.99 0 00-.76 2H6a.5.5 0 000 1h2.67a3 3 0 00.6 1.02 1.5 1.5 0 00-.38.1A2.3 2.3 0 007 12.39c0 .93.38 1.8 1 2.42v.2H4.5A1.5 1.5 0 013 13.5v-10C3 2.67 3.67 2 4.5 2v-.5c0-.28.22-.5.5-.5zm.5 10.5c0 .28.22.5.5.5h.5a.5.5 0 000-1H6a.5.5 0 00-.5.5zm3.83-.41H9.2A1.3 1.3 0 008 12.38a2.48 2.48 0 001.21 2.12c.23.13.48.24.75.3l.08.03a6.2 6.2 0 002.92 0l.08-.02A2.52 2.52 0 0015 12.38c0-.72-.6-1.3-1.33-1.3H9.33zM11.5 6a2 2 0 110 4 2 2 0 01-2-2c0-1.1.9-2 2-2z",
    fill: primaryFill
  }));
};

export const NotepadPerson16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotepadPerson16FilledIcon, 'NotepadPerson16Filled');

const NotepadPerson16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 5.5c0-.28.22-.5.5-.5h4a.5.5 0 01.4.2 3 3 0 00-1.14.8H6a.5.5 0 01-.5-.5zm3 2.5H6a.5.5 0 000 1h2.67a3 3 0 01-.17-1zm-1.1 6H4.5a.5.5 0 01-.5-.5v-10c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v1.54c.36.06.7.19 1 .36V3.5c0-.83-.67-1.5-1.5-1.5v-.5a.5.5 0 00-1 0V2h-2v-.5a.5.5 0 00-1 0V2h-2v-.5a.5.5 0 00-1 0V2C3.67 2 3 2.67 3 3.5v10c0 .83.67 1.5 1.5 1.5H8.2c-.32-.29-.59-.62-.8-1zm1.81.5A2.49 2.49 0 018 12.38a1.3 1.3 0 011.33-1.3h4.34c.74 0 1.33.58 1.33 1.3 0 1.14-.8 2.15-1.96 2.43l-.08.02a6.2 6.2 0 01-2.92 0l-.08-.02a2.63 2.63 0 01-.75-.31zM13 9.32A2 2 0 019.5 8 2 2 0 1113 9.32zM5.5 11.5c0-.28.22-.5.5-.5h.5a.5.5 0 010 1H6a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const NotepadPerson16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotepadPerson16RegularIcon, 'NotepadPerson16Regular');

const NotepadPerson20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 2.5a.5.5 0 00-1 0V3h-.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h5.87a3.21 3.21 0 01-.37-1.5c0-1.3 1-2.38 2.27-2.49A2.99 2.99 0 0115.5 9c.17 0 .34.01.5.04V4.5c0-.83-.67-1.5-1.5-1.5H14v-.5a.5.5 0 00-1 0V3h-2.5v-.5a.5.5 0 00-1 0V3H7v-.5zm0 5c0-.28.22-.5.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm0 6c0-.28.22-.5.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5zm0-3c0-.28.22-.5.5-.5H11a.5.5 0 010 1H7.5a.5.5 0 01-.5-.5zM17.5 12a2 2 0 11-4 0 2 2 0 014 0zm1.5 4.5c0 1.25-1 2.5-3.5 2.5S12 17.75 12 16.5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5z",
    fill: primaryFill
  }));
};

export const NotepadPerson20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotepadPerson20FilledIcon, 'NotepadPerson20Filled');

const NotepadPerson20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.5 7a.5.5 0 000 1h5a.5.5 0 000-1h-5zm0 6a.5.5 0 000 1h2a.5.5 0 000-1h-2zm-1-11a.5.5 0 00-.5.5V3h-.5C4.67 3 4 3.67 4 4.5v12c0 .83.67 1.5 1.5 1.5h5.87a3.18 3.18 0 01-.33-1H5.5a.5.5 0 01-.5-.5v-12c0-.28.22-.5.5-.5h9c.28 0 .5.22.5.5v4.54a3.02 3.02 0 011 0V4.5c0-.83-.67-1.5-1.5-1.5H14v-.5a.5.5 0 00-1 0V3h-2.5v-.5a.5.5 0 00-1 0V3H7v-.5a.5.5 0 00-.5-.5zm9 12a2 2 0 100-4 2 2 0 000 4zm0 5c2.5 0 3.5-1.25 3.5-2.5 0-.83-.67-1.5-1.5-1.5h-4c-.83 0-1.5.67-1.5 1.5 0 1.25 1 2.5 3.5 2.5zm-8-9a.5.5 0 000 1H11a.5.5 0 000-1H7.5z",
    fill: primaryFill
  }));
};

export const NotepadPerson20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotepadPerson20RegularIcon, 'NotepadPerson20Regular');

const NotepadPerson24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.25 2c.38 0 .7.28.74.65l.01.1v.75h.75c1.24 0 2.25 1 2.25 2.25v5.59A3.5 3.5 0 0016.05 17h-.28A2.77 2.77 0 0013 19.77v.1c0 .75.21 1.49.67 2.13H5.75c-1.24 0-2.25-1-2.25-2.25v-14c0-1.24 1-2.25 2.25-2.25h.75v-.75a.75.75 0 011.5-.1v.85h3v-.75a.75.75 0 011.5-.1v.85h3v-.75c0-.41.34-.75.75-.75zm-5 14h-4.1a.75.75 0 000 1.5H11.35a.75.75 0 000-1.5h-.1zm5-8h-9.1a.75.75 0 000 1.5h9.2a.75.75 0 000-1.5h-.1zM6.5 12.75c0 .41.34.75.75.75h6a.75.75 0 000-1.5h-6a.75.75 0 00-.75.75zM21 14.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm2 5.38c0 1.55-1.29 3.12-4.5 3.12S14 21.44 14 19.87v-.1c0-.98.8-1.77 1.77-1.77h5.46c.98 0 1.77.8 1.77 1.77v.1z",
    fill: primaryFill
  }));
};

export const NotepadPerson24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotepadPerson24FilledIcon, 'NotepadPerson24Filled');

const NotepadPerson24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.75 22c-1.24 0-2.25-1-2.25-2.25v-14c0-1.24 1-2.25 2.25-2.25h.75v-.75c0-.38.28-.7.65-.74l.1-.01c.38 0 .7.28.74.65l.01.1v.75h3v-.75c0-.38.28-.7.65-.74l.1-.01c.38 0 .7.28.74.65l.01.1v.75h3v-.75c0-.38.28-.7.65-.74l.1-.01c.38 0 .7.28.74.65l.01.1v.75h.75c1.24 0 2.25 1 2.25 2.25v5.59a3.49 3.49 0 00-1.5-.34V5.75a.75.75 0 00-.75-.75h-12c-.42 0-.75.34-.75.75v14c0 .42.34.75.75.75h7.3c.1.53.3 1.04.62 1.5H5.75zm1.5-6h4a.75.75 0 01.1 1.5h-4.1a.75.75 0 01-.1-1.5h.1zm0-8h9a.75.75 0 01.1 1.5h-9.1a.75.75 0 01-.1-1.5h.1zm11.25 9a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0 6c3.21 0 4.5-1.57 4.5-3.13v-.1c0-.98-.8-1.77-1.77-1.77h-5.46c-.98 0-1.77.8-1.77 1.77v.1c0 1.57 1.29 3.13 4.5 3.13zM7.25 12a.75.75 0 000 1.5h6a.75.75 0 000-1.5h-6z",
    fill: primaryFill
  }));
};

export const NotepadPerson24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NotepadPerson24RegularIcon, 'NotepadPerson24Regular');

const NumberCircle116FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 14A6 6 0 108 2a6 6 0 000 12zm1-8.5v5a.5.5 0 11-1 0V7.41c-.19.15-.39.29-.58.41l-.14.1a.5.5 0 11-.56-.84l.16-.1c.31-.2.51-.34.68-.53.18-.2.34-.48.45-1.05a.5.5 0 01.99.1z",
    fill: primaryFill
  }));
};

export const NumberCircle116Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle116FilledIcon, 'NumberCircle116Filled');

const NumberCircle116RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 5.5a.5.5 0 00-.99-.1 2.1 2.1 0 01-.45 1.05c-.17.19-.37.32-.68.53l-.16.1a.5.5 0 00.56.84l.14-.1c.2-.12.4-.26.58-.41v3.09a.5.5 0 101 0v-5zM8 2a6 6 0 100 12A6 6 0 008 2zM3 8a5 5 0 1110 0A5 5 0 013 8z",
    fill: primaryFill
  }));
};

export const NumberCircle116Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle116RegularIcon, 'NumberCircle116Regular');

const NumberCircle120FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm1-11.5v7a.5.5 0 01-1 0V8.48c-.38.48-.82.92-1.22 1.19a.5.5 0 11-.56-.84c.32-.2.71-.6 1.07-1.07.35-.47.62-.97.73-1.38a.5.5 0 01.98.12z",
    fill: primaryFill
  }));
};

export const NumberCircle120Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle120FilledIcon, 'NumberCircle120Filled');

const NumberCircle120RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 6.5a.5.5 0 00-.98-.12c-.1.4-.38.91-.73 1.38-.36.47-.75.86-1.07 1.07a.5.5 0 00.56.84c.4-.27.84-.7 1.22-1.2v5.03a.5.5 0 101 0v-7zM10 2a8 8 0 100 16 8 8 0 000-16zm-7 8a7 7 0 1114 0 7 7 0 01-14 0z",
    fill: primaryFill
  }));
};

export const NumberCircle120Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle120RegularIcon, 'NumberCircle120Regular');

const NumberCircle124FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 22a10 10 0 100-20 10 10 0 000 20zm1.5-14.75v9a.75.75 0 01-1.5 0V10.1a4.99 4.99 0 01-2.01 1.36.75.75 0 01-.48-1.42c.57-.2 1.15-.64 1.63-1.23.47-.59.78-1.23.87-1.7a.75.75 0 011.49.14z",
    fill: primaryFill
  }));
};

export const NumberCircle124Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle124FilledIcon, 'NumberCircle124Filled');

const NumberCircle124RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.5 7.25a.75.75 0 00-1.49-.15c-.1.48-.4 1.12-.87 1.7a3.75 3.75 0 01-1.63 1.24.75.75 0 00.48 1.42A4.99 4.99 0 0012 10.1v6.15a.75.75 0 001.5 0v-9zM12 2a10 10 0 100 20 10 10 0 000-20zM3.5 12a8.5 8.5 0 1117 0 8.5 8.5 0 01-17 0z",
    fill: primaryFill
  }));
};

export const NumberCircle124Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle124RegularIcon, 'NumberCircle124Regular');

const NumberCircle128FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 14a12 12 0 1124 0 12 12 0 01-24 0zm13.5-5.75a.75.75 0 00-1.47-.2v.01l-.03.07-.1.29c-.1.24-.27.58-.5.96a5.7 5.7 0 01-2.46 2.19.75.75 0 00.62 1.36A7.02 7.02 0 0014 11.1v8.16a.75.75 0 001.5 0v-11zm-1.47-.2z",
    fill: primaryFill
  }));
};

export const NumberCircle128Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle128FilledIcon, 'NumberCircle128Filled');

const NumberCircle128RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 14a10.5 10.5 0 1121 0 10.5 10.5 0 01-21 0zM14 2a12 12 0 100 24 12 12 0 000-24zm1.5 6.25a.75.75 0 00-1.47-.2v.01l-.03.07-.1.29c-.1.24-.27.58-.5.96a5.7 5.7 0 01-2.46 2.19.75.75 0 00.62 1.36A7.02 7.02 0 0014 11.1v8.16a.75.75 0 001.5 0v-11zm-1.47-.2z",
    fill: primaryFill
  }));
};

export const NumberCircle128Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle128RegularIcon, 'NumberCircle128Regular');

const NumberCircle132FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 16a14 14 0 1128 0 14 14 0 01-28 0zm16-7a1 1 0 00-1.96-.28v.02a4.15 4.15 0 01-.17.46c-.13.31-.32.75-.6 1.23a6.68 6.68 0 01-2.71 2.65 1 1 0 10.88 1.8A8 8 0 0016 12.84V22a1 1 0 102 0V9z",
    fill: primaryFill
  }));
};

export const NumberCircle132Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle132FilledIcon, 'NumberCircle132Filled');

const NumberCircle132RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 16a12 12 0 1124 0 12 12 0 01-24 0zM16 2a14 14 0 100 28 14 14 0 000-28zm2 7a1 1 0 00-1.96-.28v.02a4.15 4.15 0 01-.17.46c-.13.31-.32.75-.6 1.23a6.68 6.68 0 01-2.71 2.65 1 1 0 10.88 1.8A8 8 0 0016 12.84V22a1 1 0 102 0V9z",
    fill: primaryFill
  }));
};

export const NumberCircle132Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle132RegularIcon, 'NumberCircle132Regular');

const NumberCircle148FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M24 44a20 20 0 100-40 20 20 0 000 40zm2.5-29.75v18.5a1.25 1.25 0 11-2.5 0V19.67c-1 1.3-2.4 2.55-4.32 3.25a1.25 1.25 0 11-.86-2.34 8 8 0 004.11-3.84 12.47 12.47 0 001.09-2.72V14a1.25 1.25 0 012.48.26z",
    fill: primaryFill
  }));
};

export const NumberCircle148Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle148FilledIcon, 'NumberCircle148Filled');

const NumberCircle148RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 24a17.5 17.5 0 1135 0 17.5 17.5 0 01-35 0zM24 4a20 20 0 100 40 20 20 0 000-40zm2.5 10.25a1.25 1.25 0 00-2.47-.27l-.01.04a6.38 6.38 0 01-.22.76c-.18.51-.46 1.21-.87 1.96a8 8 0 01-4.11 3.84 1.25 1.25 0 10.86 2.34A9.73 9.73 0 0024 19.67v13.08a1.25 1.25 0 102.5 0v-18.5z",
    fill: primaryFill
  }));
};

export const NumberCircle148Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle148RegularIcon, 'NumberCircle148Regular');

const NumberCircle216FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 8a6 6 0 1112 0A6 6 0 012 8zm4.9-1.95l.01-.01.05-.06c.06-.05.13-.13.23-.2.2-.15.48-.28.81-.28a1 1 0 011 1c0 .2-.1.43-.35.72-.25.3-.59.58-.97.9l-.02.01c-.36.3-.76.64-1.07 1-.31.37-.59.82-.59 1.37 0 .28.22.5.5.5h3a.5.5 0 000-1H7.18l.17-.22c.25-.29.59-.58.97-.9h.02c.36-.31.76-.65 1.07-1 .32-.37.59-.83.59-1.38a2 2 0 00-2-2c-.6 0-1.08.24-1.4.47a2.72 2.72 0 00-.5.48.5.5 0 00.8.6zm0 0",
    fill: primaryFill
  }));
};

export const NumberCircle216Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle216FilledIcon, 'NumberCircle216Filled');

const NumberCircle216RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 8a5 5 0 1110 0A5 5 0 013 8zm5-6a6 6 0 100 12A6 6 0 008 2zM6.9 6.05l.01-.01.05-.06c.06-.05.13-.13.23-.2.2-.15.48-.28.81-.28a1 1 0 011 1c0 .2-.1.43-.35.72-.25.3-.59.58-.97.9l-.02.01c-.36.3-.76.64-1.07 1-.31.37-.59.82-.59 1.37 0 .28.22.5.5.5h3a.5.5 0 000-1H7.18l.17-.22c.25-.29.59-.58.97-.9h.02c.36-.31.76-.65 1.07-1 .32-.37.59-.83.59-1.38a2 2 0 00-2-2c-.6 0-1.08.24-1.4.47a2.72 2.72 0 00-.5.48.5.5 0 00.8.6zm0 0",
    fill: primaryFill
  }));
};

export const NumberCircle216Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle216RegularIcon, 'NumberCircle216Regular');

const NumberCircle220FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 10a8 8 0 1116 0 8 8 0 01-16 0zm6.4-2.7a.96.96 0 01.1-.11c.07-.08.18-.18.33-.29A2 2 0 0110 6.5c.83 0 1.5.67 1.5 1.5 0 .46-.17.78-.47 1.06-.27.26-.61.47-1.03.72l-.27.17c-.5.32-1.07.7-1.5 1.26a3.6 3.6 0 00-.73 2.29c0 .28.22.5.5.5h4a.5.5 0 000-1H8.53c.08-.5.26-.88.49-1.18.32-.4.75-.71 1.25-1.02l.23-.15c.41-.25.87-.53 1.22-.87.45-.43.78-1 .78-1.78A2.5 2.5 0 0010 5.5c-.76 0-1.36.3-1.76.6a3.47 3.47 0 00-.64.6.5.5 0 00.8.6z",
    fill: primaryFill
  }));
};

export const NumberCircle220Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle220FilledIcon, 'NumberCircle220Filled');

const NumberCircle220RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 10a7 7 0 1114 0 7 7 0 01-14 0zm7-8a8 8 0 100 16 8 8 0 000-16zM8.4 7.3a.5.5 0 01-.8-.6 1.75 1.75 0 01.18-.2c.1-.11.26-.26.46-.4.4-.3 1-.6 1.76-.6A2.5 2.5 0 0112.5 8c0 .79-.33 1.35-.78 1.78-.35.34-.8.62-1.22.87l-.23.15c-.5.3-.93.61-1.25 1.02-.23.3-.41.68-.49 1.18H12a.5.5 0 010 1H8a.5.5 0 01-.5-.5c0-.98.28-1.72.73-2.29.43-.56 1-.94 1.5-1.26l.27-.17c.42-.25.76-.46 1.03-.72.3-.28.47-.6.47-1.06 0-.83-.67-1.5-1.5-1.5a2 2 0 00-1.17.4 2.47 2.47 0 00-.43.4z",
    fill: primaryFill
  }));
};

export const NumberCircle220Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle220RegularIcon, 'NumberCircle220Regular');

const NumberCircle224FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M22 12a10 10 0 11-20 0 10 10 0 0120 0zM10.35 8.95a1.07 1.07 0 01.11-.13c.1-.09.22-.21.4-.34.34-.25.82-.48 1.39-.48.97 0 1.75.78 1.75 1.75 0 .53-.2.86-.53 1.16-.32.28-.72.5-1.24.78l-.34.18a6.4 6.4 0 00-1.94 1.48 4.38 4.38 0 00-.95 2.9c0 .41.34.75.75.75h5a.75.75 0 000-1.5h-4.18c.1-.52.3-.9.54-1.2.37-.45.88-.77 1.5-1.11l.29-.16c.51-.27 1.1-.6 1.57-1a2.9 2.9 0 001.03-2.28c0-1.8-1.46-3.25-3.25-3.25-.99 0-1.76.4-2.28.77a4.46 4.46 0 00-.82.78.75.75 0 001.2.9zm0 0z",
    fill: primaryFill
  }));
};

export const NumberCircle224Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle224FilledIcon, 'NumberCircle224Filled');

const NumberCircle224RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 12a8.5 8.5 0 1117 0 8.5 8.5 0 01-17 0zM12 2a10 10 0 100 20 10 10 0 000-20zm-1.65 6.95a.75.75 0 01-1.2-.9 2.14 2.14 0 01.23-.26c.14-.15.34-.33.6-.52a3.86 3.86 0 012.27-.77c1.8 0 3.25 1.46 3.25 3.25a2.9 2.9 0 01-1.03 2.28c-.47.4-1.06.73-1.57 1l-.29.16c-.62.34-1.13.66-1.5 1.11-.24.3-.45.68-.54 1.2h4.18a.75.75 0 010 1.5h-5a.75.75 0 01-.75-.75c0-1.25.36-2.18.95-2.9a6.4 6.4 0 011.94-1.48l.34-.18c.52-.28.92-.5 1.24-.78.34-.3.53-.63.53-1.16C14 8.78 13.22 8 12.25 8c-.57 0-1.05.23-1.4.48a2.96 2.96 0 00-.5.47z",
    fill: primaryFill
  }));
};

export const NumberCircle224Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle224RegularIcon, 'NumberCircle224Regular');

const NumberCircle228FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 14a12 12 0 1124 0 12 12 0 01-24 0zm8.3-4.02c.33.24.8.18 1.05-.15a1.74 1.74 0 01.17-.19c.12-.13.3-.3.54-.47A3.3 3.3 0 0114 8.5a2.5 2.5 0 012.5 2.5c0 .77-.29 1.24-.75 1.63-.44.37-.99.65-1.66 1l-.44.22c-.82.43-1.75.96-2.46 1.8a5.35 5.35 0 00-1.19 3.6c0 .41.34.75.75.75h6.5a.75.75 0 000-1.5h-5.7c.1-.84.4-1.43.79-1.88.5-.6 1.2-1.02 2-1.44l.38-.2c.67-.33 1.42-.71 2-1.2A3.46 3.46 0 0018 11a4 4 0 00-4-4 4.8 4.8 0 00-2.83.96 5.58 5.58 0 00-1.02.96c-.25.34-.18.8.15 1.06z",
    fill: primaryFill
  }));
};

export const NumberCircle228Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle228FilledIcon, 'NumberCircle228Filled');

const NumberCircle228RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 14a10.5 10.5 0 1121 0 10.5 10.5 0 01-21 0zM14 2a12 12 0 100 24 12 12 0 000-24zm-3.7 7.98c.33.24.8.18 1.05-.15a1.74 1.74 0 01.17-.19c.12-.13.3-.3.54-.47A3.3 3.3 0 0114 8.5a2.5 2.5 0 012.5 2.5c0 .77-.29 1.24-.75 1.63-.44.37-.99.65-1.66 1l-.44.22c-.82.43-1.75.96-2.46 1.8a5.35 5.35 0 00-1.19 3.6c0 .41.34.75.75.75h6.5a.75.75 0 000-1.5h-5.7c.1-.84.4-1.43.79-1.88.5-.6 1.2-1.02 2-1.44l.38-.2c.67-.33 1.42-.71 2-1.2A3.46 3.46 0 0018 11a4 4 0 00-4-4 4.8 4.8 0 00-2.83.96 5.58 5.58 0 00-1.02.96c-.25.34-.18.8.15 1.06z",
    fill: primaryFill
  }));
};

export const NumberCircle228Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle228RegularIcon, 'NumberCircle228Regular');

const NumberCircle232FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 16a14 14 0 1128 0 14 14 0 01-28 0zm12.38 3.16a7.67 7.67 0 012.14-1.71l.4-.24c.73-.43 1.54-.92 2.17-1.51a4.2 4.2 0 001.4-3.2A4.5 4.5 0 0016 8c-1.36 0-2.44.55-3.15 1.07a6.2 6.2 0 00-1.14 1.08 1 1 0 001.6 1.2 1.47 1.47 0 01.16-.18c.13-.13.32-.3.56-.49A3.36 3.36 0 0116 10a2.5 2.5 0 012.5 2.5c0 .77-.29 1.28-.78 1.74-.46.43-1.04.78-1.76 1.21l-.48.29c-.89.54-1.9 1.2-2.67 2.19A6.34 6.34 0 0011.5 22a1 1 0 001 1h7a1 1 0 100-2h-5.92c.14-.78.43-1.37.8-1.84z",
    fill: primaryFill
  }));
};

export const NumberCircle232Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle232FilledIcon, 'NumberCircle232Filled');

const NumberCircle232RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 16a12 12 0 1124 0 12 12 0 01-24 0zM16 2a14 14 0 100 28 14 14 0 000-28zm-1.62 17.16a3.98 3.98 0 00-.8 1.84h5.92a1 1 0 110 2h-7a1 1 0 01-1-1c0-1.74.5-3.05 1.3-4.07a9.58 9.58 0 012.68-2.2l.48-.28c.72-.43 1.3-.78 1.76-1.21.5-.46.78-.97.78-1.74A2.5 2.5 0 0016 10c-.82 0-1.49.33-1.98.68a4.19 4.19 0 00-.72.67 1 1 0 01-1.6-1.2 2.83 2.83 0 01.32-.36c.19-.2.46-.46.82-.72A5.36 5.36 0 0116 8a4.5 4.5 0 014.5 4.5 4.2 4.2 0 01-1.4 3.2c-.64.6-1.45 1.08-2.18 1.5l-.4.25a7.67 7.67 0 00-2.14 1.71z",
    fill: primaryFill
  }));
};

export const NumberCircle232Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle232RegularIcon, 'NumberCircle232Regular');

const NumberCircle248FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M24 44a20 20 0 100-40 20 20 0 000 40zm-4-26.5a1.25 1.25 0 01-2-1.5l.02-.02a2.7 2.7 0 01.11-.14l.31-.34c.27-.28.65-.65 1.15-1.01 1-.73 2.5-1.49 4.4-1.49 3.46 0 6.26 2.8 6.26 6.25a5.8 5.8 0 01-1.96 4.43c-.89.83-2.03 1.5-3.06 2.1l-.59.35a11 11 0 00-3.1 2.47 5.87 5.87 0 00-1.2 2.9H29a1.25 1.25 0 110 2.5H19c-.69 0-1.25-.56-1.25-1.25 0-2.45.71-4.28 1.83-5.7A13.4 13.4 0 0123.36 24l.67-.4c1.03-.6 1.88-1.11 2.55-1.74a3.3 3.3 0 001.17-2.6A3.75 3.75 0 0024 15.5c-1.22 0-2.21.49-2.93 1.01a6.17 6.17 0 00-1.06.99zm0 0z",
    fill: primaryFill
  }));
};

export const NumberCircle248Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle248FilledIcon, 'NumberCircle248Filled');

const NumberCircle248RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 24a17.5 17.5 0 1135 0 17.5 17.5 0 01-35 0zM24 4a20 20 0 100 40 20 20 0 000-40zm-4 13.5a1.25 1.25 0 01-2-1.5 3.22 3.22 0 01.13-.16l.31-.34c.27-.28.65-.65 1.15-1.01 1-.73 2.5-1.49 4.4-1.49 3.46 0 6.26 2.8 6.26 6.25a5.8 5.8 0 01-1.96 4.43c-.89.83-2.03 1.5-3.06 2.1l-.59.35a11 11 0 00-3.1 2.47 5.87 5.87 0 00-1.2 2.9H29a1.25 1.25 0 110 2.5H19c-.69 0-1.25-.56-1.25-1.25 0-2.45.71-4.28 1.83-5.7A13.4 13.4 0 0123.36 24l.67-.4c1.03-.6 1.88-1.11 2.55-1.74a3.3 3.3 0 001.17-2.6A3.75 3.75 0 0024 15.5c-1.22 0-2.21.49-2.93 1.01a6.17 6.17 0 00-1.06.99zm0 0z",
    fill: primaryFill
  }));
};

export const NumberCircle248Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle248RegularIcon, 'NumberCircle248Regular');

const NumberCircle316FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 8a6 6 0 1112 0A6 6 0 012 8zm3.92-1.87c.2.18.52.16.7-.05a.65.65 0 01.08-.07A2.03 2.03 0 018 5.5c.77 0 1.25.52 1.25 1s-.48 1-1.25 1h-.5a.5.5 0 100 1H8c.77 0 1.25.52 1.25 1s-.48 1-1.25 1a1.92 1.92 0 01-1.37-.57v-.01a.5.5 0 00-.76.66h.01l.01.02a1.5 1.5 0 00.15.14A3.03 3.03 0 008 11.5c1.17 0 2.25-.83 2.25-2 0-.62-.3-1.14-.76-1.5.46-.36.76-.88.76-1.5 0-1.17-1.08-2-2.25-2a2.92 2.92 0 00-2.11.9l-.01.01v.01a.5.5 0 00.04.7zm.7-.05zm0 3.84z",
    fill: primaryFill
  }));
};

export const NumberCircle316Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle316FilledIcon, 'NumberCircle316Filled');

const NumberCircle316RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 8a5 5 0 1110 0A5 5 0 013 8zm5-6a6 6 0 100 12A6 6 0 008 2zM5.92 6.13c.2.18.52.16.7-.05a.65.65 0 01.08-.07A2.03 2.03 0 018 5.5c.77 0 1.25.52 1.25 1s-.48 1-1.25 1h-.5a.5.5 0 100 1H8c.77 0 1.25.52 1.25 1s-.48 1-1.25 1a1.92 1.92 0 01-1.37-.57v-.01a.5.5 0 00-.76.66h.01l.01.02a1.5 1.5 0 00.15.14A3.03 3.03 0 008 11.5c1.17 0 2.25-.83 2.25-2 0-.62-.3-1.14-.76-1.5.46-.36.76-.88.76-1.5 0-1.17-1.08-2-2.25-2a2.92 2.92 0 00-2.11.9l-.01.01v.01a.5.5 0 00.04.7zm.7-.05zm0 3.84z",
    fill: primaryFill
  }));
};

export const NumberCircle316Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle316RegularIcon, 'NumberCircle316Regular');

const NumberCircle320FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a8 8 0 100 16 8 8 0 000-16zm-1 8c0-.28.22-.5.5-.5h.5c1.02 0 1.75-.73 1.75-1.5S11.02 6.5 10 6.5a2.53 2.53 0 00-1.87.82.5.5 0 01-.76-.64v-.01l.02-.01a2 2 0 01.17-.18A3.53 3.53 0 0110 5.5c1.46 0 2.75 1.07 2.75 2.5a2.4 2.4 0 01-1.1 2 2.4 2.4 0 011.1 2c0 1.43-1.29 2.5-2.75 2.5a3.53 3.53 0 01-2.61-1.16l-.02-.01a.5.5 0 01.76-.65l.02.02.1.09a2.53 2.53 0 001.76.71c1.01 0 1.74-.73 1.74-1.5s-.73-1.5-1.75-1.5h-.5A.5.5 0 019 10z",
    fill: primaryFill
  }));
};

export const NumberCircle320Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle320FilledIcon, 'NumberCircle320Filled');

const NumberCircle320RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 10a7 7 0 1114 0 7 7 0 01-14 0zm7-8a8 8 0 100 16 8 8 0 000-16zM7.43 7.38a.5.5 0 00.7-.06.98.98 0 01.11-.11c.09-.08.21-.18.38-.29.33-.21.8-.42 1.38-.42 1.02 0 1.75.73 1.75 1.5S11.02 9.5 10 9.5h-.5a.5.5 0 000 1h.5c1.02 0 1.75.73 1.75 1.5s-.73 1.5-1.75 1.5a2.53 2.53 0 01-1.87-.82.5.5 0 00-.76.64v.01l.02.01a1.85 1.85 0 00.17.18 3.53 3.53 0 002.44.98c1.46 0 2.75-1.07 2.75-2.5a2.4 2.4 0 00-1.1-2 2.4 2.4 0 001.1-2c0-1.43-1.29-2.5-2.75-2.5a3.53 3.53 0 00-2.61 1.16l-.02.01a.5.5 0 00.06.71z",
    fill: primaryFill
  }));
};

export const NumberCircle320Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle320RegularIcon, 'NumberCircle320Regular');

const NumberCircle324FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 22a10 10 0 100-20 10 10 0 000 20zm-1.5-10c0-.41.34-.75.75-.75h.87c1.11 0 1.88-.8 1.88-1.63C14 8.8 13.23 8 12.12 8a2.75 2.75 0 00-1.93.8 2.15 2.15 0 00-.11.12.75.75 0 01-1.16-.96l.01-.01.02-.02a2.5 2.5 0 01.21-.22 4.24 4.24 0 012.96-1.2c1.8-.01 3.38 1.32 3.38 3.12A3 3 0 0114.32 12a3 3 0 011.18 2.38c0 1.79-1.58 3.12-3.38 3.12a4.24 4.24 0 01-3.17-1.43l-.02-.02a.75.75 0 011.14-.97l.03.02.1.1a2.75 2.75 0 001.93.8c1.1 0 1.87-.8 1.87-1.63 0-.82-.77-1.62-1.88-1.62h-.87a.75.75 0 01-.75-.75zm-.43 3.08z",
    fill: primaryFill
  }));
};

export const NumberCircle324Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle324FilledIcon, 'NumberCircle324Filled');

const NumberCircle324RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 3.5a8.5 8.5 0 100 17 8.5 8.5 0 000-17zM2 12a10 10 0 1120 0 10 10 0 01-20 0zm8.5 0c0-.41.34-.75.75-.75h.87c1.11 0 1.88-.8 1.88-1.63C14 8.8 13.23 8 12.12 8a2.75 2.75 0 00-1.93.8 2.15 2.15 0 00-.11.12.75.75 0 01-1.16-.96l.01-.01.02-.02a2.5 2.5 0 01.21-.22 4.24 4.24 0 012.96-1.2c1.8-.01 3.38 1.32 3.38 3.12A3 3 0 0114.32 12a3 3 0 011.18 2.38c0 1.79-1.58 3.12-3.38 3.12a4.24 4.24 0 01-3.17-1.43l-.02-.02a.75.75 0 011.14-.97l.03.02.1.1a2.75 2.75 0 001.93.8c1.1 0 1.87-.8 1.87-1.63 0-.82-.77-1.62-1.88-1.62h-.87a.75.75 0 01-.75-.75zm-.43 3.08z",
    fill: primaryFill
  }));
};

export const NumberCircle324Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle324RegularIcon, 'NumberCircle324Regular');

const NumberCircle328FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 14a12 12 0 1124 0 12 12 0 01-24 0zm8.53-4.1c.32.26.79.2 1.05-.11a1.56 1.56 0 01.17-.18c.13-.12.32-.29.57-.46.5-.33 1.2-.65 2.05-.65 1.51 0 2.63 1.12 2.63 2.38 0 1.25-1.12 2.37-2.63 2.37h-1.12a.75.75 0 000 1.5h1.12c1.51 0 2.63 1.12 2.63 2.38 0 1.25-1.12 2.37-2.63 2.37-.86 0-1.56-.32-2.05-.65a4.17 4.17 0 01-.74-.63.75.75 0 00-1.16.94v.01l.02.02a3.36 3.36 0 00.27.28A5.17 5.17 0 0014.37 21c2.23 0 4.13-1.68 4.13-3.88 0-1.3-.67-2.42-1.69-3.12a3.78 3.78 0 001.69-3.13C18.5 8.69 16.6 7 14.37 7a5.17 5.17 0 00-3.87 1.74l-.06.07-.01.02h-.01v.01c-.26.32-.21.8.1 1.06z",
    fill: primaryFill
  }));
};

export const NumberCircle328Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle328FilledIcon, 'NumberCircle328Filled');

const NumberCircle328RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 14a10.5 10.5 0 1121 0 10.5 10.5 0 01-21 0zM14 2a12 12 0 100 24 12 12 0 000-24zm-3.47 7.9c.32.26.79.2 1.05-.11a1.56 1.56 0 01.17-.18c.13-.12.32-.29.57-.46.5-.33 1.2-.65 2.05-.65 1.51 0 2.63 1.12 2.63 2.38 0 1.25-1.12 2.37-2.63 2.37h-1.12a.75.75 0 000 1.5h1.12c1.51 0 2.63 1.12 2.63 2.38 0 1.25-1.12 2.37-2.63 2.37-.86 0-1.56-.32-2.05-.65a4.17 4.17 0 01-.74-.63.75.75 0 00-1.16.94v.01l.02.02a3.36 3.36 0 00.27.28A5.17 5.17 0 0014.37 21c2.23 0 4.13-1.68 4.13-3.88 0-1.3-.67-2.42-1.69-3.12a3.78 3.78 0 001.69-3.13C18.5 8.69 16.6 7 14.37 7a5.17 5.17 0 00-3.87 1.74l-.06.07-.01.02h-.01v.01c-.26.32-.21.8.1 1.06z",
    fill: primaryFill
  }));
};

export const NumberCircle328Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle328RegularIcon, 'NumberCircle328Regular');

const NumberCircle332FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 2a14 14 0 100 28 14 14 0 000-28zm-1.69 14a1 1 0 011-1h.94c1.58 0 2.75-1.18 2.75-2.5S17.83 10 16.25 10c-.92 0-1.66.34-2.2.7a4.48 4.48 0 00-.77.68 1 1 0 01-1.56-1.26l.01-.01.02-.03a3.44 3.44 0 01.3-.32c.21-.2.5-.45.88-.71A5.89 5.89 0 0116.25 8C18.8 8 21 9.95 21 12.5c0 1.44-.7 2.69-1.77 3.5A4.38 4.38 0 0121 19.5c0 2.55-2.2 4.5-4.75 4.5a5.89 5.89 0 01-4.2-1.76 5.18 5.18 0 01-.3-.32l-.02-.03v-.01c-.01 0 0 0 0 0a1 1 0 011.55-1.26l.03.04.14.15c.14.13.34.3.6.49.54.36 1.28.7 2.2.7 1.58 0 2.75-1.18 2.75-2.5S17.83 17 16.25 17h-.94a1 1 0 01-1-1z",
    fill: primaryFill
  }));
};

export const NumberCircle332Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle332FilledIcon, 'NumberCircle332Filled');

const NumberCircle332RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 4a12 12 0 100 24 12 12 0 000-24zM2 16a14 14 0 1128 0 14 14 0 01-28 0zm12.31 0a1 1 0 011-1h.94c1.58 0 2.75-1.18 2.75-2.5S17.83 10 16.25 10c-.92 0-1.66.34-2.2.7a4.48 4.48 0 00-.77.68 1 1 0 01-1.56-1.26l.01-.01.02-.03a3.44 3.44 0 01.3-.32c.21-.2.5-.45.88-.71A5.89 5.89 0 0116.25 8C18.8 8 21 9.95 21 12.5c0 1.44-.7 2.69-1.77 3.5A4.38 4.38 0 0121 19.5c0 2.55-2.2 4.5-4.75 4.5a5.89 5.89 0 01-4.2-1.76 5.18 5.18 0 01-.3-.32l-.02-.03v-.01c-.01 0 0 0 0 0a1 1 0 011.55-1.26l.03.04.14.15c.14.13.34.3.6.49.54.36 1.28.7 2.2.7 1.58 0 2.75-1.18 2.75-2.5S17.83 17 16.25 17h-.94a1 1 0 01-1-1z",
    fill: primaryFill
  }));
};

export const NumberCircle332Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle332RegularIcon, 'NumberCircle332Regular');

const NumberCircle348FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M24 44a20 20 0 100-40 20 20 0 000 40zm-2-20c0-.69.56-1.25 1.25-1.25h1.25c2.3 0 4-1.7 4-3.63 0-1.91-1.7-3.62-4-3.62-1.32 0-2.4.49-3.16 1a6.43 6.43 0 00-1.12.98 1.25 1.25 0 01-1.94-1.58l.01-.02.02-.01.01-.02a4.86 4.86 0 01.42-.44A8.12 8.12 0 0124.5 13c3.5-.01 6.5 2.65 6.5 6.12A5.97 5.97 0 0128.43 24 5.97 5.97 0 0131 28.88c0 3.46-3 6.12-6.5 6.12a8.12 8.12 0 01-4.56-1.43 8.92 8.92 0 01-1.65-1.45v-.01l-.01-.01a1.25 1.25 0 011.94-1.58l.05.06.2.22c.2.18.5.44.87.7.77.51 1.84 1 3.16 1 2.3 0 4-1.7 4-3.63 0-1.91-1.7-3.62-4-3.62h-1.25c-.69 0-1.25-.56-1.25-1.25zm-3.7-8.12v-.01l.02-.02",
    fill: primaryFill
  }));
};

export const NumberCircle348Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle348FilledIcon, 'NumberCircle348Filled');

const NumberCircle348RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M24 6.5a17.5 17.5 0 100 35 17.5 17.5 0 000-35zM4 24a20 20 0 1140 0 20 20 0 01-40 0zm19.25-1.25a1.25 1.25 0 100 2.5h1.25c2.3 0 4 1.7 4 3.63 0 1.91-1.7 3.62-4 3.62-1.32 0-2.4-.49-3.16-1a6.43 6.43 0 01-1.12-.97 1.25 1.25 0 00-1.94 1.57l.01.02a2.12 2.12 0 00.12.14l.33.33A8.12 8.12 0 0024.5 35c3.5.01 6.5-2.65 6.5-6.12A5.97 5.97 0 0028.43 24 5.97 5.97 0 0031 19.12c0-3.46-3-6.12-6.5-6.12-1.96 0-3.51.73-4.56 1.43a8.92 8.92 0 00-1.62 1.42l-.01.02-.02.01v.01l-.01.01a1.25 1.25 0 001.94 1.58l.26-.28c.2-.18.48-.44.86-.7.77-.51 1.84-1 3.16-1 2.3 0 4 1.7 4 3.63 0 1.91-1.7 3.62-4 3.62h-1.25zm-4.96-6.87l.02-.01.01-.02",
    fill: primaryFill
  }));
};

export const NumberCircle348Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle348RegularIcon, 'NumberCircle348Regular');

const NumberCircle416FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 8a6 6 0 1112 0A6 6 0 012 8zm7-2.62c0-.76-.99-1.04-1.39-.4l-2.54 4.1a.6.6 0 00.51.92H8v.5a.5.5 0 001 0V10h.5a.5.5 0 000-1H9V5.38zm-1 .88V9H6.3L8 6.26z",
    fill: primaryFill
  }));
};

export const NumberCircle416Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle416FilledIcon, 'NumberCircle416Filled');

const NumberCircle416RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 8a5 5 0 1110 0A5 5 0 013 8zm5-6a6 6 0 100 12A6 6 0 008 2zm1 3.38c0-.76-.99-1.04-1.39-.4l-2.54 4.1a.6.6 0 00.51.92H8v.5a.5.5 0 001 0V10h.5a.5.5 0 000-1H9V5.38zm-1 .88V9H6.3L8 6.26z",
    fill: primaryFill
  }));
};

export const NumberCircle416Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle416RegularIcon, 'NumberCircle416Regular');

const NumberCircle420FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 10a8 8 0 1116 0 8 8 0 01-16 0zm10-3.7a.75.75 0 00-1.37-.41l-3.54 5.17a.6.6 0 00.5.94h3.4v1.5a.5.5 0 001 0V12H13a.5.5 0 000-1h-1V6.3zm-1 .82V11H8.35L11 7.12z",
    fill: primaryFill
  }));
};

export const NumberCircle420Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle420FilledIcon, 'NumberCircle420Filled');

const NumberCircle420RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 10a7 7 0 1114 0 7 7 0 01-14 0zm7-8a8 8 0 100 16 8 8 0 000-16zm2 4.3a.75.75 0 00-1.37-.41l-3.54 5.17a.6.6 0 00.5.94h3.4v1.5a.5.5 0 001 0V12H13a.5.5 0 000-1h-1V6.3zm-1 .82V11H8.35L11 7.12z",
    fill: primaryFill
  }));
};

export const NumberCircle420Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle420RegularIcon, 'NumberCircle420Regular');

const NumberCircle424FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M22 12a10 10 0 11-20 0 10 10 0 0120 0zm-7.5-4.31c0-1.1-1.43-1.52-2.02-.6l-4.16 6.45a.95.95 0 00.8 1.46H13v1.25a.75.75 0 001.5 0V15h.75a.75.75 0 000-1.5h-.75V7.69zM13 9.05v4.45h-2.87L13 9.05z",
    fill: primaryFill
  }));
};

export const NumberCircle424Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle424FilledIcon, 'NumberCircle424Filled');

const NumberCircle424RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 12a8.5 8.5 0 1117 0 8.5 8.5 0 01-17 0zM12 2a10 10 0 100 20 10 10 0 000-20zm2.5 5.69c0-1.1-1.43-1.52-2.02-.6l-4.16 6.45a.95.95 0 00.8 1.46H13v1.25a.75.75 0 001.5 0V15h.75a.75.75 0 000-1.5h-.75V7.69zM13 9.05v4.45h-2.87L13 9.05z",
    fill: primaryFill
  }));
};

export const NumberCircle424Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle424RegularIcon, 'NumberCircle424Regular');

const NumberCircle428FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 14a12 12 0 1124 0 12 12 0 01-24 0zm14.5-5.58a1.1 1.1 0 00-2.02-.6l-5.4 8.2a.95.95 0 00.8 1.48H15v1.75a.75.75 0 001.5 0V17.5h1a.75.75 0 000-1.5h-1V8.42zM15 9.75V16h-4.1L15 9.75z",
    fill: primaryFill
  }));
};

export const NumberCircle428Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle428FilledIcon, 'NumberCircle428Filled');

const NumberCircle428RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 14a10.5 10.5 0 1121 0 10.5 10.5 0 01-21 0zM14 2a12 12 0 100 24 12 12 0 000-24zm2.5 6.42a1.1 1.1 0 00-2.02-.6l-5.4 8.2a.95.95 0 00.8 1.48H15v1.75a.75.75 0 001.5 0V17.5h1a.75.75 0 000-1.5h-1V8.42zM15 9.75V16h-4.1L15 9.75z",
    fill: primaryFill
  }));
};

export const NumberCircle428Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle428RegularIcon, 'NumberCircle428Regular');

const NumberCircle432FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 16a14 14 0 1128 0 14 14 0 01-28 0zm17-6.18a1.4 1.4 0 00-2.57-.78l-5.95 8.94A1.3 1.3 0 0011.56 20H17v2a1 1 0 102 0v-2h1a1 1 0 100-2h-1V9.82zm-2 1.98V18h-4.13L17 11.8z",
    fill: primaryFill
  }));
};

export const NumberCircle432Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle432FilledIcon, 'NumberCircle432Filled');

const NumberCircle432RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 16a12 12 0 1124 0 12 12 0 01-24 0zM16 2a14 14 0 100 28 14 14 0 000-28zm3 7.82a1.4 1.4 0 00-2.57-.78l-5.95 8.94A1.3 1.3 0 0011.56 20H17v2a1 1 0 102 0v-2h1a1 1 0 100-2h-1V9.82zm-2 1.98V18h-4.13L17 11.8z",
    fill: primaryFill
  }));
};

export const NumberCircle432Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle432RegularIcon, 'NumberCircle432Regular');

const NumberCircle448FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M24 44a20 20 0 100-40 20 20 0 000 40zm3.5-29.42V27.5h2.25a1.25 1.25 0 110 2.5H27.5v2.75a1.25 1.25 0 11-2.5 0V30h-8.44a1.55 1.55 0 01-1.3-2.4l9.21-13.93a1.65 1.65 0 013.03.91zM25 17.41V27.5h-6.67L25 17.4z",
    fill: primaryFill
  }));
};

export const NumberCircle448Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle448FilledIcon, 'NumberCircle448Filled');

const NumberCircle448RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.5 24a17.5 17.5 0 1135 0 17.5 17.5 0 01-35 0zM24 4a20 20 0 100 40 20 20 0 000-40zm3.5 10.58a1.65 1.65 0 00-3.03-.91l-9.2 13.92A1.55 1.55 0 0016.56 30H25v2.75a1.25 1.25 0 102.5 0V30h2.25a1.25 1.25 0 100-2.5H27.5V14.58zM25 17.41V27.5h-6.67L25 17.4z",
    fill: primaryFill
  }));
};

export const NumberCircle448Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle448RegularIcon, 'NumberCircle448Regular');

const NumberCircle516FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 8a6 6 0 1112 0A6 6 0 012 8zm7.25-2a.5.5 0 000-1H7a.5.5 0 00-.5.44l-.25 2a.5.5 0 00.5.56h.21a55.28 55.28 0 011.2.01h.01A1.25 1.25 0 116.94 9.9a.5.5 0 10-.86.5 2.25 2.25 0 102.25-3.37 9.92 9.92 0 00-.9-.02h-.1l.12-1h1.81z",
    fill: primaryFill
  }));
};

export const NumberCircle516Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle516FilledIcon, 'NumberCircle516Filled');

const NumberCircle516RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.25 6h-1.8l-.13 1h.1c.32 0 .74 0 .9.02a2.25 2.25 0 11-2.25 3.38.5.5 0 11.86-.51 1.25 1.25 0 002.31-.47c.1-.68-.38-1.31-1.06-1.4L8.14 8A2.2 2.2 0 007.9 8a25.46 25.46 0 00-.94 0h-.2a.5.5 0 01-.5-.56l.25-2A.5.5 0 017 5h2.24a.5.5 0 010 1zM8 2a6 6 0 100 12A6 6 0 008 2zM3 8a5 5 0 1110 0A5 5 0 013 8z",
    fill: primaryFill
  }));
};

export const NumberCircle516Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle516RegularIcon, 'NumberCircle516Regular');

const NumberCircle520FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 10a8 8 0 1116 0 8 8 0 01-16 0zm6.8-4a.5.5 0 00-.5.45L8 9.2a.5.5 0 00.51.55h.07a37.82 37.82 0 011.8.02 1.87 1.87 0 11-1.93 2.7.5.5 0 10-.9.44 2.87 2.87 0 102.98-4.13 10.91 10.91 0 00-1.47-.04L9.25 7H12a.5.5 0 100-1H8.8z",
    fill: primaryFill
  }));
};

export const NumberCircle520Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle520FilledIcon, 'NumberCircle520Filled');

const NumberCircle520RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a8 8 0 100 16 8 8 0 000-16zm-7 8a7 7 0 1114 0 7 7 0 01-14 0zm5.3-3.55A.5.5 0 018.8 6H12a.5.5 0 110 1H9.25l-.2 1.74h.25c.42 0 .95 0 1.22.04a2.87 2.87 0 11-2.97 4.13.5.5 0 01.9-.45 1.87 1.87 0 101.94-2.7 10.51 10.51 0 00-1.64-.02h-.17l-.05.01h-.02a.5.5 0 01-.5-.55l.3-2.75z",
    fill: primaryFill
  }));
};

export const NumberCircle520Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle520RegularIcon, 'NumberCircle520Regular');

const NumberCircle524FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M22 12a10 10 0 11-20 0 10 10 0 0120 0zM10.75 7c-.4 0-.72.3-.75.7l-.25 3.52a.75.75 0 00.8.8h.05a25.75 25.75 0 01.75-.03c.46 0 .93 0 1.18.03a2 2 0 11-2.1 2.82.75.75 0 10-1.36.62 3.5 3.5 0 103.67-4.93 10.4 10.4 0 00-1.43-.04l.14-1.99h2.8a.75.75 0 000-1.5h-3.5z",
    fill: primaryFill
  }));
};

export const NumberCircle524Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle524FilledIcon, 'NumberCircle524Filled');

const NumberCircle524RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.75 7c-.4 0-.72.3-.75.7l-.25 3.52a.75.75 0 00.8.8h.05a26.09 26.09 0 01.75-.03c.46 0 .93 0 1.18.03a2 2 0 11-2.1 2.82.75.75 0 00-1.36.62 3.5 3.5 0 103.67-4.93 10.4 10.4 0 00-1.43-.04l.14-1.99h2.8a.75.75 0 000-1.5h-3.5zM12 2a10 10 0 100 20 10 10 0 000-20zM3.5 12a8.5 8.5 0 1117 0 8.5 8.5 0 01-17 0z",
    fill: primaryFill
  }));
};

export const NumberCircle524Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle524RegularIcon, 'NumberCircle524Regular');

const NumberCircle528FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 14a12 12 0 1124 0 12 12 0 01-24 0zm14.5-4.5a.75.75 0 000-1.5H12c-.4 0-.73.31-.75.7L11 13.2a.75.75 0 00.75.8h.32a153.43 153.43 0 012.09.03 2.75 2.75 0 11-2.77 4.13.75.75 0 10-1.29.77 4.24 4.24 0 104.2-6.4l-1.48-.03h-.28l.17-3h3.8z",
    fill: primaryFill
  }));
};

export const NumberCircle528Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle528FilledIcon, 'NumberCircle528Filled');

const NumberCircle528RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.5 9.5a.75.75 0 000-1.5H12c-.4 0-.73.31-.75.7L11 13.2a.75.75 0 00.75.8h.32a153.43 153.43 0 012.09.03 2.75 2.75 0 11-2.77 4.13.75.75 0 10-1.29.77 4.24 4.24 0 104.2-6.4l-1.48-.03h-.28l.17-3h3.8zM14 2a12 12 0 100 24 12 12 0 000-24zM3.5 14a10.5 10.5 0 1121 0 10.5 10.5 0 01-21 0z",
    fill: primaryFill
  }));
};

export const NumberCircle528Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle528RegularIcon, 'NumberCircle528Regular');

const NumberCircle532FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 16a14 14 0 1128 0 14 14 0 01-28 0zm11.5-7a1 1 0 00-1 .9l-.5 5a1 1 0 001.01 1.1h.13a133.97 133.97 0 012.6 0 3 3 0 11-2.35 4.5 1 1 0 00-1.72 1 5 5 0 104.11-7.5 62.74 62.74 0 00-1.68 0l.3-3H19a1 1 0 100-2h-5.5z",
    fill: primaryFill
  }));
};

export const NumberCircle532Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle532FilledIcon, 'NumberCircle532Filled');

const NumberCircle532RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.5 9a1 1 0 00-1 .9l-.5 5a1 1 0 001.01 1.1h.13a133.97 133.97 0 012.6 0 3 3 0 11-2.35 4.5 1 1 0 10-1.72 1 5 5 0 104.11-7.5 62.74 62.74 0 00-1.68 0l.3-3H19a1 1 0 100-2h-5.5zM16 2a14 14 0 100 28 14 14 0 000-28zM4 16a12 12 0 1124 0 12 12 0 01-24 0z",
    fill: primaryFill
  }));
};

export const NumberCircle532Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle532RegularIcon, 'NumberCircle532Regular');

const NumberCircle548FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M24 44a20 20 0 100-40 20 20 0 000 40zm4.75-27.5h-6.83l-.33 4.98h.65c1.03-.01 2.33 0 2.95.09a6.75 6.75 0 11-6.6 10.37 1.25 1.25 0 112.1-1.37 4.24 4.24 0 007.77-1.73 4.25 4.25 0 00-3.62-4.8c-.4-.05-1.48-.07-2.59-.07a114.31 114.31 0 00-1.81.03h-.16A1.25 1.25 0 0119 22.67l.5-7.5c.04-.66.59-1.17 1.25-1.17h8a1.25 1.25 0 110 2.5z",
    fill: primaryFill
  }));
};

export const NumberCircle548Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle548FilledIcon, 'NumberCircle548Filled');

const NumberCircle548RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M28.75 16.5h-6.83l-.33 4.98h.66c1.02-.01 2.32 0 2.94.09a6.75 6.75 0 11-6.6 10.37 1.25 1.25 0 112.1-1.37 4.24 4.24 0 007.77-1.73 4.25 4.25 0 00-3.62-4.8c-.4-.05-1.48-.07-2.58-.07a114.31 114.31 0 00-1.82.03h-.16A1.25 1.25 0 0119 22.67l.5-7.5c.05-.66.59-1.17 1.25-1.17h8a1.25 1.25 0 010 2.5zM24 4a20 20 0 100 40 20 20 0 000-40zM6.5 24a17.5 17.5 0 1135 0 17.5 17.5 0 01-35 0z",
    fill: primaryFill
  }));
};

export const NumberCircle548Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberCircle548RegularIcon, 'NumberCircle548Regular');

const NumberRow16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1 4c0-1.1.9-2 2-2h2a2 2 0 012 2v8a2 2 0 01-2 2H3a2 2 0 01-2-2V4zm3 1a.5.5 0 00-.5.5v5a.5.5 0 001 0v-5A.5.5 0 004 5zm5-1c0-1.1.9-2 2-2h2a2 2 0 012 2v8a2 2 0 01-2 2h-2a2 2 0 01-2-2V4zm2 1.5c0 .28.22.5.5.5h.5v1.5h-.5a.5.5 0 00-.5.5v2.5c0 .28.22.5.5.5h1a.5.5 0 000-1H12V8.5h.5A.5.5 0 0013 8V5.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5z",
    fill: primaryFill
  }));
};

export const NumberRow16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberRow16FilledIcon, 'NumberRow16Filled');

const NumberRow16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 5c.28 0 .5.22.5.5v5a.5.5 0 01-1 0v-5c0-.28.22-.5.5-.5zM3 2a2 2 0 00-2 2v8c0 1.1.9 2 2 2h2a2 2 0 002-2V4a2 2 0 00-2-2H3zM2 4a1 1 0 011-1h2a1 1 0 011 1v8a1 1 0 01-1 1H3a1 1 0 01-1-1V4zm9.5 1a.5.5 0 000 1h.5v1.5h-.5a.5.5 0 00-.5.5v2.5c0 .28.22.5.5.5h1a.5.5 0 000-1H12V8.5h.5A.5.5 0 0013 8V5.5a.5.5 0 00-.5-.5h-1zM11 2a2 2 0 00-2 2v8c0 1.1.9 2 2 2h2a2 2 0 002-2V4a2 2 0 00-2-2h-2zm-1 2a1 1 0 011-1h2a1 1 0 011 1v8a1 1 0 01-1 1h-2a1 1 0 01-1-1V4z",
    fill: primaryFill
  }));
};

export const NumberRow16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberRow16RegularIcon, 'NumberRow16Regular');

const NumberRow20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3a2 2 0 00-2 2v10c0 1.1.9 2 2 2h3a2 2 0 002-2V5a2 2 0 00-2-2H4zm1 3.5a.5.5 0 011 0v7a.5.5 0 01-1 0v-7zM13 3a2 2 0 00-2 2v10c0 1.1.9 2 2 2h3a2 2 0 002-2V5a2 2 0 00-2-2h-3zm.5 3h2c.28 0 .5.22.5.5V10a.5.5 0 01-.5.5H14V13h1.5a.5.5 0 010 1h-2a.5.5 0 01-.5-.5V10c0-.28.22-.5.5-.5H15V7h-1.5a.5.5 0 010-1z",
    fill: primaryFill
  }));
};

export const NumberRow20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberRow20FilledIcon, 'NumberRow20Filled');

const NumberRow20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 6.5a.5.5 0 011 0v7a.5.5 0 01-1 0v-7zM4 3a2 2 0 00-2 2v10c0 1.1.9 2 2 2h3a2 2 0 002-2V5a2 2 0 00-2-2H4zM3 5a1 1 0 011-1h3a1 1 0 011 1v10a1 1 0 01-1 1H4a1 1 0 01-1-1V5zm10.5 1a.5.5 0 000 1H15v2.5h-1.5a.5.5 0 00-.5.5v3.5c0 .28.22.5.5.5h2a.5.5 0 000-1H14v-2.5h1.5a.5.5 0 00.5-.5V6.5a.5.5 0 00-.5-.5h-2zM13 3a2 2 0 00-2 2v10c0 1.1.9 2 2 2h3a2 2 0 002-2V5a2 2 0 00-2-2h-3zm-1 2a1 1 0 011-1h3a1 1 0 011 1v10a1 1 0 01-1 1h-3a1 1 0 01-1-1V5z",
    fill: primaryFill
  }));
};

export const NumberRow20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberRow20RegularIcon, 'NumberRow20Regular');

const NumberRow24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.75 4h4a2.75 2.75 0 012.75 2.75v10.5A2.75 2.75 0 018.75 20h-4A2.75 2.75 0 012 17.25V6.75A2.75 2.75 0 014.75 4zM6 9v6a.75.75 0 001.5 0V9A.75.75 0 006 9zm9.25-5h4A2.75 2.75 0 0122 6.75v10.5A2.75 2.75 0 0119.25 20h-4a2.75 2.75 0 01-2.75-2.75V6.75A2.75 2.75 0 0115.25 4zm2.25 5.75v1.5h-1.25a.75.75 0 00-.75.75v3c0 .41.34.75.75.75h2a.75.75 0 000-1.5H17v-1.5h1.25c.41 0 .75-.34.75-.75V9a.75.75 0 00-.75-.75h-2a.75.75 0 000 1.5h1.25z",
    fill: primaryFill
  }));
};

export const NumberRow24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberRow24FilledIcon, 'NumberRow24Filled');

const NumberRow24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.75 4a2.75 2.75 0 012.75 2.75v10.5A2.75 2.75 0 018.75 20h-4A2.75 2.75 0 012 17.25V6.75A2.75 2.75 0 014.75 4h4zm0 1.5h-4c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25h4c.69 0 1.25-.56 1.25-1.25V6.75c0-.69-.56-1.25-1.25-1.25zM19.25 4A2.75 2.75 0 0122 6.75v10.5A2.75 2.75 0 0119.25 20h-4a2.75 2.75 0 01-2.75-2.75V6.75A2.75 2.75 0 0115.25 4h4zm0 1.5h-4c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25h4c.69 0 1.25-.56 1.25-1.25V6.75c0-.69-.56-1.25-1.25-1.25zM6 9v6a.75.75 0 001.5 0V9A.75.75 0 006 9zm11.5.75v1.5h-1.25a.75.75 0 00-.75.75v3c0 .41.34.75.75.75h2a.75.75 0 000-1.5H17v-1.5h1.25c.41 0 .75-.34.75-.75V9a.75.75 0 00-.75-.75h-2a.75.75 0 000 1.5h1.25z",
    fill: primaryFill
  }));
};

export const NumberRow24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberRow24RegularIcon, 'NumberRow24Regular');

const NumberSymbol16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 2.85a.75.75 0 00-1.5-.2L10.18 5H6.7l.3-2.14a.75.75 0 10-1.48-.22L5.17 5H3.75a.75.75 0 000 1.5h1.2l-.42 3H2.75a.75.75 0 100 1.5h1.56l-.3 2.14a.75.75 0 101.48.22L5.83 11h3.49L9 13.14a.75.75 0 101.48.22l.34-2.36h1.42a.75.75 0 000-1.5h-1.2l.42-3h1.78a.75.75 0 000-1.5h-1.56l.3-2.15zM9.95 6.5l-.43 3H6.04l.43-3h3.49z",
    fill: primaryFill
  }));
};

export const NumberSymbol16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberSymbol16FilledIcon, 'NumberSymbol16Filled');

const NumberSymbol16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 2.6a.5.5 0 10-1-.19L5.55 5H3.5a.5.5 0 000 1h1.86l-.73 4H2.5a.5.5 0 000 1h1.95L4 13.41a.5.5 0 00.98.18L5.46 11h3.98l-.43 2.4a.5.5 0 00.98.19l.47-2.59h2.04a.5.5 0 000-1h-1.86l.73-4h2.13a.5.5 0 100-1h-1.95L12 2.6a.5.5 0 10-.98-.19l-.47 2.6H6.55L7 2.58zM6.36 6h3.99l-.73 4H5.64l.73-4z",
    fill: primaryFill
  }));
};

export const NumberSymbol16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberSymbol16RegularIcon, 'NumberSymbol16Regular');

const NumberSymbol20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.99 2.88a.75.75 0 00-1.48-.26L6.84 6.5H3.75a.75.75 0 000 1.5h2.83l-.68 4H2.75a.75.75 0 000 1.5h2.89L5 17.12a.75.75 0 101.48.26l.67-3.88h4.48L11 17.12a.75.75 0 101.48.26l.67-3.88h3.1a.75.75 0 000-1.5h-2.84l.69-4h3.14a.75.75 0 100-1.5h-2.88l.62-3.62a.75.75 0 00-1.48-.26l-.67 3.88H8.37l.62-3.62zM8.1 8h4.47l-.68 4H7.42l.69-4z",
    fill: primaryFill
  }));
};

export const NumberSymbol20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberSymbol20FilledIcon, 'NumberSymbol20Filled');

const NumberSymbol20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.99 2.6a.5.5 0 00-.98-.2L7.09 7H3.5a.5.5 0 100 1h3.39l-.8 4H2.5a.5.5 0 000 1h3.4L5 17.4a.5.5 0 10.98.2l.92-4.6h5l-.9 4.4a.5.5 0 00.98.2l.95-4.6h3.56a.5.5 0 000-1h-3.36l.82-4h3.54a.5.5 0 100-1h-3.33l.9-4.39a.5.5 0 10-.98-.2l-.95 4.6H8.11l.88-4.41zM7.91 8h5.03l-.82 4h-5l.79-4z",
    fill: primaryFill
  }));
};

export const NumberSymbol20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberSymbol20RegularIcon, 'NumberSymbol20Regular');

const NumberSymbol24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.98 3.16a1 1 0 00-1.97-.32L8.15 8H4a1 1 0 100 2h3.82l-.67 4H3a1 1 0 100 2h3.82L6 20.84a1 1 0 101.97.32L8.84 16h4.98l-.8 4.84a1 1 0 101.97.32l.86-5.17H20a1 1 0 000-2h-3.82l.67-4H21a1 1 0 000-2h-3.82l.8-4.83a1 1 0 10-1.97-.32l-.86 5.15h-4.97l.8-4.83zM9.85 10h4.97l-.67 4H9.18l.67-4z",
    fill: primaryFill
  }));
};

export const NumberSymbol24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberSymbol24FilledIcon, 'NumberSymbol24Filled');

const NumberSymbol24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.99 2.89a.75.75 0 10-1.48-.28L8.5 8H3.75a.75.75 0 100 1.5h4.46l-.95 5H2.75a.75.75 0 000 1.5h4.23l-.97 5.11a.75.75 0 101.48.28L8.5 16h5.47l-.97 5.12a.75.75 0 101.48.28L15.5 16h4.74a.75.75 0 100-1.5h-4.46l.95-5h4.51a.75.75 0 100-1.5h-4.23L18 2.9a.75.75 0 00-1.48-.28L15.5 8h-5.47L11 2.9zm-1.25 6.6h5.47l-.94 5H8.79l.95-5z",
    fill: primaryFill
  }));
};

export const NumberSymbol24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberSymbol24RegularIcon, 'NumberSymbol24Regular');

const NumberSymbol28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.98 3.2a1 1 0 10-1.96-.4L9.75 9H4a1 1 0 100 2h5.34l-1.22 6H3a1 1 0 100 2h4.7l-1.18 5.8a1 1 0 101.96.4L9.75 19h5.96l-1.19 5.8a1 1 0 101.96.4l1.27-6.2H23a1 1 0 100-2h-4.84l1.22-6H24a1 1 0 100-2h-4.2l1.18-5.8a1 1 0 10-1.96-.4L17.75 9H11.8l1.19-5.8zM16.12 17h-5.96l1.22-6h5.96l-1.22 6z",
    fill: primaryFill
  }));
};

export const NumberSymbol28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberSymbol28FilledIcon, 'NumberSymbol28Filled');

const NumberSymbol28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.98 3.4a.75.75 0 10-1.46-.3L10.28 9H3.75a.75.75 0 000 1.5h6.22L8.6 17H2.75a.75.75 0 100 1.5h5.54l-1.27 6.1a.75.75 0 101.46.3l1.34-6.4h6.47l-1.27 6.1a.75.75 0 001.46.3l1.34-6.4h6.43a.75.75 0 000-1.5h-6.11l1.36-6.5h5.75a.75.75 0 000-1.5h-5.44l1.17-5.6a.75.75 0 10-1.46-.3L18.28 9h-6.47l1.17-5.6zM16.61 17h-6.47l1.36-6.5h6.47L16.6 17z",
    fill: primaryFill
  }));
};

export const NumberSymbol28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberSymbol28RegularIcon, 'NumberSymbol28Regular');

const NumberSymbol32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.97 3.5a1.25 1.25 0 00-2.44-.5L11.2 9.5H5.25a1.25 1.25 0 100 2.5h5.44l-1.43 7H4.25a1.25 1.25 0 000 2.5h4.5l-1.22 6a1.25 1.25 0 102.44.5l1.33-6.5h6.95l-1.22 6a1.25 1.25 0 102.45.5l1.32-6.5h5.95a1.25 1.25 0 100-2.5h-5.44l1.43-7h5.01a1.25 1.25 0 100-2.5h-4.5l1.23-6a1.25 1.25 0 00-2.45-.5L20.7 9.5h-6.95l1.22-6zM18.77 19h-6.95l1.43-7h6.95l-1.43 7z",
    fill: primaryFill
  }));
};

export const NumberSymbol32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberSymbol32FilledIcon, 'NumberSymbol32Filled');

const NumberSymbol32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.98 3.2a1 1 0 00-1.96-.4L11.58 10H5a1 1 0 100 2h6.18l-1.4 7H4a1 1 0 100 2h5.38l-1.36 6.8a1 1 0 001.96.4l1.44-7.2h6.96l-1.36 6.8a1 1 0 001.96.4l1.44-7.2H27a1 1 0 100-2h-6.18l1.4-7H28a1 1 0 100-2h-5.38l1.36-6.8a1 1 0 00-1.96-.4L20.58 10h-6.96l1.36-6.8zm3.8 15.8h-6.96l1.4-7h6.96l-1.4 7z",
    fill: primaryFill
  }));
};

export const NumberSymbol32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberSymbol32RegularIcon, 'NumberSymbol32Regular');

const NumberSymbol48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M22.22 5.53a1.5 1.5 0 10-2.94-.55L17.4 15H7.25a1.5 1.5 0 100 3h9.6L14.6 30H5.25a1.5 1.5 0 100 3h8.8l-1.77 9.48a1.5 1.5 0 102.94.55L17.1 33h10.94l-1.76 9.48a1.5 1.5 0 102.94.55L31.1 33h9.65a1.5 1.5 0 000-3h-9.1l2.25-12h8.85a1.5 1.5 0 000-3h-8.3l1.77-9.47a1.5 1.5 0 10-2.94-.55L31.4 15H20.46l1.76-9.47zM28.6 30H17.66l2.24-12h10.94L28.6 30z",
    fill: primaryFill
  }));
};

export const NumberSymbol48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberSymbol48FilledIcon, 'NumberSymbol48Filled');

const NumberSymbol48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M21.98 5.48a1.25 1.25 0 00-2.46-.46L17.66 15H7.25a1.25 1.25 0 000 2.5h9.94L14.86 30H5.25a1.25 1.25 0 000 2.5h9.14l-1.87 10.02a1.25 1.25 0 002.46.46l1.95-10.48H28.4l-1.87 10.02a1.25 1.25 0 002.46.46l1.95-10.48h9.82a1.25 1.25 0 100-2.5H31.4l2.33-12.5h9.02a1.25 1.25 0 100-2.5H34.2l1.78-9.52a1.25 1.25 0 00-2.46-.46L31.66 15H20.2l1.78-9.52zM28.86 30H17.4l2.33-12.5H31.2L28.86 30z",
    fill: primaryFill
  }));
};

export const NumberSymbol48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberSymbol48RegularIcon, 'NumberSymbol48Regular');

const NumberSymbolDismiss20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.99 2.88a.75.75 0 00-1.48-.26L6.84 6.5H3.75a.75.75 0 000 1.5h2.83l-.68 4H2.75a.75.75 0 000 1.5h2.89L5 17.12a.75.75 0 101.48.26l.67-3.88H9.1c.1-.53.27-1.04.51-1.5H7.42l.69-4h4.47l-.24 1.44c.5-.21 1.03-.35 1.59-.41L14.11 8h3.14a.75.75 0 100-1.5h-2.88l.62-3.62a.75.75 0 00-1.48-.26l-.67 3.88H8.37l.62-3.62zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-2.65-1.15a.5.5 0 00-.7-.7l-1.15 1.14-1.15-1.14a.5.5 0 00-.7.7l1.14 1.15-1.14 1.15a.5.5 0 00.7.7l1.15-1.14 1.15 1.14a.5.5 0 00.7-.7l-1.14-1.15 1.14-1.15z",
    fill: primaryFill
  }));
};

export const NumberSymbolDismiss20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberSymbolDismiss20FilledIcon, 'NumberSymbolDismiss20Filled');

const NumberSymbolDismiss20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.99 2.6a.5.5 0 00-.98-.2L7.09 7H3.5a.5.5 0 100 1h3.39l-.8 4H2.5a.5.5 0 000 1h3.4L5 17.4a.5.5 0 10.98.2l.92-4.6h2.3c.1-.35.23-.69.4-1H7.1l.8-4h5.03l-.27 1.31c.34-.12.7-.2 1.08-.26L13.96 8h3.54a.5.5 0 100-1h-3.33l.9-4.39a.5.5 0 10-.98-.2l-.95 4.6H8.11l.88-4.41zM19 14.5a4.5 4.5 0 10-9 0 4.5 4.5 0 009 0zm-2.65-1.15l-1.14 1.15 1.14 1.15a.5.5 0 01-.7.7l-1.15-1.14-1.15 1.14a.5.5 0 01-.7-.7l1.14-1.15-1.14-1.15a.5.5 0 01.7-.7l1.15 1.14 1.15-1.14a.5.5 0 01.7.7z",
    fill: primaryFill
  }));
};

export const NumberSymbolDismiss20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberSymbolDismiss20RegularIcon, 'NumberSymbolDismiss20Regular');

const NumberSymbolDismiss24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.98 3.16a1 1 0 00-1.97-.32L8.15 8H4a1 1 0 000 2h3.82l-.67 4H3a1 1 0 100 2h3.82L6 20.84a1 1 0 101.97.32L8.84 16h2.33c.18-.72.47-1.4.85-2H9.18l.67-4h4.97l-.29 1.71a6.46 6.46 0 012.14-.66l.18-1.06H21a1 1 0 000-2h-3.82l.8-4.83a1 1 0 10-1.97-.32l-.86 5.15h-4.97l.8-4.83zM23 17.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-7.15-2.35a.5.5 0 00-.7.7l1.64 1.65-1.64 1.65a.5.5 0 00.7.7l1.65-1.64 1.65 1.64a.5.5 0 00.7-.7l-1.64-1.65 1.64-1.65a.5.5 0 00-.7-.7l-1.65 1.64-1.65-1.64z",
    fill: primaryFill
  }));
};

export const NumberSymbolDismiss24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberSymbolDismiss24FilledIcon, 'NumberSymbolDismiss24Filled');

const NumberSymbolDismiss24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.99 2.89a.75.75 0 10-1.48-.28L8.5 8H3.75a.75.75 0 100 1.5h4.46l-.95 5H2.75a.75.75 0 000 1.5h4.23l-.97 5.11a.75.75 0 101.48.28L8.5 16h2.66c.13-.52.32-1.02.56-1.5H8.8l.95-5h5.47l-.4 2.09c.52-.23 1.06-.4 1.63-.5l.3-1.59h4.51a.75.75 0 100-1.5h-4.23L18 2.9a.75.75 0 00-1.48-.28L15.5 8h-5.47L11 2.9zM23 17.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0zm-7.15-2.35a.5.5 0 00-.7.7l1.64 1.65-1.64 1.65a.5.5 0 00.7.7l1.65-1.64 1.65 1.64a.5.5 0 00.7-.7l-1.64-1.65 1.64-1.65a.5.5 0 00-.7-.7l-1.65 1.64-1.65-1.64z",
    fill: primaryFill
  }));
};

export const NumberSymbolDismiss24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberSymbolDismiss24RegularIcon, 'NumberSymbolDismiss24Regular');

const NumberSymbolSquare20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.45 9l-.43 2H8.55l.43-2h2.47zM5.5 3A2.5 2.5 0 003 5.5v9A2.5 2.5 0 005.5 17h9a2.5 2.5 0 002.5-2.5v-9A2.5 2.5 0 0014.5 3h-9zm3.6 3.01a.5.5 0 01.39.6L9.19 8h2.48L12 6.4a.5.5 0 01.98.2l-.3 1.4h.81a.5.5 0 010 1h-1.02l-.43 2H13a.5.5 0 010 1h-1.17l-.34 1.6a.5.5 0 11-.98-.2l.3-1.4H8.33L8 13.6a.5.5 0 11-.98-.2l.3-1.4H6.5a.5.5 0 010-1h1.02l.43-2H7a.5.5 0 010-1h1.17l.34-1.6a.5.5 0 01.6-.39z",
    fill: primaryFill
  }));
};

export const NumberSymbolSquare20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberSymbolSquare20FilledIcon, 'NumberSymbolSquare20Filled');

const NumberSymbolSquare20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.1 6.01a.5.5 0 01.39.6L9.19 8h2.48L12 6.4a.5.5 0 01.98.2l-.3 1.4h.81a.5.5 0 010 1h-1.02l-.43 2H13a.5.5 0 010 1h-1.17l-.34 1.6a.5.5 0 11-.98-.2l.3-1.4H8.33L8 13.6a.5.5 0 11-.98-.2l.3-1.4H6.5a.5.5 0 010-1h1.02l.43-2H7a.5.5 0 010-1h1.17l.34-1.6a.5.5 0 01.6-.39zM8.55 11h2.47l.43-2H8.98l-.43 2zM3 5.5A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v9a2.5 2.5 0 01-2.5 2.5h-9A2.5 2.5 0 013 14.5v-9zM5.5 4C4.67 4 4 4.67 4 5.5v9c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-9c0-.83-.67-1.5-1.5-1.5h-9z",
    fill: primaryFill
  }));
};

export const NumberSymbolSquare20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberSymbolSquare20RegularIcon, 'NumberSymbolSquare20Regular');

const NumberSymbolSquare24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M13.44 11l-.4 2h-2.47l.4-2h2.47zM6.25 3A3.25 3.25 0 003 6.25v11.5C3 19.55 4.46 21 6.25 21h11.5c1.8 0 3.25-1.46 3.25-3.25V6.25C21 4.45 19.54 3 17.75 3H6.25zm4.65 4.51c.4.09.67.48.59.89l-.22 1.1h2.47l.28-1.4a.75.75 0 011.47.3l-.22 1.1h.98a.75.75 0 010 1.5h-1.28l-.4 2h1.18a.75.75 0 010 1.5h-1.48l-.28 1.4a.75.75 0 01-1.48-.3l.23-1.1h-2.47l-.28 1.4a.75.75 0 01-1.48-.3l.23-1.1h-.99a.75.75 0 010-1.5h1.29l.4-2H8.25a.75.75 0 010-1.5h1.49l.28-1.4c.08-.4.47-.67.88-.59z",
    fill: primaryFill
  }));
};

export const NumberSymbolSquare24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberSymbolSquare24FilledIcon, 'NumberSymbolSquare24Filled');

const NumberSymbolSquare24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10.9 7.51c.4.09.67.48.59.89l-.22 1.1h2.47l.28-1.4a.75.75 0 011.47.3l-.22 1.1h.98a.75.75 0 010 1.5h-1.28l-.4 2h1.18a.75.75 0 010 1.5h-1.48l-.28 1.4a.75.75 0 01-1.48-.3l.23-1.1h-2.47l-.28 1.4a.75.75 0 01-1.48-.3l.23-1.1h-.99a.75.75 0 010-1.5h1.29l.4-2H8.25a.75.75 0 010-1.5h1.49l.28-1.4c.08-.4.47-.67.88-.59zM10.57 13h2.47l.4-2h-2.47l-.4 2zM3 6.25C3 4.45 4.46 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 17.75V6.25zM6.25 4.5c-.97 0-1.75.78-1.75 1.75v11.5c0 .97.78 1.75 1.75 1.75h11.5c.97 0 1.75-.78 1.75-1.75V6.25c0-.97-.78-1.75-1.75-1.75H6.25z",
    fill: primaryFill
  }));
};

export const NumberSymbolSquare24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/NumberSymbolSquare24RegularIcon, 'NumberSymbolSquare24Regular');

const Open16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.75 3.5c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h6.5c.69 0 1.25-.56 1.25-1.25v-1.5a.75.75 0 011.5 0v1.5A2.75 2.75 0 0111.25 14h-6.5A2.75 2.75 0 012 11.25v-6.5A2.75 2.75 0 014.75 2h1.5a.75.75 0 010 1.5h-1.5zM8 2.75c0-.41.34-.75.75-.75h4.5c.41 0 .75.34.75.75v4.5a.75.75 0 01-1.5 0V4.56L9.28 7.78a.75.75 0 11-1.06-1.06l3.22-3.22H8.75A.75.75 0 018 2.75z",
    fill: primaryFill
  }));
};

export const Open16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Open16FilledIcon, 'Open16Filled');

const Open16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 3C3.67 3 3 3.67 3 4.5v7c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5V9.27a.5.5 0 011 0v2.23a2.5 2.5 0 01-2.5 2.5h-7A2.5 2.5 0 012 11.5v-7A2.5 2.5 0 014.5 2h2.23a.5.5 0 010 1H4.5zm4.27-.5c0-.28.22-.5.5-.5h4.23c.28 0 .5.22.5.5v4.23a.5.5 0 01-1 0V3.71L9.62 7.08a.5.5 0 11-.7-.7L12.29 3H9.27a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const Open16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Open16RegularIcon, 'Open16Regular');

const Open20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.25 4.5c-.97 0-1.75.78-1.75 1.75v7.5c0 .97.78 1.75 1.75 1.75h7.5c.97 0 1.75-.78 1.75-1.75v-2a.75.75 0 011.5 0v2c0 1.8-1.46 3.25-3.25 3.25h-7.5A3.25 3.25 0 013 13.75v-7.5C3 4.45 4.46 3 6.25 3h2a.75.75 0 010 1.5h-2zm4.25-.75c0-.41.34-.75.75-.75h5c.41 0 .75.34.75.75v5a.75.75 0 01-1.5 0V5.56l-3.72 3.72a.75.75 0 11-1.06-1.06l3.72-3.72h-3.19a.75.75 0 01-.75-.75z",
    fill: primaryFill
  }));
};

export const Open20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Open20FilledIcon, 'Open20Filled');

const Open20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h8a2 2 0 002-2v-2.5a.5.5 0 011 0V14a3 3 0 01-3 3H6a3 3 0 01-3-3V6a3 3 0 013-3h2.5a.5.5 0 010 1H6zm5-.5c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v5a.5.5 0 01-1 0V4.7l-4.15 4.15a.5.5 0 01-.7-.7L15.29 4H11.5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const Open20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Open20RegularIcon, 'Open20Regular');

const Open24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.25 4.75c-.83 0-1.5.67-1.5 1.5v11.5c0 .83.67 1.5 1.5 1.5h11.5c.83 0 1.5-.67 1.5-1.5v-4a1 1 0 112 0v4a3.5 3.5 0 01-3.5 3.5H6.25a3.5 3.5 0 01-3.5-3.5V6.25a3.5 3.5 0 013.5-3.5h4a1 1 0 110 2h-4zm6.5-1a1 1 0 011-1h6.5a1 1 0 011 1v6.5a1 1 0 11-2 0V6.16l-4.8 4.8a1 1 0 11-1.4-1.42l4.79-4.79h-4.09a1 1 0 01-1-1z",
    fill: primaryFill
  }));
};

export const Open24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Open24FilledIcon, 'Open24Filled');

const Open24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.25 4.5c-.97 0-1.75.78-1.75 1.75v11.5c0 .97.78 1.75 1.75 1.75h11.5c.97 0 1.75-.78 1.75-1.75v-4a.75.75 0 011.5 0v4c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 17.75V6.25C3 4.45 4.46 3 6.25 3h4a.75.75 0 010 1.5h-4zM13 3.75c0-.41.34-.75.75-.75h6.5c.41 0 .75.34.75.75v6.5a.75.75 0 01-1.5 0V5.56l-5.22 5.22a.75.75 0 01-1.06-1.06l5.22-5.22h-4.69a.75.75 0 01-.75-.75z",
    fill: primaryFill
  }));
};

export const Open24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Open24RegularIcon, 'Open24Regular');

const Open28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 5a2 2 0 00-2 2v14c0 1.1.9 2 2 2h14a2 2 0 002-2v-4.5a1 1 0 112 0V21a4 4 0 01-4 4H7a4 4 0 01-4-4V7a4 4 0 014-4h4.5a1 1 0 110 2H7zm8.5-1a1 1 0 011-1H24a1 1 0 011 1v7.5a1 1 0 11-2 0V6.41l-5.8 5.8a1 1 0 11-1.4-1.42L21.58 5H16.5a1 1 0 01-1-1z",
    fill: primaryFill
  }));
};

export const Open28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Open28FilledIcon, 'Open28Filled');

const Open28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.25 4.5A2.75 2.75 0 004.5 7.25v13.5a2.75 2.75 0 002.75 2.75h13.5a2.75 2.75 0 002.75-2.75v-4.5a.75.75 0 011.5 0v4.5C25 23.1 23.1 25 20.75 25H7.25A4.25 4.25 0 013 20.75V7.25C3 4.9 4.9 3 7.25 3h4.5a.75.75 0 010 1.5h-4.5zm8.25-.75c0-.41.34-.75.75-.75h8c.41 0 .75.34.75.75v8a.75.75 0 01-1.5 0V5.56l-6.22 6.22a.75.75 0 11-1.06-1.06l6.22-6.22h-6.19a.75.75 0 01-.75-.75z",
    fill: primaryFill
  }));
};

export const Open28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Open28RegularIcon, 'Open28Regular');

const Open32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7.75 5.5c-1.24 0-2.25 1-2.25 2.25v16.5c0 1.24 1 2.25 2.25 2.25h16.5c1.24 0 2.25-1 2.25-2.25v-5a1.25 1.25 0 112.5 0v5A4.75 4.75 0 0124.25 29H7.75A4.75 4.75 0 013 24.25V7.75A4.75 4.75 0 017.75 3h5a1.25 1.25 0 110 2.5h-5zM18 4.25c0-.69.56-1.25 1.25-1.25h8.5c.69 0 1.25.56 1.25 1.25v8.5a1.25 1.25 0 11-2.5 0V7.27l-6.37 6.36a1.25 1.25 0 11-1.76-1.76l6.36-6.37h-5.48c-.69 0-1.25-.56-1.25-1.25z",
    fill: primaryFill
  }));
};

export const Open32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Open32FilledIcon, 'Open32Filled');

const Open32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.5 5A3.5 3.5 0 005 8.5v15A3.5 3.5 0 008.5 27h15a3.5 3.5 0 003.5-3.5V19a1 1 0 112 0v4.5a5.5 5.5 0 01-5.5 5.5h-15A5.5 5.5 0 013 23.5v-15A5.5 5.5 0 018.5 3H13a1 1 0 110 2H8.5zM18 4a1 1 0 011-1h9a1 1 0 011 1v9a1 1 0 11-2 0V6.41l-7.3 7.3a1 1 0 01-1.4-1.42L25.58 5H19a1 1 0 01-1-1z",
    fill: primaryFill
  }));
};

export const Open32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Open32RegularIcon, 'Open32Regular');

const Open48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M41.45 6.34c.34.27.55.7.55 1.16v12a1.5 1.5 0 01-3 0v-8.38l-9.44 9.44a1.5 1.5 0 11-2.12-2.12L36.88 9H28.5a1.5 1.5 0 010-3h11.98a1.5 1.5 0 01.97.34zM12.5 9A3.5 3.5 0 009 12.5v23a3.5 3.5 0 003.5 3.5h23a3.5 3.5 0 003.5-3.5v-8a1.5 1.5 0 113 0v8a6.5 6.5 0 01-6.5 6.5h-23A6.5 6.5 0 016 35.5v-23A6.5 6.5 0 0112.5 6h8a1.5 1.5 0 010 3h-8z",
    fill: primaryFill
  }));
};

export const Open48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Open48FilledIcon, 'Open48Filled');

const Open48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.25 8.5a3.75 3.75 0 00-3.75 3.75v23.5a3.75 3.75 0 003.75 3.75h23.5a3.75 3.75 0 003.75-3.75v-8.5a1.25 1.25 0 012.5 0v8.5C42 39.2 39.2 42 35.75 42h-23.5A6.25 6.25 0 016 35.75v-23.5C6 8.8 8.8 6 12.25 6h8.5a1.25 1.25 0 010 2.5h-8.5zM27 7.25c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v12.5a1.25 1.25 0 11-2.5 0v-9.48L29.13 20.63a1.25 1.25 0 01-1.76-1.76L37.73 8.5h-9.48c-.69 0-1.25-.56-1.25-1.25z",
    fill: primaryFill
  }));
};

export const Open48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Open48RegularIcon, 'Open48Regular');

const OpenFolder16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 5.25C2 3.45 3.46 2 5.25 2h5.5C12.55 2 14 3.46 14 5.25v2a.75.75 0 01-1.5 0v-2c0-.97-.78-1.75-1.75-1.75h-5.5c-.97 0-1.75.78-1.75 1.75v5.5c0 .97.78 1.75 1.75 1.75h3a.75.75 0 010 1.5h-3A3.25 3.25 0 012 10.75v-5.5zm4 1.5c0-.41.34-.75.75-.75h3.5a.75.75 0 010 1.5H8.56l4.22 4.22a.75.75 0 11-1.06 1.06L7.5 8.56v1.69a.75.75 0 01-1.5 0v-3.5z",
    fill: primaryFill
  }));
};

export const OpenFolder16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpenFolder16FilledIcon, 'OpenFolder16Filled');

const OpenFolder16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 5a3 3 0 013-3h6a3 3 0 013 3v2.5a.5.5 0 01-1 0V5a2 2 0 00-2-2H5a2 2 0 00-2 2v6c0 1.1.9 2 2 2h3.5a.5.5 0 010 1H5a3 3 0 01-3-3V5zm4.5 1a.5.5 0 00-.5.5v4a.5.5 0 001 0V7.7l5.15 5.15a.5.5 0 00.7-.7L7.71 7h2.79a.5.5 0 000-1h-4z",
    fill: primaryFill
  }));
};

export const OpenFolder16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpenFolder16RegularIcon, 'OpenFolder16Regular');

const OpenFolder20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6.25C3 4.45 4.46 3 6.25 3H14c1.8 0 3.25 1.46 3.25 3.25v2a.75.75 0 01-1.5 0v-2c0-.97-.78-1.75-1.75-1.75H6.25c-.97 0-1.75.78-1.75 1.75v7.5c0 .97.78 1.75 1.75 1.75h4a.75.75 0 010 1.5h-4A3.25 3.25 0 013 13.75v-7.5zm5 2.5c0-.41.34-.75.75-.75h4.5a.75.75 0 010 1.5h-2.69l5.22 5.22a.75.75 0 11-1.06 1.06L9.5 10.56v2.69a.75.75 0 01-1.5 0v-4.5z",
    fill: primaryFill
  }));
};

export const OpenFolder20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpenFolder20FilledIcon, 'OpenFolder20Filled');

const OpenFolder20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v8a3 3 0 003 3h4.5a.5.5 0 000-1H6a2 2 0 01-2-2V6c0-1.1.9-2 2-2h8a2 2 0 012 2v2.5a.5.5 0 001 0V6a3 3 0 00-3-3H6zm2.15 5.15A.5.5 0 018.5 8h4.99a.5.5 0 010 1H9.7l6.15 6.15a.5.5 0 01-.7.7L9 9.71v3.79a.5.5 0 11-1 0v-5a.5.5 0 01.15-.35z",
    fill: primaryFill
  }));
};

export const OpenFolder20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpenFolder20RegularIcon, 'OpenFolder20Regular');

const OpenFolder24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.75 3h10.5c2 0 3.64 1.57 3.75 3.55v4.7a.75.75 0 01-1.49.1v-4.6c0-1.19-.93-2.16-2.1-2.24h-.16L6.75 4.5c-1.18 0-2.15.9-2.25 2.06v10.69c0 1.2.93 2.17 2.1 2.25h4.65a.75.75 0 01.1 1.5h-4.6c-2 0-3.64-1.57-3.75-3.55V6.55A3.75 3.75 0 016.55 3l.2-.01zm3.2 6H16a1 1 0 01.11 2h-3.69l6.54 6.54a1 1 0 01.08 1.32l-.08.1a1 1 0 01-1.32.08l-.1-.08L11 12.4v3.6a1 1 0 01-.88.99H10a1 1 0 01-1-.88v-6.2l.02-.1v-.05l.03-.07.03-.1.07-.12a1 1 0 01.14-.19l.11-.1.12-.07.1-.05.1-.03.1-.02.12-.02H16 9.94z",
    fill: primaryFill
  }));
};

export const OpenFolder24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpenFolder24FilledIcon, 'OpenFolder24Filled');

const OpenFolder24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.75 3h10.5c2 0 3.64 1.57 3.75 3.55v4.7a.75.75 0 01-1.49.1v-4.6c0-1.19-.93-2.16-2.1-2.24h-.16L6.75 4.5c-1.18 0-2.15.9-2.25 2.06v10.69c0 1.2.93 2.17 2.1 2.25h4.65a.75.75 0 01.1 1.5h-4.6c-2 0-3.64-1.57-3.75-3.55V6.55A3.75 3.75 0 016.55 3l.2-.01zm3 6h6.5a.75.75 0 01.1 1.5h-4.79l7.22 7.22c.27.27.3.68.08.98l-.08.08a.75.75 0 01-.97.07l-.09-.07-7.22-7.22v4.7c0 .37-.28.68-.65.73l-.1.01a.75.75 0 01-.74-.65l-.01-.1V9.73a.5.5 0 010-.07l.03-.11.03-.1a.72.72 0 01.16-.23l.04-.04.08-.06.06-.04.1-.04.07-.02.06-.01.1-.01h6.52-6.5z",
    fill: primaryFill
  }));
};

export const OpenFolder24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpenFolder24RegularIcon, 'OpenFolder24Regular');

const OpenFolder28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 7.75a5 5 0 015-5h12a5 5 0 015 5V13a1 1 0 11-2 0V7.75a3 3 0 00-3-3H8a3 3 0 00-3 3V20a3 3 0 003 3h5a1 1 0 110 2H8a5 5 0 01-5-5V7.75zM10 11a1 1 0 011-1h8a1 1 0 110 2h-5.53l8.24 8.3a1 1 0 01-1.42 1.4L12 13.36V19a1 1 0 11-2 0v-8z",
    fill: primaryFill
  }));
};

export const OpenFolder28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpenFolder28FilledIcon, 'OpenFolder28Filled');

const OpenFolder28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 7.75A4.75 4.75 0 017.75 3h12.5A4.75 4.75 0 0125 7.75v5.5a.75.75 0 01-1.5 0v-5.5c0-1.8-1.46-3.25-3.25-3.25H7.75A3.25 3.25 0 004.5 7.75v12.5c0 1.8 1.46 3.25 3.25 3.25h5.5a.75.75 0 010 1.5h-5.5A4.75 4.75 0 013 20.25V7.75zm7.5 3.5c0-.41.34-.75.75-.75h7.5a.75.75 0 010 1.5h-5.63l8.66 8.72a.75.75 0 11-1.06 1.06L12 13v5.75a.75.75 0 01-1.5 0v-7.5z",
    fill: primaryFill
  }));
};

export const OpenFolder28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpenFolder28RegularIcon, 'OpenFolder28Regular');

const OpenFolder48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M34.63 6.13a7.5 7.5 0 017.5 7.5v9a1.5 1.5 0 01-3 0v-9a4.5 4.5 0 00-4.5-4.5H13.36a4.5 4.5 0 00-4.5 4.5v21a4.5 4.5 0 004.5 4.5h9.26a1.5 1.5 0 010 3h-9.25a7.5 7.5 0 01-7.5-7.5v-21a7.5 7.5 0 017.5-7.5h21.24zM18 19.5c0-.83.67-1.5 1.5-1.5h13a1.5 1.5 0 010 3h-9.38l14.44 14.44a1.5 1.5 0 01-2.12 2.12L21 23.12v9.38a1.5 1.5 0 01-3 0v-13z",
    fill: primaryFill
  }));
};

export const OpenFolder48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpenFolder48FilledIcon, 'OpenFolder48Filled');

const OpenFolder48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M40.75 24c.69 0 1.25-.56 1.25-1.25v-9.5c0-4-3.25-7.25-7.25-7.25h-21.5C9.25 6 6 9.25 6 13.25v21.5c0 4 3.25 7.25 7.25 7.25h9.5a1.25 1.25 0 100-2.5h-9.5a4.75 4.75 0 01-4.75-4.75v-21.5a4.75 4.75 0 014.75-4.75h21.5a4.75 4.75 0 014.75 4.75v9.5c0 .69.56 1.25 1.25 1.25zm-21.5-6c-.69 0-1.25.56-1.25 1.25v13.5a1.25 1.25 0 102.5 0V22.27l15.37 15.36a1.25 1.25 0 101.76-1.76L22.27 20.5h10.48a1.25 1.25 0 100-2.5h-13.5z",
    fill: primaryFill
  }));
};

export const OpenFolder48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpenFolder48RegularIcon, 'OpenFolder48Regular');

const OpenOff16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.8 13.52c-.43.3-.97.48-1.55.48h-6.5A2.75 2.75 0 012 11.25v-6.5c0-.58.18-1.12.48-1.56L1.15 1.85a.5.5 0 11.7-.7l13 13a.5.5 0 01-.7.7l-1.34-1.33zm-1.1-1.1L3.6 4.28c-.06.14-.09.3-.09.46v6.5c0 .69.56 1.25 1.25 1.25h6.5c.16 0 .32-.03.46-.09zM8.54 6.4l1.06 1.06 2.91-2.9v2.68a.75.75 0 101.5 0v-4.5a.75.75 0 00-.75-.75h-4.5a.75.75 0 100 1.5h2.69L8.53 6.4zm5.41 5.41l-1.44-1.44v-.63a.75.75 0 011.5 0v1.5c0 .2-.02.39-.06.57zM4.18 2.06L5.62 3.5h.63a.75.75 0 000-1.5h-1.5c-.2 0-.39.02-.57.06z",
    fill: primaryFill
  }));
};

export const OpenOff16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpenOff16FilledIcon, 'OpenOff16Filled');

const OpenOff16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.88 13.59l1.27 1.26a.5.5 0 00.7-.7l-13-13a.5.5 0 10-.7.7L2.4 3.12C2.15 3.52 2 4 2 4.5v7A2.5 2.5 0 004.5 14h7c.5 0 .98-.15 1.38-.41zm-.73-.74c-.2.1-.42.15-.65.15h-7A1.5 1.5 0 013 11.5v-7c0-.23.05-.45.15-.65l9 9zm-3.37-6.2l.57.57a.5.5 0 00.27-.14L13 3.71v3.02a.5.5 0 001 0V2.5a.5.5 0 00-.5-.5H9.27a.5.5 0 000 1h3.02L8.92 6.38a.5.5 0 00-.14.27zm5.2 5.2l-.98-.97V9.27a.5.5 0 011 0v2.23c0 .12 0 .24-.02.35zM4.15 2.02l.97.98h1.61a.5.5 0 000-1H4.5c-.12 0-.24 0-.35.02z",
    fill: primaryFill
  }));
};

export const OpenOff16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpenOff16RegularIcon, 'OpenOff16Regular');

const OpenOff20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15l15 15a.5.5 0 01-.7.7l-1.48-1.48c-.54.4-1.2.63-1.92.63h-7.5A3.25 3.25 0 013 13.75v-7.5c0-.72.23-1.38.63-1.92L2.15 2.85a.5.5 0 11.7-.7zm11.73 13.14L4.71 5.42c-.13.25-.21.53-.21.83v7.5c0 .97.78 1.75 1.75 1.75h7.5c.3 0 .59-.08.83-.21zm-4.01-6.85l.99 1a.75.75 0 00.22-.16l3.72-3.72v3.19a.75.75 0 001.5 0v-5a.75.75 0 00-.75-.75h-5a.75.75 0 000 1.5h3.19l-3.72 3.72a.75.75 0 00-.15.22zm6.28 6.29l-1.35-1.35v-1.63a.75.75 0 011.5 0v2c0 .34-.05.67-.15.98zM5.27 3.15L6.62 4.5h1.63a.75.75 0 000-1.5h-2c-.34 0-.67.05-.98.15z",
    fill: primaryFill
  }));
};

export const OpenOff20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpenOff20FilledIcon, 'OpenOff20Filled');

const OpenOff20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.85 2.15l15 15a.5.5 0 01-.7.7l-1.41-1.4c-.5.34-1.1.55-1.74.55H6a3 3 0 01-3-3V6c0-.65.2-1.25.55-1.74l-1.4-1.4a.5.5 0 11.7-.71zm12.17 13.57L4.28 4.98A2 2 0 004 6v8c0 1.1.9 2 2 2h8a2 2 0 001.02-.28zm1.88-.94l-.9-.9V11.5a.5.5 0 011 0V14a3 3 0 01-.1.78zM5.22 3.1l.9.9H8.5a.5.5 0 000-1H6a3 3 0 00-.78.1zm5.78.4c0-.28.22-.5.5-.5h5c.28 0 .5.22.5.5v5a.5.5 0 01-1 0V4.7l-4.15 4.15a.5.5 0 01-.7-.7L15.29 4H11.5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }));
};

export const OpenOff20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpenOff20RegularIcon, 'OpenOff20Regular');

const OpenOff24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.28 2.22l18.5 18.5a.75.75 0 01-1.06 1.06l-1.08-1.08c-.55.35-1.2.55-1.89.55H6.25a3.5 3.5 0 01-3.5-3.5V6.25c0-.7.2-1.34.55-1.89L2.22 3.28a.75.75 0 111.06-1.06zM18.14 19.2L4.8 5.86a1.5 1.5 0 00-.05.39v11.5c0 .83.67 1.5 1.5 1.5h11.5c.13 0 .26-.02.39-.05zM12.9 9.72l1.38 1.38a1 1 0 00.18-.14l4.79-4.8v4.09a1 1 0 002 0v-6.5a1 1 0 00-1-1h-6.5a1 1 0 000 2h4.09l-4.8 4.8a1 1 0 00-.14.17zm8.34 8.33l-1.99-1.98v-2.32a1 1 0 112 0v4l-.01.3zM5.94 2.76l2 1.99h2.31a1 1 0 100-2h-4l-.3.01z",
    fill: primaryFill
  }));
};

export const OpenOff24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpenOff24FilledIcon, 'OpenOff24Filled');

const OpenOff24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.28 2.22l18.5 18.5a.75.75 0 01-1.06 1.06l-1.26-1.26c-.5.3-1.08.48-1.71.48H6.25A3.25 3.25 0 013 17.75V6.25c0-.63.18-1.21.48-1.7L2.22 3.27a.75.75 0 111.06-1.06zM18.34 19.4L4.6 5.66c-.06.19-.1.38-.1.59v11.5c0 .97.78 1.75 1.75 1.75h11.5c.2 0 .4-.04.59-.1zm-5.26-9.5l1.02 1.02a.75.75 0 00.18-.14l5.22-5.22v4.69a.75.75 0 001.5 0v-6.5a.75.75 0 00-.75-.75h-6.5a.75.75 0 000 1.5h4.69l-5.22 5.22a.75.75 0 00-.14.18zM21 17.82l-1.5-1.5v-2.57a.75.75 0 011.5 0v4.07zM6.18 3l1.5 1.5h2.57a.75.75 0 000-1.5H6.18z",
    fill: primaryFill
  }));
};

export const OpenOff24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpenOff24RegularIcon, 'OpenOff24Regular');

const OpenOff28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.28 2.22l22.5 22.5a.75.75 0 01-1.06 1.06l-1.47-1.47c-.64.44-1.42.69-2.25.69H7a4 4 0 01-4-4V7c0-.83.25-1.6.7-2.25L2.21 3.28a.75.75 0 111.06-1.06zm18.5 20.62L5.16 6.22A2 2 0 005 7v14c0 1.1.9 2 2 2h14a2 2 0 00.78-.16zM6.25 3.07L8.18 5h3.32a1 1 0 100-2H7c-.26 0-.5.02-.75.07zm18.68 18.68L23 19.82V16.5a1 1 0 112 0V21c0 .26-.02.5-.07.75zM15.5 4a1 1 0 011-1H24a1 1 0 011 1v7.5a1 1 0 11-2 0V6.41l-5.8 5.8a1 1 0 11-1.4-1.42L21.58 5H16.5a1 1 0 01-1-1z",
    fill: primaryFill
  }));
};

export const OpenOff28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpenOff28FilledIcon, 'OpenOff28Filled');

const OpenOff28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.28 2.22l22.5 22.5a.75.75 0 01-1.06 1.06l-1.54-1.54c-.7.48-1.53.76-2.43.76H7.25A4.25 4.25 0 013 20.75V7.25c0-.9.28-1.74.76-2.43L2.22 3.28a.75.75 0 111.06-1.06zm18.81 20.93L4.85 5.91c-.22.4-.35.85-.35 1.34v13.5a2.75 2.75 0 002.75 2.75h13.5c.49 0 .94-.13 1.34-.35zM6.3 3.11L7.7 4.5h4.06a.75.75 0 000-1.5h-4.5c-.33 0-.65.04-.96.1zm18.6 18.6l-1.39-1.4v-4.06a.75.75 0 011.5 0v4.5c0 .33-.04.65-.1.96zM15.5 3.75c0-.41.34-.75.75-.75h8c.41 0 .75.34.75.75v8a.75.75 0 01-1.5 0V5.56l-6.22 6.22a.75.75 0 11-1.06-1.06l6.22-6.22h-6.19a.75.75 0 01-.75-.75z",
    fill: primaryFill
  }));
};

export const OpenOff28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpenOff28RegularIcon, 'OpenOff28Regular');

const OpenOff48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M39.13 40.9A6.47 6.47 0 0135.5 42h-23A6.5 6.5 0 016 35.5v-23c0-1.34.4-2.6 1.1-3.63L4.38 6.13a1.25 1.25 0 111.76-1.76l37.5 37.5a1.25 1.25 0 01-1.76 1.76l-2.74-2.74zm-2.2-2.2L9.3 11.07c-.2.44-.3.92-.3 1.43v23a3.5 3.5 0 003.5 3.5h23c.5 0 1-.1 1.43-.3zm4.98-2.1L39 33.7v-6.2a1.5 1.5 0 113 0v8c0 .38-.03.74-.1 1.1zM11.4 6.1L14.3 9h6.2a1.5 1.5 0 000-3h-8c-.38 0-.74.03-1.1.1zm30.05.24c.34.27.55.7.55 1.16v12a1.5 1.5 0 01-3 0v-8.38l-9.44 9.44a1.5 1.5 0 11-2.12-2.12L36.88 9H28.5a1.5 1.5 0 010-3h11.98a1.5 1.5 0 01.97.34z",
    fill: primaryFill
  }));
};

export const OpenOff48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpenOff48FilledIcon, 'OpenOff48Filled');

const OpenOff48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M39.2 40.96A6.22 6.22 0 0135.75 42h-23.5A6.25 6.25 0 016 35.75v-23.5c0-1.27.38-2.46 1.04-3.45L4.37 6.13a1.25 1.25 0 111.76-1.76l37.5 37.5a1.25 1.25 0 01-1.76 1.76l-2.67-2.67zm-1.83-1.83l-28.5-28.5a3.74 3.74 0 00-.37 1.62v23.5a3.75 3.75 0 003.75 3.75h23.5c.58 0 1.13-.13 1.62-.37zm4.57-2.5L39.5 34.2v-6.95a1.25 1.25 0 012.5 0v8.5c0 .3-.02.6-.06.88zM11.37 6.06L13.8 8.5h6.95a1.25 1.25 0 000-2.5h-8.5c-.3 0-.6.02-.88.06zM27 7.25c0-.69.56-1.25 1.25-1.25h12.5c.69 0 1.25.56 1.25 1.25v12.5a1.25 1.25 0 11-2.5 0v-9.48L29.13 20.63a1.25 1.25 0 01-1.76-1.76L37.73 8.5h-9.48c-.69 0-1.25-.56-1.25-1.25z",
    fill: primaryFill
  }));
};

export const OpenOff48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/OpenOff48RegularIcon, 'OpenOff48Regular');

const Options16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 9a2 2 0 011.94 1.5h5.56a.5.5 0 01.09 1H7.94a2 2 0 01-3.88 0H2.5a.5.5 0 01-.09-1H4.06A2 2 0 016 9zm4-6a2 2 0 011.94 1.5h1.56a.5.5 0 01.09 1H11.94a2 2 0 01-3.88 0H2.5a.5.5 0 01-.09-1H8.06A2 2 0 0110 3z",
    fill: primaryFill
  }));
};

export const Options16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Options16FilledIcon, 'Options16Filled');

const Options16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 9a2 2 0 011.94 1.5h5.56a.5.5 0 01.09 1H7.94a2 2 0 01-3.88 0H2.5a.5.5 0 01-.09-1H4.06A2 2 0 016 9zm0 1a1 1 0 100 2 1 1 0 000-2zm4-7a2 2 0 011.94 1.5h1.56a.5.5 0 01.09 1H11.94a2 2 0 01-3.88 0H2.5a.5.5 0 01-.09-1H8.06A2 2 0 0110 3zm0 1a1 1 0 100 2 1 1 0 000-2z",
    fill: primaryFill
  }));
};

export const Options16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Options16RegularIcon, 'Options16Regular');

const Options20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M17.25 5h-2.36a2.5 2.5 0 00-4.78 0H2.75a.75.75 0 000 1.5h7.36a2.5 2.5 0 004.78 0h2.36a.75.75 0 000-1.5zm-14.5 8.5a.75.75 0 000 1.5h2.36a2.5 2.5 0 004.78 0h7.36a.75.75 0 000-1.5H9.89a2.5 2.5 0 00-4.78 0H2.75z",
    fill: primaryFill
  }));
};

export const Options20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Options20FilledIcon, 'Options20Filled');

const Options20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.95 5a2.5 2.5 0 00-4.9 0H2.5a.5.5 0 000 1h7.55a2.5 2.5 0 004.9 0h2.55a.5.5 0 000-1h-2.55zM12.5 7a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm-2.55 7a2.5 2.5 0 00-4.9 0H2.5a.5.5 0 000 1h2.55a2.5 2.5 0 004.9 0h7.55a.5.5 0 000-1H9.95zM7.5 16a1.5 1.5 0 110-3 1.5 1.5 0 010 3z",
    fill: primaryFill
  }));
};

export const Options20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Options20RegularIcon, 'Options20Regular');

const Options24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.75 13.5a3.25 3.25 0 013.16 2.5h9.34a.75.75 0 01.1 1.5h-9.44a3.25 3.25 0 01-6.32 0H2.75a.75.75 0 01-.1-1.5h2.94a3.25 3.25 0 013.16-2.5zm6.5-9.5a3.25 3.25 0 013.16 2.5h2.84a.75.75 0 01.1 1.5h-2.94a3.25 3.25 0 01-6.32 0H2.75a.75.75 0 01-.1-1.5h9.44A3.25 3.25 0 0115.25 4z",
    fill: primaryFill
  }));
};

export const Options24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Options24FilledIcon, 'Options24Filled');

const Options24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8.75 13.5a3.25 3.25 0 013.16 2.5h9.34a.75.75 0 01.1 1.5h-9.44a3.25 3.25 0 01-6.32 0H2.75a.75.75 0 01-.1-1.5h2.94a3.25 3.25 0 013.16-2.5zm0 1.5c-.76 0-1.41.49-1.65 1.17l-.02.07-.04.14a1.76 1.76 0 00.02.82l.04.13.02.07a1.75 1.75 0 003.28-.07l.04-.13-.01.06a1.75 1.75 0 00.04-.82l-.03-.13-.02-.07-.04-.14A1.75 1.75 0 008.75 15zm6.5-11a3.25 3.25 0 013.16 2.5h2.84a.75.75 0 01.1 1.5h-2.94a3.25 3.25 0 01-6.32 0H2.75a.75.75 0 01-.1-1.5h9.44A3.25 3.25 0 0115.25 4zm0 1.5c-.76 0-1.41.49-1.65 1.17l-.02.07-.04.14a1.76 1.76 0 00.02.82l.04.13.02.07a1.75 1.75 0 003.28-.07l.04-.13-.01.06a1.75 1.75 0 00.04-.82l-.03-.13-.02-.07-.04-.14a1.75 1.75 0 00-1.63-1.1z",
    fill: primaryFill
  }));
};

export const Options24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Options24RegularIcon, 'Options24Regular');

const Options48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.25 15.5h19.88a6.25 6.25 0 0012.25 0h5.37a1.25 1.25 0 100-2.5h-5.38a6.25 6.25 0 00-12.24 0H5.25a1.25 1.25 0 100 2.5zm0 19h5.63a6.25 6.25 0 0012.24 0h19.63a1.25 1.25 0 100-2.5H23.12a6.25 6.25 0 00-12.25 0H5.25a1.25 1.25 0 100 2.5z",
    fill: primaryFill
  }));
};

export const Options48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Options48FilledIcon, 'Options48Filled');

const Options48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.25 15.5h19.88a6.25 6.25 0 0012.25 0h5.37a1.25 1.25 0 100-2.5h-5.38a6.25 6.25 0 00-12.24 0H5.25a1.25 1.25 0 100 2.5zm26-5a3.75 3.75 0 110 7.5 3.75 3.75 0 010-7.5zm-26 24h5.63a6.25 6.25 0 0012.24 0h19.63a1.25 1.25 0 100-2.5H23.12a6.25 6.25 0 00-12.25 0H5.25a1.25 1.25 0 100 2.5zm11.75-5a3.75 3.75 0 110 7.5 3.75 3.75 0 010-7.5z",
    fill: primaryFill
  }));
};

export const Options48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Options48RegularIcon, 'Options48Regular');

const Organization12FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 4.94a2 2 0 111 0V6h2a1 1 0 011 1v1.06a2 2 0 11-1 0V7h-5v1.06a2 2 0 11-1 0V7a1 1 0 011-1h2V4.94z",
    fill: primaryFill
  }));
};

export const Organization12Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Organization12FilledIcon, 'Organization12Filled');

const Organization12RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 4.94a2 2 0 111 0V6h2a1 1 0 011 1v1.06a2 2 0 11-1 0V7h-5v1.06a2 2 0 11-1 0V7a1 1 0 011-1h2V4.94zM6 4a1 1 0 100-2 1 1 0 000 2zm-3 7a1 1 0 100-2 1 1 0 000 2zm5-1a1 1 0 102 0 1 1 0 00-2 0z",
    fill: primaryFill
  }));
};

export const Organization12Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Organization12RegularIcon, 'Organization12Regular');

const Organization16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 3.5a2.5 2.5 0 113 2.45V7h2.13C11.4 7 12 7.61 12 8.37v1.68a2.5 2.5 0 11-1 0V8.37c0-.2-.16-.37-.37-.37H5.37c-.2 0-.37.16-.37.37v1.68a2.5 2.5 0 11-1 0V8.37C4 7.6 4.61 7 5.37 7H7.5V5.95a2.5 2.5 0 01-2-2.45z",
    fill: primaryFill
  }));
};

export const Organization16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Organization16FilledIcon, 'Organization16Filled');

const Organization16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 1a2.5 2.5 0 00-.5 4.95V7H5.37C4.6 7 4 7.61 4 8.37v1.68a2.5 2.5 0 101 0V8.37c0-.2.16-.37.37-.37h5.26c.2 0 .37.16.37.37v1.68a2.5 2.5 0 101 0V8.37C12 7.6 11.39 7 10.63 7H8.5V5.95A2.5 2.5 0 008 1zM6.5 3.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm-3.5 9a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm8.5-1.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3z",
    fill: primaryFill
  }));
};

export const Organization16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Organization16RegularIcon, 'Organization16Regular');

const Organization20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M7 5a3 3 0 113.5 2.96V9.5h3c.83 0 1.5.67 1.5 1.5v1.04a3 3 0 11-1 0V11a.5.5 0 00-.5-.5h-7a.5.5 0 00-.5.5v1.04a3 3 0 11-1 0V11c0-.83.67-1.5 1.5-1.5h3V7.96A3 3 0 017 5z",
    fill: primaryFill
  }));
};

export const Organization20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Organization20FilledIcon, 'Organization20Filled');

const Organization20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 2a3 3 0 00-.5 5.96V9.5h-3c-.83 0-1.5.67-1.5 1.5v1.04a3 3 0 101 0V11c0-.28.22-.5.5-.5h7c.28 0 .5.22.5.5v1.04a3 3 0 101 0V11c0-.83-.67-1.5-1.5-1.5h-3V7.96A3 3 0 0010 2zM8 5a2 2 0 114 0 2 2 0 01-4 0zM3.5 15a2 2 0 114 0 2 2 0 01-4 0zm11-2a2 2 0 110 4 2 2 0 010-4z",
    fill: primaryFill
  }));
};

export const Organization20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Organization20RegularIcon, 'Organization20Regular');

const Organization24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 5.75a3.75 3.75 0 114.5 3.68v2.07h3.25c1.24 0 2.25 1 2.25 2.25v.82a3.75 3.75 0 11-1.5 0v-.82a.75.75 0 00-.75-.75h-8a.75.75 0 00-.75.75v.82a3.75 3.75 0 11-1.5 0v-.82c0-1.24 1-2.25 2.25-2.25H11V9.43a3.75 3.75 0 01-3-3.68z",
    fill: primaryFill
  }));
};

export const Organization24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Organization24FilledIcon, 'Organization24Filled');

const Organization24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11.75 2A3.75 3.75 0 0011 9.43v2.07H7.75c-1.24 0-2.25 1-2.25 2.25v.83a3.75 3.75 0 101.5 0v-.83c0-.41.34-.75.75-.75h8c.41 0 .75.34.75.75v.83a3.75 3.75 0 101.5 0v-.83c0-1.24-1-2.25-2.25-2.25H12.5V9.43A3.75 3.75 0 0011.75 2zM9.5 5.75a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zM4 18.25a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zM17.25 16a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5z",
    fill: primaryFill
  }));
};

export const Organization24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Organization24RegularIcon, 'Organization24Regular');

const Organization28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9.75 6.25a4.25 4.25 0 115 4.18v3.07h4.5c1.24 0 2.25 1 2.25 2.25v1.82a4.25 4.25 0 11-1.5 0v-1.82a.75.75 0 00-.75-.75H8.75a.75.75 0 00-.75.75v1.82a4.25 4.25 0 11-1.5 0v-1.82c0-1.24 1-2.25 2.25-2.25h4.5v-3.07a4.25 4.25 0 01-3.5-4.18z",
    fill: primaryFill
  }));
};

export const Organization28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Organization28FilledIcon, 'Organization28Filled');

const Organization28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14 2a4.25 4.25 0 00-.75 8.43v3.07h-4.5c-1.24 0-2.25 1-2.25 2.25v1.82a4.25 4.25 0 101.5 0v-1.82c0-.41.34-.75.75-.75h10.5c.41 0 .75.34.75.75v1.82a4.25 4.25 0 101.5 0v-1.82c0-1.24-1-2.25-2.25-2.25h-4.5v-3.07A4.25 4.25 0 0014 2zm-2.75 4.25a2.75 2.75 0 115.5 0 2.75 2.75 0 01-5.5 0zM4.5 21.75a2.75 2.75 0 115.5 0 2.75 2.75 0 01-5.5 0zM20.75 19a2.75 2.75 0 110 5.5 2.75 2.75 0 010-5.5z",
    fill: primaryFill
  }));
};

export const Organization28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Organization28RegularIcon, 'Organization28Regular');

const Organization32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M11 7a5 5 0 116 4.9V15h5.27c1.5 0 2.73 1.22 2.73 2.73v2.37a5 5 0 11-2 0v-2.37c0-.4-.33-.73-.73-.73H9.73c-.4 0-.73.33-.73.73v2.37a5 5 0 11-2 0v-2.37C7 16.23 8.22 15 9.73 15H15v-3.1A5 5 0 0111 7z",
    fill: primaryFill
  }));
};

export const Organization32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Organization32FilledIcon, 'Organization32Filled');

const Organization32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16 2a5 5 0 00-1 9.9V15H9.73A2.73 2.73 0 007 17.73v2.37a5 5 0 102 0v-2.37c0-.4.33-.73.73-.73h12.54c.4 0 .73.33.73.73v2.37a5 5 0 102 0v-2.37c0-1.5-1.22-2.73-2.73-2.73H17v-3.1A5 5 0 0016 2zm-3 5a3 3 0 116 0 3 3 0 01-6 0zM5 25a3 3 0 116 0 3 3 0 01-6 0zm19-3a3 3 0 110 6 3 3 0 010-6z",
    fill: primaryFill
  }));
};

export const Organization32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Organization32RegularIcon, 'Organization32Regular');

const Organization48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M16.5 11.5a7.5 7.5 0 118.75 7.4V23h7.5a3.75 3.75 0 013.75 3.75v2.35a7.5 7.5 0 11-2.5 0v-2.35c0-.7-.56-1.25-1.25-1.25h-17.5c-.7 0-1.25.56-1.25 1.25v2.35a7.5 7.5 0 11-2.5 0v-2.35A3.75 3.75 0 0115.25 23h7.5v-4.1a7.5 7.5 0 01-6.25-7.4z",
    fill: primaryFill
  }));
};

export const Organization48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Organization48FilledIcon, 'Organization48Filled');

const Organization48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M24 4a7.5 7.5 0 00-1.25 14.9V23h-7.5a3.75 3.75 0 00-3.75 3.75v2.35a7.5 7.5 0 102.5 0v-2.35c0-.7.56-1.25 1.25-1.25h17.5c.69 0 1.25.56 1.25 1.25v2.35a7.5 7.5 0 102.5 0v-2.35A3.75 3.75 0 0032.75 23h-7.5v-4.1A7.5 7.5 0 0024 4zm-5 7.5a5 5 0 1110 0 5 5 0 01-10 0zm-11.25 25a5 5 0 1110 0 5 5 0 01-10 0zm27.5-5a5 5 0 110 10 5 5 0 010-10z",
    fill: primaryFill
  }));
};

export const Organization48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Organization48RegularIcon, 'Organization48Regular');

const OrganizationHorizontal20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5 13a3 3 0 112.96-3.5H9.5v-3c0-.83.67-1.5 1.5-1.5h1.04a3 3 0 110 1H11a.5.5 0 00-.5.5v7c0 .28.22.5.5.5h1.04a3 3 0 110 1H11a1.5 1.5 0 01-1.5-1.5v-3H7.96A3 3 0 015 13z",
    fill: primaryFill
  }));
};

export const OrganizationHorizontal20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/OrganizationHorizontal20FilledIcon, 'OrganizationHorizontal20Filled');

const OrganizationHorizontal20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 10a3 3 0 005.96.5H9.5v3c0 .83.67 1.5 1.5 1.5h1.04a3 3 0 100-1H11a.5.5 0 01-.5-.5v-7c0-.28.22-.5.5-.5h1.04a3 3 0 100-1H11c-.83 0-1.5.67-1.5 1.5v3H7.96A3 3 0 002 10zm3 2a2 2 0 110-4 2 2 0 010 4zm10 4.5a2 2 0 110-4 2 2 0 010 4zm-2-11a2 2 0 114 0 2 2 0 01-4 0z",
    fill: primaryFill
  }));
};

export const OrganizationHorizontal20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/OrganizationHorizontal20RegularIcon, 'OrganizationHorizontal20Regular');

const Orientation20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.25 5a.25.25 0 00-.25.25v.25a.5.5 0 01-1 0v-.25C2 4.56 2.56 4 3.25 4h.25a.5.5 0 010 1h-.25z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M5 4.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M8 4.5c0-.28.22-.5.5-.5h.25C9.44 4 10 4.56 10 5.25v.25a.5.5 0 01-1 0v-.25A.25.25 0 008.75 5H8.5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M14.85 5.85l-.15.16a3.5 3.5 0 01-.2 6.99.5.5 0 010-1 2.5 2.5 0 00.22-5l.13.15a.5.5 0 01-.7.7l-1-1a.5.5 0 010-.7l1-1a.5.5 0 01.7.7z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M3.5 9C2.67 9 2 9.67 2 10.5v4c0 .83.67 1.5 1.5 1.5h8c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-2a.5.5 0 00.5-.5v-1a.5.5 0 00-1 0v1c0 .28.22.5.5.5h-6z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M3 7.5a.5.5 0 00-1 0v1a.5.5 0 001 0v-1z",
    fill: primaryFill
  }));
};

export const Orientation20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Orientation20FilledIcon, 'Orientation20Filled');

const Orientation20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.25 5a.25.25 0 00-.25.25v.25a.5.5 0 01-1 0v-.25C2 4.56 2.56 4 3.25 4h.25a.5.5 0 010 1h-.25z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M5 4.5c0-.28.22-.5.5-.5h1a.5.5 0 010 1h-1a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M8 4.5c0-.28.22-.5.5-.5h.25C9.44 4 10 4.56 10 5.25v.25a.5.5 0 01-1 0v-.25A.25.25 0 008.75 5H8.5a.5.5 0 01-.5-.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M14.85 5.85l-.15.16a3.5 3.5 0 01-.2 6.99.5.5 0 010-1 2.5 2.5 0 00.22-5l.13.15a.5.5 0 01-.7.7l-1-1a.5.5 0 010-.7l1-1a.5.5 0 01.7.7z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M2 10.5C2 9.67 2.67 9 3.5 9h8c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-8A1.5 1.5 0 012 14.5v-4zm1.5-.5a.5.5 0 00-.5.5v4c0 .28.22.5.5.5h8a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5h-8z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M9.5 9a.5.5 0 01-.5-.5v-1a.5.5 0 011 0v1a.5.5 0 01-.5.5z",
    fill: primaryFill
  }), React.createElement("path", {
    d: "M3 7.5a.5.5 0 00-1 0v1a.5.5 0 001 0v-1z",
    fill: primaryFill
  }));
};

export const Orientation20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Orientation20RegularIcon, 'Orientation20Regular');

const Orientation24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.75 4a.75.75 0 000 1.5h1.5a.75.75 0 000-1.5h-1.5zM3.5 8.75a.75.75 0 00-1.5 0v1.5a.75.75 0 001.5 0v-1.5zM2 12.9c0-1.05.85-1.9 1.9-1.9h10.2c1.05 0 1.9.85 1.9 1.9v5.2a1.9 1.9 0 01-1.9 1.9H3.9A1.9 1.9 0 012 18.1v-5.2zM12.25 11a.75.75 0 01-.75-.75v-1.5a.75.75 0 011.5 0v1.5c0 .41-.34.75-.75.75zm-8.5-5.5a.25.25 0 00-.25.25v.5a.75.75 0 01-1.5 0v-.5C2 4.78 2.78 4 3.75 4h.5a.75.75 0 010 1.5h-.5zm7.75.25a.25.25 0 00-.25-.25h-.5a.75.75 0 010-1.5h.5c.97 0 1.75.78 1.75 1.75v.5a.75.75 0 01-1.5 0v-.5zM17 16.08c0 .48.42.87.89.74A5.5 5.5 0 0017.5 6.1l.3-.35a.75.75 0 10-1.13-.98l-1.5 1.75a.75.75 0 000 .98l1.5 1.75a.75.75 0 101.14-.98l-.6-.7a4 4 0 01.37 7.79c-.33.1-.59.38-.59.73z",
    fill: primaryFill
  }));
};

export const Orientation24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Orientation24FilledIcon, 'Orientation24Filled');

const Orientation24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6.75 4a.75.75 0 000 1.5h1.5a.75.75 0 000-1.5h-1.5zM3.5 8.75a.75.75 0 00-1.5 0v1.5a.75.75 0 001.5 0v-1.5zM3.9 11A1.9 1.9 0 002 12.9v5.2c0 1.05.85 1.9 1.9 1.9h10.2a1.9 1.9 0 001.9-1.9v-5.2a1.9 1.9 0 00-1.9-1.9h-1.85c.41 0 .75-.34.75-.75v-1.5a.75.75 0 00-1.5 0v1.5c0 .41.34.75.75.75H3.9zm-.4 1.9c0-.22.18-.4.4-.4h10.2c.22 0 .4.18.4.4v5.2a.4.4 0 01-.4.4H3.9a.4.4 0 01-.4-.4v-5.2zm.25-7.4a.25.25 0 00-.25.25v.5a.75.75 0 01-1.5 0v-.5C2 4.78 2.78 4 3.75 4h.5a.75.75 0 010 1.5h-.5zm7.75.25a.25.25 0 00-.25-.25h-.5a.75.75 0 010-1.5h.5c.97 0 1.75.78 1.75 1.75v.5a.75.75 0 01-1.5 0v-.5zM17 16.08c0 .48.42.87.89.74A5.5 5.5 0 0017.5 6.1l.3-.35a.75.75 0 10-1.13-.98l-1.5 1.75a.75.75 0 000 .98l1.5 1.75a.75.75 0 101.14-.98l-.6-.7a4 4 0 01.37 7.79c-.33.1-.59.38-.59.73z",
    fill: primaryFill
  }));
};

export const Orientation24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Orientation24RegularIcon, 'Orientation24Regular');

const Oval16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1 8a5 5 0 015-5h4a5 5 0 010 10H6a5 5 0 01-5-5z",
    fill: primaryFill
  }));
};

export const Oval16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Oval16FilledIcon, 'Oval16Filled');

const Oval16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1 8a5 5 0 015-5h4a5 5 0 010 10H6a5 5 0 01-5-5zm5-4a4 4 0 100 8h4a4 4 0 000-8H6z",
    fill: primaryFill
  }));
};

export const Oval16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Oval16RegularIcon, 'Oval16Regular');

const Oval20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 10a6 6 0 016-6h4a6 6 0 010 12H8a6 6 0 01-6-6z",
    fill: primaryFill
  }));
};

export const Oval20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Oval20FilledIcon, 'Oval20Filled');

const Oval20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 10a6 6 0 016-6h4a6 6 0 010 12H8a6 6 0 01-6-6zm6-5a5 5 0 000 10h4a5 5 0 000-10H8z",
    fill: primaryFill
  }));
};

export const Oval20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Oval20RegularIcon, 'Oval20Regular');

const Oval24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 12a8 8 0 018-8h4a8 8 0 110 16h-4a8 8 0 01-8-8z",
    fill: primaryFill
  }));
};

export const Oval24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Oval24FilledIcon, 'Oval24Filled');

const Oval24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 12a8 8 0 018-8h4a8 8 0 110 16h-4a8 8 0 01-8-8zm8-6.5a6.5 6.5 0 000 13h4a6.5 6.5 0 100-13h-4z",
    fill: primaryFill
  }));
};

export const Oval24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Oval24RegularIcon, 'Oval24Regular');

const Oval28FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 14a9 9 0 019-9h6a9 9 0 110 18h-6a9 9 0 01-9-9z",
    fill: primaryFill
  }));
};

export const Oval28Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Oval28FilledIcon, 'Oval28Filled');

const Oval28RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 14a9 9 0 019-9h6a9 9 0 110 18h-6a9 9 0 01-9-9zm9-7.5a7.5 7.5 0 100 15h6a7.5 7.5 0 000-15h-6z",
    fill: primaryFill
  }));
};

export const Oval28Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Oval28RegularIcon, 'Oval28Regular');

const Oval32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 6a10 10 0 000 20h8a10 10 0 000-20h-8z",
    fill: primaryFill
  }));
};

export const Oval32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Oval32FilledIcon, 'Oval32Filled');

const Oval32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 8a8 8 0 100 16h8a8 8 0 100-16h-8zM2 16A10 10 0 0112 6h8a10 10 0 010 20h-8A10 10 0 012 16z",
    fill: primaryFill
  }));
};

export const Oval32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Oval32RegularIcon, 'Oval32Regular');

const Oval48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 24A15 15 0 0119 9h10a15 15 0 110 30H19A15 15 0 014 24z",
    fill: primaryFill
  }));
};

export const Oval48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Oval48FilledIcon, 'Oval48Filled');

const Oval48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 24A15 15 0 0119 9h10a15 15 0 110 30H19A15 15 0 014 24zm15-12.5a12.5 12.5 0 100 25h10a12.5 12.5 0 100-25H19z",
    fill: primaryFill
  }));
};

export const Oval48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Oval48RegularIcon, 'Oval48Regular');

const Oven20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v1h14V6a3 3 0 00-3-3H6zm1.5 2.5a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm6.5 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm-4 .75a.75.75 0 110-1.5.75.75 0 010 1.5zM3 14V8h14v6a3 3 0 01-3 3H6a3 3 0 01-3-3zm3.5-4a.5.5 0 00-.5.5v3c0 .28.22.5.5.5h7a.5.5 0 00.5-.5v-3a.5.5 0 00-.5-.5h-7z",
    fill: primaryFill
  }));
};

export const Oven20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Oven20FilledIcon, 'Oven20Filled');

const Oven20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 3a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3V6a3 3 0 00-3-3H6zM4 14V8h12v6a2 2 0 01-2 2H6a2 2 0 01-2-2zm12-7H4V6c0-1.1.9-2 2-2h8a2 2 0 012 2v1zm-9.25-.75a.75.75 0 100-1.5.75.75 0 000 1.5zm6.5 0a.75.75 0 100-1.5.75.75 0 000 1.5zm-2.5-.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM6 9a1 1 0 00-1 1v4a1 1 0 001 1h8a1 1 0 001-1v-4a1 1 0 00-1-1H6zm0 5v-4h8v4H6z",
    fill: primaryFill
  }));
};

export const Oven20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Oven20RegularIcon, 'Oven20Regular');

const Oven24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6.25C3 4.45 4.46 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25V8.5H3V6.25zM8 7a1 1 0 100-2 1 1 0 000 2zm5-1a1 1 0 10-2 0 1 1 0 002 0zm4 0a1 1 0 10-2 0 1 1 0 002 0zM3 17.75V10h18v7.75c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 17.75zM7.25 12C6.56 12 6 12.56 6 13.25v3.5c0 .69.56 1.25 1.25 1.25h9.5c.69 0 1.25-.56 1.25-1.25v-3.5c0-.69-.56-1.25-1.25-1.25h-9.5z",
    fill: primaryFill
  }));
};

export const Oven24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Oven24FilledIcon, 'Oven24Filled');

const Oven24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6.25C3 4.45 4.46 3 6.25 3h11.5C19.55 3 21 4.46 21 6.25v11.5c0 1.8-1.46 3.25-3.25 3.25H6.25A3.25 3.25 0 013 17.75V6.25zm16.5 0c0-.97-.78-1.75-1.75-1.75H6.25c-.97 0-1.75.78-1.75 1.75V8h15V6.25zm0 11.5V9.5h-15v8.25c0 .97.78 1.75 1.75 1.75h11.5c.97 0 1.75-.78 1.75-1.75zM8 7.25a1 1 0 100-2 1 1 0 000 2zm5-1a1 1 0 11-2 0 1 1 0 012 0zm3 1a1 1 0 100-2 1 1 0 000 2zM7.5 16.5v-4h9v4h-9zM7.25 11C6.56 11 6 11.56 6 12.25v4.5c0 .69.56 1.25 1.25 1.25h9.5c.69 0 1.25-.56 1.25-1.25v-4.5c0-.69-.56-1.25-1.25-1.25h-9.5z",
    fill: primaryFill
  }));
};

export const Oven24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Oven24RegularIcon, 'Oven24Regular');

const Oven32FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 7.5A4.5 4.5 0 017.5 3h17A4.5 4.5 0 0129 7.5V12H3V7.5zm5.5.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm6 0a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zM22 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM3 14v10.5A4.5 4.5 0 007.5 29h17a4.5 4.5 0 004.5-4.5V14H3zm5.5 3h15c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-15A1.5 1.5 0 017 23.5v-5c0-.83.67-1.5 1.5-1.5z",
    fill: primaryFill
  }));
};

export const Oven32Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Oven32FilledIcon, 'Oven32Filled');

const Oven32RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 7.5A4.5 4.5 0 017.5 3h17A4.5 4.5 0 0129 7.5v17a4.5 4.5 0 01-4.5 4.5h-17A4.5 4.5 0 013 24.5v-17zm24 0A2.5 2.5 0 0024.5 5h-17A2.5 2.5 0 005 7.5V11h22V7.5zm0 17V13H5v11.5A2.5 2.5 0 007.5 27h17a2.5 2.5 0 002.5-2.5zm-17-15a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm6 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM23.5 8a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM9 23v-6h14v6H9zm-.5-8c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5h15c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5h-15z",
    fill: primaryFill
  }));
};

export const Oven32Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Oven32RegularIcon, 'Oven32Regular');

const Oven48FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12 6a6 6 0 00-6 6v5.5h36V12a6 6 0 00-6-6H12zm6 6.25a2 2 0 11-4 0 2 2 0 014 0zm8 0a2 2 0 11-4 0 2 2 0 014 0zm6-2a2 2 0 110 4 2 2 0 010-4zM6 20v16a6 6 0 006 6h24a6 6 0 006-6V20H6zm6.75 3.5h22.5c.97 0 1.75.78 1.75 1.75v10c0 .97-.78 1.75-1.75 1.75h-22.5c-.97 0-1.75-.78-1.75-1.75v-10c0-.97.78-1.75 1.75-1.75z",
    fill: primaryFill
  }));
};

export const Oven48Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/Oven48FilledIcon, 'Oven48Filled');

const Oven48RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M6 12.25C6 8.8 8.8 6 12.25 6h23.5C39.2 6 42 8.8 42 12.25v23.5C42 39.2 39.2 42 35.75 42h-23.5A6.25 6.25 0 016 35.75v-23.5zm2.5 23.5a3.75 3.75 0 003.75 3.75h23.5a3.75 3.75 0 003.75-3.75V18.5h-31v17.25zm0-23.5V16h31v-3.75a3.75 3.75 0 00-3.75-3.75h-23.5a3.75 3.75 0 00-3.75 3.75zm7.5 2a2 2 0 100-4 2 2 0 000 4zm8 0a2 2 0 100-4 2 2 0 000 4zm10-2a2 2 0 11-4 0 2 2 0 014 0zM13.5 34.5v-11h21v11h-21zM12.75 21c-.97 0-1.75.78-1.75 1.75v12.5c0 .97.78 1.75 1.75 1.75h22.5c.97 0 1.75-.78 1.75-1.75v-12.5c0-.97-.78-1.75-1.75-1.75h-22.5z",
    fill: primaryFill
  }));
};

export const Oven48Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/Oven48RegularIcon, 'Oven48Regular');

const PaddingDown20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.75 2.75c0 .41.34.75.75.75H15A.75.75 0 0015 2H4.5a.75.75 0 00-.75.75zm0 14.5c0 .41.34.75.75.75h1.31a.75.75 0 000-1.5H4.5a.75.75 0 00-.75.75zm3.94 0c0 .41.33.75.75.75h2.62a.75.75 0 000-1.5H8.44a.75.75 0 00-.75.75zm5.25 0c0 .41.33.75.75.75H15a.75.75 0 000-1.5h-1.31a.75.75 0 00-.75.75zm-2.66-1.97c-.3.3-.77.3-1.06 0l-4.25-4.25a.75.75 0 111.06-1.06L9 12.94V5.75a.75.75 0 011.5 0v7.19l2.97-2.97a.75.75 0 111.06 1.06l-4.25 4.25z",
    fill: primaryFill
  }));
};

export const PaddingDown20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaddingDown20FilledIcon, 'PaddingDown20Filled');

const PaddingDown20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M14.35 11.35l-4.5 4.5a.5.5 0 01-.7 0l-4.5-4.5a.5.5 0 01.7-.7L9 14.29V4.5a.5.5 0 011 0v9.8l3.65-3.65a.5.5 0 01.7.7zM3.5 3a.5.5 0 010-1h12a.5.5 0 010 1h-12zm0 15a.5.5 0 010-1h1a.5.5 0 010 1h-1zm3 0a.5.5 0 010-1h2a.5.5 0 010 1h-2zm4 0a.5.5 0 010-1h2a.5.5 0 010 1h-2zm4 0a.5.5 0 010-1h1a.5.5 0 010 1h-1z",
    fill: primaryFill
  }));
};

export const PaddingDown20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaddingDown20RegularIcon, 'PaddingDown20Regular');

const PaddingDown24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3a1 1 0 001 1h14a1 1 0 100-2H5a1 1 0 00-1 1zm0 18a1 1 0 001 1h1.75a1 1 0 100-2H5a1 1 0 00-1 1zm5.25 0a1 1 0 001 1h3.5a1 1 0 100-2h-3.5a1 1 0 00-1 1zm7 0a1 1 0 001 1H19a1 1 0 100-2h-1.75a1 1 0 00-1 1zm1.46-7.3l-5 5a1 1 0 01-1.42 0l-5-5a1 1 0 111.42-1.4L11 15.58V6a1 1 0 112 0v9.59l3.3-3.3a1 1 0 011.4 1.42z",
    fill: primaryFill
  }));
};

export const PaddingDown24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaddingDown24FilledIcon, 'PaddingDown24Filled');

const PaddingDown24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 2.75c0 .41.34.75.75.75h13a.75.75 0 000-1.5h-13a.75.75 0 00-.75.75zm0 18.5c0 .41.34.75.75.75h.87a.75.75 0 000-1.5h-.87a.75.75 0 00-.75.75zm3.47 0c0 .41.33.75.75.75h1.73a.75.75 0 000-1.5H8.72a.75.75 0 00-.75.75zm4.33 0c0 .41.34.75.75.75h1.73a.75.75 0 000-1.5h-1.73a.75.75 0 00-.75.75zm4.33 0c0 .41.34.75.75.75h.87a.75.75 0 000-1.5h-.87a.75.75 0 00-.75.75zm-4.35-2.47c-.3.3-.77.3-1.06 0l-5-5a.75.75 0 111.06-1.06L11 16.44V5.75a.75.75 0 011.5 0v10.69l3.72-3.72a.75.75 0 111.06 1.06l-5 5z",
    fill: primaryFill
  }));
};

export const PaddingDown24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaddingDown24RegularIcon, 'PaddingDown24Regular');

const PaddingLeft20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.75 3.75A.75.75 0 002 4.5v1.31a.75.75 0 001.5 0V4.5a.75.75 0 00-.75-.75zm0 3.94a.75.75 0 00-.75.75v2.62a.75.75 0 001.5 0V8.44a.75.75 0 00-.75-.75zm0 5.25a.75.75 0 00-.75.75V15a.75.75 0 001.5 0v-1.31a.75.75 0 00-.75-.75zm14.5-9.19a.75.75 0 00-.75.75V15a.75.75 0 001.5 0V4.5a.75.75 0 00-.75-.75zM4.72 10.28a.75.75 0 010-1.06l4.25-4.25a.75.75 0 111.06 1.06L7.06 9h7.19a.75.75 0 010 1.5H7.06l2.97 2.97a.75.75 0 11-1.06 1.06l-4.25-4.25z",
    fill: primaryFill
  }));
};

export const PaddingLeft20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaddingLeft20FilledIcon, 'PaddingLeft20Filled');

const PaddingLeft20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2 3.5a.5.5 0 011 0v1a.5.5 0 01-1 0v-1zm0 3a.5.5 0 011 0v2a.5.5 0 01-1 0v-2zm0 4a.5.5 0 011 0v2a.5.5 0 01-1 0v-2zm0 4a.5.5 0 011 0v1a.5.5 0 01-1 0v-1zm2.15-4.65a.5.5 0 010-.7l4.5-4.5a.5.5 0 11.7.7L5.71 9h9.79a.5.5 0 010 1H5.7l3.65 3.65a.5.5 0 01-.7.7l-4.5-4.5zM17 3.5a.5.5 0 011 0v12a.5.5 0 01-1 0v-12z",
    fill: primaryFill
  }));
};

export const PaddingLeft20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaddingLeft20RegularIcon, 'PaddingLeft20Regular');

const PaddingLeft24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 4a1 1 0 00-1 1v1.75a1 1 0 002 0V5a1 1 0 00-1-1zm0 5.25a1 1 0 00-1 1v3.5a1 1 0 102 0v-3.5a1 1 0 00-1-1zm0 7a1 1 0 00-1 1V19a1 1 0 102 0v-1.75a1 1 0 00-1-1zM21 4a1 1 0 00-1 1v14a1 1 0 102 0V5a1 1 0 00-1-1zM5.3 12.7a1 1 0 010-1.4l5-5a1 1 0 111.4 1.4L8.42 11H18a1 1 0 110 2H8.41l3.3 3.3a1 1 0 01-1.42 1.4l-5-5z",
    fill: primaryFill
  }));
};

export const PaddingLeft24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaddingLeft24FilledIcon, 'PaddingLeft24Filled');

const PaddingLeft24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.75 4.5a.75.75 0 00-.75.75v.87a.75.75 0 001.5 0v-.87a.75.75 0 00-.75-.75zm0 3.47a.75.75 0 00-.75.75v1.73a.75.75 0 001.5 0V8.72a.75.75 0 00-.75-.75zm0 4.33a.75.75 0 00-.75.75v1.73a.75.75 0 001.5 0v-1.73a.75.75 0 00-.75-.75zm0 4.33a.75.75 0 00-.75.75v.87a.75.75 0 001.5 0v-.87a.75.75 0 00-.75-.75zM21.25 4.5a.75.75 0 00-.75.75v13a.75.75 0 001.5 0v-13a.75.75 0 00-.75-.75zM5.22 12.28a.75.75 0 010-1.06l5-5a.75.75 0 111.06 1.06L7.56 11h10.69a.75.75 0 010 1.5H7.56l3.72 3.72a.75.75 0 11-1.06 1.06l-5-5z",
    fill: primaryFill
  }));
};

export const PaddingLeft24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaddingLeft24RegularIcon, 'PaddingLeft24Regular');

const PaddingRight20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.75 3.75c.41 0 .75.34.75.75V15A.75.75 0 012 15V4.5c0-.41.34-.75.75-.75zm14.5 0c.41 0 .75.34.75.75v1.31a.75.75 0 01-1.5 0V4.5c0-.41.34-.75.75-.75zm0 3.94c.41 0 .75.33.75.75v2.62a.75.75 0 01-1.5 0V8.44c0-.42.34-.75.75-.75zm0 5.25c.41 0 .75.33.75.75V15a.75.75 0 01-1.5 0v-1.31c0-.42.34-.75.75-.75zm-1.97-2.66c.3-.3.3-.77 0-1.06l-4.25-4.25a.75.75 0 10-1.06 1.06L12.94 9H5.75a.75.75 0 000 1.5h7.19l-2.97 2.97a.75.75 0 101.06 1.06l4.25-4.25z",
    fill: primaryFill
  }));
};

export const PaddingRight20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaddingRight20FilledIcon, 'PaddingRight20Filled');

const PaddingRight20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M15.85 9.85a.5.5 0 000-.7l-4.5-4.5a.5.5 0 00-.7.7L14.29 9H4.5a.5.5 0 000 1h9.8l-3.65 3.65a.5.5 0 00.7.7l4.5-4.5zM3 3.5a.5.5 0 00-1 0v12a.5.5 0 001 0v-12zm15 0a.5.5 0 00-1 0v1a.5.5 0 001 0v-1zm0 3a.5.5 0 00-1 0v2a.5.5 0 001 0v-2zm0 4a.5.5 0 00-1 0v2a.5.5 0 001 0v-2zm0 4a.5.5 0 00-1 0v1a.5.5 0 001 0v-1z",
    fill: primaryFill
  }));
};

export const PaddingRight20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaddingRight20RegularIcon, 'PaddingRight20Regular');

const PaddingRight24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 4a1 1 0 011 1v14a1 1 0 11-2 0V5a1 1 0 011-1zm18 0a1 1 0 011 1v1.75a1 1 0 11-2 0V5a1 1 0 011-1zm0 5.25a1 1 0 011 1v3.5a1 1 0 11-2 0v-3.5a1 1 0 011-1zm0 7a1 1 0 011 1V19a1 1 0 11-2 0v-1.75a1 1 0 011-1zm-2.3-3.54a1 1 0 000-1.42l-5-5a1 1 0 10-1.4 1.42L15.58 11H6a1 1 0 100 2h9.59l-3.3 3.3a1 1 0 001.42 1.4l5-5z",
    fill: primaryFill
  }));
};

export const PaddingRight24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaddingRight24FilledIcon, 'PaddingRight24Filled');

const PaddingRight24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M2.75 4.5c.41 0 .75.34.75.75v13a.75.75 0 01-1.5 0v-13c0-.41.34-.75.75-.75zm18.5 0c.41 0 .75.34.75.75v.87a.75.75 0 01-1.5 0v-.87c0-.41.34-.75.75-.75zm0 3.47c.41 0 .75.33.75.75v1.73a.75.75 0 01-1.5 0V8.72c0-.42.34-.75.75-.75zm0 4.33c.41 0 .75.34.75.75v1.73a.75.75 0 01-1.5 0v-1.73c0-.41.34-.75.75-.75zm0 4.33c.41 0 .75.34.75.75v.87a.75.75 0 01-1.5 0v-.87c0-.41.34-.75.75-.75zm-2.47-4.35c.3-.3.3-.77 0-1.06l-5-5a.75.75 0 10-1.06 1.06L16.44 11H5.75a.75.75 0 000 1.5h10.69l-3.72 3.72a.75.75 0 101.06 1.06l5-5z",
    fill: primaryFill
  }));
};

export const PaddingRight24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaddingRight24RegularIcon, 'PaddingRight24Regular');

const PaddingTop20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.75 2.75c0-.41.34-.75.75-.75h1.31a.75.75 0 010 1.5H4.5a.75.75 0 01-.75-.75zm3.94 0c0-.41.33-.75.75-.75h2.62a.75.75 0 010 1.5H8.44a.75.75 0 01-.75-.75zm5.25 0c0-.41.33-.75.75-.75H15a.75.75 0 010 1.5h-1.31a.75.75 0 01-.75-.75zm-9.19 14.5c0-.41.34-.75.75-.75H15a.75.75 0 010 1.5H4.5a.75.75 0 01-.75-.75zm6.53-12.53a.75.75 0 00-1.06 0L4.97 8.97a.75.75 0 101.06 1.06L9 7.06v7.19a.75.75 0 001.5 0V7.06l2.97 2.97a.75.75 0 101.06-1.06l-4.25-4.25z",
    fill: primaryFill
  }));
};

export const PaddingTop20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaddingTop20FilledIcon, 'PaddingTop20Filled');

const PaddingTop20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.5 2a.5.5 0 000 1h1a.5.5 0 000-1h-1zm3 0a.5.5 0 000 1h2a.5.5 0 000-1h-2zm4 0a.5.5 0 000 1h2a.5.5 0 000-1h-2zm4 0a.5.5 0 000 1h1a.5.5 0 000-1h-1zM9.85 4.15a.5.5 0 00-.7 0l-4.5 4.5a.5.5 0 10.7.7L9 5.71v9.79a.5.5 0 001 0V5.7l3.65 3.65a.5.5 0 00.7-.7l-4.5-4.5zM3.5 17a.5.5 0 000 1h12a.5.5 0 000-1h-12z",
    fill: primaryFill
  }));
};

export const PaddingTop20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaddingTop20RegularIcon, 'PaddingTop20Regular');

const PaddingTop24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 3a1 1 0 011-1h1.75a1 1 0 010 2H5a1 1 0 01-1-1zm5.25 0a1 1 0 011-1h3.5a1 1 0 110 2h-3.5a1 1 0 01-1-1zm7 0a1 1 0 011-1H19a1 1 0 110 2h-1.75a1 1 0 01-1-1zM4 21a1 1 0 011-1h14a1 1 0 110 2H5a1 1 0 01-1-1zm8.7-15.7a1 1 0 00-1.4 0l-5 5a1 1 0 101.4 1.4L11 8.42V18a1 1 0 102 0V8.41l3.3 3.3a1 1 0 001.4-1.42l-5-5z",
    fill: primaryFill
  }));
};

export const PaddingTop24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaddingTop24FilledIcon, 'PaddingTop24Filled');

const PaddingTop24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4.5 2.75c0-.41.34-.75.75-.75h.87a.75.75 0 010 1.5h-.87a.75.75 0 01-.75-.75zm3.47 0c0-.41.33-.75.75-.75h1.73a.75.75 0 010 1.5H8.72a.75.75 0 01-.75-.75zm4.33 0c0-.41.34-.75.75-.75h1.73a.75.75 0 010 1.5h-1.73a.75.75 0 01-.75-.75zm4.33 0c0-.41.34-.75.75-.75h.87a.75.75 0 010 1.5h-.87a.75.75 0 01-.75-.75zM4.5 21.25c0-.41.34-.75.75-.75h13a.75.75 0 010 1.5h-13a.75.75 0 01-.75-.75zm7.78-16.03a.75.75 0 00-1.06 0l-5 5a.75.75 0 101.06 1.06L11 7.56v10.69a.75.75 0 001.5 0V7.56l3.72 3.72a.75.75 0 101.06-1.06l-5-5z",
    fill: primaryFill
  }));
};

export const PaddingTop24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaddingTop24RegularIcon, 'PaddingTop24Regular');

const PageFit16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M1 5c0-1.1.9-2 2-2h10a2 2 0 012 2v6a2 2 0 01-2 2H3a2 2 0 01-2-2V5zm2 1v1a.5.5 0 001 0V6h1a.5.5 0 000-1H4a1 1 0 00-1 1zm9-1h-1a.5.5 0 000 1h1v1a.5.5 0 001 0V6a1 1 0 00-1-1zm0 6a1 1 0 001-1V9a.5.5 0 00-1 0v1h-1a.5.5 0 000 1h1zm-8 0h1a.5.5 0 000-1H4V9a.5.5 0 00-1 0v1a1 1 0 001 1z",
    fill: primaryFill
  }));
};

export const PageFit16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PageFit16FilledIcon, 'PageFit16Filled');

const PageFit16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3 6a1 1 0 011-1h1a.5.5 0 010 1H4v1a.5.5 0 01-1 0V6zm10 0a1 1 0 00-1-1h-1a.5.5 0 000 1h1v1a.5.5 0 001 0V6zm0 4a1 1 0 01-1 1h-1a.5.5 0 010-1h1V9a.5.5 0 011 0v1zM3 10a1 1 0 001 1h1a.5.5 0 000-1H4V9a.5.5 0 00-1 0v1zm0-7a2 2 0 00-2 2v6c0 1.1.9 2 2 2h10a2 2 0 002-2V5a2 2 0 00-2-2H3zm10 1a1 1 0 011 1v6a1 1 0 01-1 1H3a1 1 0 01-1-1V5a1 1 0 011-1h10z",
    fill: primaryFill
  }));
};

export const PageFit16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PageFit16RegularIcon, 'PageFit16Regular');

const PageFit20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 4a2 2 0 00-2 2v8c0 1.1.9 2 2 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm1.5 2h1a.5.5 0 010 1h-1a.5.5 0 00-.5.5v1a.5.5 0 01-1 0v-1C4 6.67 4.67 6 5.5 6zm8 0h1c.83 0 1.5.67 1.5 1.5v1a.5.5 0 01-1 0v-1a.5.5 0 00-.5-.5h-1a.5.5 0 010-1zM5 11.5v1c0 .28.22.5.5.5h1a.5.5 0 010 1h-1A1.5 1.5 0 014 12.5v-1a.5.5 0 011 0zm11 0v1c0 .83-.67 1.5-1.5 1.5h-1a.5.5 0 010-1h1a.5.5 0 00.5-.5v-1a.5.5 0 011 0z",
    fill: primaryFill
  }));
};

export const PageFit20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PageFit20FilledIcon, 'PageFit20Filled');

const PageFit20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 6C4.67 6 4 6.67 4 7.5v1a.5.5 0 001 0v-1c0-.28.22-.5.5-.5h1a.5.5 0 000-1h-1zm8 0a.5.5 0 000 1h1c.28 0 .5.22.5.5v1a.5.5 0 001 0v-1c0-.83-.67-1.5-1.5-1.5h-1zM5 11.5a.5.5 0 00-1 0v1c0 .83.67 1.5 1.5 1.5h1a.5.5 0 000-1h-1a.5.5 0 01-.5-.5v-1zm11 0a.5.5 0 00-1 0v1a.5.5 0 01-.5.5h-1a.5.5 0 000 1h1c.83 0 1.5-.67 1.5-1.5v-1zM2 6c0-1.1.9-2 2-2h12a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zm1 0v8a1 1 0 001 1h12a1 1 0 001-1V6a1 1 0 00-1-1H4a1 1 0 00-1 1zm2.5 0C4.67 6 4 6.67 4 7.5v1a.5.5 0 001 0v-1c0-.28.22-.5.5-.5h1a.5.5 0 000-1h-1zM5 11.5a.5.5 0 00-1 0v1c0 .83.67 1.5 1.5 1.5h1a.5.5 0 000-1h-1a.5.5 0 01-.5-.5v-1z",
    fill: primaryFill
  }));
};

export const PageFit20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PageFit20RegularIcon, 'PageFit20Regular');

const PageFit24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.25 4A3.75 3.75 0 0122 7.75v8.5A3.75 3.75 0 0118.25 20H5.75A3.75 3.75 0 012 16.25v-8.5A3.75 3.75 0 015.75 4h12.5zm0 9c-.38 0-.7.28-.74.65l-.01.1V15a.5.5 0 01-.41.5h-1.34a.75.75 0 00-.1 1.5H17a2 2 0 002-1.85v-1.4a.75.75 0 00-.75-.75zm-12.5 0c-.38 0-.7.28-.74.65l-.01.1V15a2 2 0 001.85 2h1.4a.75.75 0 00.1-1.5H7a.5.5 0 01-.5-.41v-1.34a.75.75 0 00-.75-.75zm2.5-6h-1.4a2 2 0 00-1.84 1.84L5 9v1.35a.75.75 0 001.5 0V8.91a.5.5 0 01.41-.4L7 8.5h1.35a.75.75 0 000-1.5h-.1zM17 7h-1.25a.75.75 0 00-.1 1.5H17a.5.5 0 01.5.41v1.34a.75.75 0 001.5.1V9a2 2 0 00-1.85-2H17z",
    fill: primaryFill
  }));
};

export const PageFit24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PageFit24FilledIcon, 'PageFit24Filled');

const PageFit24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M18.25 4A3.75 3.75 0 0122 7.75v8.5A3.75 3.75 0 0118.25 20H5.75A3.75 3.75 0 012 16.25v-8.5A3.75 3.75 0 015.75 4h12.5zm0 1.5H5.75c-1.24 0-2.25 1-2.25 2.25v8.5c0 1.24 1 2.25 2.25 2.25h12.5c1.24 0 2.25-1 2.25-2.25v-8.5c0-1.24-1-2.25-2.25-2.25zm0 7.5c.41 0 .75.34.75.75V15a2 2 0 01-2 2h-1.25a.75.75 0 010-1.5H17a.5.5 0 00.5-.5v-1.25c0-.41.34-.75.75-.75zm-12.5 0c.41 0 .75.34.75.75V15c0 .28.22.5.5.5h1.25a.75.75 0 010 1.5H7a2 2 0 01-2-2v-1.25c0-.41.34-.75.75-.75zM7 7h1.25a.75.75 0 01.1 1.5H7a.5.5 0 00-.5.41v1.34a.75.75 0 01-1.5.1V9a2 2 0 011.85-2H7zm10 0a2 2 0 012 2v1.25a.75.75 0 01-1.5 0V9a.5.5 0 00-.5-.5h-1.25a.75.75 0 010-1.5H17z",
    fill: primaryFill
  }));
};

export const PageFit24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PageFit24RegularIcon, 'PageFit24Regular');

const PaintBrush16FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M8 1v2.5a.5.5 0 001 0V1h1v3.5a.5.5 0 001 0V1h1.5v6h-9V1H8zM3.5 8v.5c0 1.1.9 2 2 2h1v3a1.5 1.5 0 003 0v-3h1a2 2 0 002-2V8h-9z",
    fill: primaryFill
  }));
};

export const PaintBrush16Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaintBrush16FilledIcon, 'PaintBrush16Filled');

const PaintBrush16RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M4 1a.5.5 0 00-.5.5v7c0 1.1.9 2 2 2H6V13a2 2 0 104 0v-2.5h.5a2 2 0 002-2v-7A.5.5 0 0012 1H4zm7.5 6h-7V2h3v1.5a.5.5 0 101 0V2h1v2.5a.5.5 0 001 0V2h1v5zm-7 1.5V8h7v.5a1 1 0 01-1 1h-1a.5.5 0 00-.5.5v3a1 1 0 01-2 0v-3a.5.5 0 00-.5-.5h-1a1 1 0 01-1-1z",
    fill: primaryFill
  }));
};

export const PaintBrush16Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaintBrush16RegularIcon, 'PaintBrush16Regular');

const PaintBrush20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 4.5V2H5.5a.5.5 0 00-.5.5V9h10V2.5a.5.5 0 00-.5-.5H13v3.5a.5.5 0 01-1 0V2h-1v2.5a.5.5 0 01-1 0zm5 5.5H5v1c0 1.1.9 2 2 2h1.5v3.5a1.5 1.5 0 103 0V13H13a2 2 0 002-2v-1z",
    fill: primaryFill
  }));
};

export const PaintBrush20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaintBrush20FilledIcon, 'PaintBrush20Filled');

const PaintBrush20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.5 2a.5.5 0 00-.5.5V11c0 1.1.9 2 2 2h1v3a2 2 0 104 0v-3h1a2 2 0 002-2V2.5a.5.5 0 00-.5-.5h-9zm.5 8h8v1a1 1 0 01-1 1h-1.5a.5.5 0 00-.5.5V16a1 1 0 11-2 0v-3.5a.5.5 0 00-.5-.5H7a1 1 0 01-1-1v-1zm8-1H6V3h4v1.5a.5.5 0 001 0V3h1v2.5a.5.5 0 001 0V3h1v6z",
    fill: primaryFill
  }));
};

export const PaintBrush20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaintBrush20RegularIcon, 'PaintBrush20Regular');

const PaintBrush24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M12.5 2v3.25a.75.75 0 001.5 0V2h1v4.25a.75.75 0 001.5 0V2h1.75c.41 0 .75.34.75.75V11H5V2.75c0-.41.34-.75.75-.75h6.75zM5 12.5v1.75c0 1.24 1 2.25 2.25 2.25H10V20a2 2 0 104 0v-3.5h2.75c1.24 0 2.25-1 2.25-2.25V12.5H5z",
    fill: primaryFill
  }));
};

export const PaintBrush24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaintBrush24FilledIcon, 'PaintBrush24Filled');

const PaintBrush24RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M5.75 2a.75.75 0 00-.75.75v11.5c0 1.24 1 2.25 2.25 2.25H9.5v3a2.5 2.5 0 105 0v-3h2.25c1.24 0 2.25-1 2.25-2.25V2.75a.75.75 0 00-.75-.75H5.75zm.75 9V3.5h6v1.75a.75.75 0 101.5 0V3.5h1v2.75a.75.75 0 101.5 0V3.5h1V11h-11zm0 3.25V12.5h11v1.75c0 .41-.34.75-.75.75h-3a.75.75 0 00-.75.75v3.75a1 1 0 01-2 0v-3.75a.75.75 0 00-.75-.75h-3a.75.75 0 01-.75-.75z",
    fill: primaryFill
  }));
};

export const PaintBrush24Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaintBrush24RegularIcon, 'PaintBrush24Regular');

const PaintBrushArrowDown20FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M3.57 17.24A.5.5 0 004 18h1.7l.02-.03c.26-.54.55-1.14.79-1.71.3-.73.49-1.35.49-1.76a.5.5 0 011 0c0 .63-.27 1.41-.57 2.14-.19.46-.4.92-.61 1.36H8c.2-.39.43-.8.61-1.21.24-.54.39-.99.39-1.29a.5.5 0 011 0c0 .53-.23 1.15-.48 1.7-.12.27-.25.54-.39.8h2.75l-.44-.44A1.5 1.5 0 0113 15.1V13.5a1.5 1.5 0 012-1.41V11H5v.5a12.57 12.57 0 01-1.42 5.72v.02zM5 10h10V9a2 2 0 00-2-2h-1V4a2 2 0 10-4 0v3H7a2 2 0 00-2 2v1zm10 3.5a.5.5 0 00-1 0v3.8l-1.15-1.15a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 00-.7-.7L15 17.29V13.5z",
    fill: primaryFill
  }));
};

export const PaintBrushArrowDown20Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaintBrushArrowDown20FilledIcon, 'PaintBrushArrowDown20Filled');

const PaintBrushArrowDown20RegularIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M9 4v3.5a.5.5 0 01-.5.5H7a1 1 0 00-1 1v1h8V9a1 1 0 00-1-1h-1.5a.5.5 0 01-.5-.5V4a1 1 0 10-2 0zm6 5v1.47a.57.57 0 010 .06v1.56a1.5 1.5 0 00-1 0V11H6v.5A13.57 13.57 0 014.8 17h1.37l.02-.04a16.46 16.46 0 00.66-1.7A3 3 0 007 14.5a.5.5 0 011 0c0 .32-.08.69-.18 1.03A10.96 10.96 0 017.28 17h1.24l.18-.42c.17-.4.3-.83.3-1.08a.5.5 0 011 0c0 .47-.2 1.05-.37 1.46L9.6 17h1.48c.07.2.19.4.35.56l.44.44H8.84 6.51 4a.5.5 0 01-.43-.76l.01-.02a3.9 3.9 0 00.2-.38A12.57 12.57 0 005 11.5V9c0-1.1.9-2 2-2h1V4a2 2 0 014 0v3h1a2 2 0 012 2zm0 4.5a.5.5 0 00-1 0v3.8l-1.15-1.15a.5.5 0 00-.7.7l2 2c.2.2.5.2.7 0l2-2a.5.5 0 00-.7-.7L15 17.29V13.5z",
    fill: primaryFill
  }));
};

export const PaintBrushArrowDown20Regular = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaintBrushArrowDown20RegularIcon, 'PaintBrushArrowDown20Regular');

const PaintBrushArrowDown24FilledIcon = props => {
  const {
    fill: primaryFill = 'currentColor',
    className
  } = props;
  return React.createElement("svg", Object.assign({}, props, {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }), React.createElement("path", {
    d: "M10 4a2 2 0 114 0v3.5h2.75c1.24 0 2.25 1 2.25 2.25v1.75H5.09c.01-.72 0-1.35-.02-1.87A2.06 2.06 0 017.11 7.5H10V4zm-4.96 9H19v1.15a1.74 1.74 0 00-2.45 1.6v2.44a1.75 1.75 0 00-2.04 2.8L15.53 22h-4.98c.17-.38.36-.87.54-1.39a9.53 9.53 0 00.41-1.84v-.02a.75.75 0 10-1.5.03l-.04.23c-.04.23-.12.6-.3 1.13A16.83 16.83 0 018.91 22H7.57l.4-.93c.4-.97.88-2.23 1.02-3.21a.75.75 0 00-1.48-.22c-.11.77-.51 1.88-.92 2.85A32.38 32.38 0 015.91 22H3.75a.75.75 0 01-.63-1.16c.95-1.46 1.47-3.58 1.73-5.73.1-.72.15-1.43.19-2.11zm10.18 6.22c.3-.3.77-.3 1.06 0l1.27 1.27v-4.74a.75.75 0 011.5 0v4.64l1.17-1.17a.75.75 0 111.06 1.06l-2.5 2.5a.75.75 0 01-1.06 0l-2.5-2.5a.75.75 0 010-1.06z",
    fill: primaryFill
  }));
};

export const PaintBrushArrowDown24Filled = /*#__PURE__*/wrapIcon( /*#__PURE__*/PaintBrushArrowDown24FilledIcon, 'PaintBrushArrowDown24Filled');